function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("5E2pR", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$ced1e82a7b8f38d4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("2Geeh");
    var $39xOx;
    var $beRD7;
    var $lfTZh;
    var $4kGtN;
    var $3mYHL;
    var $dxCvy;
    var $9NiTW;
    var $l8ruj;
    var $2YP9W;
    var $1bQGJ;
    var $k3OmX;
    var $5Jt5R;
    const $ced1e82a7b8f38d4$var$RelayProjectVersions = ({ match: match })=>{
        const projectContext = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const projectKey = match.params.projectKey ?? '';
        const onExperienceFail = (0, (0, parcelRequire("4kGtN")).useJiraProjectVersionExperienceFail)();
        const isNonExistingProjectKey = projectContext.data == null && projectContext.error != null && projectContext.error.statusCode === 404;
        if ((0, (0, parcelRequire("3mYHL")).isProjectArchivedCondition)(projectContext.data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3mYHL")).RedirectToArchivedPage), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "project-versions"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4kGtN")).JiraProjectVersionExperienceStart), {
            experienceId: projectKey
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, isNonExistingProjectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).NotFoundErrorPageAsync), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4kGtN")).JiraProjectVersionExperienceExpectedFailureSuccess), {
            reason: "Project does not exist with the given project key"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-versions",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3OmX")).Skeleton), null)
        }, projectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "projectVersions",
            packageName: "jiraSpaAppsProjectVersions",
            teamName: "fusion-solaris",
            onError: (loc, error)=>{
                onExperienceFail(loc, error);
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Jt5R")).default), {
            projectKey: projectKey
        })) : null)));
    };
    var $ced1e82a7b8f38d4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("1bQGJ")).withRouter)($ced1e82a7b8f38d4$var$RelayProjectVersions);
});
parcelRegister("4kGtN", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectVersionExperienceStart", ()=>$87cd8a4070da7833$export$280be5742fc2dc22);
    $parcel$export(module.exports, "JiraProjectVersionExperienceSuccess", ()=>$87cd8a4070da7833$export$6bc513cfb37586f4);
    $parcel$export(module.exports, "JiraProjectVersionExperienceExpectedFailureSuccess", ()=>$87cd8a4070da7833$export$fef40ab145516510);
    $parcel$export(module.exports, "useJiraProjectVersionExperienceFail", ()=>$87cd8a4070da7833$export$13d84dc8cd2d3dfd);
    var $5uXOq = parcelRequire("5uXOq");
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $87cd8a4070da7833$var$EXPERIENCE_NAME = 'viewVersionsPage';
    const $87cd8a4070da7833$var$ANALYTICS_SOURCE = 'versions';
    const $87cd8a4070da7833$export$280be5742fc2dc22 = ({ experienceId: experienceId })=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaHBi")).ExperienceStart), {
            experienceId: experienceId,
            experience: $87cd8a4070da7833$var$EXPERIENCE_NAME,
            analyticsSource: $87cd8a4070da7833$var$ANALYTICS_SOURCE,
            edition: appEditions.software,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE)
        });
    };
    const $87cd8a4070da7833$export$6bc513cfb37586f4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $87cd8a4070da7833$var$EXPERIENCE_NAME,
            attributes: {
                isLegacy: false
            }
        });
    const $87cd8a4070da7833$export$fef40ab145516510 = ({ reason: reason })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: $87cd8a4070da7833$var$EXPERIENCE_NAME,
            attributes: {
                isLegacy: false,
                expectedFailureReason: reason
            }
        });
    const $87cd8a4070da7833$export$13d84dc8cd2d3dfd = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $87cd8a4070da7833$var$EXPERIENCE_NAME,
            attributes: {
                isLegacy: false
            }
        });
});
parcelRegister("3mYHL", function(module, exports) {
    $parcel$export(module.exports, "isProjectArchivedCondition", ()=>$90d8776d2c89f4bd$export$34040938aec58f90);
    $parcel$export(module.exports, "RedirectToArchivedPage", ()=>$90d8776d2c89f4bd$export$36db2ddf32573bd8);
    $parcel$export(module.exports, "default", ()=>$90d8776d2c89f4bd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dAfqg;
    var $7tQej;
    const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
    const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
        if (projectKey === null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dAfqg")).ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
            }) : null);
    };
    const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        });
    var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;
});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';
parcelRegister("k3OmX", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$9556f741243eceaf$export$8f31e4c4a37b8e9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $fNobW;
    var $ggbnl;
    var $2crmU;
    const $9556f741243eceaf$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fNobW")).default), {
            name: "project-versions-skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ggbnl")).ContentWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2crmU")).SkeletonHeading), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2crmU")).SkeletonFilter), {
            avatar: false
        })));
});
parcelRegister("ggbnl", function(module, exports) {
    $parcel$export(module.exports, "ContentWrapper", ()=>$8b5ac0535e0d2a26$export$6ce170286acaa8d3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $8b5ac0535e0d2a26$export$6ce170286acaa8d3 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { marginRight: marginRight, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_129vh1m": (0, (0, parcelRequire("lD23V")).default)(__cmplp.marginRight, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1ejb _18u01jfw _4t3ioskh _1e0c1txw _2lx21bp4 _2hwx17yv _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2crmU", function(module, exports) {
    $parcel$export(module.exports, "SkeletonHeading", ()=>$4b43daac36aa2d3d$export$f9d7393532a80768);
    $parcel$export(module.exports, "SkeletonItem", ()=>$4b43daac36aa2d3d$export$fbc0ea7debdb77e);
    $parcel$export(module.exports, "SkeletonFilter", ()=>$4b43daac36aa2d3d$export$5a0e77037f4561ed);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $dC5iT;
    var $8CUq3;
    var $gwIPs;
    const $4b43daac36aa2d3d$export$f9d7393532a80768 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4b43daac36aa2d3d$var$marginBottomMap.mdMargin
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$var$SkeletonHeaderContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$export$fbc0ea7debdb77e, {
            height: (0, (0, parcelRequire("gwIPs")).gridSize) * 1.25,
            width: (0, (0, parcelRequire("gwIPs")).gridSize) * 6.5,
            "data-testid": "spa-apps-common.skeletons.small-heading"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4b43daac36aa2d3d$var$marginBottomMap.noMargin
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$var$SkeletonHeaderContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$export$fbc0ea7debdb77e, {
            height: (0, (0, parcelRequire("gwIPs")).gridSize) * 3,
            width: (0, (0, parcelRequire("gwIPs")).gridSize) * 24,
            "data-testid": "spa-apps-common.skeletons.large-heading"
        }))));
    const $4b43daac36aa2d3d$export$5a0e77037f4561ed = ({ avatar: avatar })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $4b43daac36aa2d3d$var$marginTopMap.threeTimesGridSize,
                $4b43daac36aa2d3d$var$marginBottomMap.threeTimesGridSize
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$var$SkeletonHeaderContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4b43daac36aa2d3d$var$baseStyleMarginRightStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$export$fbc0ea7debdb77e, {
            height: 5 * (0, (0, parcelRequire("gwIPs")).gridSize),
            width: 15 * (0, (0, parcelRequire("gwIPs")).gridSize),
            "data-testid": "spa-apps-common.skeletons.filter"
        })), avatar && (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$export$d02d1ff29bb075b5, null)));
    const $4b43daac36aa2d3d$export$d02d1ff29bb075b5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$var$SkeletonContainer, {
            "data-testid": "spa-apps-common.skeletons.avatar-list"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$var$SkeletonAvatar, null), (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$var$SkeletonAvatar, null), (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$var$SkeletonAvatar, null), (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$var$SkeletonAvatar, null), (0, ($parcel$interopDefault($5uXOq))).createElement($4b43daac36aa2d3d$var$SkeletonAvatar, null));
    const $4b43daac36aa2d3d$var$baseStyleMarginRightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.200'
    });
    const $4b43daac36aa2d3d$var$marginBottomMap = {
        noMargin: (0, (0, parcelRequire("8CUq3")).xcss)({
            marginBottom: 'space.0'
        }),
        mdMargin: (0, (0, parcelRequire("8CUq3")).xcss)({
            marginBottom: 'space.150'
        }),
        threeTimesGridSize: (0, (0, parcelRequire("8CUq3")).xcss)({
            marginBottom: 'space.300'
        })
    };
    const $4b43daac36aa2d3d$var$marginTopMap = {
        threeTimesGridSize: (0, (0, parcelRequire("8CUq3")).xcss)({
            marginTop: 'space.300'
        })
    };
    const $4b43daac36aa2d3d$export$fbc0ea7debdb77e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height, "px"),
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk1aqf _4t3i1474 _1bsb1rkg _2rko1b66",
                __cmplp.className
            ])
        });
    });
    const $4b43daac36aa2d3d$var$SkeletonHeaderContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc",
                __cmplp.className
            ])
        });
    });
    const $4b43daac36aa2d3d$var$SkeletonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _19pk1b66",
                __cmplp.className
            ])
        });
    });
    const $4b43daac36aa2d3d$var$SkeletonAvatar = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk1aqf _4t3ixy5q _1bsbxy5q _2rkopxbi _18u01i6y _1mfnze3t",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5Jt5R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c888939e58d7606$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jzjy1;
    var $dtqvU;
    var $ao2h1;
    var $bC7QJ;
    var $7DbgJ;
    var $9dbF6;
    var $fhVq7;
    var $4dRjY;
    var $dZw8H;
    var $9OXo1;
    const $0c888939e58d7606$var$RelayVersions = ({ projectKey: projectKey })=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { queryReference: queryReference } = (0, (0, parcelRequire("ao2h1")).useRelayResource)((0, (0, parcelRequire("bC7QJ")).projectVersionsRelayResource));
        if (!projectKey) throw new Error('Unable to find projectkey');
        const { baseUrl: baseUrl } = tenantContext;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fhVq7")).PageLayout), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dRjY")).MarkProductStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "platform"
        }), queryReference && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dtqvU")).ProjectVersionsComponent), {
            queryReference: queryReference
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7DbgJ")).default), {
            baseUrl: baseUrl,
            projectKey: projectKey
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null));
    };
    var $0c888939e58d7606$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('project-versions', (0, $4d5e0871c06cee03$export$f636b5b56f1d624a))($0c888939e58d7606$var$RelayVersions);
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("dtqvU", function(module, exports) {
    $parcel$export(module.exports, "ProjectVersionsComponent", ()=>$e9f834f141b299cb$export$24429f25746ad806);
    var $lqMPx;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $ldJSL;
    var $fVnbM;
    var $dC5iT;
    var $8CUq3;
    var $dj7Vj;
    var $jS4lj;
    var $e0tCO;
    var $gEFwt;
    var $cS37j;
    var $39xOx;
    var $beRD7;
    var $pa9q9;
    var $ew1Lk;
    var $koVbs;
    var $3HwlS;
    var $5oFIy;
    var $8zOmE;
    var $47Rfm;
    var $dxCvy;
    var $6lgIC;
    var $b4adL;
    var $dAgso;
    var $90yGq;
    var $fY39E;
    var $koeKL;
    var $itmJb;
    var $dCm1o;
    var $7hSN4;
    var $2YP9W;
    var $iJZ8l;
    var $53QJ7;
    var $4kGtN;
    var $4PoCa;
    var $acEhA;
    var $gWAh1;
    var $6c7j1;
    var $3Rez0;
    var $ej3oB;
    var $8T1hp;
    const $e9f834f141b299cb$export$24429f25746ad806 = ({ queryReference: queryReference })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("lqMPx")).default), queryReference);
        const { projectId: projectId, name: name, key: key, jiraProjectType: jiraProjectType } = data.jira.jiraProjectByKey;
        const connectionId = data.jira.jiraProjectByKey.versions.__id;
        const projectType = (0, (0, parcelRequire("8T1hp")).getProjectType)(jiraProjectType);
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const isJiraAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const activationId = (0, (0, parcelRequire("fY39E")).useActivationId)();
        const projectContext = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const isProjectAdmin = projectContext?.data?.isProjectAdmin || false;
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const [createReleaseFormQueryRef, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("47Rfm")).default));
        const loadCreateReleaseQuery = ()=>{
            if (!createReleaseFormQueryRef && accountId) loadQuery({
                accountId: accountId
            });
        };
        const [createVersionModalOpen, setCreateVersionModalOpen] = (0, $5uXOq.useState)(false);
        const createVersionExperienceStart = (0, (0, parcelRequire("b4adL")).useCreateReleaseExperienceStart)((0, $6868fc0fce0c2912$export$c5ed97509d0e2aaf));
        const hasPermissionError = (data.jira.jiraProjectByKey.versions.errors ?? []).some((error)=>(error.extensions ?? []).some((extension)=>extension.statusCode === 403));
        if (hasPermissionError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).NotFoundErrorPageAsync), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4kGtN")).JiraProjectVersionExperienceExpectedFailureSuccess), {
            reason: "User does not have permission to view this page."
        }));
        const onCreateRelease = (version)=>{
            (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
                const connectionRecord = store.get(connectionId);
                if (connectionRecord) {
                    const versionAri = (0, (0, parcelRequire("dj7Vj")).JiraVersionAri).create({
                        siteId: cloudId,
                        activationId: activationId,
                        versionId: version.id.toString()
                    }).toString();
                    const dataID = (0, (0, parcelRequire("iJZ8l")).default)({
                        id: versionAri
                    }, 'JiraVersion') ?? '';
                    const versionRecord = store.get(dataID);
                    if (versionRecord) {
                        const newEdgeRecord = (0, $8Uumt.ConnectionHandler).createEdge(store, connectionRecord, versionRecord, 'JiraVersionEdge');
                        (0, $8Uumt.ConnectionHandler).insertEdgeBefore(connectionRecord, newEdgeRecord);
                    }
                }
            });
        };
        const breadcrumbs = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jS4lj")).default), null);
        const actions = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, !(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            packageName: "jiraProjectVersions",
            teamName: "fusion-solaris",
            id: "releasesAutomationMenu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lgIC")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acEhA")).FeedbackButton), null));
        const createVersionButton = isJiraAdmin || isProjectAdmin ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "primary",
            onClick: (_e, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'createVersionButton');
                setCreateVersionModalOpen(true);
                createVersionExperienceStart();
            },
            onMouseOver: loadCreateReleaseQuery,
            onFocus: loadCreateReleaseQuery,
            testId: "project-directories.versions.main.add-version.create-button"
        }, formatMessage((0, (0, parcelRequire("6c7j1")).default).createVersionButton)) : null;
        const createVersionModal = createVersionModalOpen && createReleaseFormQueryRef != null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dAgso")).CreateReleaseModal), {
            queryReference: createReleaseFormQueryRef,
            onClose: ()=>setCreateVersionModalOpen(false),
            projectId: projectId,
            onReleaseCreation: (version)=>{
                onCreateRelease(version);
                showFlag({
                    type: 'success',
                    title: formatMessage((0, (0, parcelRequire("6c7j1")).default).successFlagDescription, {
                        name: version.name
                    }),
                    isAutoDismiss: true,
                    testId: 'project-directories.versions.flags.create.success'
                });
            }
        }) : null;
        const bottomBar = (0, ($parcel$interopDefault($5uXOq))).createElement($e9f834f141b299cb$var$BottomBarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($e9f834f141b299cb$var$Filter, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Rez0")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e9f834f141b299cb$var$versionsFilterContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gWAh1")).default), null))), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && projectType === 'software' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, actions, createVersionButton, createVersionModal) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, createVersionButton, createVersionModal));
        const pageContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e9f834f141b299cb$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("6c7j1")).default).releases)
        }), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && projectType === 'software' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $e9f834f141b299cb$var$headerBarStyles : $e9f834f141b299cb$var$headerBarStylesOld
        }, bottomBar) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cS37j")).default), {
            truncateTitle: true,
            breadcrumbs: breadcrumbs,
            actions: actions,
            bottomBar: bottomBar
        }, formatMessage((0, (0, parcelRequire("6c7j1")).default).releases)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7hSN4")).LazySuspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ej3oB")).default), {
            query: data
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4kGtN")).JiraProjectVersionExperienceSuccess), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4PoCa")).PerformanceTracker), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("53QJ7")).ProjectVersionsAnalyticsContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "project-directories.versions.main.name"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
            projectKey: key,
            projectName: name
        }, (0, (0, parcelRequire("8T1hp")).isVersionAdminContext)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0tCO")).default), {
            projectKey: key,
            projectType: projectType,
            baseUrl: ""
        }, pageContent) : pageContent)));
    };
    const $e9f834f141b299cb$var$Filter = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $e9f834f141b299cb$var$versionsFilterContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.150'
    });
    const $e9f834f141b299cb$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.300'
    });
    const $e9f834f141b299cb$var$headerBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.250',
        marginBottom: 'space.200'
    });
    const $e9f834f141b299cb$var$headerBarStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.300',
        marginBottom: 'space.300'
    });
    const $e9f834f141b299cb$var$BottomBarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dj7Vj", function(module, exports) {
    $parcel$export(module.exports, "JiraVersionAri", ()=>$9b03321cf408eff9$export$eff0d18d9de27263);
    var $lNzyZ;
    var $9KGzW;
    var $1C2Ux;
    var $9b03321cf408eff9$var$jiraVersionAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("lNzyZ")).JiraVersionAriResourceOwner),
        resourceType: (0, (0, parcelRequire("lNzyZ")).JiraVersionAriResourceType),
        resourceIdSlug: "activation/{activationId}/{versionId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            versionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
        }
    };
    var $9b03321cf408eff9$export$eff0d18d9de27263 = class _JiraVersionAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._versionId = opts.resourceIdSegmentValues.versionId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get versionId() {
            return this._versionId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $9b03321cf408eff9$var$jiraVersionAriStaticOpts.qualifier,
                platformQualifier: $9b03321cf408eff9$var$jiraVersionAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $9b03321cf408eff9$var$jiraVersionAriStaticOpts.resourceOwner,
                resourceType: $9b03321cf408eff9$var$jiraVersionAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.versionId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    versionId: opts.versionId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $9b03321cf408eff9$var$jiraVersionAriStaticOpts);
            return new _JiraVersionAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $9b03321cf408eff9$var$jiraVersionAriStaticOpts);
            return new _JiraVersionAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                versionId: this.versionId
            };
        }
    };
});
parcelRegister("lNzyZ", function(module, exports) {
    $parcel$export(module.exports, "JiraVersionAriResourceOwner", ()=>$fde9c2b80aaa0a56$export$1b35360c29caced0);
    $parcel$export(module.exports, "JiraVersionAriResourceType", ()=>$fde9c2b80aaa0a56$export$680940c40f68f72d);
    var $fde9c2b80aaa0a56$export$1b35360c29caced0 = "jira", $fde9c2b80aaa0a56$export$680940c40f68f72d = "version";
});
parcelRegister("e0tCO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67a65658db3ebd27$export$2e2bcd8739ae039);
    var $az4zD;
    var $7Xr7M;
    var $67a65658db3ebd27$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)((0, (0, parcelRequire("7Xr7M")).default));
});
parcelRegister("7Xr7M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14c779f1fa7b01b6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $c2D8L;
    var $81ps3;
    var $9zgyl;
    const $14c779f1fa7b01b6$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && (projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                href: (0, (0, parcelRequire("81ps3")).createProjectSettingsUrl)(projectKey, projectType, isSimplified),
                text: formatMessage((0, (0, parcelRequire("9zgyl")).default).projectSettingsTitle),
                type: 'projectSettings'
            }
        }, children) : children;
    var $14c779f1fa7b01b6$export$2e2bcd8739ae039 = $14c779f1fa7b01b6$var$ProjectSettingsBreadcrumb;
});
parcelRegister("9zgyl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e487ef6161e77fc4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e487ef6161e77fc4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectSettingsTitle: {
            "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
            "defaultMessage": "Project settings"
        }
    });
});
parcelRegister("cS37j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a15efb09f101ecb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $57MwZ;
    const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("57MwZ")).default), {
            ...props,
            actions: actions ? (0, ($parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
        });
    var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
    const $2a15efb09f101ecb$var$ActionsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("57MwZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9694e728fd1ea060$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eeGIy;
    const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).OuterWrapper), null, breadcrumbs, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleWrapper), {
            truncateTitle: truncateTitle
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).TitleContainer), {
            truncateTitle: truncateTitle
        }, disableTitleStyles ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).StyledTitleWrapper), {
            ref: innerRef,
            truncateTitle: truncateTitle,
            id: id
        }, children)), actions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).ActionsWrapper), null, actions)), bottomBar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eeGIy")).BottomBarWrapper), null, " ", bottomBar, " "));
    };
    var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;
});
parcelRegister("eeGIy", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$0c196d37a4e8266c$export$edaaad985a878983);
    $parcel$export(module.exports, "StyledTitleWrapper", ()=>$0c196d37a4e8266c$export$284be1ee64a3465c);
    $parcel$export(module.exports, "TitleWrapper", ()=>$0c196d37a4e8266c$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleContainer", ()=>$0c196d37a4e8266c$export$35e09ba17cc51c69);
    $parcel$export(module.exports, "ActionsWrapper", ()=>$0c196d37a4e8266c$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "BottomBarWrapper", ()=>$0c196d37a4e8266c$export$6330225854c30dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $8CUq3;
    function $0c196d37a4e8266c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c196d37a4e8266c$var$truncateStyles = {
        name: "13oenf9",
        styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0c196d37a4e8266c$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
    });
    const $0c196d37a4e8266c$var$titleStyles = {
        name: "1o56te0",
        styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
    };
    const $0c196d37a4e8266c$var$titleWrapperStyles = {
        name: "1wb76vg",
        styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
    };
    const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    };
    const $0c196d37a4e8266c$var$titleContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        maxWidth: '100%',
        flex: '1 0 auto',
        flexShrink: undefined,
        marginBlockEnd: "var(--ds-space-100, 8px)"
    });
    const $0c196d37a4e8266c$var$actionStyles = {
        name: "1ianfu6",
        styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
    };
    const $0c196d37a4e8266c$var$titleContainerTruncateStyles = {
        name: "s2a4s9",
        styles: "flex-shrink:1"
    };
    const $0c196d37a4e8266c$var$bottomBarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.200'
    });
    const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$outerStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$284be1ee64a3465c = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: [
                $0c196d37a4e8266c$var$titleStyles,
                truncateTitle && $0c196d37a4e8266c$var$truncateStyles
            ],
            ref: ref,
            tabIndex: -1,
            id: id
        }, children);
    });
    const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleWrapperStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleWrapperTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $0c196d37a4e8266c$var$titleContainerStyles,
                truncateTitle && $0c196d37a4e8266c$var$titleContainerTruncateStyles
            ]
        }, children);
    };
    const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0c196d37a4e8266c$var$actionStyles
        }, children);
    };
    const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0c196d37a4e8266c$var$bottomBarStyles
        }, children);
    };
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("47Rfm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d8a0c0c5f95d2ea$export$2e2bcd8739ae039);
    const $7d8a0c0c5f95d2ea$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "accountId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "accountId",
                "variableName": "accountId"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "createReleaseModalQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "createReleaseForm_softwareReleasesReleaseModalsRelay"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "user"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "createReleaseModalQuery",
                "selections": [
                    {
                        "args": v1,
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__typename"
                            },
                            {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isUser"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "picture"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "id"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "7ba7f55b9606c6306f9ffee483513fccb037383f6a29e7aa236eb5cbac386518",
                "metadata": {},
                "name": "createReleaseModalQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $7d8a0c0c5f95d2ea$var$node.hash = "9f85087ab53fe21f6df07185269b323d";
    var $7d8a0c0c5f95d2ea$export$2e2bcd8739ae039 = $7d8a0c0c5f95d2ea$var$node;
});
parcelRegister("6lgIC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d512d39a9a2997e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $hrfsZ;
    var $lfTZh;
    var $kxZPA;
    var $8pnTj;
    const $8d512d39a9a2997e$var$AutomationMenu = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("7AEEN")), {
        moduleId: "./src/packages/releases/automation-menu/src/index.tsx"
    });
    const $8d512d39a9a2997e$var$fallback = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pnTj")).IconWrapper), {
        "data-testid": "jira-releases-automation-menu.ui.automation-button.disabled"
    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
        glyph: (0, (0, parcelRequire("hrfsZ")).AutomationGlyph),
        label: ""
    }));
    const $8d512d39a9a2997e$var$AsyncReleaseAutomationMenu = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "releases-automation-menu",
            fallback: $8d512d39a9a2997e$var$fallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8d512d39a9a2997e$var$AutomationMenu, null));
    var $8d512d39a9a2997e$export$2e2bcd8739ae039 = $8d512d39a9a2997e$var$AsyncReleaseAutomationMenu;
});
parcelRegister("hrfsZ", function(module, exports) {
    $parcel$export(module.exports, "AutomationGlyph", ()=>$7a6859ebc905c49b$export$3b6023946faff8bc);
    var $5uXOq = parcelRequire("5uXOq");
    const $7a6859ebc905c49b$export$3b6023946faff8bc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L7 12H17L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }));
});
parcelRegister("8pnTj", function(module, exports) {
    $parcel$export(module.exports, "IconWrapper", ()=>$e5abf0a18ea0d111$export$be58b4326e23250f);
    $parcel$export(module.exports, "default", ()=>$e5abf0a18ea0d111$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jZ4fr;
    var $l1N8i;
    var $5LWLA;
    var $eZUJu;
    var $9UCCQ;
    var $imZsD;
    var $5Fk4Z;
    var $1I7E8;
    var $3bDjY;
    var $hrfsZ;
    var $jJ8Br;
    var $2vSU6;
    var $koVbs;
    var $98HlR;
    var $jNWbA;
    var $1OWKd;
    const $e5abf0a18ea0d111$var$automationIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
        glyph: (0, (0, parcelRequire("hrfsZ")).AutomationGlyph),
        label: ""
    });
    const $e5abf0a18ea0d111$var$AutomationMenuContent = (props)=>{
        const { projectType: projectType } = props;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) ? (0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$var$MenuContentWrapper, {
            "data-testid": "jira-releases-automation-menu.ui.automation-menu-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$var$MenuTitle, null, intl.formatMessage((0, (0, parcelRequire("1OWKd")).default).automationMenuTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$var$MenuSubTitle, null, intl.formatMessage((0, (0, parcelRequire("1OWKd")).default).automationMenuSubTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNWbA")).AutomationMenuTemplateRules), props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("98HlR")).AutomationMenuDeepLinks), {
            includeDiscoverAutomation: false,
            ...props
        })))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("98HlR")).AutomationMenuDeepLinks), {
            includeDiscoverAutomation: true,
            ...props
        });
    };
    const $e5abf0a18ea0d111$export$bf60e24e2fb3b05d = ({ isMenuEnabled: isMenuEnabled, projectProps: projectProps, isOpenByDefault: isOpenByDefault })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isOpenByDefault ?? false);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return isMenuEnabled && projectProps ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).default), {
            blanketIsTinted: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Fk4Z")).default), {
            name: "fusionReleaseAutomationMenu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$var$AutomationMenuContent, {
                    projectKey: projectProps.projectKey,
                    projectType: projectProps.projectType,
                    isSimplifiedProject: projectProps.isSimplifiedProject
                }),
            trigger: ({ ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "data-testid": "jira-releases-automation-menu.ui.automation-button.enabled"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jJ8Br")).default), {
                    ...triggerProps,
                    onClick: ()=>setIsOpen(!isOpen),
                    isSelected: isOpen
                }))
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jZ4fr")).EngagementSpotlight), {
            name: "fusionReleaseAutomationMenu"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$export$be58b4326e23250f, {
            "data-testid": "jira-releases-automation-menu.ui.automation-button.disabled"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: intl.formatMessage((0, (0, parcelRequire("1OWKd")).default).disabledAutomationMenuButtonTooltipMessage)
        }, $e5abf0a18ea0d111$var$automationIcon));
    };
    var $e5abf0a18ea0d111$export$2e2bcd8739ae039 = $e5abf0a18ea0d111$export$bf60e24e2fb3b05d;
    const $e5abf0a18ea0d111$var$MenuTitle = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e5abf0a18ea0d111$var$MenuTitleComponent, props));
    const $e5abf0a18ea0d111$var$MenuContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1kdj",
                __cmplp.className
            ])
        });
    });
    const $e5abf0a18ea0d111$var$MenuSubTitle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1 _1yt41rml",
                __cmplp.className
            ])
        });
    });
    const $e5abf0a18ea0d111$export$be58b4326e23250f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _4t3i1f4h _1bsb1f4h _1bah1h6o _syaz15t7 _ca0q1b66 _d0al13gf",
                __cmplp.className
            ])
        });
    });
    const $e5abf0a18ea0d111$var$MenuTitleComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41jig",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jJ8Br", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff704efab144026a$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $5LWLA;
    var $4ldhu;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $3HwlS;
    var $8zOmE;
    var $22OQR;
    var $dCm1o;
    var $hrfsZ;
    var $eBN2x;
    const $ff704efab144026a$var$MenuButton = (0, $5uXOq.forwardRef)(({ isSelected: isSelected, onClick: onClick }, ref)=>{
        const onClickWithAnalytics = (0, $5uXOq.useCallback)((event, analytics)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analytics, 'automationMenuButton');
            onClick();
        }, [
            onClick
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("eBN2x")).default).menuButtonTooltip),
            position: "top"
        }, (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ref: ref,
            appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? 'default' : 'subtle',
            onClick: onClickWithAnalytics,
            isSelected: isSelected,
            "data-testId": "automation-menu.ui.button.menu-button",
            id: "automation-menu.ui.popup",
            externalId: "automation-menu.ui.button.menu-button",
            "aria-label": formatMessage((0, (0, parcelRequire("eBN2x")).default).menuButtonTooltip),
            "aria-expanded": isSelected,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4ldhu"))))), {
                label: formatMessage((0, (0, parcelRequire("eBN2x")).default).automationsMenuButtonIcon),
                color: "currentColor",
                spacing: "spacious"
            })
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ref: ref,
            appearance: "subtle",
            spacing: "none",
            isSelected: isSelected,
            onClick: onClickWithAnalytics,
            "data-testId": "automation-menu.ui.button.menu-button",
            id: "automation-menu.ui.popup",
            externalId: "automation-menu.ui.button.menu-button",
            "aria-label": formatMessage((0, (0, parcelRequire("eBN2x")).default).menuButtonTooltip),
            "aria-expanded": isSelected,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($ff704efab144026a$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                size: "medium",
                glyph: (0, (0, parcelRequire("hrfsZ")).AutomationGlyph),
                label: formatMessage((0, (0, parcelRequire("eBN2x")).default).automationsMenuButtonIcon),
                primaryColor: isSelected ? `var(--ds-icon-selected, ${(0, $829f609a65d26a98$exports).N20})` : undefined,
                secondaryColor: "none"
            }))
        }));
    });
    var $ff704efab144026a$export$2e2bcd8739ae039 = $ff704efab144026a$var$MenuButton;
    const $ff704efab144026a$var$unselectedColor = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N500})`;
    const $ff704efab144026a$var$unselectedHoverColor = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})`;
    const $ff704efab144026a$var$multiplier = 4;
    const $ff704efab144026a$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_10u62xj": (0, (0, parcelRequire("lD23V")).default)($ff704efab144026a$var$unselectedColor),
                "--_1cs4a84": (0, (0, parcelRequire("lD23V")).default)($ff704efab144026a$var$unselectedHoverColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _syaz296t _30l31hcg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4ldhu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $32936cf628dec798$var$_UNSAFE_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $32936cf628dec798$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $32936cf628dec798$var$AutomationIcon = (props)=>$32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m6 15.25-.723-.2a.75.75 0 0 0 1.253.73zM13.25 8l.53.53a.75.75 0 0 0-.53-1.28zM10 .75l.723.2A.75.75 0 0 0 9.47.22zM2.75 8l-.53-.53a.75.75 0 0 0 .53 1.28zm3.78 7.78 7.25-7.25-1.06-1.06-7.25 7.25zm6.72-8.53H8v1.5h5.25zm-4.527.95 2-7.25-1.446-.4-2 7.25zM9.47.22 2.22 7.47l1.06 1.06 7.25-7.25zM2.75 8.75H8v-1.5H2.75zm4.527-.95-2 7.25 1.446.4 2-7.25z"/>`
        }, props));
    $32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
    var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("22OQR", function(module, exports) {
    $parcel$export(module.exports, "ThemedButton", ()=>$87e6157378e1cf19$export$f67fb575035cc7d0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2rqOp;
    const $87e6157378e1cf19$export$f67fb575035cc7d0 = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
            ...props,
            as: as,
            ref: ref
        })));
    const $87e6157378e1cf19$var$CustomButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2rqOp")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eBN2x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70fd4abbcff5ac1b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $70fd4abbcff5ac1b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        menuButtonTooltip: {
            "id": "automation-menu.button.menu-button-tooltip",
            "defaultMessage": "Automation"
        },
        automationsMenuButtonIcon: {
            "id": "automation-menu.button.automations-menu-button-icon",
            "defaultMessage": "automations-menu-button-icon"
        }
    });
});
parcelRegister("98HlR", function(module, exports) {
    $parcel$export(module.exports, "AutomationMenuDeepLinks", ()=>$fbf4dcc2f12a6c2c$export$fd3c4b1ddf70f790);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $hyEaJ;
    var $9lMrf;
    var $6uqJA;
    var $3Z96c;
    var $eZUJu;
    var $hrfsZ;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $6Wfoj;
    var $bLi0f;
    const $fbf4dcc2f12a6c2c$var$automationIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
        glyph: (0, (0, parcelRequire("hrfsZ")).AutomationGlyph),
        label: ""
    });
    const $fbf4dcc2f12a6c2c$export$fd3c4b1ddf70f790 = ({ isSimplifiedProject: isSimplifiedProject, projectKey: projectKey, projectType: projectType, includeDiscoverAutomation: includeDiscoverAutomation })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "jira-releases-automation-menu.ui.automation-menu-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, includeDiscoverAutomation ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            href: (0, (0, parcelRequire("6Wfoj")).buildDiscoverAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }),
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyEaJ"))))), {
                label: ""
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink'),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("bLi0f")).default).discoverAutomationMenuItemLabel)) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            href: (0, (0, parcelRequire("6Wfoj")).buildManageRulesAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }),
            iconBefore: $fbf4dcc2f12a6c2c$var$automationIcon,
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'manageRulesAutomationLink'),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("bLi0f")).default).manageAutomationMenuItemLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            href: (0, (0, parcelRequire("6Wfoj")).buildNewRuleAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }),
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9lMrf"))))), {
                label: ""
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'newRuleAutomationLink'),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("bLi0f")).default).createAutomationMenuItemLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            href: (0, (0, parcelRequire("6Wfoj")).buildAuditLogAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }),
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6uqJA"))))), {
                label: ""
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'auditLogAutomationLink'),
            UNSAFE_shouldDisableRouterLink: true
        }, formatMessage((0, (0, parcelRequire("bLi0f")).default).auditLogAutomationMenuItemLabel)))));
    };
});
parcelRegister("hyEaJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cc84c60139a91f28$var$_react = $cc84c60139a91f28$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $cc84c60139a91f28$var$_compass = $cc84c60139a91f28$var$_interopRequireDefault((parcelRequire("7ftyG")));
    function $cc84c60139a91f28$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cc84c60139a91f28$var$DiscoverIcon = (props)=>$cc84c60139a91f28$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0 2a9 9 0 1 1 0-18 9 9 0 0 1 0 18"/><path d="m10.86 10.186 3.896-1.948c1.11-.555 1.562-.108 1.005 1.006l-1.948 3.896c-.126.251-.426.55-.673.673l-3.897 1.948c-1.11.556-1.561.11-1.004-1.006l1.947-3.896c.126-.25.426-.55.673-.673M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></g></svg>`
        }, props, {
            newIcon: $cc84c60139a91f28$var$_compass.default
        }));
    $cc84c60139a91f28$var$DiscoverIcon.displayName = 'DiscoverIcon';
    var $cc84c60139a91f28$var$_default = module.exports.default = $cc84c60139a91f28$var$DiscoverIcon;
});
parcelRegister("7ftyG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5470dcd3a4786f26$var$_react = $5470dcd3a4786f26$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5470dcd3a4786f26$var$_UNSAFE_baseNew = $5470dcd3a4786f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5470dcd3a4786f26$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5470dcd3a4786f26$var$CompassIcon = (props)=>$5470dcd3a4786f26$var$_react.default.createElement($5470dcd3a4786f26$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.75 11.25 4.5-2-2.5-2.5z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.25 4.75-4.5 2 2.5 2.5z"/>`
        }, props));
    $5470dcd3a4786f26$var$CompassIcon.displayName = 'CompassIcon';
    var $5470dcd3a4786f26$var$_default = module.exports.default = $5470dcd3a4786f26$var$CompassIcon;
});
parcelRegister("6uqJA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b9a484973717fe2$var$_react = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4b9a484973717fe2$var$_clock = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("hyKRO")));
    function $4b9a484973717fe2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b9a484973717fe2$var$EmojiFrequentIcon = (props)=>$4b9a484973717fe2$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
        }, props, {
            newIcon: $4b9a484973717fe2$var$_clock.default
        }));
    $4b9a484973717fe2$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
    var $4b9a484973717fe2$var$_default = module.exports.default = $4b9a484973717fe2$var$EmojiFrequentIcon;
});
parcelRegister("6Wfoj", function(module, exports) {
    $parcel$export(module.exports, "buildNewRuleAutomationUrl", ()=>$cb0b6e6c85af8509$export$d6be0a6034032add);
    $parcel$export(module.exports, "buildManageRulesAutomationUrl", ()=>$cb0b6e6c85af8509$export$fb714f787469e8b0);
    $parcel$export(module.exports, "buildAuditLogAutomationUrl", ()=>$cb0b6e6c85af8509$export$7d1590b2fb4dd741);
    $parcel$export(module.exports, "buildDiscoverAutomationUrl", ()=>$cb0b6e6c85af8509$export$51ac1eeac37070f8);
    $parcel$export(module.exports, "buildTemplateRuleAutomationUrl", ()=>$cb0b6e6c85af8509$export$82ce8540ef209720);
    var $gOS29;
    const $cb0b6e6c85af8509$export$d6be0a6034032add = (projectProps)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
    const $cb0b6e6c85af8509$export$fb714f787469e8b0 = (projectProps)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#/rule-list`;
    const $cb0b6e6c85af8509$export$7d1590b2fb4dd741 = (projectProps)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#tab/audit-log`;
    const $cb0b6e6c85af8509$export$51ac1eeac37070f8 = (projectProps)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#/tab/rule-library`;
    const $cb0b6e6c85af8509$export$82ce8540ef209720 = (projectProps, templateId)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#/rule/template?templateId=${templateId}`;
});
parcelRegister("bLi0f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3f9241b4c0385fe$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b3f9241b4c0385fe$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        discoverAutomationMenuItemLabel: {
            "id": "software-releases-automation-menu.menu-contents.deep-links.discover-automation-menu-item-label",
            "defaultMessage": "Discover automation"
        },
        manageAutomationMenuItemLabel: {
            "id": "software-releases-automation-menu.menu-contents.deep-links.manage-automation-menu-item-label",
            "defaultMessage": "Manage automation"
        },
        createAutomationMenuItemLabel: {
            "id": "software-releases-automation-menu.menu-contents.deep-links.create-automation-menu-item-label",
            "defaultMessage": "Create automation"
        },
        auditLogAutomationMenuItemLabel: {
            "id": "software-releases-automation-menu.menu-contents.deep-links.audit-log-automation-menu-item-label",
            "defaultMessage": "Audit log"
        }
    });
});
parcelRegister("jNWbA", function(module, exports) {
    $parcel$export(module.exports, "AutomationMenuTemplateRules", ()=>$1ca33d1f3bafacb7$export$35643f531510af9e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5LWLA;
    var $8RBk4;
    var $8sgpE;
    var $29YN9;
    var $3Z96c;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $jTNwC;
    var $j1oLQ;
    var $6Wfoj;
    var $2X0gE;
    const $1ca33d1f3bafacb7$var$jiraIssuesIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8sgpE"))))), {
        size: "medium",
        label: ""
    });
    const $1ca33d1f3bafacb7$var$slackIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
        size: "medium",
        glyph: (0, (0, parcelRequire("j1oLQ")).SlackGlyph),
        label: ""
    });
    const $1ca33d1f3bafacb7$var$launchDarklyGliph = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
        size: "medium",
        glyph: (0, (0, parcelRequire("jTNwC")).LaunchDarklyGlyph),
        label: ""
    });
    const $1ca33d1f3bafacb7$var$ActionAndTriggerIcons = ({ trigger: trigger })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$IconShadow, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29YN9")).JiraIcon), {
            size: "small",
            appearance: "brand"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$IconShadow, null, trigger));
    const $1ca33d1f3bafacb7$export$35643f531510af9e = (props)=>{
        const { isSimplifiedProject: isSimplifiedProject, projectKey: projectKey, projectType: projectType } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            shouldTitleWrap: true,
            href: (0, (0, parcelRequire("6Wfoj")).buildTemplateRuleAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }, 'software_template_14'),
            target: "_blank",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$ActionAndTriggerIcons, {
                trigger: $1ca33d1f3bafacb7$var$jiraIssuesIcon
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'templateRuleAddVersionToInProgressIssue')
        }, formatMessage((0, (0, parcelRequire("2X0gE")).default).templateRuleAddIssueToVersionOnVersionCreate)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            shouldTitleWrap: true,
            href: (0, (0, parcelRequire("6Wfoj")).buildTemplateRuleAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }, 'devops_template_6'),
            target: "_blank",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$ActionAndTriggerIcons, {
                trigger: $1ca33d1f3bafacb7$var$launchDarklyGliph
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'templateRuleCreateLaunchDarklyFlag')
        }, formatMessage((0, (0, parcelRequire("2X0gE")).default).templateRuleCreateLaunchDarklyFlagOnVersionCreate)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            shouldTitleWrap: true,
            href: (0, (0, parcelRequire("6Wfoj")).buildTemplateRuleAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }, 'software_template_12'),
            target: "_blank",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$ActionAndTriggerIcons, {
                trigger: $1ca33d1f3bafacb7$var$slackIcon
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'templateSendSlackMessageOnVersionRelease')
        }, formatMessage((0, (0, parcelRequire("2X0gE")).default).templateRuleSendSlackMessageOnVersionRelease)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            shouldTitleWrap: true,
            href: (0, (0, parcelRequire("6Wfoj")).buildTemplateRuleAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }, 'software_template_13'),
            target: "_blank",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$ActionAndTriggerIcons, {
                trigger: $1ca33d1f3bafacb7$var$slackIcon
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'templateSendSlackMessageOnVersionUnRelease')
        }, formatMessage((0, (0, parcelRequire("2X0gE")).default).templateRuleSendSlackMessageOnVersionUnRelease)), (0, ($parcel$interopDefault($5uXOq))).createElement($1ca33d1f3bafacb7$var$DiscoverAutomationLink, {
            href: (0, (0, parcelRequire("6Wfoj")).buildDiscoverAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplifiedProject
            }),
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'discoverAutomationLink')
        }, formatMessage((0, (0, parcelRequire("2X0gE")).default).discoverMoreAutomationMenuItemLabel)));
    };
    const $1ca33d1f3bafacb7$var$IconShadow = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3izwfg _1bsbzwfg _2rko1y44 _16qszucj _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $1ca33d1f3bafacb7$var$DiscoverAutomationLink = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41nnp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8RBk4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $6740397d4ba98b13$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>$6740397d4ba98b13$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $6740397d4ba98b13$var$_arrowRight.default
        }));
    $6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("jTNwC", function(module, exports) {
    $parcel$export(module.exports, "LaunchDarklyGlyph", ()=>$b864cf68c0dd1dc4$export$f1f691d73572fca1);
    var $5uXOq = parcelRequire("5uXOq");
    const $b864cf68c0dd1dc4$export$f1f691d73572fca1 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            transform: "matrix(0.11111112 0 0 0.11111112 -0 0.058888756)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M109.8 214.94C 107.997055 214.91039 106.35804 213.88696 105.54 212.28C 104.73658 210.72453 104.908226 208.84428 105.98 207.45999L105.98 207.45999L156.47 137.93L68 174.11C 67.40301 174.38016 66.75528 174.51993 66.1 174.52C 64.01144 174.4985 62.179775 173.12071 61.579998 171.12001C 60.985783 169.13066 61.80725 166.99075 63.579998 165.91L63.579998 165.91L141.33 120L4.41 112.13C 1.9438841 111.9687 0.026099205 109.92138 0.026099205 107.45C 0.026099205 104.978615 1.9438841 102.9313 4.41 102.77L4.41 102.77L141.41 94.899994L63.61 49C 61.861492 47.905083 61.065918 45.772614 61.670002 43.8C 62.260277 41.79695 64.09185 40.41616 66.18 40.399998C 66.83458 40.396626 67.482346 40.532997 68.08 40.8L68.08 40.8L156.5 77L106 7.48C 104.93831 6.087954 104.76732 4.210975 105.56 2.65C 106.37893 1.0358694 108.03006 0.013560295 109.84 0C 111.078804 0.0081067085 112.26174 0.516624 113.119995 1.41L113.119995 1.41L213.77 102.05C 216.74506 105.03536 216.74506 109.86465 213.77 112.850006L213.77 112.850006L113.08 213.53C 112.22175 214.42337 111.03882 214.93188 109.8 214.94z",
            stroke: "none",
            fill: "#282828",
            fillRule: "nonzero"
        })));
});
parcelRegister("j1oLQ", function(module, exports) {
    $parcel$export(module.exports, "SlackGlyph", ()=>$0a27994cdc8eb4fb$export$cbfabcc4325ad3ff);
    var $5uXOq = parcelRequire("5uXOq");
    const $0a27994cdc8eb4fb$export$cbfabcc4325ad3ff = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
            fill: "white",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M6.78559 14.3429C6.78559 15.3857 5.94273 16.2286 4.89987 16.2286C3.85702 16.2286 3.01416 15.3857 3.01416 14.3429C3.01416 13.3 3.85702 12.4572 4.89987 12.4572H6.78559V14.3429ZM7.72845 14.3429C7.72845 13.3 8.5713 12.4572 9.61416 12.4572C10.657 12.4572 11.4999 13.3 11.4999 14.3429V19.0572C11.4999 20.1 10.657 20.9429 9.61416 20.9429C8.5713 20.9429 7.72845 20.1 7.72845 19.0572V14.3429Z",
            fill: "#E01E5A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.61429 6.77143C8.57143 6.77143 7.72857 5.92857 7.72857 4.88571C7.72857 3.84286 8.57143 3 9.61429 3C10.6571 3 11.5 3.84286 11.5 4.88571V6.77143H9.61429ZM9.61429 7.72857C10.6571 7.72857 11.5 8.57143 11.5 9.61429C11.5 10.6571 10.6571 11.5 9.61429 11.5H4.88571C3.84286 11.5 3 10.6571 3 9.61429C3 8.57143 3.84286 7.72857 4.88571 7.72857H9.61429Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M17.1713 9.61429C17.1713 8.57143 18.0142 7.72857 19.057 7.72857C20.0999 7.72857 20.9427 8.57143 20.9427 9.61429C20.9427 10.6571 20.0999 11.5 19.057 11.5H17.1713V9.61429ZM16.2285 9.61429C16.2285 10.6571 15.3856 11.5 14.3427 11.5C13.2999 11.5 12.457 10.6571 12.457 9.61429V4.88571C12.457 3.84286 13.2999 3 14.3427 3C15.3856 3 16.2285 3.84286 16.2285 4.88571V9.61429Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14.3427 17.1714C15.3856 17.1714 16.2285 18.0143 16.2285 19.0572C16.2285 20.1 15.3856 20.9429 14.3427 20.9429C13.2999 20.9429 12.457 20.1 12.457 19.0572V17.1714H14.3427ZM14.3427 16.2286C13.2999 16.2286 12.457 15.3857 12.457 14.3429C12.457 13.3 13.2999 12.4572 14.3427 12.4572H19.0713C20.1142 12.4572 20.957 13.3 20.957 14.3429C20.957 15.3857 20.1142 16.2286 19.0713 16.2286H14.3427Z",
            fill: "#ECB22E"
        }));
});
parcelRegister("2X0gE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a203593cf7e2d1db$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a203593cf7e2d1db$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        discoverMoreAutomationMenuItemLabel: {
            "id": "software-releases-automation-menu.menu-contents.template-rules.discover-more-automation-menu-item-label",
            "defaultMessage": "Discover more automation"
        },
        templateRuleAddIssueToVersionOnVersionCreate: {
            "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-add-issue-to-version-on-version-create",
            "defaultMessage": "When a version is created \u2192 then add all In Progress issues without a fix version"
        },
        templateRuleCreateLaunchDarklyFlagOnVersionCreate: {
            "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-create-launch-darkly-flag-on-version-create",
            "defaultMessage": "When a version is created \u2192 then create a LaunchDarkly flag"
        },
        templateRuleSendSlackMessageOnVersionRelease: {
            "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-release",
            "defaultMessage": "When a version is released \u2192 then send a Slack message"
        },
        templateRuleSendSlackMessageOnVersionUnRelease: {
            "id": "software-releases-automation-menu.menu-contents.template-rules.template-rule-send-slack-message-on-version-un-release",
            "defaultMessage": "When a version is unreleased \u2192 then send a Slack message"
        }
    });
});
parcelRegister("1OWKd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55aaaae2e5159e07$export$2e2bcd8739ae039);
    var $7VHMR;
    var $55aaaae2e5159e07$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        disabledAutomationMenuButtonTooltipMessage: {
            "id": "software-releases-automation-menu.disabled-automation-menu-button-tooltip-message",
            "defaultMessage": "You need to be a project admin to configure automation"
        },
        automationMenuTitle: {
            "id": "software-releases-automation-menu.automation-menu-title",
            "defaultMessage": "Automation"
        },
        automationMenuSubTitle: {
            "id": "software-releases-automation-menu.automation-menu-sub-title",
            "defaultMessage": "Setup your release automations from these templates, or create a new one of your own."
        }
    });
});
parcelRegister("7AEEN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bVPvc").then(()=>parcelRequire('4OeKH'));
});
parcelRegister("b4adL", function(module, exports) {
    $parcel$export(module.exports, "useCreateReleaseExperienceStart", ()=>$0ac145f04fdbe2c6$export$137d6976ddfff3f4);
    $parcel$export(module.exports, "useCreateReleaseExperienceFail", ()=>$0ac145f04fdbe2c6$export$aeb23334e467d1ba);
    $parcel$export(module.exports, "useCreateReleaseExperienceSuccess", ()=>$0ac145f04fdbe2c6$export$af6b8a20eaaa829c);
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $0ac145f04fdbe2c6$export$52919046b94109dc = 'createRelease';
    const $0ac145f04fdbe2c6$export$137d6976ddfff3f4 = (analyticsSource)=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: $0ac145f04fdbe2c6$export$52919046b94109dc,
            experienceId: `${Date.now()}`,
            analyticsSource: analyticsSource,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE),
            edition: appEditions.software
        });
    };
    const $0ac145f04fdbe2c6$export$aeb23334e467d1ba = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $0ac145f04fdbe2c6$export$52919046b94109dc
        });
    const $0ac145f04fdbe2c6$export$af6b8a20eaaa829c = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: $0ac145f04fdbe2c6$export$52919046b94109dc
        });
});
parcelRegister("dAgso", function(module, exports) {
    $parcel$export(module.exports, "CreateReleaseModal", ()=>$daec1da43dbea946$export$98347b760d62204c);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $daec1da43dbea946$var$LazyCreateReleaseModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("31Zit")).then((module)=>module.CreateReleaseModal), {
        moduleId: "./src/packages/releases/release-modals-relay/src/ui/create-release-modal/index.tsx"
    });
    const $daec1da43dbea946$export$98347b760d62204c = ({ fallback: fallback = null, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "create-release-modal",
            fallback: fallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($daec1da43dbea946$var$LazyCreateReleaseModal, props));
});
parcelRegister("31Zit", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kvCsM").then(()=>parcelRequire('8ZWi5'));
});
const $6868fc0fce0c2912$export$a181206198b7f50c = 'contains';
const $6868fc0fce0c2912$export$3e8168848b996f7 = 'status';
const $6868fc0fce0c2912$export$71089821f361e881 = 'orderDirection';
const $6868fc0fce0c2912$export$a3482d3a8df0e725 = 'orderField';
const $6868fc0fce0c2912$export$3c5e605ca7ade9f2 = 'NAME';
const $6868fc0fce0c2912$export$50241fe906e4f94e = 'RELEASE_DATE';
const $6868fc0fce0c2912$export$99a467bcc22b8df9 = 'START_DATE';
const $6868fc0fce0c2912$export$d44826c816b5619b = 'DESCRIPTION';
const $6868fc0fce0c2912$export$34694f8d8b23ee2a = 'SEQUENCE';
const $6868fc0fce0c2912$export$cb638d1fae624fbf = 20;
const $6868fc0fce0c2912$export$bbcbc202f2dfa28c = 3;
const $6868fc0fce0c2912$export$b983f2cb1f658a55 = 'RELEASED';
const $6868fc0fce0c2912$export$cb459d726a8530a5 = 'UNRELEASED';
const $6868fc0fce0c2912$export$c936349447a77fe0 = 'ARCHIVED';
const $6868fc0fce0c2912$export$c5ed97509d0e2aaf = 'projectVersions';
parcelRegister("53QJ7", function(module, exports) {
    $parcel$export(module.exports, "ProjectVersionsAnalyticsContextProvider", ()=>$3e5621b3fe25b2a9$export$4f5b37ee904fc1f9);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $dxCvy;
    var $3hGWp;
    var $2YP9W;
    var $e8T8A;
    const $3e5621b3fe25b2a9$var$useAnalyticsCustomAttributes = ()=>{
        const projectContext = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const projectId = projectContext?.data?.projectId || undefined;
        const projectType = projectContext?.data?.projectType || undefined;
        const simplified = projectContext?.data?.simplified || undefined;
        const statusAttributes = $3e5621b3fe25b2a9$var$useFilterAnalytics();
        return {
            projectId: projectId,
            projectType: projectType,
            simplified: simplified,
            ...statusAttributes
        };
    };
    const $3e5621b3fe25b2a9$var$hasStatusSelected = (status, statuses)=>statuses.length === 0 || statuses.some((selectedStatus)=>selectedStatus === status);
    const $3e5621b3fe25b2a9$var$useFilterAnalytics = ()=>{
        const [queryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)((0, $6868fc0fce0c2912$export$3e8168848b996f7));
        const statuses = (0, (0, parcelRequire("e8T8A")).transformStatusFromParam)(queryParams[0, $6868fc0fce0c2912$export$3e8168848b996f7]);
        const searchFilter = queryParams[0, $6868fc0fce0c2912$export$a181206198b7f50c] ?? '';
        return {
            hasReleasedStatusFilter: $3e5621b3fe25b2a9$var$hasStatusSelected('RELEASED', statuses),
            hasUnreleasedStatusFilter: $3e5621b3fe25b2a9$var$hasStatusSelected('UNRELEASED', statuses),
            hasArchivedStatusFilter: $3e5621b3fe25b2a9$var$hasStatusSelected('ARCHIVED', statuses),
            hasSearchFilter: searchFilter.length > 0
        };
    };
    const $3e5621b3fe25b2a9$export$4f5b37ee904fc1f9 = ({ children: children })=>{
        const attributes = $3e5621b3fe25b2a9$var$useAnalyticsCustomAttributes();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                attributes: attributes
            }
        }, children);
    };
});
parcelRegister("4PoCa", function(module, exports) {
    $parcel$export(module.exports, "PerformanceTracker", ()=>$a5527744b0da49b2$export$57a2c9a4973f6a35);
    var $5uXOq = parcelRequire("5uXOq");
    var $dGrdR;
    var $5rqex;
    const $a5527744b0da49b2$export$5de0383686b855d0 = (0, (0, parcelRequire("dGrdR")).metrics).pageLoad({
        key: 'project-versions',
        ssr: {
            doneAsFmp: true
        },
        slo: {
            fmp: {
                initial: {
                    threshold: 1000
                },
                transition: {
                    threshold: 1000
                }
            },
            tti: {
                initial: {
                    threshold: 4000
                },
                transition: {
                    threshold: 4000
                }
            }
        }
    });
    const $a5527744b0da49b2$export$57a2c9a4973f6a35 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            appName: "jira-project-versions",
            metric: $a5527744b0da49b2$export$5de0383686b855d0
        });
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $99gkn;
    var $aOr3t;
    var $1u4q7;
    var $co1wz;
    var $1AZST;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99gkn")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aOr3t")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("1u4q7")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("aOr3t", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$a3e67858f0c2f8da$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$a3e67858f0c2f8da$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1u4q7;
    var $bFU4G;
    function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("1tcYS")).default));
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("bFU4G")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("bFU4G")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $21pfT;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("21pfT")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1tcYS;
    var $1AZST;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("1tcYS")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $1u4q7;
    var $bFU4G;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $1u4q7;
    var $bFU4G;
    var $1AZST;
    var $49z18;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("1AZST")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("49z18")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("bFU4G")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $1u4q7;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("1u4q7")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("acEhA", function(module, exports) {
    $parcel$export(module.exports, "FeedbackButton", ()=>$701bb76a1fee5ba2$export$116fedbe5e2e2bd8);
    var $5uXOq = parcelRequire("5uXOq");
    var $7iULw;
    var $coTzA;
    const $701bb76a1fee5ba2$export$74189cec821240a6 = 'project-pages.project-directories.versions';
    const $701bb76a1fee5ba2$export$116fedbe5e2e2bd8 = ()=>{
        const feedbackContextEntries = [
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                value: $701bb76a1fee5ba2$export$74189cec821240a6
            }
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("coTzA")).FeedbackCollectorButton), {
            entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
            feedbackContext: feedbackContextEntries
        });
    };
});
parcelRegister("coTzA", function(module, exports) {
    $parcel$export(module.exports, "FeedbackCollectorButton", ()=>$85f5e51eda76fbac$export$b39479f42d974760);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $aEHvW;
    var $3bDjY;
    var $koVbs;
    var $koeKL;
    var $7iULw;
    var $dseDh;
    var $4uMrp;
    const $85f5e51eda76fbac$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (appearance === 'icon') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: customLabel || formatMessage((0, (0, parcelRequire("4uMrp")).messages).leaveFeedback),
            position: "top"
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $85f5e51eda76fbac$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, ($parcel$interopDefault((0, parcelRequire("aEHvW"))))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const buttonRef = (0, $5uXOq.useRef)(null);
        const onOpen = (0, $5uXOq.useCallback)(()=>{
            const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, (0, parcelRequire("7iULw")).EntryKeys).CLOUD_ID);
            const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
                ...feedbackCollectorProps.feedbackContext || [],
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).CLOUD_ID,
                    value: cloudId
                }
            ];
            openFeedbackCollector({
                ...feedbackCollectorProps,
                feedbackContext: updatedFeedbackContext,
                triggerRef: buttonRef
            });
        }, [
            cloudId,
            feedbackCollectorProps,
            openFeedbackCollector
        ]);
        const displayAsLink = buttonAppearance === 'link';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$TooltipWrapper, {
            appearance: buttonAppearance,
            customLabel: feedbackButtonCustomLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$StyledButton, {
            testId: testId,
            ref: buttonRef,
            appearance: displayAsLink ? 'link' : 'subtle',
            isHighlight: buttonAppearance === 'highlight',
            spacing: displayAsLink ? 'none' : 'default',
            onClick: onOpen,
            iconBefore: displayAsLink ? undefined : (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
                label: ""
            }),
            "aria-label": buttonAppearance === 'icon' && (feedbackButtonCustomLabel || formatMessage((0, (0, parcelRequire("4uMrp")).messages).leaveFeedback)) || ''
        }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, (0, parcelRequire("4uMrp")).messages).leaveFeedback))));
    };
    const $85f5e51eda76fbac$var$StyledButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isHighlight && "_1w901gqr _16hg1y1p _1fh11gqr _u1mb1hhp _1l5a1gfe _r7sm8kjj",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aEHvW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));
    var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
    function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>$7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
            LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
        }, props));
    $7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
    var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;
});
parcelRegister("5dqGX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3cc2df171aca9493$var$_UNSAFE_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3cc2df171aca9493$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3cc2df171aca9493$var$FeedbackIcon = (props)=>$3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
        }, props));
    $3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;
});
parcelRegister("3g1Fk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
    function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>$25f4287f17f73dc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
        }, props, {
            newIcon: $25f4287f17f73dc4$var$_feedback.default
        }));
    $25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;
});
parcelRegister("4uMrp", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$0c42512912e196d1$export$defe85febe8b728c);
    var $7VHMR;
    const $0c42512912e196d1$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        leaveFeedback: {
            "id": "platform.feedback.feedback-collector.button.leave-feedback",
            "defaultMessage": "Give feedback"
        }
    });
});
parcelRegister("gWAh1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4364330ecbb6442$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $fVnbM;
    var $BLPHT;
    var $jFrow;
    var $2RlqF;
    var $6Ingq;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $3hGWp;
    var $brjCS;
    var $e8T8A;
    var $3O3Ux;
    const $d4364330ecbb6442$var$statusDropdownItems = [
        {
            id: 'released',
            value: (0, (0, parcelRequire("brjCS")).RELEASED),
            label: (0, (0, parcelRequire("3O3Ux")).default).released
        },
        {
            id: 'unreleased',
            value: (0, (0, parcelRequire("brjCS")).UNRELEASED),
            label: (0, (0, parcelRequire("3O3Ux")).default).unreleased
        },
        {
            id: 'archived',
            value: (0, (0, parcelRequire("brjCS")).ARCHIVED),
            label: (0, (0, parcelRequire("3O3Ux")).default).archived
        }
    ];
    const $d4364330ecbb6442$var$StatusFilter = ()=>{
        const [queryParams, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)((0, $6868fc0fce0c2912$export$3e8168848b996f7));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const statuses = (0, (0, parcelRequire("e8T8A")).transformStatusFromParam)(queryParams[0, $6868fc0fce0c2912$export$3e8168848b996f7]);
        const [selectedStatuses, setSelectedStatuses] = (0, $5uXOq.useState)(statuses);
        (0, $5uXOq.useEffect)(()=>{
            setSelectedStatuses((0, (0, parcelRequire("e8T8A")).transformStatusToDropdownSelection)(queryParams[0, $6868fc0fce0c2912$export$3e8168848b996f7]));
        }, [
            queryParams
        ]);
        const handleFilterSelection = (0, ($parcel$interopDefault($lFKmC)))((selectedItem)=>{
            const updatedDisplayedStatuses = (0, (0, parcelRequire("e8T8A")).getUpdatedDisplayedStatuses)(statuses, selectedStatuses, selectedItem);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'itemClicked',
                actionSubject: 'filterDropdown'
            }), 'statusFilterFilterDropdown', {
                type: selectedItem
            });
            setQueryParams({
                [(0, $6868fc0fce0c2912$export$3e8168848b996f7)]: (0, (0, parcelRequire("e8T8A")).transformStatusToParam)(updatedDisplayedStatuses)
            });
        }, 300);
        const getStatusFilterDropdownLabel = ()=>{
            if (selectedStatuses.length === 0 || selectedStatuses.length === $d4364330ecbb6442$var$statusDropdownItems.length) return formatMessage((0, (0, parcelRequire("3O3Ux")).default).all);
            const labels = $d4364330ecbb6442$var$statusDropdownItems.filter((item)=>selectedStatuses.includes(item.value)).map((item)=>formatMessage(item.label));
            return labels.join(', ');
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...props,
                    testId: "project-directories.versions.main.filter.versions-filter.filter-dropdown.button",
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: ""
                    }),
                    ref: triggerRef
                }, getStatusFilterDropdownLabel())
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2RlqF")).default), {
            id: "actions"
        }, $d4364330ecbb6442$var$statusDropdownItems.map((status)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jFrow")).default), {
                id: status.id,
                onClick: ()=>handleFilterSelection(status.value),
                isSelected: selectedStatuses.includes(status.value),
                key: status.value
            }, formatMessage(status.label)))));
    };
    var $d4364330ecbb6442$export$2e2bcd8739ae039 = $d4364330ecbb6442$var$StatusFilter;
});
parcelRegister("jFrow", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d90ebe7a2adf26d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $j7LBE;
    var $kJpBP;
    var $VSDnB;
    var $hEtee;
    var $6PlGW;
    var $l7Q0F;
    var $6cAn5 = parcelRequire("6cAn5");
    const $9d90ebe7a2adf26d$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, (0, parcelRequire("eGmKJ")).default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, ...rest })=>{
        typeof $6cAn5;
        const [selected, setSelected] = (0, (0, parcelRequire("6PlGW")).default)({
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        });
        const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
            setSelected((selected)=>!selected);
            providedOnClick(event);
        }, [
            providedOnClick,
            setSelected
        ]);
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j7LBE")).SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            "aria-checked": selected,
            description: description,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEtee")).default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children));
    };
    var $9d90ebe7a2adf26d$export$2e2bcd8739ae039 = $9d90ebe7a2adf26d$var$DropdownItemCheckbox;
});
parcelRegister("hEtee", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$181f17e87025e1b2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV6Te;
    var $VSDnB;
    const $181f17e87025e1b2$var$CheckboxIcon = ({ checked: checked })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            size: "medium",
            primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
            secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : 'transparent'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2",
            stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
            strokeWidth: 1
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        }))));
    };
    var $181f17e87025e1b2$export$2e2bcd8739ae039 = $181f17e87025e1b2$var$CheckboxIcon;
});
parcelRegister("6PlGW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e2d30248a719600$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5MgQz;
    var $iY6id;
    const $3e2d30248a719600$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
        const { setItemState: setItemState, getItemState: getItemState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iY6id")).SelectionStoreContext));
        const groupId = (0, $5uXOq.useContext)((0, (0, parcelRequire("5MgQz")).CheckboxGroupContext));
        const persistedIsSelected = getItemState(groupId, id);
        const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
        const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
            const nextValue = newValue(persistedIsSelected);
            setLocalIsSelected(nextValue);
            setItemState(groupId, id, nextValue);
        }, [
            setItemState,
            persistedIsSelected,
            groupId,
            id
        ]);
        if (typeof isSelected === 'boolean') return [
            isSelected,
            ()=>false
        ];
        if (persistedIsSelected === undefined) setItemState(groupId, id, defaultSelected || false);
        return [
            localIsSelected,
            setLocalState
        ];
    };
    var $3e2d30248a719600$export$2e2bcd8739ae039 = $3e2d30248a719600$var$useCheckboxState;
});
parcelRegister("5MgQz", function(module, exports) {
    $parcel$export(module.exports, "CheckboxGroupContext", ()=>$155fc86a3d14dca7$export$baf37c4be89255b8);
    var $5uXOq = parcelRequire("5uXOq");
    const $155fc86a3d14dca7$export$baf37c4be89255b8 = (0, $5uXOq.createContext)('');
});
parcelRegister("2RlqF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af961a681c518d6f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    var $5MgQz;
    const $af961a681c518d6f$var$DropdownItemCheckboxGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, overrides: overrides, testId: testId, title: title, ...rest })=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5MgQz")).CheckboxGroupContext).Provider, {
            value: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            overrides: overrides,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children));
    };
    var $af961a681c518d6f$export$2e2bcd8739ae039 = $af961a681c518d6f$var$DropdownItemCheckboxGroup;
});
parcelRegister("3O3Ux", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d7c55239650acd41$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d7c55239650acd41$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unreleased: {
            "id": "project-versions.filter.unreleased",
            "defaultMessage": "Unreleased"
        },
        released: {
            "id": "project-versions.filter.released",
            "defaultMessage": "Released"
        },
        archived: {
            "id": "project-versions.filter.archived",
            "defaultMessage": "Archived"
        },
        all: {
            "id": "project-versions.filter.all",
            "defaultMessage": "All statuses"
        }
    });
});
parcelRegister("6c7j1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3e0003e06d7c66b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e3e0003e06d7c66b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releases: {
            "id": "project-versions.releases",
            "defaultMessage": "Releases"
        },
        createVersionButton: {
            "id": "project-versions.create-version-button",
            "defaultMessage": "Create version"
        },
        successFlagDescription: {
            "id": "project-versions.success-flag-description",
            "defaultMessage": "{name} created."
        }
    });
});
parcelRegister("3Rez0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ddcbd87f8867796$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $5JMh5;
    var $8zOmE;
    var $3hGWp;
    const $6ddcbd87f8867796$var$Search = ()=>{
        const [queryParams, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)((0, $6868fc0fce0c2912$export$a181206198b7f50c));
        const [currentStr, setCurrentStr] = (0, $5uXOq.useState)(queryParams[0, $6868fc0fce0c2912$export$a181206198b7f50c]);
        const handleInputChange = (0, ($parcel$interopDefault($lFKmC)))((searchStr, analyticsEvent)=>{
            setCurrentStr(searchStr);
            setQueryParams({
                [(0, $6868fc0fce0c2912$export$a181206198b7f50c)]: searchStr
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'textFilterFilterSearch', {
                length: searchStr.length
            });
        }, 300);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5JMh5")).default), {
            onChange: handleInputChange,
            value: currentStr || '',
            isAlwaysExpanded: true
        });
    };
    var $6ddcbd87f8867796$export$2e2bcd8739ae039 = $6ddcbd87f8867796$var$Search;
});
parcelRegister("5JMh5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c6c98eab5c64edc$export$2e2bcd8739ae039);
    var $8oe80;
    var $3as6V;
    var $1c6c98eab5c64edc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('filterSearch', {
        onChange: 'changed'
    })((0, (0, parcelRequire("3as6V")).default));
});
parcelRegister("3as6V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$466d610aa4e058b2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $2xSAL;
    var $dCm1o;
    const $466d610aa4e058b2$export$4c4c11a6ab1f5b09 = 1000;
    const $466d610aa4e058b2$var$debouncedSearch = (0, ($parcel$interopDefault($lFKmC)))((value, callback)=>callback(value), $466d610aa4e058b2$export$4c4c11a6ab1f5b09);
    class $466d610aa4e058b2$var$Filter extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                value: '',
                placeholder: '',
                describedById: '',
                hasAutoFocus: false,
                isCompact: true,
                increasedWidth: false,
                placeholderAlwaysVisible: false
            };
        }
        getSearchValue(value) {
            const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
            if (value !== this.prevSearchValue) {
                this.prevSearchValue = value;
                this.prevQueryValue = value;
            }
            return searchValue;
        }
        render() {
            const searchValue = this.getSearchValue(this.props.value);
            const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2xSAL")).SearchField), {
                ...props,
                autoFocus: autoFocus,
                value: searchValue,
                onChange: this.handleOnChange,
                onEnter: this.handleNewValue,
                ariaLabelText: ariaLabelText,
                showIconBeforeInput: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
            });
        }
        constructor(...args){
            super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
                $466d610aa4e058b2$var$debouncedSearch.cancel();
                if (newValue !== this.props.value) this.props.onChange(newValue);
            }, this.handleOnChange = (newValue)=>{
                this.prevQueryValue = newValue;
                newValue === '' ? this.handleNewValue(newValue) : $466d610aa4e058b2$var$debouncedSearch(newValue, this.handleNewValue);
            };
        }
    }
    var $466d610aa4e058b2$export$2e2bcd8739ae039 = $466d610aa4e058b2$var$Filter;
});
parcelRegister("2xSAL", function(module, exports) {
    $parcel$export(module.exports, "SearchField", ()=>$f115db1c327fbbaa$export$b94867ecbd698f21);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $fW62l = parcelRequire("fW62l");
    var $2NMNM;
    var $kY99m;
    var $koVbs;
    var $dCm1o;
    var $cBssJ;
    var $hJBhl;
    var $5yLnO;
    const $f115db1c327fbbaa$var$className = 'ajs-dirty-warning-exempt';
    const $f115db1c327fbbaa$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
        const [value, setValue] = (0, $5uXOq.useState)(externalValue || '');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const textInput = (0, $5uXOq.useRef)(null);
        const previousValueRef = (0, $5uXOq.useRef)();
        const previousValue = previousValueRef.current;
        if (externalValue !== previousValue && externalValue !== value) setValue(externalValue);
        previousValueRef.current = externalValue;
        const handleOnFocus = (0, $5uXOq.useCallback)((event)=>{
            setIsFocused(true);
            onFocus && onFocus(event);
        }, [
            onFocus
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur && onBlur(event);
            setIsFocused(false);
        }, [
            onBlur
        ]);
        const handleOnChange = (0, $5uXOq.useCallback)(({ currentTarget: currentTarget })=>{
            const { value: val } = currentTarget;
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue(val);
            onChange(val, analyticsEvent);
        }, [
            createAnalyticsEvent,
            onChange
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            if (event.key === 'Escape') {
                setValue('');
                onChange('', analyticsEvent);
            }
            if (onEnter && event.keyCode === (0, ($parcel$interopDefault($fW62l)))('enter')) {
                event.preventDefault();
                onEnter(event.currentTarget && event.currentTarget.value);
            }
        }, [
            createAnalyticsEvent,
            onChange,
            onEnter
        ]);
        const handleOnClear = (0, $5uXOq.useCallback)(()=>{
            if (value !== '') {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed'
                });
                setValue('');
                onChange('', analyticsEvent);
            }
            if (inputRef && inputRef.current !== null) inputRef.current.blur();
            if (textInput.current !== null) textInput.current.blur();
        }, [
            createAnalyticsEvent,
            inputRef,
            onChange,
            value
        ]);
        const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
        const textFieldProps = {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, (0, parcelRequire("cBssJ")).messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $f115db1c327fbbaa$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
        const searchIconDynamic = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIconDynamic), {
            onClear: handleOnClear,
            hasValue: value !== '',
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear),
            searchIconVisible: searchIconVisible,
            primaryColor: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
            onlyIconSpacing: isResponsive && !isExpanded
        });
        const searchIcon = showIconBeforeInput ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5yLnO")).SearchFieldIcon), {
            searchIconVisible: searchIconVisible,
            onlyIconSpacing: isResponsive && !isExpanded
        }) : undefined;
        const clearIcon = showIconBeforeInput && value !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJBhl")).ClearFieldIcon), {
            onClear: handleOnClear,
            clearIconLabel: formatMessage((0, (0, parcelRequire("cBssJ")).messages).clear)
        }) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$Container, {
            shouldFitContainerWidth: shouldFitContainerWidth
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f115db1c327fbbaa$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            increasedWidth: increasedWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ...textFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {}
        })));
    };
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.displayName = 'Search';
    $f115db1c327fbbaa$var$SearchFieldUnmemoized.whyDidYouRender = true;
    const $f115db1c327fbbaa$export$b94867ecbd698f21 = (0, $5uXOq.memo)($f115db1c327fbbaa$var$SearchFieldUnmemoized);
    $f115db1c327fbbaa$export$b94867ecbd698f21.displayName = 'Search';
    const $f115db1c327fbbaa$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.shouldFitContainerWidth && "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $f115db1c327fbbaa$var$InputWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1et2rhb": (0, (0, parcelRequire("lD23V")).default)(__cmplp.maxWidth, "px"),
                "--_47juog": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
                "--_5cv8rq": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : '32px'),
                "--_jy5l88": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
                "--_1skyi4s": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 'auto' : 0),
                "--_1qenfck": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? 1 : 0),
                "--_1b7586u": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
                "--_1b72lxu": (0, (0, parcelRequire("lD23V")).default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
                __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
                __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fW62l", function(module, exports) {
    function keyCode(searchInput) {
        if (searchInput && 'object' === typeof searchInput) {
            var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
            if (hasKeyCode) searchInput = hasKeyCode;
        }
        if ('number' === typeof searchInput) return names[searchInput];
        var search = String(searchInput);
        var foundNamedKey = codes[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        var foundNamedKey = aliases[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        if (search.length === 1) return search.charCodeAt(0);
        return undefined;
    }
    keyCode.isEventKey = function isEventKey(event, nameOrCode) {
        if (event && 'object' === typeof event) {
            var keyCode = event.which || event.keyCode || event.charCode;
            if (keyCode === null || keyCode === undefined) return false;
            if (typeof nameOrCode === 'string') {
                var foundNamedKey = codes[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
                var foundNamedKey = aliases[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
            } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
            return false;
        }
    };
    exports = module.exports = keyCode;
    var codes = exports.code = exports.codes = {
        'backspace': 8,
        'tab': 9,
        'enter': 13,
        'shift': 16,
        'ctrl': 17,
        'alt': 18,
        'pause/break': 19,
        'caps lock': 20,
        'esc': 27,
        'space': 32,
        'page up': 33,
        'page down': 34,
        'end': 35,
        'home': 36,
        'left': 37,
        'up': 38,
        'right': 39,
        'down': 40,
        'insert': 45,
        'delete': 46,
        'command': 91,
        'left command': 91,
        'right command': 93,
        'numpad *': 106,
        'numpad +': 107,
        'numpad -': 109,
        'numpad .': 110,
        'numpad /': 111,
        'num lock': 144,
        'scroll lock': 145,
        'my computer': 182,
        'my calculator': 183,
        ';': 186,
        '=': 187,
        ',': 188,
        '-': 189,
        '.': 190,
        '/': 191,
        '`': 192,
        '[': 219,
        '\\': 220,
        ']': 221,
        "'": 222
    };
    var aliases = exports.aliases = {
        'windows': 91,
        "\u21E7": 16,
        "\u2325": 18,
        "\u2303": 17,
        "\u2318": 91,
        'ctl': 17,
        'control': 17,
        'option': 18,
        'pause': 19,
        'break': 19,
        'caps': 20,
        'return': 13,
        'escape': 27,
        'spc': 32,
        'spacebar': 32,
        'pgup': 33,
        'pgdn': 34,
        'ins': 45,
        'del': 46,
        'cmd': 91
    };
    for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
    for(var i = 48; i < 58; i++)codes[i - 48] = i;
    for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
    for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
    var names = exports.names = exports.title = {};
    for(i in codes)names[codes[i]] = i;
    for(var alias in aliases)codes[alias] = aliases[alias];
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("cBssJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$08273d4fc2a6d6da$export$defe85febe8b728c);
    var $7VHMR;
    const $08273d4fc2a6d6da$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clear: {
            "id": "searchfield.clear",
            "defaultMessage": "Clear"
        },
        search: {
            "id": "searchfield.search",
            "defaultMessage": "Search"
        }
    });
});
parcelRegister("hJBhl", function(module, exports) {
    $parcel$export(module.exports, "ClearFieldIcon", ()=>$99940a7c159b00c0$export$84038b503874befa);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $i28qQ;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $99940a7c159b00c0$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $99940a7c159b00c0$var$wrapperStylesCloseIcon
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            testId: "searchfield.ui.clearfield-icon.clear-button",
            onClick: onClear,
            label: clearIconLabel,
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ")))))
        }));
    const $99940a7c159b00c0$var$wrapperStylesCloseIcon = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.025',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.050'
        }
    });
});
parcelRegister("5yLnO", function(module, exports) {
    $parcel$export(module.exports, "SearchFieldIconDynamic", ()=>$71cc18983db63a0d$export$9eef03e91cdeba14);
    $parcel$export(module.exports, "SearchFieldIcon", ()=>$71cc18983db63a0d$export$8a82bff895521bd9);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $84THj;
    var $26g7Y;
    var $hyOJh;
    var $dC5iT;
    var $h9kUS;
    var $8CUq3;
    const $71cc18983db63a0d$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
        const akSearchIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("26g7Y"))))), {
            LEGACY_size: "small",
            label: "",
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        });
        const searchIcon = searchIconVisible ? akSearchIcon : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStyles,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStyles
            ]
        }, hasValue ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
            testId: "searchfield.ui.searchfield-icon.clear-button",
            onClick: onClear,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                LEGACY_size: "small",
                label: clearIconLabel,
                LEGACY_primaryColor: primaryColor,
                color: "currentColor"
            })
        }) : searchIcon);
    };
    const $71cc18983db63a0d$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $71cc18983db63a0d$var$wrapperStylesBefore,
                onlyIconSpacing && $71cc18983db63a0d$var$spacingStylesBefore
            ]
        }, searchIconVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hyOJh"))))), {
            spacing: "none",
            label: "",
            color: "var(--ds-icon, #44546F)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null));
    const $71cc18983db63a0d$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.accent.gray',
        marginTop: 'space.0',
        marginRight: 'space.100',
        marginBottom: 'space.0',
        marginLeft: 'space.0',
        height: '16px',
        display: 'flex'
    });
    const $71cc18983db63a0d$var$spacingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginRight: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$wrapperStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        marginRight: 'space.0',
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
    const $71cc18983db63a0d$var$spacingStylesBefore = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075',
        [(0, (0, parcelRequire("h9kUS")).media).above.md]: {
            marginLeft: 'space.100'
        }
    });
});
parcelRegister("ej3oB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fab0bbe0d00b9f7$export$2e2bcd8739ae039);
    var $iZnI0;
    var $g8xd8;
    var $6ZyZ4;
    var $k45mR;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $2rqOp;
    var $dHbUn;
    var $lj8SI;
    var $f5TWP;
    var $39xOx;
    var $koVbs;
    var $1othz;
    var $8zOmE;
    var $2NMNM;
    var $80WiC;
    var $dxCvy;
    var $3hGWp;
    var $koeKL;
    var $itmJb;
    var $2YP9W;
    var $e8T8A;
    var $82JA4;
    var $ht8dz;
    var $iJQI5;
    var $4hdHc;
    var $MIIU8;
    var $3uVZB;
    var $kKyOF;
    const $0fab0bbe0d00b9f7$var$VersionFetchAnalytics = ({ isLoading: isLoading })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isLoading) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'versions fetched');
        }, [
            isLoading,
            createAnalyticsEvent
        ]);
        return null;
    };
    const $0fab0bbe0d00b9f7$var$Table = ({ query: query })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [queryParams, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)((0, $6868fc0fce0c2912$export$a181206198b7f50c), (0, $6868fc0fce0c2912$export$3e8168848b996f7), (0, $6868fc0fce0c2912$export$71089821f361e881), (0, $6868fc0fce0c2912$export$a3482d3a8df0e725));
        const { data: data, hasNext: hasNext, loadNext: loadNext, isLoadingNext: isLoadingNext, refetch: refetch } = (0, $8Uumt.usePaginationFragment)((0, (0, parcelRequire("k45mR")).default), query);
        const connectionId = data?.jira.jiraProjectByKey.versions.__id;
        const [updateVersionPosition] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("6ZyZ4")).default));
        const [moveVersionToStart] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("g8xd8")).default));
        const [moveVersionToEnd] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("iZnI0")).default));
        const currentProjectKey = data.jira.jiraProjectByKey.key;
        const totalCount = data?.jira?.jiraProjectByKey?.versions.totalCount || 0;
        const versions = (data?.jira?.jiraProjectByKey?.versions?.edges ?? []).filter(Boolean).map((edge)=>edge.node).filter(Boolean);
        const { formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectContext = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const isProjectAdmin = projectContext?.data?.isProjectAdmin || false;
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isTableRankable = isProjectAdmin || isAdmin;
        const canAtleastOneVersionQuickRelease = ()=>versions.some((version)=>version.status === (0, $6868fc0fce0c2912$export$cb459d726a8530a5) && version.allIssues?.totalCount && version.allIssues?.totalCount === version.doneIssues?.totalCount);
        const onSortUpdateQueryParams = (field, direction)=>{
            setQueryParams({
                [(0, $6868fc0fce0c2912$export$a3482d3a8df0e725)]: field,
                [(0, $6868fc0fce0c2912$export$71089821f361e881)]: direction
            });
        };
        const [suspenselessRefetch, isLoading] = (0, (0, parcelRequire("1othz")).useSuspenselessRefetch)((0, (0, parcelRequire("80WiC")).default), refetch, {
            fetchPolicy: 'network-only'
        });
        const isFirstRenderRef = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>{
            if (isFirstRenderRef.current) isFirstRenderRef.current = false;
            else suspenselessRefetch({
                searchString: queryParams[0, $6868fc0fce0c2912$export$a181206198b7f50c],
                filter: (0, (0, parcelRequire("e8T8A")).transformStatusFromParam)(queryParams[0, $6868fc0fce0c2912$export$3e8168848b996f7]),
                cloudId: cloudId,
                projectKey: currentProjectKey,
                sortBy: {
                    sortByField: (0, (0, parcelRequire("e8T8A")).transformSortFieldFromParam)(queryParams[0, $6868fc0fce0c2912$export$a3482d3a8df0e725]),
                    order: (0, (0, parcelRequire("e8T8A")).transformSortOrderFromParam)(queryParams[0, $6868fc0fce0c2912$export$71089821f361e881])
                }
            });
        }, [
            cloudId,
            currentProjectKey,
            queryParams,
            suspenselessRefetch
        ]);
        const head = {
            cells: [
                {
                    key: 'NAME',
                    content: 'Version',
                    isSortable: true,
                    width: 18
                },
                {
                    key: 'STATUS',
                    content: 'Status',
                    width: 10
                },
                {
                    key: 'PROGRESS',
                    content: 'Progress',
                    width: 18
                },
                {
                    key: 'STARTDATE',
                    content: 'Start date',
                    isSortable: true,
                    width: 10
                },
                {
                    key: 'RELEASEDATE',
                    content: 'Release date',
                    isSortable: true,
                    width: 10
                },
                {
                    key: 'DESCRIPTION',
                    content: 'Description',
                    isSortable: true
                },
                {
                    key: 'ACTIONS',
                    content: '',
                    isSortable: false,
                    width: canAtleastOneVersionQuickRelease() ? 13 : 5
                }
            ]
        };
        const handleRankEnd = (rankEnd)=>{
            if (totalCount === 1) return;
            const { sourceKey: sourceKey, destination: destination } = rankEnd;
            if (destination == null) return;
            const { afterKey: afterKey, beforeKey: beforeKey } = destination;
            const updateStoreParams = {
                connectionId: connectionId,
                sourceVersionAri: sourceKey
            };
            if (afterKey === undefined) {
                moveVersionToEnd({
                    variables: {
                        input: {
                            id: sourceKey
                        }
                    },
                    optimisticUpdater: (store)=>(0, (0, parcelRequire("kKyOF")).updateStoreOnMove)({
                            ...updateStoreParams,
                            store: store,
                            operationType: 'move-to-end'
                        }),
                    updater: (store)=>(0, (0, parcelRequire("kKyOF")).updateStoreOnMove)({
                            ...updateStoreParams,
                            store: store,
                            operationType: 'move-to-end'
                        })
                });
                return;
            }
            if (beforeKey === undefined) moveVersionToStart({
                variables: {
                    input: {
                        id: sourceKey
                    }
                },
                optimisticUpdater: (store)=>(0, (0, parcelRequire("kKyOF")).updateStoreOnMove)({
                        ...updateStoreParams,
                        store: store,
                        operationType: 'move-to-start'
                    }),
                updater: (store)=>(0, (0, parcelRequire("kKyOF")).updateStoreOnMove)({
                        ...updateStoreParams,
                        store: store,
                        operationType: 'move-to-start'
                    })
            });
            else updateVersionPosition({
                variables: {
                    input: {
                        id: sourceKey,
                        afterVersionId: beforeKey
                    }
                },
                optimisticUpdater: (store)=>(0, (0, parcelRequire("kKyOF")).updateStoreOnMove)({
                        ...updateStoreParams,
                        store: store,
                        operationType: 'move-position',
                        beforeVersionAri: beforeKey
                    }),
                updater: (store)=>(0, (0, parcelRequire("kKyOF")).updateStoreOnMove)({
                        ...updateStoreParams,
                        store: store,
                        operationType: 'move-position',
                        beforeVersionAri: beforeKey
                    })
            });
        };
        const getAppearanceFromStatus = (status)=>{
            let appearance;
            switch(status){
                case 0, $6868fc0fce0c2912$export$b983f2cb1f658a55:
                    appearance = 'success';
                    break;
                case 0, $6868fc0fce0c2912$export$cb459d726a8530a5:
                    appearance = 'inprogress';
                    break;
                case 0, $6868fc0fce0c2912$export$c936349447a77fe0:
                default:
                    appearance = 'default';
            }
            return appearance;
        };
        const rows = ()=>data?.jira?.jiraProjectByKey.versions?.edges?.map((edge)=>edge?.node).filter(Boolean).map((node)=>{
                const cells = [
                    {
                        key: 'NAME',
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hdHc")).default), {
                            jiraVersion: node,
                            jiraProject: data?.jira?.jiraProjectByKey
                        })
                    },
                    {
                        key: 'STATUS',
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                            appearance: getAppearanceFromStatus(node?.status)
                        }, node?.status)
                    },
                    {
                        key: 'PROGRESS',
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                            fallback: "unmount",
                            packageName: "jiraProjectVersions",
                            teamName: "fusion-solaris",
                            id: "releasesVersionProgressBar"
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("MIIU8")).default), {
                            query: node
                        }))
                    },
                    {
                        key: 'STARTDATE',
                        content: node?.startDate ? (0, (0, parcelRequire("e8T8A")).getFormattedVersionDate)(node?.startDate, formatDate) : null
                    },
                    {
                        key: 'RELEASEDATE',
                        content: node?.releaseDate ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uVZB")).ReleaseDateCell), {
                            releaseDate: node?.releaseDate,
                            overdue: !!node?.overdue
                        }) : null
                    },
                    {
                        key: 'DESCRIPTION',
                        content: node?.description
                    }
                ];
                const adminCells = isAdmin || isProjectAdmin ? [
                    {
                        key: 'actions',
                        content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                            fallback: "unmount",
                            packageName: "jiraProjectVersions",
                            teamName: "fusion-solaris",
                            id: "releasesActionsMenu"
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("82JA4")).default), {
                            jiraVersion: node,
                            jiraProject: data?.jira.jiraProjectByKey,
                            showSpinner: isLoading,
                            connectionId: connectionId
                        }))
                    }
                ] : [];
                return {
                    key: node.id,
                    cells: [
                        ...cells,
                        ...adminCells
                    ]
                };
            });
        const loadedVersionCount = rows?.length || 0;
        const numVersionsToPaginateIn = Math.min((0, $6868fc0fce0c2912$export$cb638d1fae624fbf), Math.max(0, totalCount - loadedVersionCount));
        const orderField = queryParams[0, $6868fc0fce0c2912$export$a3482d3a8df0e725];
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "project-directories.versions.main.table.table-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dHbUn")).default), {
            head: head,
            rows: rows(),
            loadingSpinnerSize: "large",
            isRankable: isTableRankable,
            onRankEnd: handleRankEnd,
            isLoading: isLoading,
            isFixedSize: true,
            onSort: (e)=>{
                onSortUpdateQueryParams(e.key, e.sortOrder);
            },
            sortKey: orderField !== 'RANK' ? orderField : undefined,
            sortOrder: (0, (0, parcelRequire("e8T8A")).transformSortOrderFromParam)(queryParams[0, $6868fc0fce0c2912$export$71089821f361e881]),
            emptyView: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ht8dz")).default), {
                statusFilter: (0, (0, parcelRequire("e8T8A")).transformStatusFromParam)(queryParams[0, $6868fc0fce0c2912$export$3e8168848b996f7]),
                searchFilter: queryParams[0, $6868fc0fce0c2912$export$a181206198b7f50c]
            })
        }), hasNext && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignInline: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            isLoading: isLoadingNext,
            onClick: (_e, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'showMoreButton');
                loadNext(numVersionsToPaginateIn);
            }
        }, formatMessage((0, (0, parcelRequire("iJQI5")).default).showMore, {
            count: numVersionsToPaginateIn
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement($0fab0bbe0d00b9f7$var$VersionFetchAnalytics, {
            isLoading: isLoading
        }));
    };
    var $0fab0bbe0d00b9f7$export$2e2bcd8739ae039 = $0fab0bbe0d00b9f7$var$Table;
});
parcelRegister("iZnI0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97430d69a1590c2d$export$2e2bcd8739ae039);
    const $97430d69a1590c2d$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "input"
                            }
                        ],
                        "concreteType": "JiraUpdateVersionPayload",
                        "kind": "LinkedField",
                        "name": "moveJiraVersionToEnd",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "success"
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "table_moveVersionToEndMutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "table_moveVersionToEndMutation",
                "selections": v1
            },
            "params": {
                "id": "59a84b940089ef439c94bc268f68bb3456ce8acf0dbabbcd0e2403aeaa627bc2",
                "metadata": {},
                "name": "table_moveVersionToEndMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $97430d69a1590c2d$var$node.hash = "245d2bb9c0de6e4e57289b64dc0c5201";
    var $97430d69a1590c2d$export$2e2bcd8739ae039 = $97430d69a1590c2d$var$node;
});
parcelRegister("g8xd8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29a98a6eafb16e5b$export$2e2bcd8739ae039);
    const $29a98a6eafb16e5b$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "input"
                            }
                        ],
                        "concreteType": "JiraUpdateVersionPayload",
                        "kind": "LinkedField",
                        "name": "moveJiraVersionToStart",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "success"
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "table_moveVersionToStartMutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "table_moveVersionToStartMutation",
                "selections": v1
            },
            "params": {
                "id": "b35ac2c9fb6cf1ee425dc5e7f3398eec80f51f8cc50e9d8213ade874f62c00a1",
                "metadata": {},
                "name": "table_moveVersionToStartMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $29a98a6eafb16e5b$var$node.hash = "77939c4fcd78faef0ac2c9e07c8398a6";
    var $29a98a6eafb16e5b$export$2e2bcd8739ae039 = $29a98a6eafb16e5b$var$node;
});
parcelRegister("6ZyZ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18cd17b26224c125$export$2e2bcd8739ae039);
    const $18cd17b26224c125$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "input"
                            }
                        ],
                        "concreteType": "JiraUpdateVersionPayload",
                        "kind": "LinkedField",
                        "name": "updateJiraVersionPosition",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "success"
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "table_updateJiraVersionPositionMutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "table_updateJiraVersionPositionMutation",
                "selections": v1
            },
            "params": {
                "id": "15ad5ee8e61447c764ac80e10cc756df9689df6c4dadb969daa52a50669e5642",
                "metadata": {},
                "name": "table_updateJiraVersionPositionMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $18cd17b26224c125$var$node.hash = "28f8db8e730d8adacf8286693c281f13";
    var $18cd17b26224c125$export$2e2bcd8739ae039 = $18cd17b26224c125$var$node;
});
parcelRegister("k45mR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7995c34764356565$export$2e2bcd8739ae039);
    var $80WiC;
    const $7995c34764356565$var$node = function() {
        var v0 = [
            "jira",
            "jiraProjectByKey",
            "versions"
        ], v1 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v2 = [
            v1
        ];
        return {
            "argumentDefinitions": [
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "after"
                },
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                },
                {
                    "defaultValue": [
                        "UNRELEASED"
                    ],
                    "kind": "LocalArgument",
                    "name": "filter"
                },
                {
                    "defaultValue": 20,
                    "kind": "LocalArgument",
                    "name": "first"
                },
                {
                    "kind": "RootArgument",
                    "name": "projectKey"
                },
                {
                    "defaultValue": "",
                    "kind": "LocalArgument",
                    "name": "searchString"
                },
                {
                    "defaultValue": {
                        "order": "DESC",
                        "sortByField": "SEQUENCE"
                    },
                    "kind": "LocalArgument",
                    "name": "sortBy"
                }
            ],
            "kind": "Fragment",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": v0
                    }
                ],
                "refetch": {
                    "connection": {
                        "forward": {
                            "count": "first",
                            "cursor": "after"
                        },
                        "backward": null,
                        "path": v0
                    },
                    "fragmentPathInResult": [],
                    "operation": (0, (0, parcelRequire("80WiC")).default)
                }
            },
            "name": "table_projectVersions",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "key",
                                            "variableName": "projectKey"
                                        }
                                    ],
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.key"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "name_projectVersions_NameCell_jiraProject"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "actions_projectVersions_ActionsCell_jiraProject"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "alias": "versions",
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "filter",
                                                        "variableName": "filter"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "searchString",
                                                        "variableName": "searchString"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "sortBy",
                                                        "variableName": "sortBy"
                                                    }
                                                ],
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "__uiProject__versions_connection",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v1,
                                                        "action": "THROW",
                                                        "path": "jira.jiraProjectByKey.versions.totalCount"
                                                    },
                                                    {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraVersion",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "id"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "status"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "description"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "startDate"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "releaseDate"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "overdue"
                                                                    },
                                                                    {
                                                                        "alias": "allIssues",
                                                                        "args": [
                                                                            {
                                                                                "kind": "Literal",
                                                                                "name": "filter",
                                                                                "value": "ALL"
                                                                            }
                                                                        ],
                                                                        "concreteType": "JiraIssueConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "issues",
                                                                        "plural": false,
                                                                        "selections": v2,
                                                                        "storageKey": "issues(filter:\"ALL\")"
                                                                    },
                                                                    {
                                                                        "alias": "doneIssues",
                                                                        "args": [
                                                                            {
                                                                                "kind": "Literal",
                                                                                "name": "filter",
                                                                                "value": "DONE"
                                                                            }
                                                                        ],
                                                                        "concreteType": "JiraIssueConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "issues",
                                                                        "plural": false,
                                                                        "selections": v2,
                                                                        "storageKey": "issues(filter:\"DONE\")"
                                                                    },
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": "progressBar_projectVersions_VersionProgress"
                                                                    },
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": "name_projectVersions_NameCell_jiraVersion"
                                                                    },
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": "actions_projectVersions_ActionsCell_jiraVersion"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__typename"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "cursor"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "PageInfo",
                                                        "kind": "LinkedField",
                                                        "name": "pageInfo",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "endCursor"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasNextPage"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.jiraProjectByKey.versions.__id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.versions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        };
    }();
    $7995c34764356565$var$node.hash = "bba34f786d5ff0333b47fa58a1df630e";
    var $7995c34764356565$export$2e2bcd8739ae039 = $7995c34764356565$var$node;
});
parcelRegister("80WiC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$883cf436f3256309$export$2e2bcd8739ae039);
    const $883cf436f3256309$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": [
                    "UNRELEASED"
                ],
                "kind": "LocalArgument",
                "name": "filter"
            },
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "first"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "searchString"
            },
            {
                "defaultValue": {
                    "order": "DESC",
                    "sortByField": "SEQUENCE"
                },
                "kind": "LocalArgument",
                "name": "sortBy"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "after",
                "variableName": "after"
            },
            {
                "kind": "Variable",
                "name": "filter",
                "variableName": "filter"
            },
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            },
            {
                "kind": "Variable",
                "name": "searchString",
                "variableName": "searchString"
            },
            {
                "kind": "Variable",
                "name": "sortBy",
                "variableName": "sortBy"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v4 = [
            v3
        ], v5 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": "DONE"
            }
        ], v6 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "projectVersion_PaginationQuery",
                "selections": [
                    {
                        "args": v1,
                        "kind": "FragmentSpread",
                        "name": "table_projectVersions"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "projectVersion_PaginationQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "key",
                                        "variableName": "projectKey"
                                    }
                                ],
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectType"
                                    },
                                    v2,
                                    {
                                        "args": v1,
                                        "concreteType": "JiraVersionConnection",
                                        "kind": "LinkedField",
                                        "name": "versions",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v2,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "status"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "description"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "startDate"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "releaseDate"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "overdue"
                                                            },
                                                            {
                                                                "alias": "allIssues",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "ALL"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v4,
                                                                "storageKey": "issues(filter:\"ALL\")"
                                                            },
                                                            {
                                                                "alias": "doneIssues",
                                                                "args": v5,
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v4,
                                                                "storageKey": "issues(filter:\"DONE\")"
                                                            },
                                                            {
                                                                "alias": "done",
                                                                "args": v5,
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v4,
                                                                "storageKey": "issues(filter:\"DONE\")"
                                                            },
                                                            {
                                                                "alias": "inProgress",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "IN_PROGRESS"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v4,
                                                                "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                            },
                                                            {
                                                                "alias": "toDo",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "TODO"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v4,
                                                                "storageKey": "issues(filter:\"TODO\")"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "versionId"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "name"
                                                            },
                                                            v6,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__typename"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "cursor"
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "endCursor"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            },
                                            v6
                                        ]
                                    },
                                    {
                                        "args": v1,
                                        "filters": [
                                            "filter",
                                            "searchString",
                                            "sortBy"
                                        ],
                                        "handle": "connection",
                                        "key": "uiProject__versions",
                                        "kind": "LinkedHandle",
                                        "name": "versions"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "91f523ff6840e4cbb8190e660c2de8e0ff16c6c638da6b83b76da3432138aeb7",
                "metadata": {},
                "name": "projectVersion_PaginationQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $883cf436f3256309$var$node.hash = "bba34f786d5ff0333b47fa58a1df630e";
    var $883cf436f3256309$export$2e2bcd8739ae039 = $883cf436f3256309$var$node;
});
parcelRegister("dHbUn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb6422faa785b221$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $gS5Cm;
    var $hiWL0;
    var $kF3yx;
    var $fkvnY;
    var $hK8cd;
    var $dDBI6;
    var $dk72m;
    var $50Tma;
    var $jlnvO;
    function $cb6422faa785b221$var$toggleSortOrder(currentSortOrder) {
        switch(currentSortOrder){
            case 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65:
                return 0, $d43e0bb5a9200c87$export$1dee026a19752d6b;
            case 0, $d43e0bb5a9200c87$export$1dee026a19752d6b:
                return 0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65;
            default:
                return currentSortOrder;
        }
    }
    const $cb6422faa785b221$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, (0, parcelRequire("eGmKJ")).default), onSort: providedOnSort = (0, (0, parcelRequire("eGmKJ")).default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, (0, parcelRequire("eGmKJ")).default), onRankEnd: providedOnRankEnd = (0, (0, parcelRequire("eGmKJ")).default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
        prev: 'Previous',
        next: 'Next',
        label: 'Pagination',
        pageLabel: 'Page'
    } })=>{
        const [isRanking, setIsRanking] = (0, $5uXOq.useState)(false);
        const tableBodyRef = (0, $5uXOq.useRef)(null);
        const onSort = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnSort,
            action: 'sorted',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onRankEnd = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnRankEnd,
            action: 'ranked',
            componentName: 'dynamicTable',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
            (0, (0, parcelRequire("gS5Cm")).assertIsSortable)(head);
        }, [
            sortKey,
            head
        ]);
        const onSortHandler = (item)=>()=>{
                const { key: key } = item;
                if (!key) return;
                if (onSort && isRankable && key === sortKey && sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65)) {
                    onSort({
                        key: null,
                        sortOrder: null,
                        item: item
                    });
                    return;
                }
                const sortOrderFormatted = key !== sortKey ? (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) : $cb6422faa785b221$var$toggleSortOrder(sortOrder);
                if (onSort) onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrderFormatted
                });
            };
        const onSetPageHandler = (page, event)=>{
            onSetPage(page, event);
        };
        const onRankStartHandler = (params)=>{
            setIsRanking(true);
            onRankStart(params);
        };
        const onRankEndHandler = (params)=>{
            setIsRanking(false);
            onRankEnd(params);
        };
        const getSpinnerSize = ()=>{
            if (loadingSpinnerSize) return loadingSpinnerSize;
            return (0, (0, parcelRequire("gS5Cm")).getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3) : (0, $d43e0bb5a9200c87$export$71dd4c8ecd45e95f);
        };
        const renderEmptyBody = ()=>{
            if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewWithFixedHeight), {
                testId: testId
            });
            return emptyView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kF3yx")).EmptyViewContainer), {
                testId: testId
            }, emptyView);
        };
        const rowsLength = rows && rows.length;
        let totalPages;
        let isTotalPagesControlledExternally = false;
        if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
            totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
            isTotalPagesControlledExternally = true;
        } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
        totalPages = totalPages < 1 ? 1 : totalPages;
        const getPageNumber = page > totalPages ? totalPages : page;
        const rowsExist = !!rowsLength;
        const spinnerSize = getSpinnerSize();
        const emptyBody = renderEmptyBody();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dk72m")).default), {
            isLoading: isLoading && rowsExist,
            spinnerSize: spinnerSize,
            targetRef: ()=>tableBodyRef.current,
            testId: testId,
            loadingLabel: loadingLabel
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Table), {
            isFixedSize: isFixedSize,
            "aria-label": label,
            hasDataRow: rowsExist,
            testId: testId,
            isLoading: isLoading
        }, !!caption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).Caption), null, caption), head && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jlnvO")).default), {
            head: head,
            onSort: onSortHandler,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRanking: isRanking,
            isRankable: isRankable,
            testId: testId
        }), rowsExist && (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$TableBody, {
            ref: tableBodyRef,
            highlightedRowIndex: highlightedRowIndex,
            rows: rows,
            head: head,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rowsPerPage: rowsPerPage,
            page: getPageNumber,
            isFixedSize: isFixedSize || false,
            onPageRowsUpdate: onPageRowsUpdate,
            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
            testId: testId,
            isRankable: isRankable,
            isRanking: isRanking,
            onRankStart: onRankStartHandler,
            onRankEnd: onRankEndHandler,
            isRankingDisabled: isRankingDisabled || isLoading || false
        }))), totalPages <= 1 ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hiWL0")).PaginationWrapper), {
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("50Tma")).default), {
            value: getPageNumber,
            onChange: onSetPageHandler,
            total: totalPages,
            i18n: paginationi18n,
            isDisabled: isLoading,
            testId: testId
        })), !rowsExist && emptyBody && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dDBI6")).default), {
            isLoading: isLoading,
            spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
            testId: testId,
            loadingLabel: loadingLabel
        }, emptyBody));
    };
    const $cb6422faa785b221$var$RankableTableBody = (0, $5uXOq.lazy)(()=>(parcelRequire("f9SMa")));
    const $cb6422faa785b221$var$TableBody = (0, $5uXOq.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
        const canRank = isRankable && !bodyProps.sortKey;
        const [canRenderRankable, setCanRenderRankable] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (canRank) setCanRenderRankable(true);
        }, [
            canRank
        ]);
        const nonRankableBody = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkvnY")).default), {
            ref: ref,
            ...bodyProps
        });
        return canRank && canRenderRankable ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hK8cd")).ErrorBoundary), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: nonRankableBody
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cb6422faa785b221$var$RankableTableBody, {
            ref: ref,
            ...bodyProps,
            isRanking: isRanking,
            onRankStart: onRankStart,
            onRankEnd: onRankEnd,
            isRankingDisabled: isRankingDisabled
        }))) : nonRankableBody;
    });
    var $cb6422faa785b221$export$2e2bcd8739ae039 = $cb6422faa785b221$var$DynamicTable;
});
const $d43e0bb5a9200c87$export$1dee026a19752d6b = 'ASC';
const $d43e0bb5a9200c87$export$b6abcf7fa1d94f65 = 'DESC';
const $d43e0bb5a9200c87$export$71dd4c8ecd45e95f = 'small';
const $d43e0bb5a9200c87$export$7b93a10c0fefe3e3 = 'large';
const $d43e0bb5a9200c87$export$3843c586a90b9cbf = 0.22;
parcelRegister("gS5Cm", function(module, exports) {
    $parcel$export(module.exports, "getPageRows", ()=>$7f55105045703159$export$3987dc24b734dcab);
    $parcel$export(module.exports, "assertIsSortable", ()=>$7f55105045703159$export$5eb35a4771ec4090);
    $parcel$export(module.exports, "validateSortKey", ()=>$7f55105045703159$export$9133f5a8bfe8a200);
    $parcel$export(module.exports, "inlineStylesIfRanking", ()=>$7f55105045703159$export$a601f1775e10043f);
    $parcel$export(module.exports, "reorderRows", ()=>$7f55105045703159$export$c476bbe5da59992d);
    const $7f55105045703159$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
        if (!pageNumber || !rowsPerPage || !allRows.length) return [];
        return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
    };
    const $7f55105045703159$export$5eb35a4771ec4090 = (head)=>{
        if (!head || !head.cells) return;
        head.cells.forEach((cell)=>{
            if (cell.isSortable && !cell.key) try {
                throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
            } catch (e) {
                console.error(e);
            }
        });
    };
    const $7f55105045703159$export$9133f5a8bfe8a200 = (sortKey, head)=>{
        if (!sortKey) return;
        const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
        if (!headHasKey) try {
            throw Error(`Cell with ${sortKey} key not found in head.`);
        } catch (e) {
            console.error(e);
        }
    };
    const $7f55105045703159$export$a601f1775e10043f = (isRanking, width, height)=>{
        if (!isRanking) return {};
        if (height) return {
            width: width,
            height: height
        };
        return {
            width: width
        };
    };
    const $7f55105045703159$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
        const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
        return index + itemOnPreviousPages;
    };
    const $7f55105045703159$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
        const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
        if (!destination) return rows;
        const fromIndex = $7f55105045703159$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
        const toIndex = $7f55105045703159$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
        const reordered = rows.slice();
        const [removed] = reordered.splice(fromIndex, 1);
        reordered.splice(toIndex, 0, removed);
        return reordered;
    };
});
parcelRegister("hiWL0", function(module, exports) {
    $parcel$export(module.exports, "tableRowCSSVars", ()=>$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb);
    $parcel$export(module.exports, "Table", ()=>$3b29b0d00cd7b5c6$export$54ec01a60f47d33d);
    $parcel$export(module.exports, "Caption", ()=>$3b29b0d00cd7b5c6$export$32fbfacc5d962e0c);
    $parcel$export(module.exports, "PaginationWrapper", ()=>$3b29b0d00cd7b5c6$export$3e5e12dc01f20a43);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    function $3b29b0d00cd7b5c6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb = {
        CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
        CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
        CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
        CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
    };
    const $3b29b0d00cd7b5c6$var$fixedSizeTableStyles = {
        name: "wgb42e",
        styles: "table-layout:fixed"
    };
    const $3b29b0d00cd7b5c6$var$tableStyles = {
        name: "mul4pg",
        styles: "width:100%;border-collapse:separate;border-spacing:0px"
    };
    const $3b29b0d00cd7b5c6$var$bodyBorder = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`
    });
    const $3b29b0d00cd7b5c6$export$54ec01a60f47d33d = (0, $5uXOq.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("table", {
            inert: isLoading ? '' : undefined,
            style: {
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).highlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, (0, parcelRequire("54lmm")).row).hoverHighlightedBackground,
                [$3b29b0d00cd7b5c6$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, (0, parcelRequire("54lmm")).row).focusOutline
            },
            css: [
                $3b29b0d00cd7b5c6$var$tableStyles,
                isFixedSize && $3b29b0d00cd7b5c6$var$fixedSizeTableStyles,
                hasDataRow && $3b29b0d00cd7b5c6$var$bodyBorder
            ],
            ref: ref,
            ...rest,
            "data-testid": testId && `${testId}--table`
        }, children);
    });
    const $3b29b0d00cd7b5c6$var$captionStyles = {
        name: "h9a27i",
        styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
    };
    const $3b29b0d00cd7b5c6$export$32fbfacc5d962e0c = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("caption", {
            css: $3b29b0d00cd7b5c6$var$captionStyles
        }, children);
    const $3b29b0d00cd7b5c6$var$paginationWrapperStyles = {
        name: "zl1inp",
        styles: "display:flex;justify-content:center"
    };
    const $3b29b0d00cd7b5c6$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3b29b0d00cd7b5c6$var$paginationWrapperStyles,
            "data-testid": testId && `${testId}--pagination--container`
        }, children);
});
parcelRegister("54lmm", function(module, exports) {
    $parcel$export(module.exports, "MSThemeColors", ()=>$b728acac6d8ee4bc$export$34af08ce45c78352);
    $parcel$export(module.exports, "arrow", ()=>$b728acac6d8ee4bc$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "row", ()=>$b728acac6d8ee4bc$export$120ff0929b202a6d);
    $parcel$export(module.exports, "head", ()=>$b728acac6d8ee4bc$export$5fd5031fecdacec3);
    $parcel$export(module.exports, "tableBorder", ()=>$b728acac6d8ee4bc$export$38d703b73e2cf64d);
    const $b728acac6d8ee4bc$export$34af08ce45c78352 = {
        Background: 'Canvas',
        Text: 'CanvasText',
        SelectedBackground: 'Highlight',
        SelectedText: 'HighlightText'
    };
    const $b728acac6d8ee4bc$export$f2120bbfa5450bd2 = {
        defaultColor: `var(--ds-icon-disabled, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`,
        selectedColor: `var(--ds-icon-subtle, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$120ff0929b202a6d = {
        focusOutline: `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        highlightedBackground: `var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$e655ef011c4aa1a2})`,
        hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
    };
    const $b728acac6d8ee4bc$export$5fd5031fecdacec3 = {
        textColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`
    };
    const $b728acac6d8ee4bc$export$38d703b73e2cf64d = {
        borderColor: `var(--ds-border, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
});
parcelRegister("kF3yx", function(module, exports) {
    $parcel$export(module.exports, "EmptyViewWithFixedHeight", ()=>$0852c529eaab7231$export$8f45b9407d4090d7);
    $parcel$export(module.exports, "EmptyViewContainer", ()=>$0852c529eaab7231$export$381ea436de119582);
    var $f8Sb3;
    function $0852c529eaab7231$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0852c529eaab7231$var$fixedHeightStyles = {
        name: "50gc26",
        styles: "height:9rem"
    };
    const $0852c529eaab7231$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$fixedHeightStyles,
            "data-testid": testId && `${testId}--empty-view-with-fixed-height`
        }, children);
    const $0852c529eaab7231$var$emptyViewContainerStyles = {
        name: "1yld51o",
        styles: "width:50%;margin:auto;padding:10px;text-align:center"
    };
    const $0852c529eaab7231$export$381ea436de119582 = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $0852c529eaab7231$var$emptyViewContainerStyles,
            "data-testid": testId && `${testId}--empty-view-container`
        }, children);
    };
});
parcelRegister("fkvnY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32bba7afdbc8736a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7bJDt;
    var $ggqAE;
    class $32bba7afdbc8736a$var$BodyComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", {
                "data-testid": testId && `${testId}--body`,
                ref: forwardedRef
            }, pageRows.map((row, rowIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ggqAE")).default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    key: row.key || rowIndex,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                })));
        }
    }
    const $32bba7afdbc8736a$var$Body = (0, (0, parcelRequire("7bJDt")).default)((0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($32bba7afdbc8736a$var$BodyComponent, {
            ...props,
            forwardedRef: ref
        });
    }));
    var $32bba7afdbc8736a$export$2e2bcd8739ae039 = $32bba7afdbc8736a$var$Body;
});
parcelRegister("7bJDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc6eeecb3dc05edd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    const $dc6eeecb3dc05edd$var$getSortingCellValue = (cells, head, sortKey)=>{
        for(let i = 0; i < cells.length; i++){
            if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
        }
        return undefined;
    };
    const $dc6eeecb3dc05edd$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
        if (!sortKey || !head) return rows;
        if (!rows) return [];
        const modifier = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b) ? 1 : -1;
        const collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'accent'
        });
        const sortableRows = Array.from(rows);
        return sortableRows.sort((a, b)=>{
            const valA = $dc6eeecb3dc05edd$var$getSortingCellValue(a.cells, head, sortKey);
            const valB = $dc6eeecb3dc05edd$var$getSortingCellValue(b.cells, head, sortKey);
            if (valA === undefined || valB === undefined) return modifier;
            if (typeof valA !== typeof valB) {
                if (typeof valA === 'number') return -1;
                if (typeof valB === 'number') return 1;
                if (typeof valA === 'string') return -1;
                if (typeof valB === 'string') return 1;
            }
            if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
            if (!valA && valA !== 0 || valA < valB) return -modifier;
            if (!valB && valB !== 0 || valA > valB) return modifier;
            if (valA === valB) return 0;
            return 1;
        });
    };
    function $dc6eeecb3dc05edd$export$2e2bcd8739ae039(WrappedComponent) {
        class WithSortedPageRows extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static getDerivedStateFromProps(props, state) {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
                (0, (0, parcelRequire("gS5Cm")).validateSortKey)(sortKey, head);
                let sortedRows;
                let pageRows;
                if (isTotalPagesControlledExternally) {
                    sortedRows = rows;
                    pageRows = rows;
                } else {
                    sortedRows = $dc6eeecb3dc05edd$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                    pageRows = (0, (0, parcelRequire("gS5Cm")).getPageRows)(sortedRows, page, rowsPerPage);
                }
                return {
                    ...state,
                    pageRows: pageRows
                };
            }
            componentDidMount() {
                this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
            }
            componentDidUpdate(_prevProps, prevState) {
                if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
            }
            render() {
                const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    pageRows: this.state.pageRows,
                    head: head,
                    ...restProps,
                    ref: forwardedRef
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    pageRows: []
                };
            }
        }
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WithSortedPageRows, {
                ...props,
                forwardedRef: ref
            });
        });
    }
});
parcelRegister("ggqAE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$136b57fea50cecd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1g0dL;
    var $d9WgS;
    const $136b57fea50cecd2$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
        const { cells: cells, ...restRowProps } = row;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9WgS")).TableBodyRow), {
            ...restRowProps,
            isHighlighted: isHighlighted,
            ...isHighlighted ? {
                'data-ts--dynamic-table--table-row--highlighted': true
            } : null,
            testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
        }, cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1g0dL")).TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        }));
    };
    var $136b57fea50cecd2$export$2e2bcd8739ae039 = $136b57fea50cecd2$var$Row;
});
parcelRegister("1g0dL", function(module, exports) {
    $parcel$export(module.exports, "TableBodyCell", ()=>$11c3ea74eda01ab8$export$948e91fcef170792);
    var $f8Sb3;
    var $9GQPi;
    const $11c3ea74eda01ab8$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("td", {
            style: (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            css: [
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                (0, (0, parcelRequire("9GQPi")).cellStyles)
            ],
            ref: innerRef,
            ...props
        });
});
parcelRegister("9GQPi", function(module, exports) {
    $parcel$export(module.exports, "truncationWidthStyles", ()=>$99c9652c1fab2b08$export$708a733455f59a29);
    $parcel$export(module.exports, "fixedSizeTruncateStyles", ()=>$99c9652c1fab2b08$export$616c93ee022c8812);
    $parcel$export(module.exports, "overflowTruncateStyles", ()=>$99c9652c1fab2b08$export$7f2cd17defa265d8);
    $parcel$export(module.exports, "getTruncationStyleVars", ()=>$99c9652c1fab2b08$export$5e6497a652ae30b5);
    $parcel$export(module.exports, "cellStyles", ()=>$99c9652c1fab2b08$export$f7913df521f684e2);
    var $f8Sb3;
    function $99c9652c1fab2b08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $99c9652c1fab2b08$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
    const $99c9652c1fab2b08$export$708a733455f59a29 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `var(${$99c9652c1fab2b08$var$CSS_VAR_WIDTH})`
    });
    const $99c9652c1fab2b08$export$616c93ee022c8812 = {
        name: "1s7jr4j",
        styles: "text-overflow:ellipsis;white-space:nowrap"
    };
    const $99c9652c1fab2b08$export$7f2cd17defa265d8 = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $99c9652c1fab2b08$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
            [$99c9652c1fab2b08$var$CSS_VAR_WIDTH]: `${width}%`
        } : undefined;
    const $99c9652c1fab2b08$export$f7913df521f684e2 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        border: 'none',
        textAlign: 'left',
        '&:first-of-type': {
            paddingInlineStart: "var(--ds-space-0, 0px)"
        },
        '&:last-child': {
            paddingInlineEnd: "var(--ds-space-0, 0px)"
        }
    });
});
parcelRegister("d9WgS", function(module, exports) {
    $parcel$export(module.exports, "TableBodyRow", ()=>$ba9cb59faf06ce7f$export$45f39d9c38b886d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hiWL0;
    const $ba9cb59faf06ce7f$var$rowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        '&:focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
            outlineOffset: `-2px`
        }
    });
    const $ba9cb59faf06ce7f$var$rowBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${`var(${(0, (0, parcelRequire("hiWL0")).tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
        }
    });
    const $ba9cb59faf06ce7f$export$45f39d9c38b886d5 = (0, $5uXOq.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("tr", {
            style: style,
            css: [
                $ba9cb59faf06ce7f$var$rowStyles,
                isHighlighted ? $ba9cb59faf06ce7f$var$rowHighlightedBackgroundStyles : $ba9cb59faf06ce7f$var$rowBackgroundStyles
            ],
            ...rest,
            ref: ref,
            "data-testid": testId
        }, children);
    });
});
parcelRegister("hK8cd", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$883137116243a6a0$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $883137116243a6a0$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        render() {
            if (this.state.hasError) return this.props.fallback;
            return this.props.children;
        }
    }
});
parcelRegister("dDBI6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e4b90b361173610$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $lLAKY;
    class $2e4b90b361173610$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: (0, $d43e0bb5a9200c87$export$3843c586a90b9cbf),
                loadingLabel: 'Loading table'
            };
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).Container), {
                testId: testId
            }, !isLoading ? children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).ContentsContainer), {
                contentsOpacity: contentsOpacity,
                testId: testId
            }, children), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLAKY")).SpinnerContainer), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            })));
        }
    }
});
parcelRegister("lLAKY", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$d0e2766ad96d94ad$export$42a852a2b6b56249);
    $parcel$export(module.exports, "ContentsContainer", ()=>$d0e2766ad96d94ad$export$67c29eae8ae2137a);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$d0e2766ad96d94ad$export$a5e06607a5ac6158);
    var $f8Sb3;
    function $d0e2766ad96d94ad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d0e2766ad96d94ad$export$c335a80381ec61f5 = '--contents-opacity';
    const $d0e2766ad96d94ad$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $d0e2766ad96d94ad$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$containerStyles,
            "data-testid": testId && `${testId}--container`
        }, children);
    const $d0e2766ad96d94ad$var$contentsContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: `var(${$d0e2766ad96d94ad$export$c335a80381ec61f5})`,
        pointerEvents: 'none'
    });
    const $d0e2766ad96d94ad$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$d0e2766ad96d94ad$export$c335a80381ec61f5]: contentsOpacity
            },
            css: [
                $d0e2766ad96d94ad$var$contentsContainerStyles
            ],
            "data-testid": testId && `${testId}--contents--container`
        }, children);
    const $d0e2766ad96d94ad$var$spinnerContainerStyles = {
        name: "su4u96",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
    };
    const $d0e2766ad96d94ad$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d0e2766ad96d94ad$var$spinnerContainerStyles,
            "data-testid": testId && `${testId}--spinner--container`
        }, children);
});
parcelRegister("dk72m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba39c903b39a83b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $4xXH4;
    class $ba39c903b39a83b1$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isLoading: true,
                spinnerSize: (0, $d43e0bb5a9200c87$export$7b93a10c0fefe3e3),
                contentsOpacity: `var(--ds-opacity-loading, ${`${0, $d43e0bb5a9200c87$export$3843c586a90b9cbf}`})`,
                loadingLabel: 'Loading table'
            };
        }
        attachListeners() {
            window.addEventListener('scroll', this.handleScroll);
            window.addEventListener('resize', this.handleResize);
        }
        detachListeners() {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.handleResize);
        }
        updateSpinnerPosition() {
            const viewportHeight = window.innerHeight;
            const targetNode = this.getTargetNode();
            const spinnerNode = this.spinnerRef?.current;
            if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
            const targetRect = targetNode.getBoundingClientRect();
            const spinnerRect = spinnerNode.getBoundingClientRect();
            const spinnerHeight = spinnerRect.height;
            const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
            const { top: top, bottom: bottom, height: height } = targetRect;
            if (isInViewport) {
                const canFollow = height >= spinnerHeight * 3;
                if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                    if (top >= 0) {
                        const viewportSpaceTakenByElement = viewportHeight - top;
                        const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                        const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    } else if (top < 0 && bottom > viewportHeight) {
                        const y = viewportHeight / 2 - spinnerHeight / 2;
                        this.translateSpinner(spinnerNode, y, true);
                    } else {
                        const diff = bottom / 2 - spinnerHeight / 2;
                        const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                        this.translateSpinner(spinnerNode, y, true);
                    }
                    return;
                }
            } else {
                if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
            }
            const containerNode = this.containerRef?.current;
            if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
                const thisTop = containerNode.getBoundingClientRect().top;
                const y = (top - thisTop) / 2;
                this.translateSpinner(spinnerNode, y, false);
            }
        }
        render() {
            const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).Container), {
                testId: testId && `${testId}--loading--container--advanced`,
                ref: this.containerRef
            }, children, isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerBackdrop), {
                testId: testId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4xXH4")).SpinnerContainer), {
                ref: this.spinnerRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: spinnerSize,
                testId: testId && `${testId}--loadingSpinner`,
                label: loadingLabel
            }))));
        }
        constructor(...args){
            super(...args), this.spinnerRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.componentDidMount = ()=>{
                if (this.props.isLoading && this.hasTargetNode()) {
                    this.attachListeners();
                    this.updateTargetAppearance();
                    this.updateSpinnerPosition();
                }
            }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
                if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
                else if (!this.props.isLoading) this.attachListeners();
            }, this.componentDidUpdate = ()=>{
                if (this.hasTargetNode()) {
                    this.updateTargetAppearance();
                    if (this.props.isLoading) this.updateSpinnerPosition();
                }
            }, this.componentWillUnmount = ()=>{
                this.detachListeners();
            }, this.getTargetNode = (nextProps = this.props)=>{
                const { targetRef: targetRef } = nextProps;
                const target = targetRef?.();
                return target || this.containerRef.current;
            }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                if (bottom <= 0) return false;
                return top < viewportHeight;
            }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
                const { top: top, bottom: bottom } = elementRect;
                return top >= 0 && bottom <= viewportHeight;
            }, this.handleResize = ()=>{
                this.updateSpinnerPosition();
            }, this.handleScroll = ()=>{
                this.updateSpinnerPosition();
            }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
                spinnerNode.style.position = isFixed ? 'fixed' : '';
                spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
            }, this.updateTargetAppearance = ()=>{
                const targetNode = this.getTargetNode();
                const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
                if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                    targetNode.style.pointerEvents = isLoading ? 'none' : '';
                    targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
                }
            };
        }
    }
});
parcelRegister("4xXH4", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$48301faf1109874f$export$42a852a2b6b56249);
    $parcel$export(module.exports, "SpinnerBackdrop", ()=>$48301faf1109874f$export$aa207050321b0c53);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$48301faf1109874f$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $48301faf1109874f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48301faf1109874f$var$containerStyles = {
        name: "17fhw1k",
        styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
    };
    const $48301faf1109874f$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$containerStyles,
            ...rest,
            "data-testid": testId,
            ref: ref
        }, children));
    });
    const $48301faf1109874f$var$spinnerBackdropStyles = {
        name: "1yy6mjk",
        styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
    };
    const $48301faf1109874f$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerBackdropStyles,
            "data-testid": testId && `${testId}--spinner-backdrop`
        }, children);
    const $48301faf1109874f$var$spinnerContainerStyles = {
        name: "vi3nlf",
        styles: "position:relative;inset-block-start:0"
    };
    const $48301faf1109874f$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ children: children }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $48301faf1109874f$var$spinnerContainerStyles,
            ref: ref
        }, children));
});
parcelRegister("50Tma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21d5ee5c6331aeb9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $xBgAj;
    class $21d5ee5c6331aeb9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
            const pages = [
                ...Array(total)
            ].map((_, index)=>index + 1);
            const selectedIndex = value - 1;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xBgAj")).default), {
                selectedIndex: selectedIndex,
                isDisabled: isDisabled,
                label: i18n?.label,
                nextLabel: i18n?.next,
                previousLabel: i18n?.prev,
                pageLabel: i18n?.pageLabel,
                onChange: this.onChange,
                pages: pages,
                testId: testId && `${testId}--pagination`
            });
        }
        constructor(...args){
            super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
                this.props.onChange(newValue, analyticsEvent);
            };
        }
    }
});
parcelRegister("xBgAj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8aaadfaafd170b3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6QvkM;
    var $eGmKJ;
    var $33etG;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $5HBW9;
    var $15F6T;
    var $lmPue;
    var $fc5SA;
    var $gRWrA;
    const $8aaadfaafd170b3c$var$analyticsAttributes = {
        componentName: 'pagination',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $8aaadfaafd170b3c$var$paginationMenuStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0',
        margin: 'space.0'
    });
    const $8aaadfaafd170b3c$var$paginationMenuItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.0'
    });
    const $8aaadfaafd170b3c$var$navigatorIconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.075'
    });
    function $8aaadfaafd170b3c$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
        const Chevron = chevronDirection === 'left' ? (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))) : (0, ($parcel$interopDefault((0, parcelRequire("6s76W")))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $8aaadfaafd170b3c$var$navigatorIconWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor"
        }));
    }
    function $8aaadfaafd170b3c$var$InnerPagination({ components: components = (0, (0, parcelRequire("fc5SA")).emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, (0, parcelRequire("fc5SA")).emptyObject), max: max = 7, onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, (0, parcelRequire("lmPue")).default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
        const [selectedIndexValue, setSelectedIndexValue] = (0, (0, parcelRequire("33etG")).default)(selectedIndex, ()=>defaultSelectedIndex || 0);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (value, analyticsEvent)=>{
                const { event: event, selectedPageIndex: selectedPageIndex } = value;
                if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
                if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
            },
            action: 'changed',
            actionSubject: 'pageNumber',
            analyticsData: analyticsContext,
            ...$8aaadfaafd170b3c$var$analyticsAttributes
        });
        const transform = (page, currPageIndex, testId)=>{
            const selectedPage = pages[selectedIndexValue];
            const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
            const isCurrentPage = page === selectedPage;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                as: "li",
                xcss: $8aaadfaafd170b3c$var$paginationMenuItemStyles,
                key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("15F6T")).default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
            }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
        };
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            style: style,
            ref: ref,
            "aria-label": label,
            as: "nav"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "left-navigator",
            component: components.Previous,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue - 1
                }),
            isDisabled: isDisabled || selectedIndexValue === 0,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "left"
            }),
            "aria-label": previousLabel,
            testId: testId && `${testId}--left-navigator`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "baseline",
            as: "ul",
            xcss: $8aaadfaafd170b3c$var$paginationMenuStyles
        }, (0, (0, parcelRequire("gRWrA")).default)(pages, selectedIndexValue, {
            max: max,
            ellipsis: renderEllipsis,
            transform: transform
        }, testId)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HBW9")).default), {
            key: "right-navigator",
            component: components.Next,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: selectedIndexValue + 1
                }),
            isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($8aaadfaafd170b3c$var$NavigatorIcon, {
                chevronDirection: "right"
            }),
            "aria-label": nextLabel,
            testId: testId && `${testId}--right-navigator`
        }))));
    }
    const $8aaadfaafd170b3c$var$Pagination = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)($8aaadfaafd170b3c$var$InnerPagination));
    var $8aaadfaafd170b3c$export$2e2bcd8739ae039 = $8aaadfaafd170b3c$var$Pagination;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("5HBW9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63acbbc2953d9b5a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $63acbbc2953d9b5a$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            "aria-label": props['aria-label'],
            isDisabled: props.isDisabled,
            iconBefore: props.iconBefore,
            testId: props.testId,
            onClick: props.onClick,
            component: props.component,
            appearance: "subtle"
        });
    }
});
parcelRegister("15F6T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097dd42f19f41562$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    function $097dd42f19f41562$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            appearance: "subtle"
        });
    }
});
parcelRegister("lmPue", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d144cd0d91a90ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $jldZL;
    const $3d144cd0d91a90ab$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        position: 'relative'
    });
    function $3d144cd0d91a90ab$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "li",
            testId: testId,
            key: key,
            xcss: $3d144cd0d91a90ab$var$containerStyles,
            paddingInline: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            testId: testId && `${testId}-text`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
    }
});
parcelRegister("fc5SA", function(module, exports) {
    $parcel$export(module.exports, "emptyObject", ()=>$cbef1c2cfb373aca$export$3f860eba1218f8d3);
    const $cbef1c2cfb373aca$export$3f860eba1218f8d3 = {};
});
parcelRegister("gRWrA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48fbac64848b775a$export$2e2bcd8739ae039);
    var $8QpSo;
    const $48fbac64848b775a$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
        const total = pages.length;
        const needEllipsis = total > max;
        const hasStartEllipsis = needEllipsis && max - 4 < current;
        const hasEndEllipsis = needEllipsis && current < total - max + 3;
        const getPageComponents = (0, (0, parcelRequire("8QpSo")).default)((startIndex = 0, lastIndex = total)=>{
            return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
        });
        if (!needEllipsis) return getPageComponents(0, total);
        if (hasStartEllipsis && !hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, 1),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: 2,
                    to: total - pageCount
                }),
                ...getPageComponents(total - pageCount)
            ];
        }
        if (!hasStartEllipsis && hasEndEllipsis) {
            const pageCount = max - 2;
            return [
                ...getPageComponents(0, pageCount),
                ellipsis({
                    key: 'ellipsis-1',
                    testId: testId && `${testId}-ellipsis`,
                    from: pageCount + 1,
                    to: total - 1
                }),
                ...getPageComponents(total - 1)
            ];
        }
        const pageCount = max - 4;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: current - Math.floor(pageCount / 2)
            }),
            ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
            ellipsis({
                key: 'ellipsis-2',
                testId: testId && `${testId}-ellipsis`,
                from: current + 3,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    };
    var $48fbac64848b775a$export$2e2bcd8739ae039 = $48fbac64848b775a$var$collapseRange;
});
parcelRegister("jlnvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097ee65829e33b82$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gS5Cm;
    var $9Ooyy;
    var $a41RA;
    var $dpXLF;
    class $097ee65829e33b82$var$TableHead extends (0, ($parcel$interopDefault($5uXOq))).Component {
        UNSAFE_componentWillMount() {
            (0, (0, parcelRequire("gS5Cm")).validateSortKey)(this.props.sortKey, this.props.head);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, (0, parcelRequire("gS5Cm")).validateSortKey)(nextProps.sortKey, nextProps.head);
        }
        render() {
            const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
            if (!head) return null;
            const HeadCellComponent = isRankable ? (0, (0, parcelRequire("a41RA")).default) : (0, (0, parcelRequire("dpXLF")).default);
            const { cells: cells, ...rest } = head;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).Head), {
                ...rest,
                isRanking: isRanking,
                testId: testId && `${testId}--head`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("tr", null, cells.map((cell, index)=>{
                const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, ...restCellProps } = cell;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(HeadCellComponent, {
                    colSpan: colSpan,
                    content: content,
                    isFixedSize: isFixedSize,
                    isSortable: !!isSortable,
                    isRanking: isRanking,
                    key: key || index,
                    onClick: isSortable ? onSort(cell) : undefined,
                    testId: cellTestId || testId,
                    shouldTruncate: shouldTruncate,
                    sortOrder: key === sortKey ? sortOrder : undefined,
                    width: width,
                    ...restCellProps
                });
            })));
        }
    }
    var $097ee65829e33b82$export$2e2bcd8739ae039 = $097ee65829e33b82$var$TableHead;
});
parcelRegister("9Ooyy", function(module, exports) {
    $parcel$export(module.exports, "Head", ()=>$e002e0403dc403bb$export$e93312b7773dfcac);
    $parcel$export(module.exports, "HeadCell", ()=>$e002e0403dc403bb$export$4e8024263ace498b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $54lmm;
    var $9GQPi;
    function $e002e0403dc403bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
    const $e002e0403dc403bb$var$rankingStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $e002e0403dc403bb$var$headStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `none`
    });
    const $e002e0403dc403bb$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("thead", {
            css: [
                $e002e0403dc403bb$var$headStyles,
                isRanking && $e002e0403dc403bb$var$rankingStyles
            ],
            "data-testid": testId,
            ...props
        });
    };
    const $e002e0403dc403bb$var$headCellBaseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        position: 'relative',
        border: 'none',
        borderBlockEnd: `2px solid ${(0, (0, parcelRequire("54lmm")).tableBorder).borderColor}`,
        color: `var(--ds-text-subtle, ${`var(${$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR})`})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        textAlign: 'left',
        verticalAlign: 'top',
        '&:focus-visible': {
            outline: `solid 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $e002e0403dc403bb$var$onClickStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            cursor: 'pointer'
        }
    });
    const $e002e0403dc403bb$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            padding: "var(--ds-space-0, 0)",
            position: 'relative',
            appearance: 'none',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            '&::before, &::after': {
                display: 'block',
                width: 0,
                height: 0,
                position: 'absolute',
                border: '3px solid transparent',
                content: '""',
                insetInlineEnd: "var(--ds-space-negative-100, -8px)"
            },
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: "var(--ds-space-100, 8px)"
            },
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).defaultColor}`,
                insetBlockEnd: 0
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before, &::after': {
                    border: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Background}`
                },
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                },
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).Text}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$ascendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::before': {
                borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::before': {
                    borderBlockEnd: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$var$descendingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '& > button': {
            '&::after': {
                borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).arrow).selectedColor}`
            }
        },
        '@media (forced-colors: active)': {
            '& > button': {
                '&::after': {
                    borderBlockStart: `3px solid ${(0, (0, parcelRequire("54lmm")).MSThemeColors).SelectedBackground}`
                }
            }
        }
    });
    const $e002e0403dc403bb$export$4e8024263ace498b = (0, $5uXOq.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
        const mergedStyles = {
            ...style,
            ...width && (0, (0, parcelRequire("9GQPi")).getTruncationStyleVars)({
                width: width
            }),
            [$e002e0403dc403bb$var$CSS_VAR_TEXT_COLOR]: (0, (0, parcelRequire("54lmm")).head).textColor
        };
        const isASC = sortOrder === (0, $d43e0bb5a9200c87$export$1dee026a19752d6b);
        const isDESC = sortOrder === (0, $d43e0bb5a9200c87$export$b6abcf7fa1d94f65);
        const getFormattedSortOrder = ()=>{
            if (isASC) return 'ascending';
            else if (isDESC) return 'descending';
        };
        const Component = children ? 'th' : 'td';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            "aria-sort": getFormattedSortOrder(),
            style: mergedStyles,
            css: [
                (0, (0, parcelRequire("9GQPi")).cellStyles),
                $e002e0403dc403bb$var$headCellBaseStyles,
                onClick && $e002e0403dc403bb$var$onClickStyles,
                (0, (0, parcelRequire("9GQPi")).truncationWidthStyles),
                isFixedSize && shouldTruncate && (0, (0, parcelRequire("9GQPi")).fixedSizeTruncateStyles),
                isFixedSize && (0, (0, parcelRequire("9GQPi")).overflowTruncateStyles),
                isSortable && $e002e0403dc403bb$var$baseStyles,
                isASC && $e002e0403dc403bb$var$ascendingStyles,
                isDESC && $e002e0403dc403bb$var$descendingStyles
            ],
            onClick: onClick,
            ref: ref,
            "data-testid": testId,
            ...rest
        }, children);
    });
});
parcelRegister("a41RA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$669a06e89a9827f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cVljL;
    var $gS5Cm;
    var $dpXLF;
    class $669a06e89a9827f7$var$RankableTableHeadCellComponent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
            const inlineStyles = (0, (0, parcelRequire("gS5Cm")).inlineStylesIfRanking)(isRanking, refWidth);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dpXLF")).default), {
                inlineStyles: inlineStyles,
                ...restProps
            });
        }
    }
    const $669a06e89a9827f7$var$RankableTableHeadCell = (0, (0, parcelRequire("cVljL")).default)($669a06e89a9827f7$var$RankableTableHeadCellComponent);
    var $669a06e89a9827f7$export$2e2bcd8739ae039 = $669a06e89a9827f7$var$RankableTableHeadCell;
});
parcelRegister("cVljL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3e49a9b167764eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a3e49a9b167764eb$export$2e2bcd8739ae039(WrappedComponent) {
        return class WithDimensions extends (0, ($parcel$interopDefault($5uXOq))).Component {
            UNSAFE_componentWillReceiveProps(nextProps) {
                const wasRanking = this.props.isRanking;
                const willRanking = nextProps.isRanking;
                if (willRanking && !wasRanking) this.updateDimensions();
            }
            render() {
                const { refWidth: refWidth, refHeight: refHeight } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    refWidth: refWidth,
                    refHeight: refHeight,
                    innerRef: this.innerRef,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    refWidth: 0,
                    refHeight: 0
                }, this.innerRef = (ref)=>{
                    if (ref && !this.props.isRanking) this.ref = ref;
                }, this.updateDimensions = ()=>{
                    if (!this.ref) return;
                    const clientRect = this.ref.getBoundingClientRect();
                    const { width: width } = clientRect;
                    const { height: height } = clientRect;
                    if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                        refWidth: width,
                        refHeight: height
                    });
                };
            }
        };
    }
});
parcelRegister("dpXLF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9c80f4a483cfd6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9Ooyy;
    const $d9c80f4a483cfd6a$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ooyy")).HeadCell), {
            style: inlineStyles,
            testId: testId && `${testId}--head--cell`,
            ref: typeof innerRef !== 'string' ? innerRef : null,
            ...rest,
            onClick: onClick,
            isSortable: isSortable
        }, isSortable ? (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            type: "button",
            "aria-roledescription": "Sort button"
        }, content) : content);
    };
    var $d9c80f4a483cfd6a$export$2e2bcd8739ae039 = $d9c80f4a483cfd6a$var$TableHeadCell;
});
parcelRegister("f9SMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("bz1jP")
    ]).then(()=>parcelRequire('4THp8'));
});
parcelRegister("1othz", function(module, exports) {
    $parcel$export(module.exports, "useSuspenselessRefetch", ()=>$7714fce489d6815b$export$c7ce5f64dc007896);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $biQrn;
    const $7714fce489d6815b$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
        const inFlightRequestsRef = (0, $5uXOq.useRef)([]);
        return (0, $5uXOq.useMemo)(()=>({
                onNewRequest: (request)=>{
                    inFlightRequestsRef.current.push(request);
                },
                onRequestFinish: (request, onIfRequestIsRelevant)=>{
                    const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                    if (inFlightRequestIndex !== -1) {
                        onIfRequestIsRelevant?.();
                        inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                        setIsLoading?.(!!inFlightRequestsRef.current.length);
                    }
                }
            }), [
            setIsLoading
        ]);
    };
    const $7714fce489d6815b$export$ae1adabf094b2244 = (query, refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const isMounted = (0, (0, parcelRequire("biQrn")).useIsMounted)();
        const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $7714fce489d6815b$var$useInFlightRequests({
            setIsLoading: setIsLoading
        });
        return (0, $5uXOq.useCallback)((variables)=>{
            if (isMounted.current) setIsLoading?.(true);
            onNewRequest(variables);
            return (0, $8Uumt.fetchQuery)(environment, query, variables, {
                fetchPolicy: fetchPolicy,
                networkCacheConfig: networkCacheConfig
            }).subscribe({
                complete () {
                    if (isMounted.current) {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>refetch(variables, {
                                fetchPolicy: 'store-only'
                            }));
                    }
                },
                error (e) {
                    if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
                }
            });
        }, [
            environment,
            fetchPolicy,
            isMounted,
            networkCacheConfig,
            onNewRequest,
            onRequestFinish,
            query,
            refetch,
            setIsLoading,
            setLastFetchError
        ]);
    };
    const $7714fce489d6815b$export$c7ce5f64dc007896 = (query, refetch, options)=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [lastFetchError, setLastFetchError] = (0, $5uXOq.useState)(null);
        const refetchFunction = $7714fce489d6815b$export$ae1adabf094b2244(query, refetch, {
            ...options,
            setIsLoading: setIsLoading,
            setLastFetchError: setLastFetchError
        });
        return [
            refetchFunction,
            isLoading,
            lastFetchError
        ];
    };
});
parcelRegister("biQrn", function(module, exports) {
    $parcel$export(module.exports, "useIsMounted", ()=>$c6adaed2787020bf$export$80c2a3957bcb42ea);
    var $5uXOq = parcelRequire("5uXOq");
    const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        }, [
            isMounted
        ]);
        return isMounted;
    };
});
parcelRegister("82JA4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b770800b7ad53e2$export$2e2bcd8739ae039);
    var $cJEGL;
    var $bcBCK;
    var $1dEUP;
    var $731G3;
    var $fxqay;
    var $gT9EG;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8Uumt = parcelRequire("8Uumt");
    var $ldJSL;
    var $fVnbM;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $3oUqw;
    var $i8Qvm;
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    var $3bDjY;
    var $dj7Vj;
    var $8oe80;
    var $39xOx;
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $lfTZh;
    var $8zOmE;
    var $cmpyR;
    var $l3bEE;
    var $hlRDe;
    var $dxCvy;
    var $kfztd;
    var $4i1Dv;
    var $02grs;
    var $5fLvR;
    var $0ceWi;
    var $51R3o;
    var $fY39E;
    var $koeKL;
    var $DVljb;
    var $kB2wS;
    var $lqWUw;
    var $2YP9W;
    var $iJZ8l;
    var $camqO;
    const $6b770800b7ad53e2$var$DropdownItemWithAnalytics = (0, (0, parcelRequire("8oe80")).default)('dropdownItem', {
        onClick: 'clicked'
    })((0, (0, parcelRequire("6B7KL")).default));
    const $6b770800b7ad53e2$var$getHasReleaseNote = async (versionId, environment)=>{
        try {
            const data = await (0, $8Uumt.fetchQuery)(environment, (0, (0, parcelRequire("gT9EG")).default), {
                versionId: versionId
            }).toPromise();
            return data?.jira?.version?.hasReleaseNote ?? false;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'jiraProjectVersionsHasReleaseNoteQuery',
                    packageName: 'jiraProjectVersions',
                    teamName: 'fusion-solaris'
                },
                error: new Error('Unable to get "hasReleaseNote" for "release version" modal')
            });
            return false;
        }
    };
    const $6b770800b7ad53e2$var$useHasReleaseNote = (versionId, shouldLoadHasReleaseNote)=>{
        const [hasReleaseNote, setHasReleaseNote] = (0, $5uXOq.useState)(null);
        const environment = (0, $8Uumt.useRelayEnvironment)();
        (0, $5uXOq.useEffect)(()=>{
            if (shouldLoadHasReleaseNote) $6b770800b7ad53e2$var$getHasReleaseNote(versionId, environment).then(setHasReleaseNote);
        }, [
            versionId,
            environment,
            shouldLoadHasReleaseNote
        ]);
        return hasReleaseNote;
    };
    const $6b770800b7ad53e2$var$ActionsCell = ({ jiraVersion: jiraVersion, jiraProject: jiraProject, showSpinner: showSpinner, connectionId: connectionId })=>{
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("fxqay")).default), jiraVersion);
        const project = (0, $8Uumt.useFragment)((0, (0, parcelRequire("731G3")).default), jiraProject);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const activationId = (0, (0, parcelRequire("fY39E")).useActivationId)();
        const projectContext = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const isProjectAdmin = projectContext?.data?.isProjectAdmin || false;
        const isSimplified = projectContext?.data?.simplified || false;
        const projectKey = project.key;
        const projectAri = project.id;
        const [editReleaseFormQueryRef, loadEditReleaseModalQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("cmpyR")).default));
        const [releaseNotesQueryRef, loadReleaseNotesQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("hlRDe")).default));
        const [mergeReleaseFormQueryRef, loadMergeReleaseModalQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("l3bEE")).default));
        const loadEditQuery = ()=>{
            if (!editReleaseFormQueryRef) loadEditReleaseModalQuery({
                versionAri: version.id
            });
        };
        const loadCreateReleaseNotesQuery = ()=>{
            if (!releaseNotesQueryRef) loadReleaseNotesQuery({
                versionAri: version.id
            }, {
                fetchPolicy: 'store-and-network'
            });
        };
        const loadMergeQuery = ()=>{
            if (!mergeReleaseFormQueryRef) loadMergeReleaseModalQuery({
                projectAri: projectAri
            });
        };
        const editExperienceStart = (0, (0, parcelRequire("02grs")).useEditReleaseExperienceStart)((0, $6868fc0fce0c2912$export$c5ed97509d0e2aaf));
        const mergeExperienceStart = (0, (0, parcelRequire("5fLvR")).useMergeReleaseExperienceStart)((0, $6868fc0fce0c2912$export$c5ed97509d0e2aaf));
        const [updateVersionReleased] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("1dEUP")).default));
        const [updateVersionArchived] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("bcBCK")).default));
        const [deleteVersionWithNoIssues] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("cJEGL")).default));
        const [editVersionModalOpen, setEditVersionModalOpen] = (0, $5uXOq.useState)(false);
        const [isReleaseModalOpen, setIsReleaseModalOpen] = (0, $5uXOq.useState)(false);
        const [isReleaseNotesModalOpen, setIsReleaseNotesModalOpen] = (0, $5uXOq.useState)(false);
        const [isDeleteVersionModalOpen, setIsDeleteVersionModalOpen] = (0, $5uXOq.useState)(false);
        const [mergeVersionModalOpen, setMergeVersionModalOpen] = (0, $5uXOq.useState)(false);
        const hasReleaseNote = $6b770800b7ad53e2$var$useHasReleaseNote(version.id, isReleaseModalOpen);
        const canMergeVersions = ()=>!isSimplified;
        const canBeReleased = ()=>version.status !== 'RELEASED' && version.status !== 'ARCHIVED';
        const canBeArchived = ()=>version.status !== 'ARCHIVED';
        const canBeUnreleased = ()=>version.status === 'RELEASED';
        const canDelete = ()=>isProjectAdmin;
        const canQuickRelease = ()=>version.status === 'UNRELEASED' && version.allIssues.totalCount > 0 && version.allIssues.totalCount === version.doneIssues.totalCount;
        const onReleaseClicked = ()=>{
            if (!(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)()) loadCreateReleaseNotesQuery();
            setIsReleaseModalOpen(true);
        };
        const onUnreleaseClicked = ()=>{
            updateVersionReleased({
                variables: {
                    input: {
                        id: version.id,
                        isReleased: false
                    }
                },
                onCompleted: ()=>{
                    showFlag({
                        type: 'success',
                        title: [
                            (0, (0, parcelRequire("camqO")).default).unReleaseTitle,
                            {
                                name: version.name
                            }
                        ]
                    });
                },
                onError: ()=>{
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'jiraProjectVersionsUnReleaseMutation',
                            packageName: 'jiraProjectVersions',
                            teamName: 'fusion-solaris'
                        },
                        error: new Error('Unable to update version released status'),
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag({
                        type: 'error',
                        title: (0, (0, parcelRequire("camqO")).default).genericUpdateFailedFlagTitle,
                        description: (0, (0, parcelRequire("camqO")).default).releaseFailedFlagDescription
                    });
                },
                optimisticResponse: {
                    jira: {
                        updateVersionReleasedStatus: {
                            success: true,
                            version: {
                                id: version.id,
                                status: (0, $6868fc0fce0c2912$export$cb459d726a8530a5)
                            }
                        }
                    }
                }
            });
        };
        const onArchiveClicked = ()=>{
            updateVersionArchived({
                variables: {
                    input: {
                        id: version.id,
                        isArchived: true
                    }
                },
                onCompleted: ()=>{
                    showFlag({
                        type: 'success',
                        title: [
                            (0, (0, parcelRequire("camqO")).default).archiveTitle,
                            {
                                name: version.name
                            }
                        ]
                    });
                },
                optimisticResponse: {
                    jira: {
                        updateVersionArchivedStatus: {
                            success: true,
                            version: {
                                id: version.id,
                                status: (0, $6868fc0fce0c2912$export$c936349447a77fe0)
                            }
                        }
                    }
                },
                onError: ()=>{
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'jiraProjectVersionsArchiveMutation',
                            packageName: 'jiraProjectVersions',
                            teamName: 'fusion-solaris'
                        },
                        error: new Error('Unable to update version archived status'),
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag({
                        type: 'error',
                        title: (0, (0, parcelRequire("camqO")).default).genericUpdateFailedFlagTitle,
                        description: (0, (0, parcelRequire("camqO")).default).archiveFailedFlagDescription
                    });
                }
            });
        };
        const onUnarchiveClicked = ()=>{
            updateVersionArchived({
                variables: {
                    input: {
                        id: version.id,
                        isArchived: false
                    }
                },
                onCompleted: ()=>{
                    showFlag({
                        type: 'success',
                        title: [
                            (0, (0, parcelRequire("camqO")).default).unarchiveTitle,
                            {
                                name: version.name
                            }
                        ]
                    });
                },
                optimisticResponse: {
                    jira: {
                        updateVersionArchivedStatus: {
                            success: true,
                            version: {
                                id: version.id,
                                status: (0, $6868fc0fce0c2912$export$cb459d726a8530a5)
                            }
                        }
                    }
                },
                onError: ()=>{
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'jiraProjectVersionsUnArchiveMutation',
                            packageName: 'jiraProjectVersions',
                            teamName: 'fusion-solaris'
                        },
                        error: new Error('Unable to update version archived status'),
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag({
                        type: 'error',
                        title: (0, (0, parcelRequire("camqO")).default).genericUpdateFailedFlagTitle,
                        description: (0, (0, parcelRequire("camqO")).default).archiveFailedFlagDescription
                    });
                }
            });
        };
        const onMergeClicked = ()=>{
            mergeExperienceStart();
            setMergeVersionModalOpen(true);
        };
        const onEditClicked = ()=>{
            editExperienceStart();
            setEditVersionModalOpen(true);
        };
        const onDeleteClicked = ()=>{
            if (version.allIssues.totalCount) setIsDeleteVersionModalOpen(true);
            else deleteVersionWithNoIssues({
                variables: {
                    input: {
                        id: version.id
                    }
                },
                optimisticUpdater: updateStoreOnDeleteVersionWithNoIssues,
                updater: updateStoreOnDeleteVersionWithNoIssues,
                onCompleted: ()=>{
                    showFlag({
                        type: 'success',
                        title: formatMessage((0, (0, parcelRequire("camqO")).default).deleteTitle, {
                            name: version.name
                        }),
                        testId: 'project-directories.versions.flags.delete.success'
                    });
                },
                onError: ()=>{
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'jiraProjectVersionsDeleteVersionWithNoIssuesMutation',
                            packageName: 'jiraProjectVersions',
                            teamName: 'fusion-solaris'
                        },
                        error: new Error('Unable to delete version'),
                        sendToPrivacyUnsafeSplunk: true
                    });
                    showFlag({
                        type: 'error',
                        title: (0, (0, parcelRequire("camqO")).default).genericUpdateFailedFlagTitle,
                        description: (0, (0, parcelRequire("camqO")).default).deleteFailedDescription
                    });
                }
            });
        };
        const updateStoreOnReleased = ()=>{
            (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
                const dataID = (0, (0, parcelRequire("iJZ8l")).default)({
                    id: version.id
                }, 'JiraVersion') ?? '';
                const versionRecord = store.get(dataID);
                if (versionRecord) versionRecord.setValue((0, $6868fc0fce0c2912$export$b983f2cb1f658a55), 'status');
            });
        };
        const updateStoreOnDelete = (targetVersionId)=>{
            (0, $8Uumt.commitLocalUpdate)(environment, (store)=>{
                const getVersionLinkedRecordByStatus = (record, status)=>record.getLinkedRecord(`issues(filter:"${status}")`);
                const getVersionIssueCountByStatus = (record, status)=>Number(getVersionLinkedRecordByStatus(record, status)?.getValue('totalCount')) || 0;
                if (connectionId) {
                    const connectionRecord = store.get(connectionId);
                    if (connectionRecord) {
                        if (targetVersionId) {
                            const targetVersionAri = (0, (0, parcelRequire("dj7Vj")).JiraVersionAri).create({
                                siteId: cloudId,
                                activationId: activationId,
                                versionId: targetVersionId
                            }).toString();
                            const targetVersionRecord = store.get((0, (0, parcelRequire("iJZ8l")).default)({
                                id: targetVersionAri
                            }, 'JiraVersion') ?? '');
                            const sourceVersionRecord = store.get((0, (0, parcelRequire("iJZ8l")).default)({
                                id: version.id
                            }, 'JiraVersion') ?? '');
                            if (targetVersionRecord && sourceVersionRecord) [
                                'ALL',
                                'TODO',
                                'IN_PROGRESS',
                                'DONE'
                            ].forEach((status)=>{
                                getVersionLinkedRecordByStatus(targetVersionRecord, status).setValue(getVersionIssueCountByStatus(targetVersionRecord, status) + getVersionIssueCountByStatus(sourceVersionRecord, status), 'totalCount');
                            });
                        }
                        (0, $8Uumt.ConnectionHandler).deleteNode(connectionRecord, version.__id);
                    }
                }
            });
        };
        const updateStoreOnDeleteVersionWithNoIssues = (store)=>{
            const deletedVersionRecord = store.get((0, (0, parcelRequire("iJZ8l")).default)({
                id: version.id
            }, 'JiraVersion') ?? '');
            if (deletedVersionRecord) store.delete(deletedVersionRecord.getDataID());
        };
        const renderReleaseButton = ()=>{
            if (!canQuickRelease()) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($6b770800b7ad53e2$var$ButtonGroupItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                isDisabled: showSpinner,
                onClick: onReleaseClicked
            }, formatMessage((0, (0, parcelRequire("camqO")).default).releaseAction)));
        };
        const renderDropdownItem = (action, message, analyticsEventTitle, href, testId, disabledTooltipMessage, preload)=>{
            const otherProps = testId ? {
                'data-test-id': testId
            } : {};
            if (disabledTooltipMessage) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage(disabledTooltipMessage)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                onClick: action,
                isDisabled: true,
                href: href,
                ...otherProps,
                UNSAFE_shouldDisableRouterLink: true
            }, formatMessage(message)));
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                onFocus: preload || undefined,
                onMouseOver: preload || undefined
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($6b770800b7ad53e2$var$DropdownItemWithAnalytics, {
                onClick: (_e, analyticsEvent)=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, analyticsEventTitle);
                    action();
                },
                href: href,
                ...otherProps
            }, formatMessage(message)));
        };
        const renderDropdownGroup = ()=>{
            if (!canBeArchived()) {
                const innerContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderDropdownItem(onUnarchiveClicked, (0, (0, parcelRequire("camqO")).default).unarchiveAction, 'unarchive'), canMergeVersions() ? renderDropdownItem(onMergeClicked, (0, (0, parcelRequire("camqO")).default).mergeAction, 'merge', undefined, undefined, undefined, loadMergeQuery) : null, renderDropdownItem(onEditClicked, (0, (0, parcelRequire("camqO")).default).editAction, 'edit', undefined, undefined, undefined, loadEditQuery), renderDropdownItem(onDeleteClicked, (0, (0, parcelRequire("camqO")).default).deleteAction, 'delete', undefined, undefined, !canDelete() ? (0, (0, parcelRequire("camqO")).default).deleteActionDisabledTooltip : undefined));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, innerContent);
            }
            const innerContentDefault = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !canQuickRelease() && canBeReleased() ? renderDropdownItem(onReleaseClicked, (0, (0, parcelRequire("camqO")).default).releaseAction, 'release', undefined, 'project-directories.versions.main.release-version-item') : null, canBeUnreleased() ? renderDropdownItem(onUnreleaseClicked, (0, (0, parcelRequire("camqO")).default).unreleaseAction, 'unrelease') : null, renderDropdownItem(onArchiveClicked, (0, (0, parcelRequire("camqO")).default).archiveAction, 'archive'), canMergeVersions() ? renderDropdownItem(onMergeClicked, (0, (0, parcelRequire("camqO")).default).mergeAction, 'merge', undefined, undefined, undefined, loadMergeQuery) : null, renderDropdownItem(onEditClicked, (0, (0, parcelRequire("camqO")).default).editAction, 'edit', undefined, undefined, undefined, loadEditQuery), renderDropdownItem(onDeleteClicked, (0, (0, parcelRequire("camqO")).default).deleteAction, 'delete', undefined, 'project-directories.versions.main.delete-version-item', !canDelete() ? (0, (0, parcelRequire("camqO")).default).deleteActionDisabledTooltip : undefined));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, innerContentDefault);
        };
        const IconBefore = showSpinner ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6b770800b7ad53e2$var$spinnerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
            label: "More"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6b770800b7ad53e2$var$ActionsCellWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ldJSL")).default), null, renderReleaseButton(), (0, ($parcel$interopDefault($5uXOq))).createElement($6b770800b7ad53e2$var$ButtonGroupItem, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            placement: "bottom-end",
            trigger: ({ triggerRef: triggerRef, onClick: onClick, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...props,
                    onClick: (event, analyticsEvent)=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'versionAction');
                        if (onClick != null) onClick(event);
                    },
                    ref: triggerRef,
                    appearance: "subtle",
                    iconBefore: IconBefore,
                    isDisabled: showSpinner
                }),
            defaultOpen: false
        }, renderDropdownGroup()))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, editReleaseFormQueryRef && editVersionModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("0ceWi")).EditReleaseModal), {
            versionId: version.versionId,
            isOpen: editVersionModalOpen,
            onClose: ()=>setEditVersionModalOpen(false),
            queryReference: editReleaseFormQueryRef
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "flag",
            packageName: "jiraProjectVersions",
            teamName: "fusion-solaris",
            id: "releasesReleaseNotesModal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "release-notes-modal",
            fallback: null
        }, isReleaseNotesModalOpen && releaseNotesQueryRef && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4i1Dv")).ReleaseNotesModal), {
            queryReference: releaseNotesQueryRef,
            onClose: ()=>setIsReleaseNotesModalOpen(false)
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isReleaseModalOpen && hasReleaseNote !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lqWUw")).default), {
            baseUrl: "",
            locale: locale,
            projectKey: project.key,
            versionId: version.versionId,
            onOpened: (0, ($parcel$interopDefault($8Rkzz))),
            onCancel: ()=>setIsReleaseModalOpen(false),
            onSuccess: (_updatedVersion, params)=>{
                setIsReleaseModalOpen(false);
                updateStoreOnReleased();
                if (params && params.shouldRedirectToCreateReleaseNotes) setIsReleaseNotesModalOpen(true);
            },
            onError: ()=>{
                showFlag({
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("camqO")).default).genericUpdateFailedFlagTitle),
                    description: formatMessage((0, (0, parcelRequire("camqO")).default).releaseFailedFlagDescription)
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: new Error('Failed to release the version'),
                    meta: {
                        id: 'jiraProjectVersionsReleaseModal',
                        packageName: 'jiraProjectVersions',
                        teamName: 'fusion-solaris'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            shouldShowCreateReleaseNotesOption: !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)(),
            hasReleaseNote: hasReleaseNote ?? false
        })), mergeReleaseFormQueryRef && mergeVersionModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("51R3o")).MergeReleaseModal), {
            jiraVersion: version,
            queryReference: mergeReleaseFormQueryRef,
            onClose: ()=>setMergeVersionModalOpen(false)
        }), isDeleteVersionModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "flag",
            packageName: "jiraProjectVersions",
            teamName: "fusion-solaris",
            id: "releasesDeleteModal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kB2wS")).default), {
            baseUrl: "",
            projectKey: projectKey,
            version: {
                id: version.versionId,
                name: version.name
            },
            onError: ()=>{
                showFlag({
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("camqO")).default).deleteFailedTitle),
                    description: formatMessage((0, (0, parcelRequire("camqO")).default).deleteFailedDescription)
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: new Error('Failed to delete the version'),
                    meta: {
                        id: 'jiraProjectVersionsDeleteModal',
                        packageName: 'jiraProjectVersions',
                        teamName: 'fusion-solaris'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onSuccess: (successParams)=>{
                showFlag({
                    type: 'success',
                    title: formatMessage((0, (0, parcelRequire("camqO")).default).deleteTitle, {
                        name: version.name
                    })
                });
                updateStoreOnDelete(successParams.movedRelatedIssuesTo);
            },
            onCancel: ()=>setIsDeleteVersionModalOpen(false),
            onOpened: (0, ($parcel$interopDefault($8Rkzz)))
        })));
    };
    var $6b770800b7ad53e2$export$2e2bcd8739ae039 = $6b770800b7ad53e2$var$ActionsCell;
    const $6b770800b7ad53e2$var$spinnerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: 'space.025',
        width: 'space.025'
    });
    const $6b770800b7ad53e2$var$ButtonGroupItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41b66",
                __cmplp.className
            ])
        });
    });
    const $6b770800b7ad53e2$var$ActionsCellWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21sbv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cJEGL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f02a417887652cf$export$2e2bcd8739ae039);
    const $3f02a417887652cf$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "input"
                            }
                        ],
                        "concreteType": "JiraUpdateVersionPayload",
                        "kind": "LinkedField",
                        "name": "deleteJiraVersionWithNoIssues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "success"
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "actions_deleteVersionWithNoIssuesMutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "actions_deleteVersionWithNoIssuesMutation",
                "selections": v1
            },
            "params": {
                "id": "5c9ba59756316e1ee64f1543626c9781e9bdc074e90056f11cf2c1ae0ed92f25",
                "metadata": {},
                "name": "actions_deleteVersionWithNoIssuesMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $3f02a417887652cf$var$node.hash = "b81aa40061fe9aaae97b566e66bb6164";
    var $3f02a417887652cf$export$2e2bcd8739ae039 = $3f02a417887652cf$var$node;
});
parcelRegister("bcBCK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f64fd3a053799af$export$2e2bcd8739ae039);
    const $4f64fd3a053799af$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "status"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "actions_updateVersionArchivedMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionArchivedStatus",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "actions_updateVersionArchivedMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionArchivedStatus",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "5cf4f9a703d62bd2a8533178b0a0aa399f1de2f3c946bddac7ffc8b2f7fbc28f",
                "metadata": {},
                "name": "actions_updateVersionArchivedMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $4f64fd3a053799af$var$node.hash = "072694ea470a98bb3011a1ec0f8078ca";
    var $4f64fd3a053799af$export$2e2bcd8739ae039 = $4f64fd3a053799af$var$node;
});
parcelRegister("1dEUP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fa11fed8769151e$export$2e2bcd8739ae039);
    const $8fa11fed8769151e$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "kind": "ScalarField",
            "name": "status"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "actions_updateVersionReleasedMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionReleasedStatus",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "actions_updateVersionReleasedMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUpdateVersionPayload",
                                "kind": "LinkedField",
                                "name": "updateVersionReleasedStatus",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "00a59505c39bdec9611c09609b088eb9b01dc4a27e481b28382e3db659bcec17",
                "metadata": {},
                "name": "actions_updateVersionReleasedMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $8fa11fed8769151e$var$node.hash = "de8237e18f09aa8fe2fa05dd5d8cd028";
    var $8fa11fed8769151e$export$2e2bcd8739ae039 = $8fa11fed8769151e$var$node;
});
parcelRegister("731G3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4809eebb1ef0202f$export$2e2bcd8739ae039);
    const $4809eebb1ef0202f$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "actions_projectVersions_ActionsCell_jiraProject",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            }
        ],
        "type": "JiraProject"
    };
    $4809eebb1ef0202f$var$node.hash = "89a8fb84e50bfcb14d124a20a8989874";
    var $4809eebb1ef0202f$export$2e2bcd8739ae039 = $4809eebb1ef0202f$var$node;
});
parcelRegister("fxqay", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6befabbe4e40cb14$export$2e2bcd8739ae039);
    const $6befabbe4e40cb14$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "totalCount"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "actions_projectVersions_ActionsCell_jiraVersion",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "id"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    "action": "THROW",
                    "path": "name"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "versionId"
                    },
                    "action": "THROW",
                    "path": "versionId"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "status"
                    },
                    "action": "THROW",
                    "path": "status"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "allIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "ALL"
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "allIssues.totalCount"
                            }
                        ],
                        "storageKey": "issues(filter:\"ALL\")"
                    },
                    "action": "THROW",
                    "path": "allIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "doneIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "DONE"
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "doneIssues.totalCount"
                            }
                        ],
                        "storageKey": "issues(filter:\"DONE\")"
                    },
                    "action": "THROW",
                    "path": "doneIssues"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "mergeReleaseModal_softwareReleasesReleaseModalsRelay_jiraVersion"
                },
                {
                    "kind": "ClientExtension",
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "__id"
                            },
                            "action": "THROW",
                            "path": "__id"
                        }
                    ]
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $6befabbe4e40cb14$var$node.hash = "de48072074c29111b9724b11cad9c676";
    var $6befabbe4e40cb14$export$2e2bcd8739ae039 = $6befabbe4e40cb14$var$node;
});
parcelRegister("gT9EG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7eb5e2517cf8aeb8$export$2e2bcd8739ae039);
    const $7eb5e2517cf8aeb8$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "versionId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionId"
            }
        ], v2 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasReleaseNote"
                }
            ],
            "type": "JiraVersion"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "actions_versionHasReleaseNoteQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v2
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "actions_versionHasReleaseNoteQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    v2,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "f93d76c6ef6566bb8fcd64936b6b1bff727e8f9d0d3cc511066903d28697d6e0",
                "metadata": {},
                "name": "actions_versionHasReleaseNoteQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $7eb5e2517cf8aeb8$var$node.hash = "ef82cca181efdaab2168c14aa947a137";
    var $7eb5e2517cf8aeb8$export$2e2bcd8739ae039 = $7eb5e2517cf8aeb8$var$node;
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("cmpyR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80ca2c200763ba21$export$2e2bcd8739ae039);
    const $80ca2c200763ba21$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "versionAri"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionAri"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v3 = {
            "kind": "ScalarField",
            "name": "id"
        }, v4 = {
            "kind": "ScalarField",
            "name": "name"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "editReleaseModalQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "editReleaseForm_softwareReleasesReleaseModalsRelay"
                                                    }
                                                ],
                                                "type": "JiraVersion"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.version"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "editReleaseModalQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            },
                                            v4,
                                            {
                                                "kind": "ScalarField",
                                                "name": "startDate"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "releaseDate"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "status"
                                            },
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "project",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectId"
                                                    },
                                                    v3
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraVersionDriverResult",
                                                "kind": "LinkedField",
                                                "name": "driverData",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "driver",
                                                        "plural": false,
                                                        "selections": [
                                                            v2,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "accountId"
                                                            },
                                                            v4,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "picture"
                                                            },
                                                            v3
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "queryError",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "message"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraVersion"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v3
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "441de3c880d4177455c0d6e8ae98a6f2af92fa46c233a198cc39edf9e4a252a5",
                "metadata": {},
                "name": "editReleaseModalQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $80ca2c200763ba21$var$node.hash = "78bd9d672cd7c6a79f8f0214003cbacd";
    var $80ca2c200763ba21$export$2e2bcd8739ae039 = $80ca2c200763ba21$var$node;
});
parcelRegister("l3bEE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$345b3eecf65678f9$export$2e2bcd8739ae039);
    const $345b3eecf65678f9$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "searchString"
            }
        ], v1 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": [
                    "ARCHIVED",
                    "UNRELEASED",
                    "RELEASED"
                ]
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 6
            },
            {
                "kind": "Variable",
                "name": "jiraProjectId",
                "variableName": "projectAri"
            },
            {
                "kind": "Variable",
                "name": "searchString",
                "variableName": "searchString"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "mergeReleaseModalQuery",
                "selections": [
                    {
                        "args": v1,
                        "kind": "FragmentSpread",
                        "name": "mergeReleaseModal_softwareReleasesReleaseModalsRelay_query"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "mergeReleaseModalQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "id",
                                        "variableName": "projectAri"
                                    }
                                ],
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProject",
                                "plural": false,
                                "selections": [
                                    v2
                                ]
                            },
                            {
                                "args": v1,
                                "concreteType": "JiraVersionConnection",
                                "kind": "LinkedField",
                                "name": "versionsForProject",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersionEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraVersion",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v2,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v1,
                                "filters": [
                                    "jiraProjectId",
                                    "filter",
                                    "searchString"
                                ],
                                "handle": "connection",
                                "key": "mergeReleaseModal_versionsForProject",
                                "kind": "LinkedHandle",
                                "name": "versionsForProject"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "99aa9d7945ae892264764cfa6f33e773b4a15ec64bc45b6db2b6a04345af90fc",
                "metadata": {},
                "name": "mergeReleaseModalQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $345b3eecf65678f9$var$node.hash = "18d434f389db050d0bda57545ded9c74";
    var $345b3eecf65678f9$export$2e2bcd8739ae039 = $345b3eecf65678f9$var$node;
});
parcelRegister("hlRDe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9a3cf061de648cd$export$2e2bcd8739ae039);
    const $c9a3cf061de648cd$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "releaseNoteConfiguration"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionAri"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "versionAri"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = {
            "kind": "ScalarField",
            "name": "canEditRelatedWork"
        }, v6 = {
            "kind": "ScalarField",
            "name": "releasesNotesPreferenceType"
        }, v7 = {
            "kind": "ScalarField",
            "name": "issueKeyConfig"
        }, v8 = {
            "kind": "ScalarField",
            "name": "issueFieldIds"
        }, v9 = {
            "kind": "ScalarField",
            "name": "issueTypeIds"
        }, v10 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 100
            }
        ], v11 = [
            {
                "kind": "Variable",
                "name": "releaseNoteConfiguration",
                "variableName": "releaseNoteConfiguration"
            }
        ], v12 = {
            "kind": "ScalarField",
            "name": "isSystem"
        }, v13 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v14 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ],
            "type": "QueryError"
        }, v15 = {
            "kind": "ScalarField",
            "name": "name"
        }, v16 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v17 = {
            "kind": "ScalarField",
            "name": "endCursor"
        }, v18 = {
            "kind": "ScalarField",
            "name": "hasNextPage"
        }, v19 = [
            {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    v18,
                    v17
                ]
            },
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v3,
                            v4,
                            v15
                        ]
                    },
                    v16
                ]
            }
        ], v20 = [
            "searchString"
        ], v21 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 10
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "uiReleaseNotesModalQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v4,
                                                        "action": "THROW",
                                                        "path": "jira.version.id"
                                                    },
                                                    v5,
                                                    v6,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraReleaseNotesConfiguration",
                                                            "kind": "LinkedField",
                                                            "name": "releaseNotesConfiguration",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7,
                                                                    "action": "THROW",
                                                                    "path": "jira.version.releaseNotesConfiguration.issueKeyConfig"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v8,
                                                                    "action": "THROW",
                                                                    "path": "jira.version.releaseNotesConfiguration.issueFieldIds"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9,
                                                                    "action": "THROW",
                                                                    "path": "jira.version.releaseNotesConfiguration.issueTypeIds"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.version.releaseNotesConfiguration"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "args": v10,
                                                            "concreteType": "JiraIssueTypeConnection",
                                                            "kind": "LinkedField",
                                                            "name": "releaseNotesOptionsIssueTypes",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "JiraIssueTypeEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "FragmentSpread",
                                                                                "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModal_jiraIssueTypeEdges"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.version.releaseNotesOptionsIssueTypes.edges"
                                                                }
                                                            ],
                                                            "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.version.releaseNotesOptionsIssueTypes"
                                                    },
                                                    {
                                                        "args": v11,
                                                        "kind": "FragmentSpread",
                                                        "name": "ui_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalContent_version"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "formattingOptions_softwareReleasesAddReleaseNotesModal"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "embeddedPageReleaseNotes_softwareReleasesAddReleaseNotesModal_EmbeddedPageReleaseNotesModal"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "analyticsContext_softwareReleasesAddReleaseNotesModal_ReleaseNotesModalAnalyticsContext"
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "versionSelector_softwareReleasesAddReleaseNotesModal"
                                                    },
                                                    {
                                                        "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                                        "kind": "LinkedField",
                                                        "name": "availableSites",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v12,
                                                                                        "action": "LOG",
                                                                                        "path": "jira.version.availableSites.edges.node.isSystem"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            "action": "LOG",
                                                                            "path": "jira.version.availableSites.edges.node"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "LOG",
                                                                "path": "jira.version.availableSites.edges"
                                                            }
                                                        ]
                                                    },
                                                    v13
                                                ],
                                                "type": "JiraVersion"
                                            },
                                            v14
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.version"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "uiReleaseNotesModalQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v4,
                                            v5,
                                            v6,
                                            {
                                                "concreteType": "JiraReleaseNotesConfiguration",
                                                "kind": "LinkedField",
                                                "name": "releaseNotesConfiguration",
                                                "plural": false,
                                                "selections": [
                                                    v7,
                                                    v8,
                                                    v9
                                                ]
                                            },
                                            {
                                                "args": v10,
                                                "concreteType": "JiraIssueTypeConnection",
                                                "kind": "LinkedField",
                                                "name": "releaseNotesOptionsIssueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueTypeEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v4,
                                                                    v15,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "xsmall"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v3
                                                                ]
                                                            },
                                                            v16
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "PageInfo",
                                                        "kind": "LinkedField",
                                                        "name": "pageInfo",
                                                        "plural": false,
                                                        "selections": [
                                                            v17,
                                                            v18
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "releaseNotesOptionsIssueTypes(first:100)"
                                            },
                                            {
                                                "args": v10,
                                                "handle": "connection",
                                                "key": "issueTypeSelector_releaseNotesOptionsIssueTypes",
                                                "kind": "LinkedHandle",
                                                "name": "releaseNotesOptionsIssueTypes"
                                            },
                                            {
                                                "args": v11,
                                                "concreteType": "JiraADF",
                                                "kind": "LinkedField",
                                                "name": "releaseNotes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "json"
                                                    }
                                                ]
                                            },
                                            {
                                                "args": v10,
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "releaseNotesOptionsIssueFields",
                                                "plural": false,
                                                "selections": v19,
                                                "storageKey": "releaseNotesOptionsIssueFields(first:100)"
                                            },
                                            {
                                                "args": v10,
                                                "filters": v20,
                                                "handle": "connection",
                                                "key": "issueFieldSelectors_releaseNotesOptionsIssueFields",
                                                "kind": "LinkedHandle",
                                                "name": "releaseNotesOptionsIssueFields"
                                            },
                                            {
                                                "args": v21,
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "nativeReleaseNotesOptionsIssueFields",
                                                "plural": false,
                                                "selections": v19,
                                                "storageKey": "nativeReleaseNotesOptionsIssueFields(first:10)"
                                            },
                                            {
                                                "args": v21,
                                                "filters": v20,
                                                "handle": "connection",
                                                "key": "issueFieldSelectors_nativeReleaseNotesOptionsIssueFields",
                                                "kind": "LinkedHandle",
                                                "name": "nativeReleaseNotesOptionsIssueFields"
                                            },
                                            {
                                                "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesConnection",
                                                "kind": "LinkedField",
                                                "name": "availableSites",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraReleaseNotesInConfluenceAvailableSitesEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraReleaseNotesInConfluenceAvailableSite",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v12
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            v13
                                        ],
                                        "type": "JiraVersion"
                                    },
                                    v14,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v4
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "37f717b64e4486e6291f013eacaff04d5801050c0cedd59372868f44083b4686",
                "metadata": {},
                "name": "uiReleaseNotesModalQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $c9a3cf061de648cd$var$node.hash = "f68c70e5840c60381e97022c22e35462";
    var $c9a3cf061de648cd$export$2e2bcd8739ae039 = $c9a3cf061de648cd$var$node;
});
parcelRegister("4i1Dv", function(module, exports) {
    $parcel$export(module.exports, "ReleaseNotesModal", ()=>$4e0db3a273624333$export$d334132901e7fcb2);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1R1Ge;
    var $7QSqG;
    var $eZJjh;
    var $9fuVs;
    var $4R6GH;
    var $lfTZh;
    var $kxZPA;
    const $4e0db3a273624333$var$LazyReleaseNotesModalContent = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("4qdC1")).then((module)=>module.ReleaseNotesModalContent), {
        moduleId: "./src/packages/releases/release-notes-modal/src/ui/index.tsx"
    });
    const $4e0db3a273624333$var$LazyEmbeddedPageReleaseNotesEditorModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("f9ftL")).then((module)=>module.EmbeddedPageReleaseNotesEditorModal), {
        moduleId: "./src/packages/releases/release-notes-modal/src/ui/embedded-page-release-notes-editor-modal/index.tsx"
    });
    const $4e0db3a273624333$var$LoadingModalBody = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$export$43a792a870d28db2, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "large"
        })));
    const $4e0db3a273624333$export$d334132901e7fcb2 = (props)=>{
        const [confluenceReleaseNotesDraftUrl, setConfluenceReleaseNotesDraftUrl] = (0, $5uXOq.useState)(null);
        const { onClose: onClose } = props;
        const onCreateConfluenceReleaseNotes = (0, $5uXOq.useCallback)((draftUrl)=>{
            setConfluenceReleaseNotesDraftUrl(draftUrl);
        }, []);
        const onCloseConfluenceReleaseNotes = (0, $5uXOq.useCallback)(()=>{
            setConfluenceReleaseNotesDraftUrl(null);
            onClose();
        }, [
            onClose
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, (0, parcelRequire("4R6GH")).fg)('embedded_automated_release_notes') && confluenceReleaseNotesDraftUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$var$LazyEmbeddedPageReleaseNotesEditorModal, {
            draftUrl: confluenceReleaseNotesDraftUrl,
            onClose: onCloseConfluenceReleaseNotes
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "x-large",
            autoFocus: false,
            onClose: props.onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "release-notes-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$var$LoadingModalBody, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4e0db3a273624333$var$LazyReleaseNotesModalContent, {
            ...props,
            onCreateConfluenceReleaseNotes: onCreateConfluenceReleaseNotes
        }))));
    };
    const $4e0db3a273624333$export$43a792a870d28db2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kdj",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("4qdC1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cXbgi")
    ]).then(()=>parcelRequire('lk3mD'));
});
parcelRegister("f9ftL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("6C8yY")
    ]).then(()=>parcelRequire('8qZpw'));
});
parcelRegister("02grs", function(module, exports) {
    $parcel$export(module.exports, "useEditReleaseExperienceStart", ()=>$a06d564ad0f6c8e3$export$577bb5b810a3f6a6);
    $parcel$export(module.exports, "useEditReleaseExperienceFail", ()=>$a06d564ad0f6c8e3$export$469ee200c06358a7);
    $parcel$export(module.exports, "useEditReleaseExperienceSuccess", ()=>$a06d564ad0f6c8e3$export$83d1c1cb383d6e6b);
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $a06d564ad0f6c8e3$export$52919046b94109dc = 'editRelease';
    const $a06d564ad0f6c8e3$export$577bb5b810a3f6a6 = (analyticsSource)=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: $a06d564ad0f6c8e3$export$52919046b94109dc,
            experienceId: `${Date.now()}`,
            analyticsSource: analyticsSource,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE),
            edition: appEditions.software
        });
    };
    const $a06d564ad0f6c8e3$export$469ee200c06358a7 = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $a06d564ad0f6c8e3$export$52919046b94109dc
        });
    const $a06d564ad0f6c8e3$export$83d1c1cb383d6e6b = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: $a06d564ad0f6c8e3$export$52919046b94109dc
        });
});
parcelRegister("5fLvR", function(module, exports) {
    $parcel$export(module.exports, "useMergeReleaseExperienceStart", ()=>$76ed61f26a204f0b$export$c4e891e089b16790);
    $parcel$export(module.exports, "useMergeReleaseExperienceFail", ()=>$76ed61f26a204f0b$export$e8301e99207d212b);
    $parcel$export(module.exports, "useMergeReleaseExperienceSuccess", ()=>$76ed61f26a204f0b$export$d6f0dd934084b04a);
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $efvDm;
    var $k9JTq;
    const $76ed61f26a204f0b$export$52919046b94109dc = 'mergeRelease';
    const $76ed61f26a204f0b$export$c4e891e089b16790 = (analyticsSource)=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        return (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: $76ed61f26a204f0b$export$52919046b94109dc,
            experienceId: `${Date.now()}`,
            analyticsSource: analyticsSource,
            application: (0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE),
            edition: appEditions.software
        });
    };
    const $76ed61f26a204f0b$export$e8301e99207d212b = ()=>(0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: $76ed61f26a204f0b$export$52919046b94109dc
        });
    const $76ed61f26a204f0b$export$d6f0dd934084b04a = ()=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: $76ed61f26a204f0b$export$52919046b94109dc
        });
});
parcelRegister("0ceWi", function(module, exports) {
    $parcel$export(module.exports, "EditReleaseModal", ()=>$4d28033e0cf07afd$export$6569c3e6e9f50540);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    var $02grs;
    const $4d28033e0cf07afd$var$LazyEditReleaseModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("fJP0s")).then((module)=>module.EditReleaseModal), {
        moduleId: "./src/packages/releases/release-modals-relay/src/ui/edit-release-modal/index.tsx"
    });
    const $4d28033e0cf07afd$export$6569c3e6e9f50540 = (props)=>{
        const experienceFail = (0, (0, parcelRequire("02grs")).useEditReleaseExperienceFail)();
        return props.isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            packageName: "jiraSoftwareReleasesReleaseModalsRelay",
            teamName: "fusion-solaris",
            id: "editReleaseModal",
            fallback: "flag",
            onError: (location, error)=>experienceFail(location, error)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "edit-release-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4d28033e0cf07afd$var$LazyEditReleaseModal, props))) : null;
    };
});
parcelRegister("fJP0s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eTLou")
    ]).then(()=>parcelRequire('2tfTH'));
});
parcelRegister("51R3o", function(module, exports) {
    $parcel$export(module.exports, "MergeReleaseModal", ()=>$dfd43bdcd69bc9ec$export$d42ace32f7ad150f);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $kxZPA;
    const $dfd43bdcd69bc9ec$var$LazyMergeReleaseModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("caU0q")).then((module)=>module.MergeReleaseModal), {
        moduleId: "./src/packages/releases/release-modals-relay/src/ui/merge-release-modal/index.tsx"
    });
    const $dfd43bdcd69bc9ec$export$d42ace32f7ad150f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "merge-release-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($dfd43bdcd69bc9ec$var$LazyMergeReleaseModal, props));
});
parcelRegister("caU0q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1UMDq").then(()=>parcelRequire('e5Hb4'));
});
parcelRegister("kB2wS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$457a6b6b653a24f2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jD5no;
    var $lf2Au;
    var $9pe79;
    var $35GOq;
    var $Oh7JP;
    var $amHIM;
    var $hGJRM;
    class $457a6b6b653a24f2$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.store = (0, (0, parcelRequire("amHIM")).default)((0, (0, parcelRequire("35GOq")).default));
            this.store.dispatch((0, (0, parcelRequire("Oh7JP")).initializeAppProps)(this.props));
            this.store.dispatch((0, (0, parcelRequire("Oh7JP")).getRelatedIssuesCount)());
        }
        componentDidUpdate(prevProps) {
            if ((0, (0, parcelRequire("9pe79")).default)(prevProps, this.props)) return;
            this.store.dispatch((0, (0, parcelRequire("Oh7JP")).initializeAppProps)(this.props));
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
                store: this.store
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lf2Au")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hGJRM")).default), null)));
        }
    }
});
parcelRegister("lf2Au", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9249f8c63b854f95$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $gwIPs;
    var $cSD7y;
    const $9249f8c63b854f95$var$AppStyle = ({ children: children })=>$5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ect41sbm _1wyb1oud _4t3i1kw7 _1dyz4jg8"
            ])
        }, children);
    const $9249f8c63b854f95$var$AppStyleOld = (0, $47bDC.default).div.withConfig({
        componentId: "h5xpn2-0"
    })({
        fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
        fontSize: `${(0, (0, parcelRequire("gwIPs")).fontSize)}px`,
        height: 'inherit',
        letterSpacing: 'normal'
    });
    const $9249f8c63b854f95$var$appStyles = null;
    const $9249f8c63b854f95$var$AppStyleFinal = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jfp-1020-use-compiled', $9249f8c63b854f95$var$AppStyle, $9249f8c63b854f95$var$AppStyleOld);
    var $9249f8c63b854f95$export$2e2bcd8739ae039 = $9249f8c63b854f95$var$AppStyleFinal;
});
parcelRegister("35GOq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de0573106bf23613$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $ifZKc;
    var $6UZsn;
    var $5wq6N;
    var $laSs4;
    var $de0573106bf23613$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("5wq6N")).epic), (0, (0, parcelRequire("6UZsn")).epic), (0, (0, parcelRequire("ifZKc")).errorEpic), (0, (0, parcelRequire("ifZKc")).successEpic), (0, (0, parcelRequire("ifZKc")).cancelEpic), (0, (0, parcelRequire("ifZKc")).modalShownEpic), (0, (0, parcelRequire("laSs4")).epic));
});
parcelRegister("ifZKc", function(module, exports) {
    $parcel$export(module.exports, "cancelEpic", ()=>$9ecd4c6331698bef$export$54b67771de971d85);
    $parcel$export(module.exports, "successEpic", ()=>$9ecd4c6331698bef$export$37094086df254c90);
    $parcel$export(module.exports, "modalShownEpic", ()=>$9ecd4c6331698bef$export$b8769bb96f58e8ad);
    $parcel$export(module.exports, "errorEpic", ()=>$9ecd4c6331698bef$export$6b665fe9832a87ab);
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $Oh7JP;
    var $9Buuq;
    const $9ecd4c6331698bef$export$54b67771de971d85 = (action$, store)=>action$.ofType((0, (0, parcelRequire("Oh7JP")).CANCEL)).mergeMap(()=>{
            (0, (0, parcelRequire("9Buuq")).getCancelCallback)(store.getState())();
            return (0, $kVLXA.Observable).empty();
        });
    const $9ecd4c6331698bef$export$37094086df254c90 = (action$, store)=>action$.ofType((0, (0, parcelRequire("Oh7JP")).DELETION_SUCCESS)).mergeMap(()=>{
            const state = store.getState();
            (0, (0, parcelRequire("9Buuq")).getSuccessCallback)(state)({
                movedRelatedIssuesTo: (0, (0, parcelRequire("9Buuq")).getTargetVersionForFixVersionField)(state)
            });
            return (0, $kVLXA.Observable).empty();
        });
    const $9ecd4c6331698bef$export$b8769bb96f58e8ad = (action$, store)=>action$.ofType((0, (0, parcelRequire("Oh7JP")).SHOW_DIALOG)).mergeMap(()=>{
            const state = store.getState();
            (0, (0, parcelRequire("9Buuq")).getModalShownCallback)(state)();
            return (0, $kVLXA.Observable).empty();
        });
    const $9ecd4c6331698bef$export$6b665fe9832a87ab = (action$, store)=>action$.ofType((0, (0, parcelRequire("Oh7JP")).DELETION_FAILURE)).mergeMap((action)=>{
            (0, (0, parcelRequire("9Buuq")).getErrorCallback)(store.getState())(action.payload);
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("Oh7JP", function(module, exports) {
    $parcel$export(module.exports, "INITIALIZE_APP_PROPS", ()=>$323d3aaa5bb2a170$export$84856e4ae7cd7538);
    $parcel$export(module.exports, "initializeAppProps", ()=>$323d3aaa5bb2a170$export$5f0e35553cecddfe);
    $parcel$export(module.exports, "GET_RELATED_ISSUES_COUNT", ()=>$323d3aaa5bb2a170$export$615f9c4a62763ff3);
    $parcel$export(module.exports, "getRelatedIssuesCount", ()=>$323d3aaa5bb2a170$export$cbaa0ff7bfb57fc);
    $parcel$export(module.exports, "SET_RELATED_ISSUES_COUNT", ()=>$323d3aaa5bb2a170$export$7e8b8dbf8b2d288c);
    $parcel$export(module.exports, "setRelatedIssuesCount", ()=>$323d3aaa5bb2a170$export$27989d72f62c8ab5);
    $parcel$export(module.exports, "SHOW_DIALOG", ()=>$323d3aaa5bb2a170$export$b41a4d6f993c3c30);
    $parcel$export(module.exports, "showDialog", ()=>$323d3aaa5bb2a170$export$61e0a65f251cfdb3);
    $parcel$export(module.exports, "DELETE_VERSION", ()=>$323d3aaa5bb2a170$export$16dd37fceb6070aa);
    $parcel$export(module.exports, "deleteVersion", ()=>$323d3aaa5bb2a170$export$deb9d79d96b11bc6);
    $parcel$export(module.exports, "SET_OPERATION_FOR_FIELD", ()=>$323d3aaa5bb2a170$export$ae4fc50e7b424b6f);
    $parcel$export(module.exports, "setOperationForField", ()=>$323d3aaa5bb2a170$export$e05bdbc3d852df90);
    $parcel$export(module.exports, "SET_VERSION_FOR_FIELD", ()=>$323d3aaa5bb2a170$export$e2c9bbdeccabda4f);
    $parcel$export(module.exports, "setVersionForField", ()=>$323d3aaa5bb2a170$export$128dcd6805442f12);
    $parcel$export(module.exports, "DELETION_SUCCESS", ()=>$323d3aaa5bb2a170$export$e212c7761003d0c0);
    $parcel$export(module.exports, "deletionSuccess", ()=>$323d3aaa5bb2a170$export$ac8a826dc2795329);
    $parcel$export(module.exports, "DELETION_FAILURE", ()=>$323d3aaa5bb2a170$export$3e9642deec0d27d1);
    $parcel$export(module.exports, "deletionFailure", ()=>$323d3aaa5bb2a170$export$c94cb18caba25f86);
    $parcel$export(module.exports, "CANCEL", ()=>$323d3aaa5bb2a170$export$2b10f4b30fb65583);
    $parcel$export(module.exports, "cancel", ()=>$323d3aaa5bb2a170$export$70b61ad426ddbe54);
    const $323d3aaa5bb2a170$export$84856e4ae7cd7538 = 'delete-version.state.INITIALIZE_APP_PROPS';
    const $323d3aaa5bb2a170$export$5f0e35553cecddfe = (appProps)=>({
            type: $323d3aaa5bb2a170$export$84856e4ae7cd7538,
            payload: appProps
        });
    const $323d3aaa5bb2a170$export$615f9c4a62763ff3 = 'delete-version.state.GET_RELATED_ISSUES_COUNT';
    const $323d3aaa5bb2a170$export$cbaa0ff7bfb57fc = ()=>({
            type: $323d3aaa5bb2a170$export$615f9c4a62763ff3
        });
    const $323d3aaa5bb2a170$export$7e8b8dbf8b2d288c = 'delete-version.state.SET_RELATED_ISSUES_COUNT';
    const $323d3aaa5bb2a170$export$27989d72f62c8ab5 = (payload)=>({
            type: $323d3aaa5bb2a170$export$7e8b8dbf8b2d288c,
            payload: payload
        });
    const $323d3aaa5bb2a170$export$b41a4d6f993c3c30 = 'delete-version.state.SHOW_DIALOG';
    const $323d3aaa5bb2a170$export$61e0a65f251cfdb3 = ()=>({
            type: $323d3aaa5bb2a170$export$b41a4d6f993c3c30
        });
    const $323d3aaa5bb2a170$export$16dd37fceb6070aa = 'delete-version.state.DELETE_VERSION';
    const $323d3aaa5bb2a170$export$deb9d79d96b11bc6 = ()=>({
            type: $323d3aaa5bb2a170$export$16dd37fceb6070aa
        });
    const $323d3aaa5bb2a170$export$ae4fc50e7b424b6f = 'delete-version.state.SET_OPERATION_FOR_FIELD';
    const $323d3aaa5bb2a170$export$e05bdbc3d852df90 = (payload)=>({
            type: $323d3aaa5bb2a170$export$ae4fc50e7b424b6f,
            payload: payload
        });
    const $323d3aaa5bb2a170$export$e2c9bbdeccabda4f = 'delete-version.state.SET_VERSION_FOR_FIELD';
    const $323d3aaa5bb2a170$export$128dcd6805442f12 = (payload)=>({
            type: $323d3aaa5bb2a170$export$e2c9bbdeccabda4f,
            payload: payload
        });
    const $323d3aaa5bb2a170$export$e212c7761003d0c0 = 'delete-version.state.DELETION_SUCCESS';
    const $323d3aaa5bb2a170$export$ac8a826dc2795329 = ()=>({
            type: $323d3aaa5bb2a170$export$e212c7761003d0c0
        });
    const $323d3aaa5bb2a170$export$3e9642deec0d27d1 = 'delete-version.state.DELETION_FAILURE';
    const $323d3aaa5bb2a170$export$c94cb18caba25f86 = (payload)=>({
            type: $323d3aaa5bb2a170$export$3e9642deec0d27d1,
            payload: payload
        });
    const $323d3aaa5bb2a170$export$2b10f4b30fb65583 = 'delete-version.state.CANCEL';
    const $323d3aaa5bb2a170$export$70b61ad426ddbe54 = ()=>({
            type: $323d3aaa5bb2a170$export$2b10f4b30fb65583
        });
});
parcelRegister("9Buuq", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$fa9674d97c78315f$export$f654b28f82155665);
    $parcel$export(module.exports, "getProjectKey", ()=>$fa9674d97c78315f$export$667f2a0f99c75faa);
    $parcel$export(module.exports, "getVersionName", ()=>$fa9674d97c78315f$export$1c8770fb67bc1686);
    $parcel$export(module.exports, "getVersionId", ()=>$fa9674d97c78315f$export$d0a84488c5034e2b);
    $parcel$export(module.exports, "getSuccessCallback", ()=>$fa9674d97c78315f$export$f916928c6ed991ef);
    $parcel$export(module.exports, "getErrorCallback", ()=>$fa9674d97c78315f$export$be7719b1c8edb902);
    $parcel$export(module.exports, "getCancelCallback", ()=>$fa9674d97c78315f$export$daa6fcadbe6b8199);
    $parcel$export(module.exports, "getModalShownCallback", ()=>$fa9674d97c78315f$export$b4b8c1e0789de5b);
    $parcel$export(module.exports, "getFields", ()=>$fa9674d97c78315f$export$d5523731e7fe4ded);
    $parcel$export(module.exports, "getSortedFields", ()=>$fa9674d97c78315f$export$556e7723f75d8f85);
    $parcel$export(module.exports, "getFieldOperation", ()=>$fa9674d97c78315f$export$5c89158bea368dea);
    $parcel$export(module.exports, "isFieldVersionPickerDisabled", ()=>$fa9674d97c78315f$export$5cf1684ed04fcae4);
    $parcel$export(module.exports, "getFieldTargetVersion", ()=>$fa9674d97c78315f$export$ffcc490b2a32206e);
    $parcel$export(module.exports, "getTargetVersionForFixVersionField", ()=>$fa9674d97c78315f$export$70b9462681b3dcab);
    $parcel$export(module.exports, "isDialogVisible", ()=>$fa9674d97c78315f$export$6931412cced8431b);
    $parcel$export(module.exports, "isSwapValid", ()=>$fa9674d97c78315f$export$fba1dcdce680a78);
    $parcel$export(module.exports, "isInProgress", ()=>$fa9674d97c78315f$export$350bfa81fecdb6f3);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $1vvHL;
    const $fa9674d97c78315f$export$f654b28f82155665 = (state)=>state.baseUrl;
    const $fa9674d97c78315f$export$667f2a0f99c75faa = (state)=>state.projectKey;
    const $fa9674d97c78315f$export$1c8770fb67bc1686 = (state)=>state.version.name;
    const $fa9674d97c78315f$export$d0a84488c5034e2b = (state)=>state.version.id;
    const $fa9674d97c78315f$export$f916928c6ed991ef = (state)=>state.onSuccess;
    const $fa9674d97c78315f$export$be7719b1c8edb902 = (state)=>state.onError;
    const $fa9674d97c78315f$export$daa6fcadbe6b8199 = (state)=>state.onCancel;
    const $fa9674d97c78315f$export$b4b8c1e0789de5b = (state)=>state.onOpened;
    const $fa9674d97c78315f$export$d5523731e7fe4ded = (state)=>Object.values(state.fields);
    const $fa9674d97c78315f$export$556e7723f75d8f85 = (0, $dGvGJ.createSelector)([
        $fa9674d97c78315f$export$d5523731e7fe4ded
    ], (fields)=>{
        const fieldIdx = (field)=>{
            if (field.id === (0, (0, parcelRequire("1vvHL")).FIXED_IN).id) return 2;
            if (field.id === (0, (0, parcelRequire("1vvHL")).AFFECTS).id) return 1;
            return 0;
        };
        const sortFields = (fo1, fo2)=>fieldIdx(fo2.relatedField.field) - fieldIdx(fo1.relatedField.field);
        return fields.sort(sortFields);
    });
    const $fa9674d97c78315f$export$5c89158bea368dea = (state, id)=>state.fields[id] && state.fields[id].operation;
    const $fa9674d97c78315f$export$5cf1684ed04fcae4 = (state, id)=>state.inProgress || $fa9674d97c78315f$export$5c89158bea368dea(state, id) === (0, $df74d50e6f902fa3$export$4bd2facc4a3e6aa1);
    const $fa9674d97c78315f$export$ffcc490b2a32206e = (state, id)=>state.fields[id] && state.fields[id].targetVersion;
    const $fa9674d97c78315f$export$70b9462681b3dcab = (state)=>$fa9674d97c78315f$export$5c89158bea368dea(state, (0, (0, parcelRequire("1vvHL")).FIXED_IN).id) === (0, $df74d50e6f902fa3$export$346f08c1f0d0fe41) ? $fa9674d97c78315f$export$ffcc490b2a32206e(state, (0, (0, parcelRequire("1vvHL")).FIXED_IN).id) : undefined;
    const $fa9674d97c78315f$export$6931412cced8431b = (state)=>state.isVisible;
    const $fa9674d97c78315f$export$fba1dcdce680a78 = (0, $dGvGJ.createSelector)([
        $fa9674d97c78315f$export$d5523731e7fe4ded
    ], (fields)=>fields.reduce((valid, { operation: operation, targetVersion: targetVersion })=>valid && (operation !== (0, $df74d50e6f902fa3$export$346f08c1f0d0fe41) || Boolean(targetVersion)), true));
    const $fa9674d97c78315f$export$350bfa81fecdb6f3 = (state)=>state.inProgress;
});
const $df74d50e6f902fa3$export$346f08c1f0d0fe41 = 'move';
const $df74d50e6f902fa3$export$4bd2facc4a3e6aa1 = 'delete';
parcelRegister("1vvHL", function(module, exports) {
    $parcel$export(module.exports, "FIXED_IN", ()=>$f1a3759a32ec416f$export$c1319bacb5863ea8);
    $parcel$export(module.exports, "AFFECTS", ()=>$f1a3759a32ec416f$export$fc27897d4865f00b);
    $parcel$export(module.exports, "default", ()=>$f1a3759a32ec416f$export$2e2bcd8739ae039);
    const $f1a3759a32ec416f$export$c1319bacb5863ea8 = {
        id: 'fixVersion',
        name: 'Fix Version'
    };
    const $f1a3759a32ec416f$export$fc27897d4865f00b = {
        id: 'affectedVersion',
        name: 'Affects version'
    };
    var $f1a3759a32ec416f$export$2e2bcd8739ae039 = [
        $f1a3759a32ec416f$export$c1319bacb5863ea8,
        $f1a3759a32ec416f$export$fc27897d4865f00b
    ];
});
parcelRegister("6UZsn", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$64523588dfaa5b2b$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("9o0uh");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $fsh9d;
    var $dv4WW;
    var $Oh7JP;
    var $9Buuq;
    const $64523588dfaa5b2b$var$LOG_LOCATION = 'project-directories.versions.delete-version.ops.delete';
    const $64523588dfaa5b2b$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("Oh7JP")).DELETE_VERSION)).mergeMap(()=>(0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("dv4WW")).deleteAndSwapVersion)((0, (0, parcelRequire("9Buuq")).getBaseUrl)(store.getState()), (0, (0, parcelRequire("9Buuq")).getVersionId)(store.getState()), (0, (0, parcelRequire("9Buuq")).getFields)(store.getState()))).map((0, (0, parcelRequire("Oh7JP")).deletionSuccess)).catch((error)=>{
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, $64523588dfaa5b2b$var$LOG_LOCATION, (0, $71a059cf91522abc$export$6c87c1302bf5163c));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("Oh7JP")).deletionFailure)(error));
            }));
});
parcelRegister("fsh9d", function(module, exports) {
    $parcel$export(module.exports, "logSafeErrorWithoutCustomerData", ()=>$064efdbf2b7e743c$export$c77be5886e7f1d9e);
    var $dJl1T;
    const $064efdbf2b7e743c$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, message || error.message, error);
    const $064efdbf2b7e743c$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, message || error.message, error);
});
const $71a059cf91522abc$export$595d93fed3fb6b04 = 'jiraReleasesVersions';
const $71a059cf91522abc$export$6c87c1302bf5163c = 'directories.versions.error';
parcelRegister("dv4WW", function(module, exports) {
    $parcel$export(module.exports, "deleteAndSwapVersion", ()=>$9c490572e3a34aee$export$8d0d936cc5a9c564);
    var $6WLMm;
    var $dJl1T;
    var $3MayK;
    var $aKjh2;
    const $9c490572e3a34aee$export$8d0d936cc5a9c564 = (baseUrl, id, swapConfiguration)=>(0, (0, parcelRequire("3MayK")).deleteAndSwapVersion)(baseUrl, id, (0, (0, parcelRequire("aKjh2")).transformSwapConfiguration)(swapConfiguration)).then((result)=>{
            try {
                id && (0, (0, parcelRequire("6WLMm")).default).remove(id);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('project-directories.versions.cache.remove', error.message);
            }
            return result;
        });
});
parcelRegister("6WLMm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad7441a7f1af8523$export$2e2bcd8739ae039);
    var $c3jsi;
    var $cwR1K;
    var $ad7441a7f1af8523$export$2e2bcd8739ae039 = (0, (0, parcelRequire("c3jsi")).default)((0, (0, parcelRequire("cwR1K")).props));
});
parcelRegister("c3jsi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ccdca2a0bd8756d7$export$2e2bcd8739ae039);
    var $8Op28;
    const $ccdca2a0bd8756d7$var$pNothing = ()=>Promise.resolve();
    var $ccdca2a0bd8756d7$export$2e2bcd8739ae039 = (config)=>{
        if (!false) {
            const Cache = (0, (0, parcelRequire("8Op28")).default)(config);
            const getAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
            const get = (key)=>Cache.then((cache)=>cache.get(key));
            const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
            const remove = (key)=>Cache.then((cache)=>cache.delete(key));
            const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
            const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
            const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>Promise.all(entries.map(([key])=>cache.delete(key)))).then(()=>{}));
            return {
                get: get,
                getAll: getAll,
                set: set,
                remove: remove,
                update: update,
                refresh: refresh,
                clearAll: clearAll
            };
        }
        return {
            get: $ccdca2a0bd8756d7$var$pNothing,
            getAll: ()=>Promise.resolve([]),
            set: ()=>Promise.resolve(),
            remove: $ccdca2a0bd8756d7$var$pNothing,
            update: $ccdca2a0bd8756d7$var$pNothing,
            refresh: ()=>Promise.resolve([]),
            clearAll: $ccdca2a0bd8756d7$var$pNothing
        };
    };
});
parcelRegister("8Op28", function(module, exports) {
    $parcel$export(module.exports, "Cache", ()=>$3e46065a4b1d2500$export$94affb487e701bf2);
    $parcel$export(module.exports, "default", ()=>$3e46065a4b1d2500$export$2e2bcd8739ae039);
    var $bSSG7;
    var $eNf8a;
    var $dJl1T;
    var $1NZBJ;
    const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
    function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
        const cache = new Map();
        const { size: size } = props;
        let storage;
        let hasSyncedFromStorage = false;
        const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
            name: `Cache ${props.cacheKey}`,
            serialize: true
        }) : null;
        const syncWithDevTools = (type, payload)=>{
            if ((0, (0, parcelRequire("1NZBJ")).default).devTools) devTools && devTools.send({
                type: type,
                payload: payload
            }, cache, {}, props.cacheKey);
        };
        const removeExpiredKeysFromStorage = async (store)=>{
            const updatedStore = {
                ...store
            };
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
            const { cacheKey: cacheKey, maxAge: maxAge } = props;
            if (maxAge !== undefined) {
                Object.keys(store).forEach((key)=>{
                    const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                    if (keyAge > maxAge) {
                        syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                            [String(key)]: updatedStore[key]
                        });
                        delete updatedStore[key];
                        cache.delete(key);
                    }
                });
                storage.set(cacheKey, updatedStore);
            }
            return updatedStore;
        };
        const removeExpiredEntry = (key, val)=>{
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const { maxAge: maxAge } = props;
                if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: val
                    });
                    cache.delete(key);
                    return true;
                }
            }
            return false;
        };
        const createStore = ()=>{
            if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)((0, (0, parcelRequire("1NZBJ")).CACHE_PREFIX));
            else storage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)((0, (0, parcelRequire("1NZBJ")).CACHE_PREFIX));
            return storage;
        };
        const set = async (key, value)=>{
            await load();
            cache.delete(key);
            const entry = {
                value: value,
                timestamp: Date.now()
            };
            let storedContent = {};
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                storedContent = storage.get(props.cacheKey) || {};
                storedContent[key] = entry;
            }
            cache.set(key, entry);
            syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
                [String(key)]: entry
            });
            if (cache.size > size) {
                const keys = cache.keys();
                const firstEntry = keys.next().value;
                if (firstEntry !== undefined) {
                    cache.delete(firstEntry);
                    syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                    if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) delete storedContent[firstEntry];
                }
            }
            props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
        };
        const load = async ()=>{
            if (false || hasSyncedFromStorage) return;
            hasSyncedFromStorage = true;
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
            const { cacheKey: cacheKey } = props;
            storage = createStore();
            try {
                let data = storage.get(cacheKey) || {};
                data = await removeExpiredKeysFromStorage(data);
                syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
                const orderedKeys = Object.keys(data).sort((key1, key2)=>data[key1].timestamp - data[key2].timestamp);
                await Promise.all(orderedKeys.map(async (key)=>{
                    await set(key, data[key].value);
                }));
            } catch (err) {
                (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
                throw err;
            }
        };
        const clear = async ()=>{
            await load();
            cache.clear();
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const { cacheKey: cacheKey } = props;
                storage.remove(cacheKey);
            }
            syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
        };
        const get = async (key)=>{
            await load();
            let val = cache.get(key);
            if (val) {
                if (removeExpiredEntry(key, val)) val = undefined;
            }
            syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
                [String(key)]: val
            });
            return val && val.value;
        };
        const update = async (key, value)=>{
            await load();
            const previousValue = cache.get(key);
            if (!previousValue) return;
            const entry = {
                value: value,
                timestamp: previousValue.timestamp
            };
            let storedContent = {};
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                storedContent = storage.get(props.cacheKey) || {};
                storedContent[key] = entry;
            }
            cache.set(key, entry);
            syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
                [String(key)]: entry
            });
            props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
        };
        const getEntries = async ()=>{
            await load();
            const entries = Array.from(cache.entries()).filter(([key, value])=>!removeExpiredEntry(key, value));
            syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
            return entries.map(([key, { value: value }])=>[
                    key,
                    value
                ]);
        };
        const deleteEntry = async (key)=>{
            await load();
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const storedContent = storage.get(props.cacheKey) || {};
                delete storedContent[key];
                storage.set(props.cacheKey, storedContent);
            }
            cache.delete(key);
            syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
                [String(key)]: cache.get(key)
            });
        };
        const refresh = async ()=>{
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
            cache.clear();
            hasSyncedFromStorage = false;
            await load();
        };
        if ((0, (0, parcelRequire("1NZBJ")).default).scopes.current !== (0, (0, parcelRequire("1NZBJ")).default).scopes.prev) clear();
        return {
            cache: cache,
            get: get,
            set: set,
            delete: deleteEntry,
            clear: clear,
            load: load,
            update: update,
            getEntries: getEntries,
            refresh: refresh
        };
    }
    const $3e46065a4b1d2500$var$cacheMap = {};
    const $3e46065a4b1d2500$var$getCache = async (props)=>{
        await (0, (0, parcelRequire("1NZBJ")).scopeGuard)().catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
        });
        const { cacheKey: cacheKey } = props;
        $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
        return $3e46065a4b1d2500$var$cacheMap[cacheKey];
    };
    const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
        Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
    };
    var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;
});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';
parcelRegister("cwR1K", function(module, exports) {
    $parcel$export(module.exports, "props", ()=>$2ce541f0114884c6$export$8128bb6492cf3de7);
    const $2ce541f0114884c6$var$MAX_RESULTS = 10;
    const $2ce541f0114884c6$var$CACHE_SIZE = $2ce541f0114884c6$var$MAX_RESULTS * 2;
    const $2ce541f0114884c6$var$VERSIONS_CACHE_KEY = 'versions';
    const $2ce541f0114884c6$export$8128bb6492cf3de7 = {
        size: $2ce541f0114884c6$var$CACHE_SIZE,
        cacheKey: $2ce541f0114884c6$var$VERSIONS_CACHE_KEY,
        maxAge: 604800000,
        storageType: (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)
    };
});
parcelRegister("3MayK", function(module, exports) {
    $parcel$export(module.exports, "deleteAndSwapVersion", ()=>$a0f871507b55cdf0$export$8d0d936cc5a9c564);
    var $aDvGo;
    var $jJZqs;
    const $a0f871507b55cdf0$export$b2e9fbb4ccceec79 = (baseUrl, id)=>`${baseUrl}/rest/api/2/version/${id}/removeAndSwap`;
    const $a0f871507b55cdf0$export$8d0d936cc5a9c564 = async (baseUrl, versionId, swap)=>{
        const response = await fetch($a0f871507b55cdf0$export$b2e9fbb4ccceec79(baseUrl, versionId), {
            ...(0, (0, parcelRequire("aDvGo")).default),
            method: 'POST',
            body: JSON.stringify(swap)
        });
        if (response.ok) return;
        const text = await response.text();
        throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, text);
    };
});
parcelRegister("aKjh2", function(module, exports) {
    $parcel$export(module.exports, "transformSwapConfiguration", ()=>$69988bc36f85133a$export$b87e89a18e0e57e5);
    var $8LQ84 = parcelRequire("8LQ84");
    var $3dHKF = parcelRequire("3dHKF");
    var $1vvHL;
    const $69988bc36f85133a$var$mapFieldToKey = (field, targetVersion)=>{
        if (field.id === (0, (0, parcelRequire("1vvHL")).FIXED_IN).id) return {
            moveFixIssuesTo: targetVersion
        };
        if (field.id === (0, (0, parcelRequire("1vvHL")).AFFECTS).id) return {
            moveAffectedIssuesTo: targetVersion
        };
        return {
            customFieldReplacementList: [
                {
                    customFieldId: field.id,
                    moveTo: targetVersion
                }
            ]
        };
    };
    const $69988bc36f85133a$var$customizer = (objValue, srcValue)=>{
        if ((0, ($parcel$interopDefault($8LQ84)))(objValue)) return objValue.concat(srcValue);
        return undefined;
    };
    const $69988bc36f85133a$export$b87e89a18e0e57e5 = (configuration)=>(0, ($parcel$interopDefault($3dHKF)))({}, ...configuration.map(({ operation: operation, relatedField: relatedField, targetVersion: targetVersion })=>operation === (0, $df74d50e6f902fa3$export$346f08c1f0d0fe41) && targetVersion ? $69988bc36f85133a$var$mapFieldToKey(relatedField.field, targetVersion) : {}), $69988bc36f85133a$var$customizer);
});
parcelRegister("3dHKF", function(module, exports) {
    var $1m1GH = parcelRequire("1m1GH");
    var $9MM2g = parcelRequire("9MM2g");
    var $2584862af7fb4983$var$mergeWith = $9MM2g(function(object, source, srcIndex, customizer) {
        $1m1GH(object, source, srcIndex, customizer);
    });
    module.exports = $2584862af7fb4983$var$mergeWith;
});
parcelRegister("5wq6N", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$dacaff82765911b1$export$8ec5145af6f76965);
    parcelRequire("fp4O3");
    parcelRequire("9o0uh");
    parcelRequire("d0pqD");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $kVLXA = parcelRequire("kVLXA");
    var $fsh9d;
    var $8ajLm;
    var $Oh7JP;
    var $9Buuq;
    const $dacaff82765911b1$var$LOG_LOCATION = 'project-directories.versions.delete-version.ops.get-related-issues-count';
    const $dacaff82765911b1$export$8ec5145af6f76965 = (action$, store)=>action$.ofType((0, (0, parcelRequire("Oh7JP")).GET_RELATED_ISSUES_COUNT)).mergeMap(()=>(0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("8ajLm")).getRelatedIssues)((0, (0, parcelRequire("9Buuq")).getBaseUrl)(store.getState()), (0, (0, parcelRequire("9Buuq")).getVersionId)(store.getState()))).map((relatedIssues)=>(0, (0, parcelRequire("Oh7JP")).setRelatedIssuesCount)(relatedIssues)).catch((error)=>{
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, $dacaff82765911b1$var$LOG_LOCATION, (0, $71a059cf91522abc$export$6c87c1302bf5163c));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("Oh7JP")).deletionFailure)(error));
            }));
});
parcelRegister("8ajLm", function(module, exports) {
    $parcel$export(module.exports, "getRelatedIssues", ()=>$1f6d1ef9fc377b47$export$5d18be4905cf7f19);
    var $8CDBc;
    var $cLNLM;
    const $1f6d1ef9fc377b47$export$5d18be4905cf7f19 = (baseUrl, id)=>(0, (0, parcelRequire("8CDBc")).getRelatedIssueCount)(baseUrl, id).then((0, (0, parcelRequire("cLNLM")).transformRelatedIssueCountsResponse));
});
parcelRegister("8CDBc", function(module, exports) {
    $parcel$export(module.exports, "getRelatedIssueCount", ()=>$ae36eb8f72015cbc$export$a589d742480d1165);
    var $7f4tk;
    const $ae36eb8f72015cbc$export$925758e6be80617a = (baseUrl, id)=>`${baseUrl}/rest/api/2/version/${id}/relatedIssueCounts`;
    const $ae36eb8f72015cbc$export$a589d742480d1165 = (baseUrl, versionId)=>(0, (0, parcelRequire("7f4tk")).default)($ae36eb8f72015cbc$export$925758e6be80617a(baseUrl, versionId));
});
parcelRegister("cLNLM", function(module, exports) {
    $parcel$export(module.exports, "transformRelatedIssueCountsResponse", ()=>$852eb376f5e28cfd$export$95d9c414d6450d15);
    var $1vvHL;
    const $852eb376f5e28cfd$var$affectsFieldCount = (issueCount)=>({
            [(0, (0, parcelRequire("1vvHL")).AFFECTS).id]: {
                field: (0, (0, parcelRequire("1vvHL")).AFFECTS),
                issueCount: issueCount
            }
        });
    const $852eb376f5e28cfd$var$fixedInFieldCount = (issueCount)=>({
            [(0, (0, parcelRequire("1vvHL")).FIXED_IN).id]: {
                field: (0, (0, parcelRequire("1vvHL")).FIXED_IN),
                issueCount: issueCount
            }
        });
    const $852eb376f5e28cfd$var$customFieldsCount = (customFields)=>Object.assign({}, ...customFields.map(({ fieldName: fieldName, customFieldId: customFieldId, issueCountWithVersionInCustomField: issueCountWithVersionInCustomField })=>({
                [customFieldId]: {
                    field: {
                        name: fieldName,
                        id: customFieldId
                    },
                    issueCount: issueCountWithVersionInCustomField
                }
            })));
    const $852eb376f5e28cfd$export$95d9c414d6450d15 = (response)=>({
            ...response.issuesAffectedCount > 0 ? $852eb376f5e28cfd$var$affectsFieldCount(response.issuesAffectedCount) : {},
            ...response.issuesFixedCount > 0 ? $852eb376f5e28cfd$var$fixedInFieldCount(response.issuesFixedCount) : {},
            ...response.issueCountWithCustomFieldsShowingVersion > 0 && response.customFieldUsage ? $852eb376f5e28cfd$var$customFieldsCount(response.customFieldUsage) : {}
        });
});
parcelRegister("laSs4", function(module, exports) {
    $parcel$export(module.exports, "epic", ()=>$78d5c9193f28173b$export$8ec5145af6f76965);
    parcelRequire("d0pqD");
    var $gccSB = parcelRequire("gccSB");
    var $Oh7JP;
    const $78d5c9193f28173b$export$8ec5145af6f76965 = (action$)=>action$.ofType((0, (0, parcelRequire("Oh7JP")).SET_RELATED_ISSUES_COUNT)).map((action)=>{
            const relatedIssues = action.payload;
            if ((0, ($parcel$interopDefault($gccSB)))(relatedIssues)) return (0, (0, parcelRequire("Oh7JP")).deleteVersion)();
            return (0, (0, parcelRequire("Oh7JP")).showDialog)();
        });
});
parcelRegister("amHIM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82dd1b387dd307dd$export$2e2bcd8739ae039);
    var $F2Mxm;
    var $4CHd9;
    var $82dd1b387dd307dd$export$2e2bcd8739ae039 = (rootEpic)=>(0, (0, parcelRequire("F2Mxm")).default)({
            appName: 'delete-version',
            rootReducer: (0, parcelRequire("4CHd9")).default,
            rootEpic: rootEpic
        });
});
parcelRegister("4CHd9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c47df113c9660d96$export$2e2bcd8739ae039);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $Oh7JP;
    const $c47df113c9660d96$export$49d5fc8cba920a0 = {
        baseUrl: '',
        projectKey: '',
        onError: (0, ($parcel$interopDefault($8Rkzz))),
        onSuccess: (0, ($parcel$interopDefault($8Rkzz))),
        onCancel: (0, ($parcel$interopDefault($8Rkzz))),
        onOpened: (0, ($parcel$interopDefault($8Rkzz))),
        version: {
            name: '',
            id: ''
        },
        fields: {},
        inProgress: false,
        isVisible: false
    };
    var $c47df113c9660d96$export$2e2bcd8739ae039 = (state = $c47df113c9660d96$export$49d5fc8cba920a0, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("Oh7JP")).INITIALIZE_APP_PROPS:
                return {
                    ...state,
                    ...action.payload,
                    version: {
                        name: action.payload.version.name,
                        id: action.payload.version.id
                    },
                    fields: {}
                };
            case 0, (0, parcelRequire("Oh7JP")).SET_RELATED_ISSUES_COUNT:
                return {
                    ...state,
                    fields: Object.entries(action.payload).reduce((fields, [fieldId, field])=>{
                        fields[fieldId] = {
                            relatedField: field,
                            operation: (0, $df74d50e6f902fa3$export$346f08c1f0d0fe41)
                        };
                        return fields;
                    }, {})
                };
            case 0, (0, parcelRequire("Oh7JP")).SHOW_DIALOG:
                return {
                    ...state,
                    isVisible: true
                };
            case 0, (0, parcelRequire("Oh7JP")).SET_VERSION_FOR_FIELD:
                if (Object.prototype.hasOwnProperty.call(state.fields, action.payload.fieldId)) return {
                    ...state,
                    fields: {
                        ...state.fields,
                        [action.payload.fieldId]: {
                            ...state.fields[action.payload.fieldId],
                            targetVersion: action.payload.target
                        }
                    }
                };
                return state;
            case 0, (0, parcelRequire("Oh7JP")).SET_OPERATION_FOR_FIELD:
                if (Object.prototype.hasOwnProperty.call(state.fields, action.payload.fieldId)) return {
                    ...state,
                    fields: {
                        ...state.fields,
                        [action.payload.fieldId]: {
                            ...state.fields[action.payload.fieldId],
                            operation: action.payload.operation
                        }
                    }
                };
                return state;
            case 0, (0, parcelRequire("Oh7JP")).DELETE_VERSION:
                return {
                    ...state,
                    inProgress: true
                };
            case 0, (0, parcelRequire("Oh7JP")).DELETION_FAILURE:
                return {
                    ...state,
                    inProgress: false
                };
            case 0, (0, parcelRequire("Oh7JP")).DELETION_SUCCESS:
            case 0, (0, parcelRequire("Oh7JP")).CANCEL:
                return {
                    ...state,
                    inProgress: false,
                    isVisible: false
                };
            case 0, (0, parcelRequire("Oh7JP")).GET_RELATED_ISSUES_COUNT:
                return state;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("hGJRM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08b6b337167efc79$export$2e2bcd8739ae039);
    var $bC2fB;
    var $Oh7JP;
    var $9Buuq;
    var $4eHxA;
    var $1I3kH;
    var $3ugIg;
    const $08b6b337167efc79$var$mapStateToProps = (state)=>({
            Content: (0, parcelRequire("4eHxA")).default,
            Footer: (0, parcelRequire("1I3kH")).default,
            isDialogVisible: (0, (0, parcelRequire("9Buuq")).isDialogVisible)(state),
            versionName: (0, (0, parcelRequire("9Buuq")).getVersionName)(state)
        });
    const $08b6b337167efc79$var$mapDispatchToProps = {
        onClose: (0, (0, parcelRequire("Oh7JP")).cancel)
    };
    var $08b6b337167efc79$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($08b6b337167efc79$var$mapStateToProps, $08b6b337167efc79$var$mapDispatchToProps)((0, (0, parcelRequire("3ugIg")).default));
});
parcelRegister("4eHxA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8a241e1bf8eea3d0$export$2e2bcd8739ae039);
    var $bC2fB;
    var $7P3tV;
    var $9Buuq;
    var $cJw3r;
    var $ghtf5;
    const $8a241e1bf8eea3d0$var$mapStateToProps = (state)=>({
            MoveVersion: (0, parcelRequire("cJw3r")).default,
            fields: (0, (0, parcelRequire("9Buuq")).getSortedFields)(state),
            versionName: (0, (0, parcelRequire("9Buuq")).getVersionName)(state),
            renderVersionUrl: (field)=>(0, (0, parcelRequire("7P3tV")).getIssuesForRelatedFieldUrl)((0, (0, parcelRequire("9Buuq")).getBaseUrl)(state), (0, (0, parcelRequire("9Buuq")).getProjectKey)(state), (0, (0, parcelRequire("9Buuq")).getVersionId)(state), field)
        });
    var $8a241e1bf8eea3d0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($8a241e1bf8eea3d0$var$mapStateToProps, {})((0, (0, parcelRequire("ghtf5")).default));
});
parcelRegister("7P3tV", function(module, exports) {
    $parcel$export(module.exports, "getIssuesForRelatedFieldUrl", ()=>$c34ea9bdd868a66c$export$1f88f7aa26cf4491);
    var $cIy4l;
    var $1vvHL;
    const $c34ea9bdd868a66c$export$1f88f7aa26cf4491 = (baseUrl, projectKey, versionId, field)=>{
        const fieldInJql = (0, (0, parcelRequire("1vvHL")).default).includes(field) ? field.id : (0, (0, parcelRequire("cIy4l")).toQuotedString)(field.name);
        const jql = `project = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(projectKey)} AND ${fieldInJql} = ${versionId}`;
        return (0, (0, parcelRequire("cIy4l")).createIssuesUrl)(jql);
    };
});
parcelRegister("cIy4l", function(module, exports) {
    $parcel$export(module.exports, "toQuotedString", ()=>$ae91325110cc96a6$export$dbeab020a4aa404);
    $parcel$export(module.exports, "createIssuesUrl", ()=>$ae91325110cc96a6$export$c623a4b2d8c439ab);
    const $ae91325110cc96a6$var$ENCODE_MAP = {
        '\t': '\\t',
        '\n': '\\n',
        '\r': '\\r',
        '"': '\\"',
        "'": "\\'",
        '\\': '\\\\'
    };
    const $ae91325110cc96a6$export$946fe289c25510be = (character, ignoredCharacter)=>{
        if (character === ignoredCharacter) return character;
        return $ae91325110cc96a6$var$ENCODE_MAP[character] || character;
    };
    const $ae91325110cc96a6$export$dbeab020a4aa404 = (parameter)=>{
        let escaped = '';
        for(let position = 0; position < parameter.length; position += 1)escaped += $ae91325110cc96a6$export$946fe289c25510be(parameter[position], "'");
        return `"${escaped}"`;
    };
    const $ae91325110cc96a6$export$c623a4b2d8c439ab = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;
});
parcelRegister("cJw3r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$102eaea68cf9fed1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bC2fB;
    var $7ZIA5;
    var $Oh7JP;
    var $9Buuq;
    var $dqmqz;
    const $102eaea68cf9fed1$var$VERSION_STATUS_WHITELIST = [
        'released',
        'unreleased'
    ];
    const $102eaea68cf9fed1$var$mapStateToProps = (state, ownProps)=>({
            renderVersionPicker: ({ onChange: onChange })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ZIA5")).default), {
                    onSelected: onChange,
                    baseUrl: (0, (0, parcelRequire("9Buuq")).getBaseUrl)(state),
                    projectKey: (0, (0, parcelRequire("9Buuq")).getProjectKey)(state),
                    ignore: [
                        (0, (0, parcelRequire("9Buuq")).getVersionId)(state)
                    ],
                    versionStatuses: $102eaea68cf9fed1$var$VERSION_STATUS_WHITELIST,
                    isDisabled: (0, (0, parcelRequire("9Buuq")).isFieldVersionPickerDisabled)(state, ownProps.id)
                }),
            operation: (0, (0, parcelRequire("9Buuq")).getFieldOperation)(state, ownProps.id),
            target: (0, (0, parcelRequire("9Buuq")).getFieldTargetVersion)(state, ownProps.id),
            isDisabled: (0, (0, parcelRequire("9Buuq")).isInProgress)(state)
        });
    const $102eaea68cf9fed1$var$mapDispatchToProps = (dispatch, ownProps)=>({
            onOperationChanged: (operation)=>dispatch((0, (0, parcelRequire("Oh7JP")).setOperationForField)({
                    operation: operation,
                    fieldId: ownProps.id
                })),
            onTargetVersionChanged: (versionId)=>dispatch((0, (0, parcelRequire("Oh7JP")).setVersionForField)({
                    target: versionId,
                    fieldId: ownProps.id
                }))
        });
    var $102eaea68cf9fed1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($102eaea68cf9fed1$var$mapStateToProps, $102eaea68cf9fed1$var$mapDispatchToProps)((0, (0, parcelRequire("dqmqz")).default));
});
parcelRegister("7ZIA5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6639293982f702ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $iQv12;
    var $4U4qk;
    var $az4zD;
    var $bcrAM;
    var $5wI4U;
    var $kVzJJ;
    class $6639293982f702ce$export$c7c815960e157d78 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isRequired: false,
                isDisabled: false,
                isClearableWithCrossIcon: false,
                baseUrl: '',
                noPortal: false,
                value: undefined,
                label: '',
                placeholder: undefined,
                ignore: [],
                versionStatuses: [],
                onSelected: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        getVersionIdsToIgnore() {
            const { value: value, ignore: ignore } = this.props;
            if (value) return [
                value.id,
                ...ignore
            ];
            return ignore;
        }
        getPlaceholder() {
            const { intl: { formatMessage: formatMessage } } = this.props;
            return this.props.placeholder === undefined ? formatMessage((0, (0, parcelRequire("kVzJJ")).default).placeholder) : this.props.placeholder;
        }
        getValue() {
            const { value: value } = this.props;
            if (value === null || value === undefined) return value;
            return (0, (0, parcelRequire("5wI4U")).transformVersion)(value);
        }
        render() {
            const { label: label, isRequired: isRequired, isDisabled: isDisabled, intl: intl, noPortal: noPortal, isClearableWithCrossIcon: isClearableWithCrossIcon } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4U4qk")).Picker), {
                value: this.getValue(),
                label: label,
                placeholder: this.getPlaceholder(),
                isRequired: isRequired,
                isDisabled: isDisabled,
                isClearableWithCrossIcon: isClearableWithCrossIcon,
                errorMessage: intl.formatMessage((0, (0, parcelRequire("kVzJJ")).default).error),
                onSelected: this.onSelected,
                options: this.onFetchOptions,
                noPortal: noPortal,
                intl: intl
            });
        }
        constructor(...args){
            super(...args), this.onSelected = (selectedOption, analyticsEvent)=>selectedOption ? this.props.onSelected({
                    id: selectedOption.value,
                    name: selectedOption.label
                }, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent), this.onFetchOptions = (filter)=>(0, (0, parcelRequire("bcrAM")).requestVersions)(this.props.baseUrl, this.props.projectKey, filter, this.props.versionStatuses, this.getVersionIdsToIgnore());
        }
    }
    var $6639293982f702ce$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)((0, (0, parcelRequire("iQv12")).default)({
        onSelected: 'versionPicker'
    })($6639293982f702ce$export$c7c815960e157d78));
});
parcelRegister("iQv12", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$945500a9598c3ac2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gvRPW;
    const $945500a9598c3ac2$var$fireWithUIAnalytics = (ConnectedProps)=>{
        const providedKeys = Object.keys(ConnectedProps).sort();
        const cachedMappedProps = {};
        const cachedConnectedProps = {};
        const getStateFromMappedProps = (mapped)=>{
            providedKeys.forEach((key, index)=>{
                const prop = mapped[index];
                if (key in cachedMappedProps && cachedMappedProps[key] === prop) return;
                cachedMappedProps[key] = prop;
                cachedConnectedProps[key] = (...attrs)=>{
                    const analyticsEvent = attrs[attrs.length - 1].clone();
                    const connectedProp = ConnectedProps[key];
                    if (typeof ConnectedProps[key] === 'string') analyticsEvent.update({
                        name: connectedProp,
                        analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                    }).fire();
                    else if (typeof connectedProp === 'function') {
                        const update = connectedProp(...attrs);
                        analyticsEvent.update({
                            ...update,
                            analyticsType: (0, (0, parcelRequire("gvRPW")).UI_EVENT_TYPE)
                        }).fire();
                    }
                    if (typeof prop === 'function') prop(...attrs);
                };
            });
            return cachedConnectedProps;
        };
        return (WrappedComponent)=>class WithAnalytics extends (0, $5uXOq.Component) {
                static{
                    this.displayName = `WithAnalytics(${WrappedComponent.displayName || WrappedComponent.name || 'UnnamedComponent'}`;
                }
                render() {
                    const newMappedProps = getStateFromMappedProps(providedKeys.map((key)=>this.props[key]));
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        ...newMappedProps
                    });
                }
            };
    };
    var $945500a9598c3ac2$export$2e2bcd8739ae039 = $945500a9598c3ac2$var$fireWithUIAnalytics;
});
parcelRegister("4U4qk", function(module, exports) {
    $parcel$export(module.exports, "getOptionBaseStyles", ()=>$0d1a93ba35d548ba$export$cef6e25059b681a);
    $parcel$export(module.exports, "Picker", ()=>$0d1a93ba35d548ba$export$ba25329847403e11);
    $parcel$export(module.exports, "default", ()=>$0d1a93ba35d548ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lFKmC = parcelRequire("lFKmC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $ctg8C;
    var $dC5iT;
    var $8CUq3;
    var $1ZftP;
    var $94bNw;
    var $bChGW;
    var $iOwNT;
    var $7K5PP;
    var $3bDjY;
    var $VgvL1;
    var $fVAPR;
    var $gwIPs;
    var $az4zD;
    var $e239o;
    const $0d1a93ba35d548ba$export$3a3072dd741f354b = 500;
    const $0d1a93ba35d548ba$export$cef6e25059b681a = (optionState)=>({
            ...optionState.isDisabled ? {
                cursor: 'not-allowed',
                color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N90})`,
                '&, :active': {
                    backgroundColor: 'transparent'
                }
            } : {
                cursor: 'pointer'
            },
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        });
    class $0d1a93ba35d548ba$export$ba25329847403e11 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isRequired: false,
                isDisabled: false,
                isClearable: false,
                isCompact: false,
                isCreatable: false,
                isMulti: false,
                noPortal: false,
                isCheckbox: false,
                label: '',
                defaultValue: undefined,
                width: 'auto',
                onSelected: (0, ($parcel$interopDefault($8Rkzz))),
                onMultiSelected: (0, ($parcel$interopDefault($8Rkzz)))
            };
        }
        static getDerivedStateFromProps(props) {
            if (props.menuIsOpen !== undefined) return {
                menuIsOpen: props.menuIsOpen
            };
            return null;
        }
        constructor(props){
            super(props), this.state = {
                validationState: 'default',
                showErrorMessage: false,
                menuWasOpen: false,
                menuIsOpen: false,
                initialFocusHandled: false
            }, this.onSelected = (selection, action, analyticsEvent)=>{
                this.setState(()=>({
                        menuIsOpen: false
                    }));
                const { isMulti: isMulti } = this.props;
                if (Array.isArray(selection)) {
                    if (isMulti) this.props.onMultiSelected(selection, analyticsEvent);
                    else this.props.onSelected(undefined, analyticsEvent);
                } else selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
            }, this.onMenuOpen = ()=>{
                this.setState(()=>({
                        menuIsOpen: true,
                        menuWasOpen: true
                    }));
            }, this.onMenuClose = ()=>{
                this.setState(()=>({
                        menuIsOpen: false
                    }));
            }, this.onBlur = (event)=>{
                this.hideErrorMessage();
                const { onBlur: onBlur } = this.props;
                if (onBlur && typeof onBlur === 'function') onBlur(event);
            }, this.onFocus = (event)=>{
                this.showErrorMessage();
                const { onFocus: onFocus } = this.props;
                if (onFocus && typeof onFocus === 'function') onFocus(event);
            }, this.setErrorState = ()=>{
                this.setState({
                    showErrorMessage: true,
                    validationState: 'error'
                });
            }, this.showErrorMessage = ()=>this.setState({
                    showErrorMessage: true
                }), this.hideErrorMessage = ()=>this.setState({
                    showErrorMessage: false
                }), this.loadOptions = (filter, callback)=>{
                this.setState({
                    validationState: 'default'
                });
                this.debouncedLoadOptions(filter, callback);
            }, this.renderOption = (props)=>{
                const propsData = props.data;
                const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                    position: "right",
                    content: disableReason
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Option, props));
            }, this.renderMenuList = (menuListProps)=>{
                const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
                return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MenuList, menuListProps, isClearable && menuListProps.hasValue && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $0d1a93ba35d548ba$var$clearButtonWrapperStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "link",
                    shouldFitContainer: true,
                    onClick: menuListProps.clearValue
                }, formatMessage((0, (0, parcelRequire("e239o")).default).clearSelected))), menuListProps.children));
            }, this.renderValueContainer = (props)=>{
                const { onValueContainerClick: onValueContainerClick } = props.selectProps;
                return (0, ($parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$StyledValueContainer, {
                    "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                    onClick: onValueContainerClick
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).ValueContainer, props));
            };
            this.debouncedLoadOptions = (0, ($parcel$interopDefault($lFKmC)))((filter, callback)=>{
                this.props.options(filter).then(callback, ()=>{
                    callback([]);
                    this.setErrorState();
                });
            }, $0d1a93ba35d548ba$export$3a3072dd741f354b);
            this.selectRef = (0, $5uXOq.createRef)();
        }
        getSelectComponent(isAsync) {
            if (this.props.isCreatable) return isAsync ? (0, (0, parcelRequire("1ZftP")).default) : (0, (0, parcelRequire("iOwNT")).default);
            if (isAsync) return 0, (0, parcelRequire("VgvL1")).AsyncSelectWithAnalytics;
            return this.props.isCheckbox ? (0, (0, parcelRequire("94bNw")).default) : (0, (0, parcelRequire("7K5PP")).default);
        }
        getComponentOverrides() {
            const { menuWasOpen: menuWasOpen } = this.state;
            const Option = {
                Option: this.renderOption
            };
            const MenuList = {
                MenuList: this.renderMenuList
            };
            const LoadingIndicator = menuWasOpen ? {} : {
                LoadingIndicator: null
            };
            return {
                ...Option,
                ...MenuList,
                ...LoadingIndicator
            };
        }
        render() {
            const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
            const { intl: { formatMessage: formatMessage } } = this.props;
            const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, (0, parcelRequire("e239o")).default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
            const isAsync = typeof options === 'function';
            const SelectComponent = this.getSelectComponent(isAsync);
            const isErrorMessageOpened = showErrorMessage && validationState === 'error';
            let selectParams = {
                placeholder: placeholder,
                isDisabled: isDisabled,
                isClearable: isClearableWithCrossIcon || false,
                defaultValue: defaultValue,
                defaultOptions: true,
                autoFocus: !!this.props.autoFocus,
                loadOptions: isAsync && this.loadOptions,
                options: !isAsync && options,
                onChange: this.onSelected,
                noOptionsMessage: ()=>formatMessage((0, (0, parcelRequire("e239o")).default).noOptions),
                loadingMessage: ()=>formatMessage((0, (0, parcelRequire("e239o")).default).loading),
                validationState: this.state.validationState,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                menuPortalTarget: noPortal ? null : document.body,
                spacing: isCompact ? 'compact' : 'default',
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
                        }),
                    container: (base)=>({
                            ...base,
                            width: width,
                            minWidth: minWidth
                        }),
                    option: (base, optionState)=>({
                            ...base,
                            ...$0d1a93ba35d548ba$export$cef6e25059b681a(optionState),
                            ...listItemCustomStyles
                        })
                }
            };
            if (!isCheckbox) selectParams = {
                ...selectParams,
                menuIsOpen: menuIsOpen,
                onMenuOpen: this.onMenuOpen,
                onMenuClose: this.onMenuClose,
                components: this.getComponentOverrides()
            };
            if (hasDraggableParentComponent) {
                const { initialFocusHandled: initialFocusHandled } = this.state;
                const handleClick = ()=>{
                    if (initialFocusHandled) this.setState((state)=>({
                            menuIsOpen: !state.menuIsOpen
                        }));
                    else if (!menuIsOpen) {
                        this.selectRef.current.focus();
                        this.setState(()=>({
                                initialFocusHandled: true
                            }));
                    }
                };
                selectParams = {
                    ...selectParams,
                    ref: this.selectRef,
                    components: {
                        ...this.getComponentOverrides,
                        ValueContainer: this.renderValueContainer
                    },
                    onValueContainerClick: handleClick,
                    openMenuOnFocus: true
                };
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, label && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVAPR")).FieldLabel), {
                htmlFor: this.props.inputId,
                label: label,
                isRequired: isRequired
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctg8C")).default), {
                content: errorMessage,
                isOpen: isErrorMessageOpened,
                placement: "right"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
                inputId: this.props.inputId,
                ...this.props,
                ...selectParams,
                options: isAsync ? undefined : this.props.options
            })));
        }
    }
    const $0d1a93ba35d548ba$var$PickerWithIntl = (0, (0, parcelRequire("az4zD")).injectIntlV2)($0d1a93ba35d548ba$export$ba25329847403e11);
    const $0d1a93ba35d548ba$var$DefaultPicker = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0d1a93ba35d548ba$var$PickerWithIntl, props);
    };
    $0d1a93ba35d548ba$var$DefaultPicker.defaultProps = $0d1a93ba35d548ba$export$ba25329847403e11.defaultProps;
    var $0d1a93ba35d548ba$export$2e2bcd8739ae039 = $0d1a93ba35d548ba$var$DefaultPicker;
    const $0d1a93ba35d548ba$var$StyledValueContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $0d1a93ba35d548ba$var$clearButtonWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`
    });
});
parcelRegister("1ZftP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffe39b95a8bd43db$export$2e2bcd8739ae039);
    var $isgat;
    var $3c98u;
    const $ffe39b95a8bd43db$var$AsyncCreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("isgat")).default));
    var $ffe39b95a8bd43db$export$2e2bcd8739ae039 = $ffe39b95a8bd43db$var$AsyncCreatableSelect;
});
parcelRegister("isgat", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6ce0d05b9e97e68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $2HH7Y;
    var $9uJ4X;
    const $d6ce0d05b9e97e68$var$AsyncCreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const stateManagerProps = (0, (0, parcelRequire("iaInK")).default)(props);
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(stateManagerProps);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $d6ce0d05b9e97e68$export$2e2bcd8739ae039 = $d6ce0d05b9e97e68$var$AsyncCreatableSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props), this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            }, this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)(), this.controlRef = null, this.getControlRef = (ref)=>{
                this.controlRef = ref;
            }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            }, this.inputRef = null, this.getInputRef = (ref)=>{
                this.inputRef = ref;
            }, this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            }, this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            }, this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            }, this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            }, this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            }, this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            }, this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            }, this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            }, this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            }, this.getStyles = (key, props)=>{
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            }, this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            }, this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            }, this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            }, this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            }, this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            }, this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            }, this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            }, this.onCompositionStart = ()=>{
                this.isComposing = true;
            }, this.onCompositionEnd = ()=>{
                this.isComposing = false;
            }, this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            }, this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            }, this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            }, this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            }, this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            }, this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            }, this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            }, this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            }, this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            }, this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            }, this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            }, this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            }, this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } })=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        });
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({ theme: { spacing: spacing } })=>({
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        });
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } })=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        });
    const $13f090f36c42825d$export$e1687335805e1230 = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = $13f090f36c42825d$var$baseCSS;
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } })=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } })=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } })=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } })=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            textAlign: 'center',
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } })=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        });
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis })=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused })=>({
            alignItems: 'center',
            display: 'flex',
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } })=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        });
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } })=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } })=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("2HH7Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$994aeb783b6f955a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eEtcC;
    var $gyjU7;
    const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
        const candidate = String(inputValue).toLowerCase();
        const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
        const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
        return optionValue === candidate || optionLabel === candidate;
    };
    const $994aeb783b6f955a$var$builtins = {
        formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
        isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
        getNewOptionData: (inputValue, optionLabel)=>({
                label: optionLabel,
                value: inputValue,
                __isNew__: true
            })
    };
    function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
        const { getOptionValue: getOptionValue = (0, (0, parcelRequire("eEtcC")).getOptionValue), getOptionLabel: getOptionLabel = (0, (0, parcelRequire("eEtcC")).getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
        const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, (0, parcelRequire("gyjU7")).cleanValue)(value), propsOptions, {
                getOptionValue: getOptionValue,
                getOptionLabel: getOptionLabel
            }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
            formatCreateLabel,
            getNewOptionData,
            getOptionLabel,
            getOptionValue,
            inputValue,
            isValidNewOption,
            propsOptions,
            value
        ]);
        const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
                newOption,
                ...propsOptions
            ] : [
                ...propsOptions,
                newOption
            ] : propsOptions, [
            allowCreateWhileLoading,
            createOptionPosition,
            isLoading,
            newOption,
            propsOptions
        ]);
        const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
            const valueArray = Array.isArray(newValue) ? newValue : [
                newValue
            ];
            if (valueArray[valueArray.length - 1] === newOption) {
                if (onCreateOption) onCreateOption(inputValue);
                else {
                    const newOptionData = getNewOptionData(inputValue, inputValue);
                    const newActionMeta = {
                        action: 'create-option',
                        name: name,
                        option: newOptionData
                    };
                    propsOnChange((0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, [
                        ...(0, (0, parcelRequire("gyjU7")).cleanValue)(value),
                        newOptionData
                    ], newOptionData), newActionMeta);
                }
                return;
            }
            propsOnChange(newValue, actionMeta);
        }, [
            getNewOptionData,
            inputValue,
            isMulti,
            name,
            newOption,
            onCreateOption,
            propsOnChange,
            value
        ]);
        return {
            ...restSelectProps,
            options: options,
            onChange: onChange
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VXAu;
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $eaXSR;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)((0, (0, parcelRequire("eaXSR")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("eaXSR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7eb841defe611e3$export$2e2bcd8739ae039);
    var $VSDnB;
    function $b7eb841defe611e3$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $829f609a65d26a98$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $829f609a65d26a98$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $829f609a65d26a98$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("94bNw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebf832c571222d72$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7K5PP;
    var $itpgN;
    const $ebf832c571222d72$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
        const mergedComponents = (0, $5uXOq.useMemo)(()=>({
                ...components,
                Option: (0, (0, parcelRequire("itpgN")).CheckboxOption)
            }), [
            components
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            closeMenuOnSelect: false,
            hideSelectedOptions: false,
            isMulti: true,
            ...props,
            components: mergedComponents
        });
    };
    const $ebf832c571222d72$var$CheckboxSelect = (0, ($parcel$interopDefault($5uXOq))).memo($ebf832c571222d72$var$CheckboxSelectInternal);
    var $ebf832c571222d72$export$2e2bcd8739ae039 = $ebf832c571222d72$var$CheckboxSelect;
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("itpgN", function(module, exports) {
    $parcel$export(module.exports, "CheckboxOption", ()=>$f5875245cd0ad0c1$export$d40cc97ecda916f9);
    $parcel$export(module.exports, "RadioOption", ()=>$f5875245cd0ad0c1$export$82ab7168879267a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6aY6N;
    var $iQHJo;
    var $dV6Te;
    var $VSDnB;
    function $f5875245cd0ad0c1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f5875245cd0ad0c1$var$getPrimitiveStyles = (props)=>{
        const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
        const baseStyles = {
            alignItems: 'center',
            backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : 'transparent',
            color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
            display: 'flex ',
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-050, 4px)",
            boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`}` : 'none',
            ':active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
            },
            '@media screen and (-ms-high-contrast: active)': {
                borderLeft: isFocused ? '2px solid transparent' : ''
            }
        };
        const augmentedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
            ...getStyles('option', props),
            ...baseStyles
        });
        const bemClasses = {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        };
        return [
            augmentedStyles,
            cx(bemClasses, className)
        ];
    };
    const $f5875245cd0ad0c1$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isActive) return `var(--ds-background-selected-pressed, ${0, $829f609a65d26a98$export$8c13c2ee36917869})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$e62e8919cca44969})`;
        else if (isFocused) return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`;
        else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (!isSelected) return 'transparent';
        return `var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
    };
    const $f5875245cd0ad0c1$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isActive) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        else if (isFocused) return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
        return `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`;
    };
    const $f5875245cd0ad0c1$var$baseIconStyles = {
        name: "35x0q3",
        styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
    };
    const $f5875245cd0ad0c1$var$baseOptionStyles = {
        name: "16e0ede",
        styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    class $f5875245cd0ad0c1$var$ControlOption extends (0, $5uXOq.Component) {
        render() {
            const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
            const props = {
                ...innerProps,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            const [styles, classes] = $f5875245cd0ad0c1$var$getPrimitiveStyles({
                getStyles: getStyles,
                ...rest
            });
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: styles,
                className: classes,
                ref: innerRef,
                ...props
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $f5875245cd0ad0c1$var$baseIconStyles,
                    {
                        '& svg rect, & svg circle:first-of-type': {
                            stroke: $f5875245cd0ad0c1$var$getBorderColor({
                                ...this.props,
                                ...this.state
                            })
                        }
                    }
                ]
            }, !!Icon ? (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
                label: "",
                primaryColor: $f5875245cd0ad0c1$var$getPrimaryColor({
                    ...this.props,
                    ...this.state
                }),
                secondaryColor: $f5875245cd0ad0c1$var$getSecondaryColor({
                    ...this.props,
                    ...this.state
                }),
                isFacadeDisabled: true
            }) : null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $f5875245cd0ad0c1$var$baseOptionStyles
            }, children)));
        }
        constructor(...args){
            super(...args), this.state = {
                isActive: false
            }, this.onMouseDown = ()=>this.setState({
                    isActive: true
                }), this.onMouseUp = ()=>this.setState({
                    isActive: false
                }), this.onMouseLeave = ()=>this.setState({
                    isActive: false
                });
        }
    }
    const $f5875245cd0ad0c1$var$NewCheckboxIcon = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), props, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        })));
    const $f5875245cd0ad0c1$var$NewRadioIcon = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), props, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "6.75",
            fill: "currentColor",
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "3",
            fill: "inherit"
        })));
    const $f5875245cd0ad0c1$export$d40cc97ecda916f9 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewCheckboxIcon : (0, ($parcel$interopDefault((0, parcelRequire("6aY6N"))))),
            ...props
        });
    const $f5875245cd0ad0c1$export$82ab7168879267a7 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($f5875245cd0ad0c1$var$ControlOption, {
            Icon: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? $f5875245cd0ad0c1$var$NewRadioIcon : (0, ($parcel$interopDefault((0, parcelRequire("iQHJo"))))),
            ...props
        });
});
parcelRegister("6aY6N", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $47f24d9003b82760$var$_react = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $47f24d9003b82760$var$_checkboxChecked = $47f24d9003b82760$var$_interopRequireDefault((parcelRequire("aoKYM")));
    function $47f24d9003b82760$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $47f24d9003b82760$var$CheckboxIcon = (props)=>$47f24d9003b82760$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $47f24d9003b82760$var$_checkboxChecked.default
        }));
    $47f24d9003b82760$var$CheckboxIcon.displayName = 'CheckboxIcon';
    var $47f24d9003b82760$var$_default = module.exports.default = $47f24d9003b82760$var$CheckboxIcon;
});
parcelRegister("aoKYM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79209663d32c0c44$var$_react = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79209663d32c0c44$var$_UNSAFE_baseNew = $79209663d32c0c44$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $79209663d32c0c44$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79209663d32c0c44$var$CheckboxCheckedIcon = (props)=>$79209663d32c0c44$var$_react.default.createElement($79209663d32c0c44$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $79209663d32c0c44$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
    var $79209663d32c0c44$var$_default = module.exports.default = $79209663d32c0c44$var$CheckboxCheckedIcon;
});
parcelRegister("iQHJo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $db8f016a0af5fda9$var$_react = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $db8f016a0af5fda9$var$_radioChecked = $db8f016a0af5fda9$var$_interopRequireDefault((parcelRequire("kqGQn")));
    function $db8f016a0af5fda9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $db8f016a0af5fda9$var$RadioIcon = (props)=>$db8f016a0af5fda9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
        }, props, {
            newIcon: $db8f016a0af5fda9$var$_radioChecked.default
        }));
    $db8f016a0af5fda9$var$RadioIcon.displayName = 'RadioIcon';
    var $db8f016a0af5fda9$var$_default = module.exports.default = $db8f016a0af5fda9$var$RadioIcon;
});
parcelRegister("kqGQn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $edf7783e719984ba$var$_react = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $edf7783e719984ba$var$_UNSAFE_baseNew = $edf7783e719984ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $edf7783e719984ba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $edf7783e719984ba$var$RadioCheckedIcon = (props)=>$edf7783e719984ba$var$_react.default.createElement($edf7783e719984ba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
        }, props));
    $edf7783e719984ba$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
    var $edf7783e719984ba$var$_default = module.exports.default = $edf7783e719984ba$var$RadioCheckedIcon;
});
parcelRegister("iOwNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59b6485f0cb008dd$export$2e2bcd8739ae039);
    var $9OU1i;
    var $3c98u;
    const $59b6485f0cb008dd$var$CreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("9OU1i")).default));
    var $59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;
});
parcelRegister("9OU1i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b29f1caecd9c7d5a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useCreatable", ()=>(parcelRequire("2HH7Y")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $2HH7Y;
    var $9uJ4X;
    const $b29f1caecd9c7d5a$var$CreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(props);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;
});
parcelRegister("VgvL1", function(module, exports) {
    $parcel$export(module.exports, "AsyncSelectWithAnalytics", ()=>$462c399840da3e1c$export$ee664e5add893f9);
    var $d7FF4;
    var $8oe80;
    const $462c399840da3e1c$export$ee664e5add893f9 = (0, (0, parcelRequire("8oe80")).default)('select', {
        onChange: 'changed'
    })((0, (0, parcelRequire("d7FF4")).default));
});
parcelRegister("d7FF4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac4d84cf4438daea$export$2e2bcd8739ae039);
    var $eAthk;
    var $3c98u;
    const $ac4d84cf4438daea$var$AsyncSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    var $ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;
});
parcelRegister("fVAPR", function(module, exports) {
    $parcel$export(module.exports, "FieldLabel", ()=>$97462970d1593b07$export$1acdcf5a973a8414);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $3RZIb;
    var $gwIPs;
    const $97462970d1593b07$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$Label, {
            htmlFor: htmlFor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$LabelText, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, label), isRequired ? (0, ($parcel$interopDefault($5uXOq))).createElement($97462970d1593b07$var$RequiredIndicator, {
            role: "presentation"
        }, "*") : null));
    const $97462970d1593b07$var$Label = (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule",
                __cmplp.className
            ])
        });
    });
    const $97462970d1593b07$var$LabelText = (0, $47bDC.default).div.withConfig({
        componentId: "sc-9kgl5s-0"
    })`${(0, (0, parcelRequire("3RZIb")).h200)()} display:block;font-family:${(0, (0, parcelRequire("gwIPs")).fontFamily)};margin:0;${(0, $47bDC.css)({
        padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
    })}`;
    const $97462970d1593b07$var$RequiredIndicator = (0, $47bDC.default).span.withConfig({
        componentId: "sc-9kgl5s-1"
    })({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$exports).R400})`,
        fontFamily: (0, parcelRequire("gwIPs")).fontFamily,
        paddingLeft: "var(--ds-space-025, 2px)"
    });
    $97462970d1593b07$var$RequiredIndicator.displayName = 'RequiredIndicator';
});
parcelRegister("e239o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c6849afedcc0fa8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1c6849afedcc0fa8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOptions: {
            "id": "common.components.picker.base.no-options",
            "defaultMessage": "No results"
        },
        loading: {
            "id": "common.components.picker.base.loading",
            "defaultMessage": "Searching..."
        },
        defaultPlaceholder: {
            "id": "common.components.picker.base.default-placeholder",
            "defaultMessage": "Select..."
        },
        clearSelected: {
            "id": "common.components.picker.base.clear-selected",
            "defaultMessage": "Clear selected"
        }
    });
});
parcelRegister("bcrAM", function(module, exports) {
    $parcel$export(module.exports, "requestVersions", ()=>$5693781e34d2d219$export$aadfb092a4919504);
    var $fosv1;
    var $5wI4U;
    const $5693781e34d2d219$export$aadfb092a4919504 = async (baseUrl, projectKey, filter, versionStatuses, ignore, excludeArchivedVersions = false)=>{
        const pageVersions = await (0, (0, parcelRequire("fosv1")).requestVersions)(baseUrl, projectKey, filter, versionStatuses, ignore);
        return (0, (0, parcelRequire("5wI4U")).transformVersions)(pageVersions.values, ignore, excludeArchivedVersions);
    };
});
parcelRegister("fosv1", function(module, exports) {
    $parcel$export(module.exports, "MAX_RESULTS", ()=>$8ee5477fd3092e8b$export$f6b2881bc1090cea);
    $parcel$export(module.exports, "requestVersions", ()=>$8ee5477fd3092e8b$export$aadfb092a4919504);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    const $8ee5477fd3092e8b$export$f6b2881bc1090cea = 5;
    const $8ee5477fd3092e8b$export$b702ac644ba114c = (baseUrl, projectKey)=>`${baseUrl}/rest/api/2/project/${projectKey}/version`;
    const $8ee5477fd3092e8b$export$10181c3ba572bfce = (filter, versionStatuses, ignore)=>(0, $ebyGx.stringify)({
            startAt: 0,
            query: filter,
            maxResults: $8ee5477fd3092e8b$export$f6b2881bc1090cea + ignore.length,
            orderBy: '+NAME',
            status: versionStatuses.join(',')
        });
    const $8ee5477fd3092e8b$export$8395ad088d65e586 = (baseUrl, projectKey, filter, versionStatuses, ignore)=>`${$8ee5477fd3092e8b$export$b702ac644ba114c(baseUrl, projectKey)}?${$8ee5477fd3092e8b$export$10181c3ba572bfce(filter, versionStatuses, ignore)}`;
    const $8ee5477fd3092e8b$export$aadfb092a4919504 = async (baseUrl, projectKey, filter, versionStatuses, ignore)=>(0, (0, parcelRequire("7f4tk")).default)($8ee5477fd3092e8b$export$8395ad088d65e586(baseUrl, projectKey, filter, versionStatuses, ignore));
});
parcelRegister("5wI4U", function(module, exports) {
    $parcel$export(module.exports, "transformVersion", ()=>$9ac4e1645e42431e$export$390ab7123357e756);
    $parcel$export(module.exports, "transformVersions", ()=>$9ac4e1645e42431e$export$8bc7a3929156b65e);
    var $fosv1;
    const $9ac4e1645e42431e$export$390ab7123357e756 = (component)=>({
            value: component.id,
            label: component.name
        });
    const $9ac4e1645e42431e$export$8bc7a3929156b65e = (data, ignore, excludeArchivedVersions)=>data.filter((value)=>!ignore.includes(value.id) && (!excludeArchivedVersions || !value.archived)).map($9ac4e1645e42431e$export$390ab7123357e756).slice(0, (0, (0, parcelRequire("fosv1")).MAX_RESULTS));
});
parcelRegister("kVzJJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc1b839fbdef43a1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cc1b839fbdef43a1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        error: {
            "id": "version-picker.error",
            "defaultMessage": "We couldn't retrieve versions"
        },
        placeholder: {
            "id": "version-picker.placeholder",
            "defaultMessage": "Select version"
        }
    });
});
parcelRegister("dqmqz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1cc7b4e0f5269288$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jouoW;
    var $az4zD;
    var $b0eUs;
    class $1cc7b4e0f5269288$export$7dd97fb25ed038e extends (0, $5uXOq.Component) {
        render() {
            const { intl: { formatMessage: formatMessage }, renderVersionPicker: renderVersionPicker, operation: operation, isDisabled: isDisabled } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                isChecked: operation === (0, $df74d50e6f902fa3$export$346f08c1f0d0fe41),
                onChange: this.onMoveSelected,
                isDisabled: isDisabled,
                label: formatMessage((0, (0, parcelRequire("b0eUs")).default).moveIssues),
                testId: "version-modals.delete-version.content.move-version.move-radio"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($1cc7b4e0f5269288$var$PickerContainer, null, renderVersionPicker({
                onChange: this.onVersionPicked
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                isChecked: operation === (0, $df74d50e6f902fa3$export$4bd2facc4a3e6aa1),
                onChange: this.onDeleteSelected,
                isDisabled: isDisabled,
                label: formatMessage((0, (0, parcelRequire("b0eUs")).default).removeVersion),
                testId: "version-modals.delete-version.content.move-version.remove-radio"
            }));
        }
        constructor(...args){
            super(...args), this.onMoveSelected = ()=>{
                this.props.onOperationChanged((0, $df74d50e6f902fa3$export$346f08c1f0d0fe41));
            }, this.onDeleteSelected = ()=>{
                this.props.onOperationChanged((0, $df74d50e6f902fa3$export$4bd2facc4a3e6aa1));
            }, this.onVersionPicked = (version)=>{
                this.props.onTargetVersionChanged(version ? version.id : undefined);
            };
        }
    }
    var $1cc7b4e0f5269288$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($1cc7b4e0f5269288$export$7dd97fb25ed038e);
    const $1cc7b4e0f5269288$var$PickerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1mjv _18s811d5",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jouoW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d22fafff331be84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $VSDnB;
    function $5d22fafff331be84$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5d22fafff331be84$var$packageName = "platform-pkg";
    const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
    const $5d22fafff331be84$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $5d22fafff331be84$var$labelPaddingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $5d22fafff331be84$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        position: 'relative',
        alignItems: 'flex-start',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
            cursor: 'not-allowed'
        }
    });
    const $5d22fafff331be84$var$radioStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '24px',
        height: '24px',
        margin: "var(--ds-space-0, 0px)",
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        backgroundColor: 'var(--radio-background-color)',
        border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        MozAppearance: 'none',
        outline: 'none',
        '--radio-background-color': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-dot-opacity': 0,
        transform: 'scale(calc(7 / 12))',
        transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
        verticalAlign: 'top',
        WebkitAppearance: 'none',
        '&::after': {
            width: 'calc(4px * 12 / 7)',
            height: 'calc(4px * 12 / 7)',
            position: 'absolute',
            background: 'var(--radio-dot-color)',
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: "''",
            opacity: 'var(--radio-dot-opacity)',
            transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
        },
        '&:hover': {
            '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
        },
        '&:active': {
            '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        },
        '&:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&:checked': {
            '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-dot-opacity': 1
        },
        '&:checked:hover': {
            '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`
        },
        '&:checked:active': {
            '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
            '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        '&:checked:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&[data-invalid], &:checked[data-invalid]': {
            '--radio-border-color': `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        },
        '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
            cursor: 'not-allowed',
            '--radio-background-color': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-border-color': `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
        }
    });
    const $5d22fafff331be84$var$newRadioStyles = {
        name: "5rrwak",
        styles: "transform:scale(calc(7.5 / 12));&::after{width:calc(5.6px * 12 / 7);height:calc(5.6px * 12 / 7);}"
    };
    const $5d22fafff331be84$var$InnerRadio = (0, $5uXOq.forwardRef)(function Radio(props, ref) {
        const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, ...rest } = props;
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'radio',
            packageName: $5d22fafff331be84$var$packageName,
            packageVersion: $5d22fafff331be84$var$packageVersion
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            "data-testid": testId && `${testId}--radio-label`,
            "data-disabled": isDisabled ? 'true' : undefined,
            css: $5d22fafff331be84$var$labelStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...rest,
            tabIndex: 0,
            "aria-label": ariaLabel,
            checked: isChecked,
            disabled: isDisabled,
            name: name,
            onChange: onChangeAnalytics,
            required: isRequired,
            type: "radio",
            value: value,
            "data-testid": testId && `${testId}--radio-input`,
            "data-invalid": isInvalid ? 'true' : undefined,
            css: [
                $5d22fafff331be84$var$radioStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') && $5d22fafff331be84$var$newRadioStyles
            ],
            ref: ref
        }), label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $5d22fafff331be84$var$labelPaddingStyles
        }, label) : null);
    });
    const $5d22fafff331be84$var$Radio = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Radio(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($5d22fafff331be84$var$InnerRadio, {
            ...props,
            ref: ref
        });
    }));
    var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;
});
parcelRegister("b0eUs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3f5567a67ac55cc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c3f5567a67ac55cc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moveIssues: {
            "id": "project-directories.versions.delete-version.content.move-version.move-issues",
            "defaultMessage": "Move issues to"
        },
        removeVersion: {
            "id": "project-directories.versions.delete-version.content.move-version.remove-version",
            "defaultMessage": "Remove the version"
        }
    });
});
parcelRegister("ghtf5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$302514ef6794ed14$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7O4UO;
    var $dC5iT;
    var $8CUq3;
    var $ousew;
    var $az4zD;
    var $1vvHL;
    var $kN3Hj;
    class $302514ef6794ed14$export$7c6e2c02157bb7d2 extends (0, $5uXOq.Component) {
        getFieldName(field) {
            if ((0, (0, parcelRequire("1vvHL")).default).includes(field)) return this.props.intl.formatMessage((0, (0, parcelRequire("kN3Hj")).default)[field.id]);
            return field.name;
        }
        renderSingleField() {
            const { fields: [first], intl: { formatMessage: formatMessage }, MoveVersion: MoveVersion, renderVersionUrl: renderVersionUrl } = this.props;
            const issueCountLink = (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: renderVersionUrl(first.relatedField.field),
                target: "_blank"
            }, formatMessage((0, (0, parcelRequire("kN3Hj")).default).issueCount, {
                count: first.relatedField.issueCount
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("kN3Hj")).default).oneFieldDescription,
                values: {
                    issueCountLink: issueCountLink
                }
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $302514ef6794ed14$var$deleteSingleOptionContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(MoveVersion, {
                id: first.relatedField.field.id
            })));
        }
        renderFieldDescription(relatedField) {
            const { renderVersionUrl: renderVersionUrl } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.getFieldName(relatedField.field), " (", (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                target: "_blank",
                href: renderVersionUrl(relatedField.field)
            }, relatedField.issueCount), ")");
        }
        renderMultipleFields() {
            const { fields: fields, intl: { formatMessage: formatMessage }, MoveVersion: MoveVersion, versionName: versionName } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("kN3Hj")).default).multipleFieldsDescription, {
                name: versionName
            }), fields.map(({ relatedField: relatedField })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    key: relatedField.field.id
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    name: relatedField.field.name,
                    label: this.renderFieldDescription(relatedField)
                }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(MoveVersion, {
                        id: relatedField.field.id
                    })))));
        }
        render() {
            return this.props.fields.length === 1 ? this.renderSingleField() : this.renderMultipleFields();
        }
    }
    var $302514ef6794ed14$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($302514ef6794ed14$export$7c6e2c02157bb7d2);
    const $302514ef6794ed14$var$deleteSingleOptionContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.200'
    });
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("kN3Hj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7a37ec7c14ef66d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a7a37ec7c14ef66d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        oneFieldDescription: {
            "id": "project-directories.versions.delete-version.content.one-field-description",
            "defaultMessage": "Deleting this version will remove it from {issueCountLink}."
        },
        issueCount: {
            "id": "project-directories.versions.delete-version.content.issue-count",
            "defaultMessage": "{count} {count, plural, one {issue} other {issues}}"
        },
        multipleFieldsDescription: {
            "id": "project-directories.versions.delete-version.content.multiple-fields-description",
            "defaultMessage": "A few issue fields reference {name}. You can update the fields to reference another version or clear the value of those fields."
        },
        affectedVersion: {
            "id": "project-directories.versions.delete-version.content.affected-version",
            "defaultMessage": "Affects version"
        },
        fixVersion: {
            "id": "project-directories.versions.delete-version.content.fix-version",
            "defaultMessage": "Fix version"
        }
    });
});
parcelRegister("1I3kH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfcee179b36deaf4$export$2e2bcd8739ae039);
    var $bC2fB;
    var $Oh7JP;
    var $9Buuq;
    var $j8eNQ;
    const $cfcee179b36deaf4$var$mapStateToProps = (state)=>({
            isDeleteEnabled: (0, (0, parcelRequire("9Buuq")).isSwapValid)(state),
            isDeleteInProgress: (0, (0, parcelRequire("9Buuq")).isInProgress)(state)
        });
    const $cfcee179b36deaf4$var$mapDispatchToProps = {
        onCancel: (0, (0, parcelRequire("Oh7JP")).cancel),
        onDelete: (0, (0, parcelRequire("Oh7JP")).deleteVersion)
    };
    var $cfcee179b36deaf4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($cfcee179b36deaf4$var$mapStateToProps, $cfcee179b36deaf4$var$mapDispatchToProps)((0, (0, parcelRequire("j8eNQ")).default));
});
parcelRegister("j8eNQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44ef4cb60f226c23$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fVnbM;
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    var $iQv12;
    var $az4zD;
    var $fSGXZ;
    function $44ef4cb60f226c23$export$a06f1c675e846f6f(props) {
        const { intl: { formatMessage: formatMessage }, onCancel: onCancel, onDelete: onDelete, isDeleteEnabled: isDeleteEnabled, isDeleteInProgress: isDeleteInProgress } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($44ef4cb60f226c23$var$ButtonsContainer, null, isDeleteInProgress && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $44ef4cb60f226c23$var$spinnerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "warning",
            isDisabled: !isDeleteEnabled || isDeleteInProgress,
            onClick: onDelete
        }, formatMessage((0, (0, parcelRequire("fSGXZ")).default).delete)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            onClick: onCancel
        }, formatMessage((0, (0, parcelRequire("fSGXZ")).default).cancel)));
    }
    $44ef4cb60f226c23$export$a06f1c675e846f6f.defaultProps = {
        isDeleteEnabled: true,
        isDeleteInProgress: false,
        onCancel: (0, ($parcel$interopDefault($8Rkzz))),
        onDelete: (0, ($parcel$interopDefault($8Rkzz)))
    };
    var $44ef4cb60f226c23$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iQv12")).default)({
        onCancel: 'cancel',
        onDelete: 'delete'
    })((0, (0, parcelRequire("az4zD")).injectIntlV2)($44ef4cb60f226c23$export$a06f1c675e846f6f));
    const $44ef4cb60f226c23$var$ButtonsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _4cvr1h6o _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $44ef4cb60f226c23$var$spinnerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.200'
    });
});
parcelRegister("fSGXZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd8561e2a58a1d9b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fd8561e2a58a1d9b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        delete: {
            "id": "project-directories.versions.delete-version.footer.delete",
            "defaultMessage": "Delete"
        },
        cancel: {
            "id": "project-directories.versions.delete-version.footer.cancel",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("3ugIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf59583555e827bd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $jzjy1;
    var $hZHze;
    var $9fuVs;
    var $az4zD;
    var $h8Myg;
    function $bf59583555e827bd$export$73392e09138fecd6({ Content: Content, Footer: Footer, isDialogVisible: isDialogVisible, onClose: onClose, intl: { formatMessage: formatMessage }, versionName: versionName }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isDialogVisible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "warning"
        }, formatMessage((0, (0, parcelRequire("h8Myg")).default).title, {
            name: versionName
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement(Content, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(Footer, null)))));
    }
    var $bf59583555e827bd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('deleteVersion', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))((0, (0, parcelRequire("az4zD")).injectIntlV2)($bf59583555e827bd$export$73392e09138fecd6));
});
parcelRegister("hZHze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69dc4a27be9f367e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $994MI;
    var $cb25w;
    var $gvRPW;
    class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.props.onMount();
        }
        render() {
            return null;
        }
    }
    const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'view-tracker'
    })((0, (0, parcelRequire("cb25w")).default)({
        onMount: (createEvent)=>createEvent({
                action: (0, (0, parcelRequire("gvRPW")).PAGE_EVENT_ACTION)
            }).fire()
    })($69dc4a27be9f367e$var$ViewTracker));
    var $69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
            onMount: (0, ($parcel$interopDefault($8Rkzz)))
        });
});
parcelRegister("h8Myg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ac3eef38e771acb$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1ac3eef38e771acb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "project-directories.versions.delete-version.title",
            "defaultMessage": "Delete {name}"
        }
    });
});
parcelRegister("lqWUw", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$b15b9ab9c95e18c3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aB8eX = parcelRequire("aB8eX");
    var $jD5no;
    var $9pe79;
    var $bxJen;
    var $3yLu1;
    var $dGae8;
    var $6FZ5A;
    class $b15b9ab9c95e18c3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.store = (0, (0, parcelRequire("dGae8")).default)((0, (0, parcelRequire("bxJen")).default));
            this.setAppProps(this.props);
            this.store.dispatch((0, (0, parcelRequire("3yLu1")).initialRequest)(this.props.versionId));
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if ((0, (0, parcelRequire("9pe79")).default)(nextProps, this.props)) return;
            this.setAppProps(this.props);
        }
        setAppProps(props) {
            const { baseUrl: baseUrl, projectKey: projectKey, onOpened: onOpened, onError: onError, onSuccess: onSuccess, onCancel: onCancel, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption = false, hasReleaseNote: hasReleaseNote = false } = props;
            this.store.dispatch((0, $aB8eX.batchActions)([
                (0, (0, parcelRequire("3yLu1")).setContext)({
                    baseUrl: baseUrl,
                    projectKey: projectKey
                }),
                (0, (0, parcelRequire("3yLu1")).setHandlers)({
                    onOpened: onOpened,
                    onError: onError,
                    onSuccess: onSuccess,
                    onCancel: onCancel
                }),
                (0, (0, parcelRequire("3yLu1")).setCreateReleaseNotesOptionConfig)({
                    shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption,
                    hasReleaseNote: hasReleaseNote
                })
            ]));
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
                store: this.store,
                id: "versionReleaseModal"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6FZ5A")).default), null));
        }
    }
});
parcelRegister("bxJen", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4baa4be00b04d5f9$export$2e2bcd8739ae039);
    var $e1AU2 = parcelRequire("e1AU2");
    var $5Lfyk;
    var $cHY1X;
    var $4baa4be00b04d5f9$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)((0, (0, parcelRequire("5Lfyk")).initialRequestEpic), (0, (0, parcelRequire("5Lfyk")).fetchUnresolvedIssues), (0, (0, parcelRequire("cHY1X")).initialRequestSuccessEpic), (0, (0, parcelRequire("5Lfyk")).releaseVersionRequestEpic), (0, (0, parcelRequire("cHY1X")).releaseVersionRequestFailureEpic), (0, (0, parcelRequire("cHY1X")).releaseVersionRequestSuccessEpic));
});
parcelRegister("5Lfyk", function(module, exports) {
    $parcel$export(module.exports, "initialRequestEpic", ()=>$45a7f90f7cc0949b$export$73dafa621a3e5eba);
    $parcel$export(module.exports, "fetchUnresolvedIssues", ()=>$45a7f90f7cc0949b$export$5f5c175d78772606);
    $parcel$export(module.exports, "releaseVersionRequestEpic", ()=>$45a7f90f7cc0949b$export$b327638b0f58ac49);
    parcelRequire("fp4O3");
    parcelRequire("9o0uh");
    parcelRequire("c66Ur");
    parcelRequire("fPS7b");
    var $gccSB = parcelRequire("gccSB");
    var $fr1K2 = parcelRequire("fr1K2");
    var $3NMrl = parcelRequire("3NMrl");
    var $kVLXA = parcelRequire("kVLXA");
    var $fsh9d;
    var $c42uT;
    var $3yLu1;
    var $ai3Yq;
    const $45a7f90f7cc0949b$export$73dafa621a3e5eba = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("ai3Yq")).getBaseUrl)(state);
            return (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("c42uT")).getVersion)(baseUrl, versionId)).mergeMap((version)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).initialRequestSuccess)(version))).catch((error)=>{
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.get.version', (0, $71a059cf91522abc$export$6c87c1302bf5163c));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).releaseVersionFailure)({
                    id: versionId
                }));
            });
        });
    const $45a7f90f7cc0949b$export$5f5c175d78772606 = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).INITIAL_REQUEST)).mergeMap(({ payload: versionId })=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("ai3Yq")).getBaseUrl)(state);
            return (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("c42uT")).getUnresolvedIssues)(baseUrl, versionId)).mergeMap((unresolvedIssuesCount)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).setUnreleasedIssuesCount)(unresolvedIssuesCount))).catch((error)=>{
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.get.getUnresolvedIssues', (0, $71a059cf91522abc$export$6c87c1302bf5163c));
                return (0, $kVLXA.Observable).empty();
            });
        });
    const $45a7f90f7cc0949b$export$b327638b0f58ac49 = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_REQUEST)).mergeMap(()=>{
            const state = store.getState();
            const baseUrl = (0, (0, parcelRequire("ai3Yq")).getBaseUrl)(state);
            const keepIssues = (0, (0, parcelRequire("ai3Yq")).isKeepingIssues)(state);
            const version = (0, (0, parcelRequire("ai3Yq")).getVersion)(state);
            const versionToRelease = keepIssues ? (0, ($parcel$interopDefault($fr1K2)))(version, 'moveUnfixedIssuesTo') : version;
            return (0, $kVLXA.Observable).fromPromise((0, (0, parcelRequire("c42uT")).releaseVersion)(baseUrl, versionToRelease)).mergeMap((releasedVersion)=>(0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).releaseVersionSuccess)(releasedVersion))).catch((error)=>{
                try {
                    const errors = (0, ($parcel$interopDefault($3NMrl)))(JSON.parse(error.message).errors, [
                        'releaseDate',
                        'moveUnfixedIssuesTo'
                    ]);
                    if (!(0, ($parcel$interopDefault($gccSB)))(errors)) return (0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).releaseVersionValidationFailure)(errors));
                } catch (e) {}
                (0, (0, parcelRequire("fsh9d")).logSafeErrorWithoutCustomerData)(error, 'project-directories.versions.release.ops.release.version', (0, $71a059cf91522abc$export$6c87c1302bf5163c));
                return (0, $kVLXA.Observable).of((0, (0, parcelRequire("3yLu1")).releaseVersionFailure)());
            });
        });
});
parcelRegister("c42uT", function(module, exports) {
    $parcel$export(module.exports, "getVersion", ()=>$c81fe9e74b3610a0$export$c506eb22e615ba4a);
    $parcel$export(module.exports, "getUnresolvedIssues", ()=>$c81fe9e74b3610a0$export$d98ed0fcfb679bfe);
    $parcel$export(module.exports, "releaseVersion", ()=>$c81fe9e74b3610a0$export$b8e3d145af76ef26);
    $parcel$export(module.exports, "useReleaseAutomationBanner", ()=>$c81fe9e74b3610a0$export$d9a4a1588da51f7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $90yGq;
    var $hhRBl;
    var $5Y6UB;
    var $gCDZi;
    var $kMTMr;
    var $agk64;
    const $c81fe9e74b3610a0$export$c506eb22e615ba4a = (baseUrl, versionId)=>(0, (0, parcelRequire("hhRBl")).getVersion)(baseUrl, versionId).then((0, (0, parcelRequire("5Y6UB")).transformVersion)).then((0, (0, parcelRequire("kMTMr")).addDefaultReleaseDate));
    const $c81fe9e74b3610a0$export$d98ed0fcfb679bfe = (baseUrl, versionId)=>(0, (0, parcelRequire("hhRBl")).getUnresolvedIssuesCount)(baseUrl, versionId).then((0, (0, parcelRequire("5Y6UB")).transformUnresolvedIssuesCount));
    const $c81fe9e74b3610a0$export$b8e3d145af76ef26 = (baseUrl, version)=>(0, (0, parcelRequire("gCDZi")).releaseVersion)(baseUrl, (0, (0, parcelRequire("kMTMr")).transformReleasableToRestVersion)(version)).then((0, (0, parcelRequire("5Y6UB")).transformVersion));
    const $c81fe9e74b3610a0$export$d9a4a1588da51f7c = ()=>{
        const [showBanner, setShowBanner] = (0, $5uXOq.useState)(false);
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        (0, $5uXOq.useEffect)(()=>{
            if (accountId != null) (0, (0, parcelRequire("agk64")).getHasDismissedReleaseAutomationBanner)(accountId).then((hasDismissed)=>setShowBanner(!hasDismissed)).catch((0, (0, parcelRequire("agk64")).fireReleaseAutomationBannerError));
        }, [
            accountId
        ]);
        const dismissBanner = async ()=>{
            setShowBanner(false);
            if (accountId != null) await (0, (0, parcelRequire("agk64")).dismissReleaseAutomationBanner)(accountId).catch((0, (0, parcelRequire("agk64")).fireReleaseAutomationBannerError));
        };
        return {
            showBanner: showBanner,
            dismissBanner: dismissBanner
        };
    };
});
parcelRegister("hhRBl", function(module, exports) {
    $parcel$export(module.exports, "getVersionEndpointUrl", ()=>$8d02574a1b02ba22$export$9513b66f34c81f7d);
    $parcel$export(module.exports, "getVersion", ()=>$8d02574a1b02ba22$export$c506eb22e615ba4a);
    $parcel$export(module.exports, "getUnresolvedIssuesCount", ()=>$8d02574a1b02ba22$export$b7679bf23524baba);
    var $7f4tk;
    const $8d02574a1b02ba22$export$9513b66f34c81f7d = (baseUrl, versionId)=>`${baseUrl}/rest/api/2/version/${versionId}`;
    const $8d02574a1b02ba22$export$18ba274da71f4912 = (baseUrl, versionId)=>`${$8d02574a1b02ba22$export$9513b66f34c81f7d(baseUrl, versionId)}?expand=issuesstatus`;
    const $8d02574a1b02ba22$export$fdc7e642e6597237 = (baseUrl, versionId)=>`${$8d02574a1b02ba22$export$9513b66f34c81f7d(baseUrl, versionId)}/unresolvedIssueCount`;
    const $8d02574a1b02ba22$export$c506eb22e615ba4a = (baseUrl, versionId)=>(0, (0, parcelRequire("7f4tk")).default)($8d02574a1b02ba22$export$18ba274da71f4912(baseUrl, versionId));
    const $8d02574a1b02ba22$export$b7679bf23524baba = (baseUrl, versionId)=>(0, (0, parcelRequire("7f4tk")).default)($8d02574a1b02ba22$export$fdc7e642e6597237(baseUrl, versionId));
});
parcelRegister("5Y6UB", function(module, exports) {
    $parcel$export(module.exports, "transformVersion", ()=>$62220a7fcc1eb582$export$390ab7123357e756);
    $parcel$export(module.exports, "transformUnresolvedIssuesCount", ()=>$62220a7fcc1eb582$export$9c917bd1ad6cfd7f);
    var $brjCS;
    const $62220a7fcc1eb582$var$transformStatus = (archived, released)=>{
        if (archived) return 0, (0, parcelRequire("brjCS")).ARCHIVED;
        if (released) return 0, (0, parcelRequire("brjCS")).RELEASED;
        return 0, (0, parcelRequire("brjCS")).UNRELEASED;
    };
    const $62220a7fcc1eb582$var$transformIssuesStatus = ({ toDo: toDo, inProgress: inProgress, done: done })=>({
            toDo: toDo,
            inProgress: inProgress,
            done: done
        });
    const $62220a7fcc1eb582$export$390ab7123357e756 = (restVersion)=>{
        const version = {
            id: restVersion.id,
            name: restVersion.name,
            description: restVersion.description ? restVersion.description : '',
            status: $62220a7fcc1eb582$var$transformStatus(restVersion.archived, restVersion.released),
            startDate: restVersion.startDate,
            releaseDate: restVersion.releaseDate,
            overdue: !!restVersion.overdue,
            projectId: restVersion.projectId
        };
        if (restVersion.issuesStatusForFixVersion) version.issuesStatus = $62220a7fcc1eb582$var$transformIssuesStatus(restVersion.issuesStatusForFixVersion);
        return version;
    };
    const $62220a7fcc1eb582$export$9c917bd1ad6cfd7f = (rest)=>rest.issuesUnresolvedCount;
});
parcelRegister("gCDZi", function(module, exports) {
    $parcel$export(module.exports, "releaseVersion", ()=>$24fa99d1c29a27de$export$b8e3d145af76ef26);
    var $9RyXH;
    var $hhRBl;
    const $24fa99d1c29a27de$export$b8e3d145af76ef26 = (baseUrl, version)=>{
        const url = (0, (0, parcelRequire("hhRBl")).getVersionEndpointUrl)(baseUrl, version.id);
        return (0, (0, parcelRequire("9RyXH")).default)(url, {
            method: 'put',
            body: JSON.stringify({
                ...version
            })
        });
    };
});
parcelRegister("9RyXH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01c4a849d3703fe6$export$2e2bcd8739ae039);
    var $aDvGo;
    var $jJZqs;
    var $01c4a849d3703fe6$export$2e2bcd8739ae039 = (url, options = {})=>{
        const option = {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        };
        return fetch(url, option).then((response)=>{
            if (!response.ok) {
                const { status: status } = response;
                return response.text().then((str)=>{
                    throw new (0, (0, parcelRequire("jJZqs")).default)(status, str);
                });
            }
            return response.json();
        });
    };
});
parcelRegister("kMTMr", function(module, exports) {
    $parcel$export(module.exports, "transformReleasableToRestVersion", ()=>$9820223a518af481$export$6c7ef87ae81a803f);
    $parcel$export(module.exports, "addDefaultReleaseDate", ()=>$9820223a518af481$export$a3871b8272282d64);
    var $fr1K2 = parcelRequire("fr1K2");
    var $kMUwX;
    const $9820223a518af481$export$6c7ef87ae81a803f = (version)=>{
        const restVersion = (0, ($parcel$interopDefault($fr1K2)))(version, [
            'issuesStatus'
        ]);
        return {
            ...restVersion,
            released: true,
            releaseDate: (0, (0, parcelRequire("kMUwX")).atlasKitToServerDateFormat)(version.releaseDate)
        };
    };
    const $9820223a518af481$export$a3871b8272282d64 = (version)=>{
        const { id: id, name: name, releaseDate: releaseDate, issuesStatus: issuesStatus } = version;
        return {
            id: id,
            name: name,
            issuesStatus: issuesStatus,
            moveUnfixedIssuesTo: '',
            releaseDate: releaseDate ? (0, (0, parcelRequire("kMUwX")).ISOToAtlasKitDateFormat)(releaseDate) : (0, (0, parcelRequire("kMUwX")).todayToAtlasKitDateFormat)()
        };
    };
});
parcelRegister("kMUwX", function(module, exports) {
    $parcel$export(module.exports, "ISOToAtlasKitDateFormat", ()=>$013f23539a74f0d2$export$4df2a4adbb0e5391);
    $parcel$export(module.exports, "todayToAtlasKitDateFormat", ()=>$013f23539a74f0d2$export$d9939b5b983bc908);
    $parcel$export(module.exports, "atlasKitToServerDateFormat", ()=>$013f23539a74f0d2$export$bcd9d8ad44970e94);
    var $k7m40;
    var $b77vc;
    var $jovBr;
    var $eZDAP;
    var $htiPW;
    const $013f23539a74f0d2$export$c9b0b9ddba618847 = (dateStr)=>{
        if (dateStr) {
            const date = (0, (0, parcelRequire("eZDAP")).default)(dateStr.replace(/\//g, '-'));
            if ((0, (0, parcelRequire("jovBr")).default)(date)) return (0, (0, parcelRequire("k7m40")).default)(new Date(date), 'yyyy-MM-dd');
        }
        return '';
    };
    const $013f23539a74f0d2$export$4df2a4adbb0e5391 = (dateStr)=>{
        if (dateStr) {
            const date = (0, (0, parcelRequire("eZDAP")).default)(dateStr);
            if ((0, (0, parcelRequire("jovBr")).default)(date)) return (0, (0, parcelRequire("k7m40")).default)(new Date(date), 'yyyy/MM/dd');
        }
        return '';
    };
    const $013f23539a74f0d2$export$d9939b5b983bc908 = ()=>(0, (0, parcelRequire("k7m40")).default)((0, (0, parcelRequire("htiPW")).default)(), 'yyyy/MM/dd');
    const $013f23539a74f0d2$export$6350eb346dee22fe = (dateStr)=>{
        if (dateStr) return (0, (0, parcelRequire("jovBr")).default)((0, (0, parcelRequire("eZDAP")).default)(dateStr.replace(/\//g, '-')));
        return false;
    };
    const $013f23539a74f0d2$export$bcd9d8ad44970e94 = (dateStr)=>{
        let dateISO;
        if (dateStr && $013f23539a74f0d2$export$6350eb346dee22fe(dateStr)) dateISO = $013f23539a74f0d2$export$c9b0b9ddba618847(dateStr);
        return dateISO || null;
    };
    const $013f23539a74f0d2$export$e36c611b04695a2e = (dateStr)=>{
        const date = (0, (0, parcelRequire("eZDAP")).default)(dateStr);
        if ((0, (0, parcelRequire("jovBr")).default)(date)) return (0, (0, parcelRequire("b77vc")).default)(date);
        return undefined;
    };
    const $013f23539a74f0d2$export$8d60448f563c47a6 = {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    };
});
parcelRegister("agk64", function(module, exports) {
    $parcel$export(module.exports, "getHasDismissedReleaseAutomationBanner", ()=>$42933e7c8516f8fa$export$b8702a08258e1098);
    $parcel$export(module.exports, "dismissReleaseAutomationBanner", ()=>$42933e7c8516f8fa$export$7f678873378110b8);
    $parcel$export(module.exports, "fireReleaseAutomationBannerError", ()=>$42933e7c8516f8fa$export$76cf25de6ffb8030);
    var $aDvGo;
    var $jcw0u;
    const $42933e7c8516f8fa$export$b8702a08258e1098 = async (accountId)=>{
        const fetchResponse = await fetch(`/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`, (0, (0, parcelRequire("aDvGo")).default));
        if (fetchResponse.ok) {
            const responseObj = await fetchResponse.json();
            return responseObj.value;
        }
        const { status: status } = fetchResponse;
        if (status === 401) return true;
        if (status === 404) return false;
        throw new Error(`Fetching hasDismisssedReleaseAutomationBanner user property failed. Status code: ${fetchResponse.status}`);
    };
    const $42933e7c8516f8fa$export$7f678873378110b8 = async (accountId)=>{
        const fetchResponse = await fetch(`/rest/api/3/user/properties/hasDismissedReleaseAutomationBanner?accountId=${accountId}`, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            method: 'PUT',
            body: JSON.stringify(true)
        });
        if (!fetchResponse.ok) throw Error('Failed to dismiss release automation banner via user properties.');
    };
    const $42933e7c8516f8fa$export$76cf25de6ffb8030 = (error)=>(0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'versions.release.version.modal.release.automation.user.property',
                packageName: 'jiraVersionModals',
                teamName: 'fusion-solaris'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
});
parcelRegister("3yLu1", function(module, exports) {
    $parcel$export(module.exports, "SET_CONTEXT", ()=>$efa9dcf433ebc4c7$export$4bc4e62e7d72b94b);
    $parcel$export(module.exports, "setContext", ()=>$efa9dcf433ebc4c7$export$2f04de43fe27971a);
    $parcel$export(module.exports, "SET_HANDLERS", ()=>$efa9dcf433ebc4c7$export$bc2eae499d5e6cec);
    $parcel$export(module.exports, "setHandlers", ()=>$efa9dcf433ebc4c7$export$241365d6eef6c169);
    $parcel$export(module.exports, "INITIAL_REQUEST", ()=>$efa9dcf433ebc4c7$export$e1efaa8f406867bb);
    $parcel$export(module.exports, "initialRequest", ()=>$efa9dcf433ebc4c7$export$3bccc812fdbc3954);
    $parcel$export(module.exports, "INITIAL_REQUEST_SUCCESS", ()=>$efa9dcf433ebc4c7$export$37a4e72ae1c0a1b5);
    $parcel$export(module.exports, "initialRequestSuccess", ()=>$efa9dcf433ebc4c7$export$fbef4e4c40c06dae);
    $parcel$export(module.exports, "SET_VERSION_UNRESOLVED_ISSUES_COUNT", ()=>$efa9dcf433ebc4c7$export$a558394b02430fa);
    $parcel$export(module.exports, "setUnreleasedIssuesCount", ()=>$efa9dcf433ebc4c7$export$521ad3c091ef9f4b);
    $parcel$export(module.exports, "SWAP_ISSUES", ()=>$efa9dcf433ebc4c7$export$1e105c795f4df801);
    $parcel$export(module.exports, "swapIssues", ()=>$efa9dcf433ebc4c7$export$f9d0b46042c1093d);
    $parcel$export(module.exports, "RELEASE_VERSION_UPDATE", ()=>$efa9dcf433ebc4c7$export$a7943bb075347bd4);
    $parcel$export(module.exports, "releaseVersionUpdate", ()=>$efa9dcf433ebc4c7$export$6e5a7b93aba64e1c);
    $parcel$export(module.exports, "RELEASE_VERSION_REQUEST", ()=>$efa9dcf433ebc4c7$export$b482a6a2418379a4);
    $parcel$export(module.exports, "releaseVersionRequest", ()=>$efa9dcf433ebc4c7$export$f25b64441359ac5d);
    $parcel$export(module.exports, "RELEASE_VERSION_SUCCESS", ()=>$efa9dcf433ebc4c7$export$9f45f3d28614fd39);
    $parcel$export(module.exports, "releaseVersionSuccess", ()=>$efa9dcf433ebc4c7$export$ef2ca233886223dd);
    $parcel$export(module.exports, "RELEASE_VERSION_FAILURE", ()=>$efa9dcf433ebc4c7$export$f79008eab89d4f56);
    $parcel$export(module.exports, "releaseVersionFailure", ()=>$efa9dcf433ebc4c7$export$f40837cd887e0e7d);
    $parcel$export(module.exports, "RELEASE_VERSION_VALIDATION_FAILURE", ()=>$efa9dcf433ebc4c7$export$15feef518e3a0f72);
    $parcel$export(module.exports, "releaseVersionValidationFailure", ()=>$efa9dcf433ebc4c7$export$d206bb816a78117c);
    $parcel$export(module.exports, "CREATE_RELEASE_NOTES_OPTIONS", ()=>$efa9dcf433ebc4c7$export$95df9c1149c6615a);
    $parcel$export(module.exports, "setCreateReleaseNotesOptionConfig", ()=>$efa9dcf433ebc4c7$export$778db09b7ef0e606);
    $parcel$export(module.exports, "RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS", ()=>$efa9dcf433ebc4c7$export$95c8c0da90c589f);
    $parcel$export(module.exports, "releaseRedirectToCreateReleaseNotesStatus", ()=>$efa9dcf433ebc4c7$export$bec051bc82fda7b3);
    const $efa9dcf433ebc4c7$export$4bc4e62e7d72b94b = 'release-version-modal.state.SET_CONTEXT';
    const $efa9dcf433ebc4c7$export$2f04de43fe27971a = (payload)=>({
            type: $efa9dcf433ebc4c7$export$4bc4e62e7d72b94b,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$bc2eae499d5e6cec = 'release-version-modal.state.SET_HANDLERS';
    const $efa9dcf433ebc4c7$export$241365d6eef6c169 = (payload)=>({
            type: $efa9dcf433ebc4c7$export$bc2eae499d5e6cec,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$e1efaa8f406867bb = 'release-version-modal.state.INITIAL_REQUEST';
    const $efa9dcf433ebc4c7$export$3bccc812fdbc3954 = (versionId)=>({
            type: $efa9dcf433ebc4c7$export$e1efaa8f406867bb,
            payload: versionId
        });
    const $efa9dcf433ebc4c7$export$37a4e72ae1c0a1b5 = 'release-version-modal.state.INITIAL_REQUEST_SUCCESS';
    const $efa9dcf433ebc4c7$export$fbef4e4c40c06dae = (version)=>({
            type: $efa9dcf433ebc4c7$export$37a4e72ae1c0a1b5,
            payload: version
        });
    const $efa9dcf433ebc4c7$export$a558394b02430fa = 'release-version-modal.state.SET_VERSION_UNRESOLVED_ISSUES_COUNT';
    const $efa9dcf433ebc4c7$export$521ad3c091ef9f4b = (payload)=>({
            type: $efa9dcf433ebc4c7$export$a558394b02430fa,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$33d1af9ce619539e = 'release-version-modal.state.SET_VERSION';
    const $efa9dcf433ebc4c7$export$f99c3c9c04cda7ae = (payload)=>({
            type: $efa9dcf433ebc4c7$export$33d1af9ce619539e,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$1e105c795f4df801 = 'release-version-modal.state.SWAP_ISSUES';
    const $efa9dcf433ebc4c7$export$f9d0b46042c1093d = (payload)=>({
            type: $efa9dcf433ebc4c7$export$1e105c795f4df801,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$a7943bb075347bd4 = 'release-version-modal.state.RELEASE_VERSION_UPDATE';
    const $efa9dcf433ebc4c7$export$6e5a7b93aba64e1c = (payload)=>({
            type: $efa9dcf433ebc4c7$export$a7943bb075347bd4,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$b482a6a2418379a4 = 'release-version-modal.state.RELEASE_VERSION_REQUEST';
    const $efa9dcf433ebc4c7$export$f25b64441359ac5d = ()=>({
            type: $efa9dcf433ebc4c7$export$b482a6a2418379a4
        });
    const $efa9dcf433ebc4c7$export$9f45f3d28614fd39 = 'release-version-modal.state.RELEASE_VERSION_SUCCESS';
    const $efa9dcf433ebc4c7$export$ef2ca233886223dd = (payload)=>({
            type: $efa9dcf433ebc4c7$export$9f45f3d28614fd39,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$f79008eab89d4f56 = 'release-version-modal.state.RELEASE_VERSION_FAILURE';
    const $efa9dcf433ebc4c7$export$f40837cd887e0e7d = (payload)=>({
            type: $efa9dcf433ebc4c7$export$f79008eab89d4f56,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$15feef518e3a0f72 = 'release-version-modal.state.RELEASE_VERSION_VALIDATION_FAILURE';
    const $efa9dcf433ebc4c7$export$d206bb816a78117c = (payload)=>({
            type: $efa9dcf433ebc4c7$export$15feef518e3a0f72,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$95df9c1149c6615a = 'release-version-modal.state.CREATE_RELEASE_NOTES_OPTIONS';
    const $efa9dcf433ebc4c7$export$778db09b7ef0e606 = (payload)=>({
            type: $efa9dcf433ebc4c7$export$95df9c1149c6615a,
            payload: payload
        });
    const $efa9dcf433ebc4c7$export$95c8c0da90c589f = 'release-version-modal.state.RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS';
    const $efa9dcf433ebc4c7$export$bec051bc82fda7b3 = (payload)=>({
            type: $efa9dcf433ebc4c7$export$95c8c0da90c589f,
            payload: payload
        });
});
parcelRegister("ai3Yq", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$9799cf0a53e1d000$export$f654b28f82155665);
    $parcel$export(module.exports, "getProjectKey", ()=>$9799cf0a53e1d000$export$667f2a0f99c75faa);
    $parcel$export(module.exports, "getVersion", ()=>$9799cf0a53e1d000$export$c506eb22e615ba4a);
    $parcel$export(module.exports, "getVersionId", ()=>$9799cf0a53e1d000$export$d0a84488c5034e2b);
    $parcel$export(module.exports, "getTodoInProgressIssuesCount", ()=>$9799cf0a53e1d000$export$7c32856ef2a2cb6);
    $parcel$export(module.exports, "getUnresolvedIssuesCount", ()=>$9799cf0a53e1d000$export$b7679bf23524baba);
    $parcel$export(module.exports, "getResolvedIssuesCount", ()=>$9799cf0a53e1d000$export$96488947387acc21);
    $parcel$export(module.exports, "getDoneIssuesCount", ()=>$9799cf0a53e1d000$export$51a75c074eb3f4d4);
    $parcel$export(module.exports, "getName", ()=>$9799cf0a53e1d000$export$7d9f7e9c1c02b41e);
    $parcel$export(module.exports, "getReleaseDate", ()=>$9799cf0a53e1d000$export$9664966f747b3c18);
    $parcel$export(module.exports, "getErrors", ()=>$9799cf0a53e1d000$export$501239432719417d);
    $parcel$export(module.exports, "isSwapSelected", ()=>$9799cf0a53e1d000$export$8fff49f07292ff94);
    $parcel$export(module.exports, "isSaving", ()=>$9799cf0a53e1d000$export$3b51d1dcee070cea);
    $parcel$export(module.exports, "isInitiating", ()=>$9799cf0a53e1d000$export$8b35c3a55e549a0d);
    $parcel$export(module.exports, "getOnOpenedHandler", ()=>$9799cf0a53e1d000$export$9cb228195867c4ba);
    $parcel$export(module.exports, "getOnErrorHandler", ()=>$9799cf0a53e1d000$export$1a207b7e599ecdc7);
    $parcel$export(module.exports, "getOnSuccessHandler", ()=>$9799cf0a53e1d000$export$8fb55c0bc571e8e7);
    $parcel$export(module.exports, "getOnCancelHandler", ()=>$9799cf0a53e1d000$export$e776433ed4e15cc4);
    $parcel$export(module.exports, "getPropsForVersionPicker", ()=>$9799cf0a53e1d000$export$95a1217518b748b8);
    $parcel$export(module.exports, "isReleaseDisabled", ()=>$9799cf0a53e1d000$export$2a2f3b8b22c4af1f);
    $parcel$export(module.exports, "isKeepingIssues", ()=>$9799cf0a53e1d000$export$e783a0e680cad4ec);
    $parcel$export(module.exports, "shouldShowCreateReleaseNotesOption", ()=>$9799cf0a53e1d000$export$37c3a3cc47342e65);
    $parcel$export(module.exports, "shouldRedirectToCreateReleaseNotes", ()=>$9799cf0a53e1d000$export$24122e8f86a884b6);
    var $dGvGJ = parcelRequire("dGvGJ");
    const $9799cf0a53e1d000$export$f654b28f82155665 = (state)=>state.context.baseUrl;
    const $9799cf0a53e1d000$export$667f2a0f99c75faa = (state)=>state.context.projectKey;
    const $9799cf0a53e1d000$export$c506eb22e615ba4a = (state)=>state.version;
    const $9799cf0a53e1d000$export$57294fc3393f82ae = (state)=>state.version.moveUnfixedIssuesTo;
    const $9799cf0a53e1d000$export$d0a84488c5034e2b = (state)=>state.version.id;
    const $9799cf0a53e1d000$export$7c32856ef2a2cb6 = (state)=>{
        if (state.version.issuesStatus) return state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
        return 0;
    };
    const $9799cf0a53e1d000$export$b7679bf23524baba = (state)=>state.unresolvedIssuesCount;
    const $9799cf0a53e1d000$export$36e4434605c3220 = (state)=>{
        if (state.version.issuesStatus) return state.version.issuesStatus.done + state.version.issuesStatus.toDo + state.version.issuesStatus.inProgress;
        return 0;
    };
    const $9799cf0a53e1d000$export$96488947387acc21 = (state)=>$9799cf0a53e1d000$export$36e4434605c3220(state) - $9799cf0a53e1d000$export$b7679bf23524baba(state);
    const $9799cf0a53e1d000$export$51a75c074eb3f4d4 = (state)=>{
        if (state.version.issuesStatus) return state.version.issuesStatus.done;
        return 0;
    };
    const $9799cf0a53e1d000$export$7d9f7e9c1c02b41e = (state)=>$9799cf0a53e1d000$export$c506eb22e615ba4a(state).name || '';
    const $9799cf0a53e1d000$export$9664966f747b3c18 = (state)=>$9799cf0a53e1d000$export$c506eb22e615ba4a(state).releaseDate || '';
    const $9799cf0a53e1d000$export$501239432719417d = (0, $dGvGJ.createSelector)((state)=>state.errors, (errors)=>{
        const { releaseDate: releaseDate = '', moveUnfixedIssuesTo: moveUnfixedIssuesTo = '' } = errors || {};
        return {
            releaseDate: releaseDate,
            moveUnfixedIssuesTo: moveUnfixedIssuesTo
        };
    });
    const $9799cf0a53e1d000$export$8fff49f07292ff94 = (state)=>state.shouldSwapIssues;
    const $9799cf0a53e1d000$export$3b51d1dcee070cea = (state)=>!!state.isSaving;
    const $9799cf0a53e1d000$export$8b35c3a55e549a0d = (state)=>!!state.isInitiating;
    const $9799cf0a53e1d000$export$9cb228195867c4ba = (state)=>state.handlers.onOpened;
    const $9799cf0a53e1d000$export$1a207b7e599ecdc7 = (state)=>state.handlers.onError;
    const $9799cf0a53e1d000$export$8fb55c0bc571e8e7 = (state)=>state.handlers.onSuccess;
    const $9799cf0a53e1d000$export$e776433ed4e15cc4 = (state)=>state.handlers.onCancel;
    const $9799cf0a53e1d000$export$95a1217518b748b8 = (state)=>({
            baseUrl: state.context.baseUrl,
            projectKey: state.context.projectKey,
            shouldSwapIssues: state.shouldSwapIssues,
            isSaving: state.isSaving,
            versionId: state.version.id
        });
    const $9799cf0a53e1d000$var$hasTodoInProgressIssues = (state)=>$9799cf0a53e1d000$export$7c32856ef2a2cb6(state) > 0;
    const $9799cf0a53e1d000$export$2a2f3b8b22c4af1f = (state)=>state.isSaving || $9799cf0a53e1d000$export$b7679bf23524baba(state) > 0 && state.shouldSwapIssues && !$9799cf0a53e1d000$export$57294fc3393f82ae(state);
    const $9799cf0a53e1d000$export$e783a0e680cad4ec = (state)=>{
        if ($9799cf0a53e1d000$var$hasTodoInProgressIssues(state)) return state.shouldSwapIssues ? !$9799cf0a53e1d000$export$57294fc3393f82ae(state) : true;
        return true;
    };
    const $9799cf0a53e1d000$export$37c3a3cc47342e65 = (state)=>state.shouldShowCreateReleaseNotesOption;
    const $9799cf0a53e1d000$export$24122e8f86a884b6 = (state)=>state.shouldRedirectToCreateReleaseNotes;
});
parcelRegister("cHY1X", function(module, exports) {
    $parcel$export(module.exports, "initialRequestSuccessEpic", ()=>$d761eb56ba97a1cf$export$9d210f02e9fc914d);
    $parcel$export(module.exports, "releaseVersionRequestSuccessEpic", ()=>$d761eb56ba97a1cf$export$77863bf7469abd8f);
    $parcel$export(module.exports, "releaseVersionRequestFailureEpic", ()=>$d761eb56ba97a1cf$export$79de050f634d0345);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("6hSeW");
    parcelRequire("fPS7b");
    var $3yLu1;
    var $ai3Yq;
    const $d761eb56ba97a1cf$export$9d210f02e9fc914d = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).INITIAL_REQUEST_SUCCESS)).mergeMap(()=>{
            const state = store.getState();
            const versionId = (0, (0, parcelRequire("ai3Yq")).getVersionId)(state);
            (0, (0, parcelRequire("ai3Yq")).getOnOpenedHandler)(state)({
                id: versionId
            });
            return (0, $kVLXA.Observable).empty();
        });
    const $d761eb56ba97a1cf$export$77863bf7469abd8f = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_SUCCESS)).mergeMap(({ payload: version })=>{
            const state = store.getState();
            (0, (0, parcelRequire("ai3Yq")).getOnSuccessHandler)(state)(version, {
                shouldRedirectToCreateReleaseNotes: (0, (0, parcelRequire("ai3Yq")).shouldRedirectToCreateReleaseNotes)(state)
            });
            return (0, $kVLXA.Observable).empty();
        });
    const $d761eb56ba97a1cf$export$79de050f634d0345 = (action$, store)=>action$.ofType((0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_FAILURE)).mergeMap(({ payload: id })=>{
            const state = store.getState();
            (0, (0, parcelRequire("ai3Yq")).getOnErrorHandler)(state)(id);
            return (0, $kVLXA.Observable).empty();
        });
});
parcelRegister("dGae8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73fa150bafb032f5$export$2e2bcd8739ae039);
    var $F2Mxm;
    var $5lQMY;
    var $73fa150bafb032f5$export$2e2bcd8739ae039 = (rootEpic)=>(0, (0, parcelRequire("F2Mxm")).default)({
            appName: 'release-version',
            rootReducer: (0, parcelRequire("5lQMY")).default,
            rootEpic: rootEpic
        });
});
parcelRegister("5lQMY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d40ac852e63d3642$export$2e2bcd8739ae039);
    var $6Csk1 = parcelRequire("6Csk1");
    var $1UikQ = parcelRequire("1UikQ");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $fr1K2 = parcelRequire("fr1K2");
    var $3yLu1;
    const $d40ac852e63d3642$export$d4c72bab9d6cc13a = {
        context: {
            baseUrl: '',
            projectKey: ''
        },
        handlers: {
            onOpened: (0, ($parcel$interopDefault($8Rkzz))),
            onError: (0, ($parcel$interopDefault($8Rkzz))),
            onSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onCancel: (0, ($parcel$interopDefault($8Rkzz)))
        },
        version: {
            id: '0',
            name: ''
        },
        unresolvedIssuesCount: 0,
        shouldSwapIssues: true,
        isInitiating: true,
        isSaving: false,
        shouldShowCreateReleaseNotesOption: false,
        hasReleaseNote: false,
        shouldRedirectToCreateReleaseNotes: true
    };
    var $d40ac852e63d3642$export$2e2bcd8739ae039 = (state = $d40ac852e63d3642$export$d4c72bab9d6cc13a, action)=>{
        switch(action.type){
            case 0, (0, parcelRequire("3yLu1")).SET_CONTEXT:
                {
                    const context = action.payload;
                    return {
                        ...state,
                        context: context
                    };
                }
            case 0, (0, parcelRequire("3yLu1")).SET_VERSION_UNRESOLVED_ISSUES_COUNT:
                {
                    const unresolvedIssuesCount = action.payload;
                    return {
                        ...state,
                        unresolvedIssuesCount: unresolvedIssuesCount || 0
                    };
                }
            case 0, (0, parcelRequire("3yLu1")).SWAP_ISSUES:
                return {
                    ...state,
                    shouldSwapIssues: action.payload
                };
            case 0, (0, parcelRequire("3yLu1")).SET_HANDLERS:
                {
                    const handlers = action.payload;
                    return {
                        ...state,
                        handlers: (0, ($parcel$interopDefault($1UikQ)))({}, state.handlers, handlers)
                    };
                }
            case 0, (0, parcelRequire("3yLu1")).INITIAL_REQUEST_SUCCESS:
                {
                    const version = action.payload;
                    return (0, ($parcel$interopDefault($fr1K2)))({
                        ...state,
                        version: version
                    }, 'isInitiating');
                }
            case 0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_UPDATE:
                {
                    const prevVersion = state.version;
                    const prevErrors = state.errors;
                    const nextVersion = action.payload;
                    const errors = {};
                    if (action.payload && action.payload.moveUnfixedIssuesTo) errors.moveUnfixedIssuesTo = '';
                    if (action.payload && action.payload.releaseDate) errors.releaseDate = '';
                    return {
                        ...state,
                        errors: (0, ($parcel$interopDefault($6Csk1)))({}, prevErrors, errors),
                        version: (0, ($parcel$interopDefault($6Csk1)))({}, prevVersion, nextVersion)
                    };
                }
            case 0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_VALIDATION_FAILURE:
                {
                    const errors = action.payload;
                    return (0, ($parcel$interopDefault($fr1K2)))({
                        ...state,
                        errors: errors
                    }, 'isSaving');
                }
            case 0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_REQUEST:
                return {
                    ...state,
                    isSaving: true
                };
            case 0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_SUCCESS:
            case 0, (0, parcelRequire("3yLu1")).RELEASE_VERSION_FAILURE:
                return (0, ($parcel$interopDefault($fr1K2)))(state, 'isSaving');
            case 0, (0, parcelRequire("3yLu1")).INITIAL_REQUEST:
                return state;
            case 0, (0, parcelRequire("3yLu1")).CREATE_RELEASE_NOTES_OPTIONS:
                return {
                    ...state,
                    ...action.payload,
                    shouldRedirectToCreateReleaseNotes: !(action.payload?.hasReleaseNote ?? false)
                };
            case 0, (0, parcelRequire("3yLu1")).RELEASE_SET_REDIRECT_TO_CREATE_RELEASE_NOTES_STATUS:
                {
                    const shouldRedirectToCreateReleaseNotes = action.payload !== undefined ? action.payload : false;
                    return {
                        ...state,
                        shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes
                    };
                }
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("6FZ5A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dba542cd4fb317a1$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3yLu1;
    var $ai3Yq;
    var $gdGCZ;
    var $61jfR;
    const $dba542cd4fb317a1$var$mapStateToProps = (state)=>({
            unresolvedIssuesCount: (0, (0, parcelRequire("ai3Yq")).getUnresolvedIssuesCount)(state),
            isReleaseDisabled: (0, (0, parcelRequire("ai3Yq")).isReleaseDisabled)(state),
            name: (0, (0, parcelRequire("ai3Yq")).getName)(state),
            isSaving: (0, (0, parcelRequire("ai3Yq")).isSaving)(state),
            isInitiating: (0, (0, parcelRequire("ai3Yq")).isInitiating)(state),
            onCancel: (0, (0, parcelRequire("ai3Yq")).getOnCancelHandler)(state),
            Content: (0, parcelRequire("gdGCZ")).default,
            shouldRedirectToCreateReleaseNotes: (0, (0, parcelRequire("ai3Yq")).shouldRedirectToCreateReleaseNotes)(state),
            shouldShowCreateReleaseNotesOption: (0, (0, parcelRequire("ai3Yq")).shouldShowCreateReleaseNotesOption)(state)
        });
    const $dba542cd4fb317a1$var$dispatcher = (dispatch)=>({
            onRelease: ()=>dispatch((0, (0, parcelRequire("3yLu1")).releaseVersionRequest)()),
            setRedirectToCreateReleaseNotesStatus: (value)=>dispatch((0, (0, parcelRequire("3yLu1")).releaseRedirectToCreateReleaseNotesStatus)(value))
        });
    const $dba542cd4fb317a1$var$mapDispatchToProps = (dispatch)=>$dba542cd4fb317a1$var$dispatcher(dispatch);
    var $dba542cd4fb317a1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($dba542cd4fb317a1$var$mapStateToProps, $dba542cd4fb317a1$var$mapDispatchToProps)((0, (0, parcelRequire("61jfR")).default));
});
parcelRegister("gdGCZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc6b5ee15f8b82ed$export$2e2bcd8739ae039);
    var $bC2fB;
    var $jC89g;
    var $ai3Yq;
    var $ixV8C;
    var $50qub;
    var $3nRuh;
    var $uKe1m;
    const $bc6b5ee15f8b82ed$var$mapStateToProps = (state)=>({
            SwapIssues: (0, parcelRequire("3nRuh")).default,
            ReleaseDate: (0, parcelRequire("50qub")).default,
            ReleaseAutomationBanner: (0, parcelRequire("ixV8C")).ReleaseAutomationBanner,
            doneIssues: (0, (0, parcelRequire("ai3Yq")).getDoneIssuesCount)(state),
            unresolvedIssuesCount: (0, (0, parcelRequire("ai3Yq")).getUnresolvedIssuesCount)(state),
            resolvedIssuesCount: (0, (0, parcelRequire("ai3Yq")).getResolvedIssuesCount)(state),
            unresolvedIssuesUrl: (0, (0, parcelRequire("jC89g")).getUnresolvedIssuesInVersionJql)((0, (0, parcelRequire("ai3Yq")).getProjectKey)(state), (0, (0, parcelRequire("ai3Yq")).getName)(state)),
            resolvedIssueUrl: (0, (0, parcelRequire("jC89g")).getResolvedIssuesInVersionJql)((0, (0, parcelRequire("ai3Yq")).getProjectKey)(state), (0, (0, parcelRequire("ai3Yq")).getName)(state))
        });
    var $bc6b5ee15f8b82ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($bc6b5ee15f8b82ed$var$mapStateToProps, {})((0, (0, parcelRequire("uKe1m")).default));
});
parcelRegister("jC89g", function(module, exports) {
    $parcel$export(module.exports, "getUnresolvedIssuesInVersionJql", ()=>$a27f6842930b4a90$export$6ec377b2fc8168c7);
    $parcel$export(module.exports, "getResolvedIssuesInVersionJql", ()=>$a27f6842930b4a90$export$c14e075033246e76);
    var $cIy4l;
    const $a27f6842930b4a90$export$6ec377b2fc8168c7 = (projectKey, versionName)=>{
        const jql = `project = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(projectKey)} AND fixVersion = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(versionName)} AND resolution is EMPTY`;
        return (0, (0, parcelRequire("cIy4l")).createIssuesUrl)(jql);
    };
    const $a27f6842930b4a90$export$c14e075033246e76 = (projectKey, versionName)=>(0, (0, parcelRequire("cIy4l")).createIssuesUrl)(`project = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(projectKey)} AND fixVersion = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(versionName)} AND resolution is NOT EMPTY`);
});
parcelRegister("ixV8C", function(module, exports) {
    $parcel$export(module.exports, "ReleaseAutomationBanner", ()=>$52f7cd2e766f7238$export$45e1a2bd60e730ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $itzrU;
    var $fVnbM;
    var $lLLkM;
    var $gOS29;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $2NMNM;
    var $dAfqg;
    var $c42uT;
    var $5d48Z = parcelRequire("5d48Z");
    var $4eavD;
    const $52f7cd2e766f7238$export$d6be0a6034032add = (projectProps)=>`${(0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)(projectProps)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;
    const $52f7cd2e766f7238$export$45e1a2bd60e730ec = ({ isTransitionEnabled: isTransitionEnabled = true })=>{
        const { showBanner: showBanner, dismissBanner: dismissBanner } = (0, (0, parcelRequire("c42uT")).useReleaseAutomationBanner)();
        const { data: projectContext, loading: loading, error: error } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        if (loading) return null;
        if (error) throw error;
        if (projectContext == null) throw Error('Missing project context when rendering ReleaseAutomationBanner');
        const { simplified: isSimplified, projectKey: projectKey, projectType: projectType } = projectContext;
        const renderBannerContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($52f7cd2e766f7238$var$Spacer, null), (0, ($parcel$interopDefault($5uXOq))).createElement($52f7cd2e766f7238$var$Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            width: 14,
            height: 16,
            src: (0, ($parcel$interopDefault($5d48Z))),
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($52f7cd2e766f7238$var$CallToAction, {
            href: $52f7cd2e766f7238$export$d6be0a6034032add({
                isSimplified: isSimplified,
                projectKey: projectKey,
                projectType: projectType
            }),
            target: "_blank",
            rel: "noopener noreferrer",
            title: formatMessage((0, (0, parcelRequire("4eavD")).default).setupReleaseAutomation),
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                }), 'newRuleAutomationLink');
                dismissBanner();
            }
        }, formatMessage((0, (0, parcelRequire("4eavD")).default).setupReleaseAutomation)), (0, ($parcel$interopDefault($5uXOq))).createElement($52f7cd2e766f7238$var$Dismiss, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            shouldFitContainer: true,
            appearance: "subtle",
            onClick: (_, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dismissButton');
                dismissBanner();
            },
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
                label: formatMessage((0, (0, parcelRequire("4eavD")).default).dismiss),
                size: "small"
            })
        }))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84),
            sourceName: "releaseAutomationCallToAction"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), isTransitionEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement($52f7cd2e766f7238$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itzrU")).default), {
            in: showBanner,
            timeout: $52f7cd2e766f7238$var$TRANSITION_DURATION,
            classNames: "release-automation-banner",
            unmountOnExit: true
        }, renderBannerContent)) : renderBannerContent);
    };
    const $52f7cd2e766f7238$var$BANNER_HEIGHT = 80;
    const $52f7cd2e766f7238$var$TRANSITION_DURATION = 400;
    const $52f7cd2e766f7238$var$Section = (0, $5uXOq.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _2rko1y44 _1yt4pxbi _zulppxbi _189eyh40 _1dqonqa1 _1h6d193x",
                __cmplp.className
            ])
        });
    });
    const $52f7cd2e766f7238$var$CallToAction = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $52f7cd2e766f7238$var$Dismiss = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbzwfg",
                __cmplp.className
            ])
        });
    });
    const $52f7cd2e766f7238$var$Spacer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg",
                __cmplp.className
            ])
        });
    });
    const $52f7cd2e766f7238$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1k7uidpf _lnbg15vq _11ok15vq _pmb0idpf _lghnkb7n _1sz115vq _iayz15vq _3g9qys9h _19q1o91y _28jmkb7n _1b0e15vq _19ci15vq _13e1ys9h _zsv0idpf _1g5d15vq _153n15vq _qigkidpf _khvao91y",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5d48Z", function(module, exports) {
    module.exports = new URL("lightning.44c03a60.svg", import.meta.url).toString();
});
parcelRegister("4eavD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$428af210918cdaf9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $428af210918cdaf9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        setupReleaseAutomation: {
            "id": "project-directories.versions.release-version-modal.content.release-automation-banner.setup-release-automation",
            "defaultMessage": "Set up release automation"
        },
        dismiss: {
            "id": "project-directories.versions.release-version-modal.content.release-automation-banner.dismiss",
            "defaultMessage": "Dismiss"
        }
    });
});
parcelRegister("50qub", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b98138cc474c021$export$2e2bcd8739ae039);
    var $bC2fB;
    var $3yLu1;
    var $ai3Yq;
    var $2Nd4Z;
    const $9b98138cc474c021$var$mapStateToProps = (state)=>({
            releaseDate: (0, (0, parcelRequire("ai3Yq")).getReleaseDate)(state),
            errors: (0, (0, parcelRequire("ai3Yq")).getErrors)(state),
            isSaving: (0, (0, parcelRequire("ai3Yq")).isSaving)(state)
        });
    const $9b98138cc474c021$var$dispatcher = (dispatch)=>({
            onInputChange: (version)=>dispatch((0, (0, parcelRequire("3yLu1")).releaseVersionUpdate)(version))
        });
    const $9b98138cc474c021$var$mapDispatchToProps = (dispatch)=>$9b98138cc474c021$var$dispatcher(dispatch);
    var $9b98138cc474c021$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($9b98138cc474c021$var$mapStateToProps, $9b98138cc474c021$var$mapDispatchToProps)((0, (0, parcelRequire("2Nd4Z")).default));
});
parcelRegister("2Nd4Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf173cf292ca0eac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jj52j;
    var $cHapz;
    var $7O4UO;
    var $8tAHc;
    var $az4zD;
    var $3LzsZ;
    var $lhpg4;
    class $bf173cf292ca0eac$export$55e7fadddcffb796 extends (0, $5uXOq.Component) {
        inputChange(update) {
            const { onInputChange: onInputChange } = this.props;
            onInputChange({
                releaseDate: update.releaseDate
            });
        }
        render() {
            const { intl: { formatMessage: formatMessage, locale: locale }, releaseDate: releaseDate, errors: errors, isSaving: isSaving } = this.props;
            const { releaseDate: releaseDateError } = errors;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                name: "releaseDate",
                label: formatMessage((0, (0, parcelRequire("lhpg4")).default).releaseDate)
            }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($bf173cf292ca0eac$var$DatePickerContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3LzsZ")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHapz")).default), {
                    isDisabled: isSaving,
                    defaultValue: releaseDate !== '' ? (0, (0, parcelRequire("jj52j")).default)(new Date(releaseDate)) : releaseDate,
                    onChange: this.onReleaseDateChange,
                    placeholder: formatMessage((0, (0, parcelRequire("8tAHc")).default).placeholderDate),
                    locale: locale
                })))), releaseDateError && (0, ($parcel$interopDefault($5uXOq))).createElement($bf173cf292ca0eac$var$ValidationError, null, releaseDateError));
        }
        constructor(...args){
            super(...args), this.onReleaseDateChange = (releaseDate)=>{
                if (releaseDate) this.inputChange({
                    releaseDate: releaseDate
                });
                else this.inputChange({
                    releaseDate: ''
                });
            };
        }
    }
    var $bf173cf292ca0eac$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($bf173cf292ca0eac$export$55e7fadddcffb796);
    const $bf173cf292ca0eac$var$DatePickerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1ssb",
                __cmplp.className
            ])
        });
    });
    const $bf173cf292ca0eac$var$ValidationError = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pku2gc _syaz17af",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cHapz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a844b50b385d50f7$export$2e2bcd8739ae039);
    var $VSDnB;
    var $cKsfY;
    var $2TI0z;
    var $jcbUF;
    const $a844b50b385d50f7$var$DatePicker = (0, (0, parcelRequire("cKsfY")).componentWithCondition)(()=>(0, (0, parcelRequire("VSDnB")).fg)('dst-date-picker-use-functional-component'), (0, (0, parcelRequire("jcbUF")).default), (0, (0, parcelRequire("2TI0z")).default));
    var $a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;
});
parcelRegister("cKsfY", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$8f027f90da2b6bac$export$6e8ea24b15199873);
    var $5uXOq = parcelRequire("5uXOq");
    function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $5uXOq.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("2TI0z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19201d0a1f7d7d54$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $9KnKW;
    var $acknU;
    var $cTemL;
    var $7qZ1x;
    var $VSDnB;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $7K5PP;
    var $7VXAu;
    var $jldZL;
    var $jHBnA;
    var $5RLF6;
    var $iaQLg;
    var $gtijU;
    var $6AqCE;
    var $dBs4v;
    function $19201d0a1f7d7d54$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
    const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
    const $19201d0a1f7d7d54$var$dropdownIndicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $19201d0a1f7d7d54$var$CalendarIcon = (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("acknU"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cTemL")))));
    const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
        defaultIsOpen: false,
        defaultValue: '',
        disabled: [],
        disabledDateFilter: (_)=>false,
        locale: 'en-US',
        onBlur: (_event)=>{},
        onChange: (_value)=>{},
        onFocus: (_event)=>{}
    };
    const $19201d0a1f7d7d54$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $19201d0a1f7d7d54$var$iconContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        insetBlockStart: 0,
        insetInlineEnd: 0,
        transition: `color 150ms`,
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        }
    });
    const $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles = {
        name: "jd0mtf",
        styles: "margin-inline-end:var(--ds-space-400, 2rem)"
    };
    const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew = {
        name: "129q61y",
        styles: "margin-inline-end:var(--ds-space-050, 0.25rem)"
    };
    const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles = {
        name: "sz3drw",
        styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
    };
    const $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $19201d0a1f7d7d54$var$calendarButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
        }
        constructor(props){
            super(props), this.containerRef = null, this.calendarRef = (0, $5uXOq.createRef)(), this.calendarButtonRef = (0, $5uXOq.createRef)(), this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
                this.setState({
                    calendarValue: (0, (0, parcelRequire("5RLF6")).getParsedISO)({
                        iso: iso
                    })
                });
            }, this.onCalendarSelect = ({ iso: iso })=>{
                this.setState({
                    selectInputValue: '',
                    isOpen: false,
                    calendarValue: iso,
                    value: iso,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onChange(iso);
                if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                this.setState({
                    isOpen: false
                });
            }, this.onInputClick = ()=>{
                if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            }, this.onContainerBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (!this.containerRef?.contains(newlyFocusedElement)) {
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    this.props.onBlur(event);
                }
            }, this.onContainerFocus = ()=>{
                this.setState({
                    shouldSetFocusOnCurrentDay: false
                });
            }, this.onSelectBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (this.state.clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else if (!this.containerRef?.contains(newlyFocusedElement)) this.setState({
                    isOpen: false,
                    isFocused: false,
                    wasOpenedFromCalendarButton: false
                });
            }, this.onSelectFocus = (event)=>{
                const { clearingFromIcon: clearingFromIcon } = this.state;
                const value = this.getValue();
                if (clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else this.setState({
                    isOpen: !this.props.shouldShowCalendarButton,
                    calendarValue: value,
                    isFocused: true,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onFocus(event);
            }, this.onTextInput = (event)=>{
                const inputValue = event.target.value;
                if (inputValue) {
                    const parsed = (0, (0, parcelRequire("5RLF6")).parseDate)(inputValue, {
                        parseInputValue: this.props.parseInputValue,
                        dateFormat: this.props.dateFormat,
                        l10n: this.state.l10n
                    });
                    if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) this.setState({
                        calendarValue: (0, (0, parcelRequire("6AqCE")).getShortISOString)(parsed)
                    });
                }
                this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            }, this.onInputKeyDown = (event)=>{
                const { calendarValue: calendarValue } = this.state;
                const value = this.getValue();
                const keyPressed = event.key.toLowerCase();
                if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
                switch(keyPressed){
                    case 'escape':
                        if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                        else {
                            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                            innerCombobox?.focus();
                        }
                        this.setState({
                            isOpen: false,
                            shouldSetFocusOnCurrentDay: false,
                            wasOpenedFromCalendarButton: false
                        });
                        break;
                    case 'backspace':
                    case 'delete':
                        {
                            const inputCount = 0;
                            if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) this.setState({
                                clearingFromIcon: false,
                                value: ''
                            });
                            break;
                        }
                    case 'enter':
                        if (!this.state.isOpen) return;
                        event.preventDefault();
                        if (!(0, (0, parcelRequire("5RLF6")).isDateDisabled)(calendarValue, {
                            disabled: this.props.disabled
                        })) {
                            const safeCalendarValue = (0, (0, parcelRequire("6AqCE")).getSafeCalendarValue)(calendarValue);
                            const valueChanged = safeCalendarValue !== value;
                            this.setState({
                                selectInputValue: '',
                                isOpen: false,
                                value: safeCalendarValue,
                                calendarValue: safeCalendarValue,
                                wasOpenedFromCalendarButton: false
                            });
                            if (valueChanged) this.props.onChange(safeCalendarValue);
                        }
                        break;
                    case 'arrowdown':
                    case 'arrowup':
                        if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                            isOpen: true,
                            shouldSetFocusOnCurrentDay: true
                        });
                        break;
                    default:
                        break;
                }
            }, this.onCalendarButtonKeyDown = (e)=>{
                if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
                if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                    e.stopPropagation();
                    this.setState({
                        isKeyDown: true,
                        wasOpenedFromCalendarButton: true
                    });
                }
            }, this.onCalendarButtonClick = (e)=>{
                this.setState({
                    isOpen: !this.state.isOpen,
                    wasOpenedFromCalendarButton: true
                }, ()=>{
                    if (!this.state.isKeyDown) return;
                    this.setState({
                        isKeyDown: false
                    });
                    this.calendarRef?.current?.querySelector('button')?.focus();
                });
                e.stopPropagation();
            }, this.onClear = ()=>{
                let changedState = {
                    value: '',
                    calendarValue: this.props.defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date())
                };
                if (!this.props.hideIcon) changedState = {
                    ...changedState,
                    clearingFromIcon: true
                };
                this.setState(changedState);
                this.props.onChange('');
            }, this.onSelectChange = (_value, action)=>{
                if (action.action === 'clear') this.onClear();
            }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
                const onInputChange = this.props.selectProps?.onInputChange;
                if (onInputChange) onInputChange(selectInputValue, actionMeta);
                this.setState({
                    selectInputValue: selectInputValue
                });
            }, this.getContainerRef = (ref)=>{
                const oldRef = this.containerRef;
                this.containerRef = ref;
                if (oldRef == null && ref != null) this.forceUpdate();
            };
            this.state = {
                isKeyDown: false,
                isOpen: this.props.defaultIsOpen,
                isFocused: false,
                clearingFromIcon: false,
                selectInputValue: this.props.selectProps?.inputValue || '',
                value: this.props.value || this.props.defaultValue,
                calendarValue: this.props.value || this.props.defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()),
                l10n: (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(this.props.locale),
                locale: this.props.locale,
                shouldSetFocusOnCurrentDay: false,
                wasOpenedFromCalendarButton: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.locale !== prevState.locale) return {
                l10n: (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(nextProps.locale),
                locale: nextProps.locale
            };
            else return null;
        }
        render() {
            const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = $19201d0a1f7d7d54$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
            const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
            const value = this.getValue();
            let actualSelectInputValue;
            actualSelectInputValue = selectInputValue;
            const menuIsOpen = this.getIsOpen() && !isDisabled;
            const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
            let clearIndicator = Icon;
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $19201d0a1f7d7d54$var$dropdownIndicatorStyles
                }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
            const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
            const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
                lang: this.props.locale
            });
            const selectComponents = {
                DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("jHBnA")).EmptyComponent) : dropDownIcon,
                ...shouldShowCalendarButton ? {
                    IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iaQLg")).IndicatorsContainer), {
                            ...props,
                            showClearIndicator: showClearIndicator
                        })
                } : {},
                Menu: (0, parcelRequire("gtijU")).Menu,
                SingleValue: SingleValue,
                ...!showClearIndicator && {
                    ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
                }
            };
            const { styles: selectStyles = {} } = selectProps;
            const disabledStyle = isDisabled ? {
                pointerEvents: 'none',
                color: "var(--ds-icon-disabled, inherit)"
            } : {};
            const calendarProps = {
                calendarContainerRef: this.containerRef,
                calendarDisabled: disabled,
                calendarDisabledDateFilter: disabledDateFilter,
                calendarMaxDate: maxDate,
                calendarMinDate: minDate,
                calendarRef: this.calendarRef,
                calendarValue: value && (0, (0, parcelRequire("6AqCE")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(value)),
                calendarView: calendarValue,
                onCalendarChange: this.onCalendarChange,
                onCalendarSelect: this.onCalendarSelect,
                calendarLocale: locale,
                calendarWeekStartDay: weekStartDay,
                shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
            };
            const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
                control: (base)=>({
                        ...base,
                        ...disabledStyle
                    }),
                indicatorsContainer: (base)=>({
                        ...base,
                        paddingLeft: "var(--ds-space-025, 2px)",
                        paddingRight: "var(--ds-space-075, 6px)"
                    })
            });
            const initialValue = value ? {
                label: (0, (0, parcelRequire("5RLF6")).formatDate)(value, {
                    formatDisplayLabel: this.props.formatDisplayLabel,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }),
                value: value
            } : null;
            const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...innerProps,
                css: $19201d0a1f7d7d54$var$pickerContainerStyles,
                role: "presentation",
                onBlur: this.onContainerBlur,
                onFocus: this.onContainerFocus,
                onClick: this.onInputClick,
                onInput: this.onTextInput,
                onKeyDown: this.onInputKeyDown,
                ref: this.getContainerRef,
                "data-testid": testId && `${testId}--container`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7K5PP")).default), {
                appearance: this.props.appearance,
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                components: selectComponents,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: this.onSelectBlur,
                onChange: this.onSelectChange,
                onFocus: this.onSelectFocus,
                onInputChange: this.handleSelectInputChange,
                placeholder: (0, (0, parcelRequire("5RLF6")).getPlaceholder)({
                    placeholder: this.props.placeholder,
                    l10n: this.state.l10n
                }),
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
            }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9KnKW")).IdProvider), {
                prefix: "open-calendar-label--"
            }, ({ id: openCalendarLabelId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: [
                        $19201d0a1f7d7d54$var$iconContainerStyles,
                        value && !hideIcon ? $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew : $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles
                    ]
                }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
                    id: openCalendarLabelId
                }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
                    ...inputLabelId ? {
                        'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
                    } : {
                        'aria-label': fullopenCalendarLabel
                    },
                    onClick: this.onCalendarButtonClick,
                    onKeyDown: this.onCalendarButtonKeyDown,
                    ref: this.calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`,
                    type: "button",
                    backgroundColor: "color.background.neutral.subtle",
                    padding: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
                    xcss: [
                        $19201d0a1f7d7d54$var$calendarButtonStyles,
                        (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') && $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles
                    ]
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($19201d0a1f7d7d54$var$CalendarIcon, {
                    label: "",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                        color: "var(--ds-icon, #44546F)"
                    } : {
                        primaryColor: "var(--ds-icon, #44546F)"
                    }
                })))) : null));
        }
    }
    const $19201d0a1f7d7d54$var$DatePicker = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'datePicker',
        packageName: $19201d0a1f7d7d54$var$packageName,
        packageVersion: $19201d0a1f7d7d54$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: (0, (0, parcelRequire("gB4mS")).default)('atlaskit')({
            action: 'selectedDate',
            actionSubject: 'datePicker',
            attributes: {
                componentName: 'datePicker',
                packageName: $19201d0a1f7d7d54$var$packageName,
                packageVersion: $19201d0a1f7d7d54$var$packageVersion
            }
        })
    })($19201d0a1f7d7d54$export$df43d21f5faca9f7));
    var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;
});
parcelRegister("acknU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));
    var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
    function $76cad653a4883392$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $76cad653a4883392$var$CalendarIcon = (props)=>$76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
            LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
        }, props));
    $76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
    var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;
});
parcelRegister("3fesp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $25cdfcb8bb836404$var$_UNSAFE_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25cdfcb8bb836404$var$CalendarIcon = (props)=>$25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
        }, props));
    $25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
    var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;
});
parcelRegister("cTemL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
    function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9625c3edd02eaf26$var$CalendarIcon = (props)=>$9625c3edd02eaf26$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
        }, props, {
            newIcon: $9625c3edd02eaf26$var$_calendar.default
        }));
    $9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
    var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;
});
parcelRegister("7qZ1x", function(module, exports) {
    $parcel$export(module.exports, "createLocalizationProvider", ()=>$71bdd27445bf5301$export$ea56ca58f08ffa52);
    var $lCAti;
    var $is0Fy;
    var $1cWOp;
    const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
        const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
                hour: 'numeric',
                minute: 'numeric'
            }).format(date);
        const getDays = (weekStartDay = 0, length)=>{
            const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
                weekday: length
            });
            const weekdays = [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
            const rotatedWeekdays = weekStartDay > 0 ? [
                ...weekdays.slice(weekStartDay),
                ...weekdays.slice(0, weekStartDay)
            ] : weekdays;
            return rotatedWeekdays.map((day)=>{
                const result = dayFormatter.format(new Date(2000, 9, day + 1, 12)).replace(/[\s\u200E]/g, '');
                if (length === 'short') return result.substring(0, 3);
                else return result;
            });
        };
        const getDaysShort = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'short');
        };
        const getDaysLong = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'long');
        };
        const getMonthsLong = ()=>{
            const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
                month: 'long'
            });
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map((month)=>monthFormatter.format(new Date(2020, month, 1)));
        };
        const parseDate = (date)=>(0, (0, parcelRequire("is0Fy")).createDateParser)(normalizedLocale)(date);
        const formatToParts = (date = new Date())=>{
            const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
            const fixedDate = new Date(date);
            fixedDate.setFullYear(2020);
            const fixedParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(fixedDate));
            const originalParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(date));
            if (fixedParts.year) fixedParts.year = originalParts.year;
            if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
            return fixedParts;
        };
        return {
            getDaysShort: getDaysShort,
            getDaysLong: getDaysLong,
            getMonthsLong: getMonthsLong,
            formatDate: formatDate,
            formatTime: formatTime,
            parseDate: parseDate,
            formatToParts: formatToParts
        };
    };
});
parcelRegister("lCAti", function(module, exports) {
    $parcel$export(module.exports, "normalizeLocale", ()=>$13af55a9724edafd$export$dca0327c9b9c6498);
    const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
});
parcelRegister("is0Fy", function(module, exports) {
    $parcel$export(module.exports, "createDateParser", ()=>$d8bb223589902df4$export$cfa2ef2687faeda2);
    var $3wYKB;
    var $lCAti;
    const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
    const $d8bb223589902df4$var$INVARIANT = {
        year: 1993,
        month: 2,
        day: 18
    };
    const $d8bb223589902df4$var$INVARIANT_DATE = (0, (0, parcelRequire("3wYKB")).toDate)($d8bb223589902df4$var$INVARIANT);
    const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
    const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
    const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
    const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
        return matchResult.splice(1, 4).map((datePart)=>parseInt(datePart, 10));
    };
    const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
        const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
        const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
        const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
        if (!formatMatch) throw new Error('Unable to create DateParser');
        const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
        const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
        const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
        const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
        return (date)=>{
            const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
            if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
            const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
            const extractedDate = {
                year: dateParts[yearPosition],
                month: dateParts[monthPosition],
                day: dateParts[dayPosition]
            };
            const normalizedDate = (0, (0, parcelRequire("3wYKB")).normalizeDate)(extractedDate);
            if (!(0, (0, parcelRequire("3wYKB")).isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
            return (0, (0, parcelRequire("3wYKB")).toDate)(normalizedDate);
        };
    };
});
parcelRegister("3wYKB", function(module, exports) {
    $parcel$export(module.exports, "toDate", ()=>$121d324fc62f760d$export$e67a095c620b86fe);
    $parcel$export(module.exports, "isValid", ()=>$121d324fc62f760d$export$1ea939691cdc45b8);
    $parcel$export(module.exports, "normalizeDate", ()=>$121d324fc62f760d$export$fcc71269590ba0a8);
    const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        });
    const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>new Date(date.year, date.month - 1, date.day);
    const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    };
    const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
        if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
        return [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][month - 1];
    };
    const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
        const { year: year, month: month, day: day } = date;
        const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
        return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
    };
    const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
        const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
        const { year: year, month: month, day: day } = date;
        const fullYear = year < 100 ? 2000 + year : year;
        const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
        const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
        const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
        return {
            year: normalizedYear,
            month: normalizedMonth,
            day: normalizedDay
        };
    };
});
parcelRegister("1cWOp", function(module, exports) {
    $parcel$export(module.exports, "toFormattedParts", ()=>$56bd04270448c035$export$9b7ca29af37c192);
    const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
                ...result,
                [datePart.type]: datePart.value
            }), {});
});
parcelRegister("jHBnA", function(module, exports) {
    $parcel$export(module.exports, "EmptyComponent", ()=>$91948b176ea23188$export$5e30e9a24d6c1203);
    $parcel$export(module.exports, "placeholderDatetime", ()=>$91948b176ea23188$export$fff8babee5abe3e2);
    $parcel$export(module.exports, "defaultTimes", ()=>$91948b176ea23188$export$b42ffb9f09b1861b);
    $parcel$export(module.exports, "defaultTimeFormat", ()=>$91948b176ea23188$export$9e6d8fcf62256b85);
    $parcel$export(module.exports, "defaultDateFormat", ()=>$91948b176ea23188$export$75032c84f56650eb);
    $parcel$export(module.exports, "padToTwo", ()=>$91948b176ea23188$export$a7de57e5b672ccdb);
    $parcel$export(module.exports, "formatDateTimeZoneIntoIso", ()=>$91948b176ea23188$export$2eeb05a2ecc2ce0a);
    const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
    const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
    const $91948b176ea23188$export$b42ffb9f09b1861b = [
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00'
    ];
    const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
    const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
    function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
        return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
    }
    function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
        const needsLeadingZero = /^\d:/;
        const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
        return `${date}T${sanitizedTime}${zone}`;
    }
});
parcelRegister("5RLF6", function(module, exports) {
    $parcel$export(module.exports, "isDateDisabled", ()=>$e0db4b6edb7dbfac$export$d38e7e283938128c);
    $parcel$export(module.exports, "getParsedISO", ()=>$e0db4b6edb7dbfac$export$38db26406d1a1ee2);
    $parcel$export(module.exports, "parseDate", ()=>$e0db4b6edb7dbfac$export$6b862160d295c8e);
    $parcel$export(module.exports, "formatDate", ()=>$e0db4b6edb7dbfac$export$3ae94a2503e890a1);
    $parcel$export(module.exports, "getPlaceholder", ()=>$e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
    var $k7m40;
    var $5I2ju;
    var $eZDAP;
    var $2ucUe;
    var $jHBnA;
    const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
        const { disabled: disabled } = di;
        return disabled.indexOf(date) > -1;
    };
    const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
        const { iso: iso } = di;
        const [year, month, date] = iso.split('-');
        let newIso = iso;
        const parsedDate = parseInt(date, 10);
        const parsedMonth = parseInt(month, 10);
        const parsedYear = parseInt(year, 10);
        const lastDayInMonth = (0, (0, parcelRequire("5I2ju")).default)(new Date(parsedYear, parsedMonth - 1)).getDate();
        if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(lastDayInMonth)}`;
        else newIso = `${parsedYear}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedDate)}`;
        return newIso;
    };
    const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
        const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
        if (parseInputValue) return parseInputValue(date, dateFormat || (0, (0, parcelRequire("jHBnA")).defaultDateFormat));
        return l10n.parseDate(date);
    };
    const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
        const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
        if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, (0, parcelRequire("jHBnA")).defaultDateFormat));
        const date = (0, (0, parcelRequire("eZDAP")).default)(value);
        return dateFormat ? (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)(dateFormat)) : l10n.formatDate(date);
    };
    const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
        const { placeholder: placeholder, l10n: l10n } = di;
        return placeholder || l10n.formatDate((0, (0, parcelRequire("jHBnA")).placeholderDatetime));
    };
});
parcelRegister("2ucUe", function(module, exports) {
    $parcel$export(module.exports, "convertTokens", ()=>$ca6f20a476eda5dc$export$4d5430175be73d45);
    const $ca6f20a476eda5dc$var$tokensMap = {
        M: 'L',
        Mo: 'Mo',
        MM: 'LL',
        MMM: 'LLL',
        MMMM: 'LLLL',
        Q: 'q',
        Qo: 'qo',
        D: 'd',
        Do: 'do',
        DD: 'dd',
        DDD: 'D',
        DDDo: 'Do',
        DDDD: 'DDD',
        d: 'i',
        do: 'io',
        dd: 'iiiiii',
        ddd: 'iii',
        dddd: 'iiii',
        A: 'a',
        a: 'a',
        aa: 'aaaa',
        E: 'i',
        W: 'I',
        Wo: 'Io',
        WW: 'II',
        YY: 'yy',
        YYYY: 'yyyy',
        GG: 'RR',
        GGGG: 'RRRR',
        H: 'H',
        HH: 'HH',
        h: 'h',
        hh: 'hh',
        m: 'm',
        mm: 'mm',
        s: 's',
        ss: 'ss',
        S: 'S',
        SS: 'SS',
        SSS: 'SSS',
        Z: 'xxx',
        ZZ: 'xx',
        X: 't',
        x: 'T'
    };
    const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
    const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp("(\\[[^\\[]*\\])|(\\\\)?('.+'|" + $ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
    function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
        const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
        if (!tokensCaptures) return format;
        return tokensCaptures.reduce((parsed, tokenString, index)=>{
            const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
            if (!v2token) {
                const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
                if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
                else parsed.escapedTextBuffer.push(tokenString);
            }
            const endOfString = index === tokensCaptures.length - 1;
            if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
                const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
                parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
                parsed.escapedTextBuffer = [];
            }
            if (v2token) parsed.formatBuffer.push(v2token);
            return parsed;
        }, {
            formatBuffer: [],
            escapedTextBuffer: []
        }).formatBuffer.join('');
    }
});
parcelRegister("iaQLg", function(module, exports) {
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$d73476b891de3e0c$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $bChGW;
    function $d73476b891de3e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d73476b891de3e0c$var$calendarButtonInclusionStyles = {
        name: "i3e4rp",
        styles: "margin-inline-start:var(--ds-space-400, 32px)"
    };
    const $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles = {
        name: "19a3ait",
        styles: "margin-inline-start:var(--ds-space-300, 24px)"
    };
    const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: showClearIndicator ? $d73476b891de3e0c$var$calendarButtonInclusionStyles : $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorsContainer, rest));
});
parcelRegister("gtijU", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$e800a879ee1613fc$export$d9b273488cd8ce6f);
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $1f0Hs;
    var $9MHPe;
    var $k5uoT;
    var $avHVh;
    function $e800a879ee1613fc$var$getValidDate(isos) {
        return isos.reduce((acc, iso)=>{
            const date = (0, (0, parcelRequire("eZDAP")).default)(iso);
            return (0, (0, parcelRequire("jovBr")).default)(date) ? {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear()
            } : acc;
        }, {});
    }
    const $e800a879ee1613fc$var$menuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog(),
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        overflow: 'hidden'
    });
    const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
        const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
        const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
            calendarValue,
            calendarView
        ]);
        const onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avHVh")).default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $e800a879ee1613fc$var$menuStyles,
                ...innerProps,
                onMouseDown: onMenuMouseDown
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1f0Hs")).default), {
                day: day,
                month: month,
                year: year,
                disabled: selectProps.calendarDisabled,
                disabledDateFilter: selectProps.calendarDisabledDateFilter,
                minDate: selectProps.calendarMinDate,
                maxDate: selectProps.calendarMaxDate,
                nextMonthLabel: selectProps.nextMonthLabel,
                onChange: selectProps.onCalendarChange,
                onSelect: selectProps.onCalendarSelect,
                previousMonthLabel: selectProps.previousMonthLabel,
                ref: selectProps.calendarRef,
                selected: [
                    selectProps.calendarValue
                ],
                shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                locale: selectProps.calendarLocale,
                testId: selectProps.testId && `${selectProps.testId}--calendar`,
                weekStartDay: selectProps.calendarWeekStartDay
            })),
            testId: selectProps.testId
        }));
    };
});
parcelRegister("1f0Hs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16abbcd9b9109722$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $ePz3p;
    var $lJWdi;
    var $avO9B;
    var $iioJV;
    var $jihAA;
    var $bbnGB;
    var $hbcve;
    var $2TGJ3;
    var $f9D1v;
    var $9efze;
    const $16abbcd9b9109722$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-block',
        userSelect: 'none'
    });
    const $16abbcd9b9109722$var$analyticsAttributes = {
        componentName: 'calendar',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $16abbcd9b9109722$var$InnerCalendar = (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, (0, parcelRequire("iioJV")).blankStringArray), defaultSelected: defaultSelected = (0, (0, parcelRequire("iioJV")).blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, (0, parcelRequire("eGmKJ")).default), onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), onFocus: onFocus = (0, (0, parcelRequire("eGmKJ")).default), onSelect: onSelect = (0, (0, parcelRequire("eGmKJ")).default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
        const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, (0, parcelRequire("jihAA")).default)({
            day: day,
            defaultDay: defaultDay,
            month: month,
            defaultMonth: defaultMonth,
            year: year,
            defaultYear: defaultYear,
            today: today,
            selected: selected,
            defaultSelected: defaultSelected,
            previouslySelected: previouslySelected,
            defaultPreviouslySelected: defaultPreviouslySelected
        });
        const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            ...$16abbcd9b9109722$var$analyticsAttributes
        });
        const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, (0, parcelRequire("2TGJ3")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            shouldSetFocus: [
                shouldSetFocus,
                setShouldSetFocus
            ],
            onChange: onChangeWithAnalytics
        });
        const onSelectWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onSelect,
            action: 'selected',
            analyticsData: analyticsContext,
            ...$16abbcd9b9109722$var$analyticsAttributes
        });
        const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, (0, parcelRequire("f9D1v")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                ,
                setPreviouslySelectedValue
            ],
            onSelect: onSelectWithAnalytics,
            navigate: navigate
        });
        const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, (0, parcelRequire("bbnGB")).default)({
            onFocus: onFocus,
            onBlur: onBlur
        });
        const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, (0, parcelRequire("9efze")).default)({
            locale: locale,
            weekStartDay: weekStartDay
        });
        const weeks = (0, (0, parcelRequire("hbcve")).default)({
            day: dayValue,
            month: monthValue,
            year: yearValue,
            today: todayValue,
            selected: selectedValue,
            previouslySelected: previouslySelectedValue,
            disabled: disabled,
            disabledDateFilter: disabledDateFilter,
            minDate: minDate,
            maxDate: maxDate,
            daysLong: daysLong,
            weekStartDay: weekStartDay
        });
        const getNextHeading = ()=>{
            const nextMonth = monthValue % 12;
            const showNextYear = monthValue === 12;
            return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
        };
        const getPreviousHeading = ()=>{
            const previousMonth = (monthValue + 12 - 2) % 12;
            const showPreviousYear = monthValue === 1;
            return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
        };
        const headerId = (0, (0, parcelRequire("9KnKW")).useId)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            style: style,
            onBlur: handleContainerBlur,
            onFocus: handleContainerFocus,
            "data-testid": testId && `${testId}--container`,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $16abbcd9b9109722$var$boxStyles,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ePz3p")).default), {
            monthLongTitle: monthsLong[monthValue - 1],
            year: yearValue,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel,
            nextHeading: getNextHeading(),
            previousHeading: getPreviousHeading(),
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev,
            headerId: headerId,
            tabIndex: tabIndex,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            role: "grid",
            onKeyDown: handleContainerKeyDown,
            "aria-labelledby": headerId,
            testId: testId && `${testId}--calendar-dates`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avO9B")).default), {
            daysShort: daysShort,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lJWdi")).default), {
            weeks: weeks,
            handleClickDay: handleClickDay,
            monthsLong: monthsLong,
            shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
            tabIndex: tabIndex,
            testId: testId
        })))));
    });
    const $16abbcd9b9109722$var$Calendar = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Calendar(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($16abbcd9b9109722$var$InnerCalendar, {
            ...props,
            ref: ref
        });
    }));
    $16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
    var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;
});
parcelRegister("ePz3p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$995afee12cb828f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $42CjB;
    var $9KnKW;
    var $l1N8i;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    const $995afee12cb828f6$var$Header = (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
        const announceId = (0, (0, parcelRequire("9KnKW")).useId)();
        const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $5uXOq.useState)(false);
        const handlePrevMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickPrev(e);
        };
        const handleNextMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickNext(e);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            paddingInline: "space.100"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevMonthInteraction,
            testId: testId && `${testId}--previous-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))),
            label: `${previousMonthLabel}, ${previousHeading}`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
            id: announceId,
            testId: testId && `${testId}--current-month-year--container`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall",
            as: "h2",
            id: headerId,
            testId: testId && `${testId}--current-month-year`
        }, `${monthLongTitle} ${year}`)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextMonthInteraction,
            testId: testId && `${testId}--next-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("6s76W"))))),
            label: `${nextMonthLabel}, ${nextHeading}`
        })));
    });
    $995afee12cb828f6$var$Header.displayName = 'Header';
    var $995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;
});
parcelRegister("lJWdi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43f22a52ec309eeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $1q4y8;
    var $h581D;
    const $43f22a52ec309eeb$var$WeekDays = (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            role: "rowgroup",
            testId: testId && `${testId}--month`
        }, weeks.map((week, i)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("h581D")).default), {
                key: i,
                testId: testId && `${testId}--week`
            }, week.values.map((weekDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1q4y8")).default), {
                    key: `${week.id}-${weekDay.id}`,
                    isDisabled: weekDay.isDisabled,
                    isFocused: weekDay.isFocused,
                    isToday: weekDay.isToday,
                    dayLong: weekDay.weekDayName,
                    month: weekDay.month,
                    monthLong: monthsLong[weekDay.month - 1],
                    onClick: handleClickDay,
                    isPreviouslySelected: weekDay.isPreviouslySelected,
                    isSelected: weekDay.isSelected,
                    isSibling: weekDay.isSiblingMonth,
                    year: weekDay.year,
                    shouldSetFocus: shouldSetFocus,
                    tabIndex: tabIndex,
                    testId: testId
                }, weekDay.day)))));
    });
    $43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
    var $43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;
});
parcelRegister("1q4y8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d70b02566a310b79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eGmKJ;
    var $bgrar;
    var $h0WbJ;
    const $d70b02566a310b79$var$Date = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, (0, parcelRequire("eGmKJ")).default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
        const dateRef = (0, $5uXOq.useRef)({
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: day,
                month: month,
                year: year,
                isDisabled: isDisabled
            };
        }, [
            day,
            month,
            year,
            isDisabled
        ]);
        const focusRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
        }, [
            isFocused,
            shouldSetFocus
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
            if (!isDisabledValue) onClick({
                day: dayValue,
                month: monthValue,
                year: yearValue
            });
        }, [
            onClick
        ]);
        const dateCellStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("h0WbJ")).dateCellStyles)());
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bgrar")).default), {
            role: "gridcell",
            alignItems: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: dateCellStyles,
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
        }, day));
    }));
    $d70b02566a310b79$var$Date.displayName = 'Date';
    var $d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;
});
parcelRegister("h0WbJ", function(module, exports) {
    $parcel$export(module.exports, "dateCellStyles", ()=>$a52fc59169f9ec00$export$f62807af68630d86);
    const $a52fc59169f9ec00$export$f62807af68630d86 = ()=>({
            all: 'unset',
            display: 'block',
            padding: `${"var(--ds-space-050, 4px)"} 9px`,
            position: 'relative',
            backgroundColor: 'transparent',
            border: '2px solid transparent',
            borderRadius: 3,
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'pointer',
            flexGrow: 1,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            textAlign: 'center',
            '&[data-sibling]': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            },
            '&[data-today]': {
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`,
                fontWeight: "var(--ds-font-weight-bold, bold)",
                '&::after': {
                    display: 'block',
                    height: 2,
                    position: 'absolute',
                    right: "var(--ds-space-025, 2px)",
                    bottom: "var(--ds-space-025, 2px)",
                    left: "var(--ds-space-025, 2px)",
                    backgroundColor: 'currentColor',
                    content: '""'
                }
            },
            '&[data-prev-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`,
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$29a4f05edc054374})`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`,
                cursor: 'not-allowed'
            },
            '&:focus-visible': {
                border: `2px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`,
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&:active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&[data-selected]:hover': {
                backgroundColor: `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-prev-selected]:hover': {
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-sibling]:hover': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            },
            '&[data-disabled]:hover': {
                backgroundColor: 'transparent',
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`
            }
        });
});
parcelRegister("h581D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c8aba25f4ae00ff$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $bgrar;
    const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
        const row = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bgrar")).default), {
            testId: testId,
            templateColumns: "repeat(7, minmax(max-content, 1fr))",
            role: "row"
        }, children);
        return isHidden ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-hidden": "true"
        }, row) : row;
    };
    var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;
});
parcelRegister("avO9B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f29b1b1295ce3a84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $h581D;
    const $f29b1b1295ce3a84$var$columnHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: 'size.400',
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'center'
    });
    const $f29b1b1295ce3a84$var$WeekHeader = (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("h581D")).default), {
            isHidden: true,
            testId: testId && `${testId}--column-headers`
        }, daysShort.map((shortDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$columnHeaderStyles,
                key: shortDay,
                role: "columnheader",
                testId: testId && `${testId}--column-header`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                weight: "bold",
                size: "UNSAFE_small",
                align: "center",
                color: "color.text.subtle"
            }, shortDay))));
    });
    $f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
    var $f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;
});
parcelRegister("iioJV", function(module, exports) {
    $parcel$export(module.exports, "arrowKeys", ()=>$85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
    $parcel$export(module.exports, "daysPerWeek", ()=>$85c2ac8e9452c4bf$export$3ae905d9742bef55);
    $parcel$export(module.exports, "monthsPerYear", ()=>$85c2ac8e9452c4bf$export$c9b7c010035d60c6);
    $parcel$export(module.exports, "blankStringArray", ()=>$85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
    const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
        ArrowDown: 'down',
        ArrowLeft: 'left',
        ArrowRight: 'right',
        ArrowUp: 'up'
    };
    const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
    const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
    const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];
});
parcelRegister("jihAA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$654a69afe715a212$export$2e2bcd8739ae039);
    var $33etG;
    var $f8qry;
    var $3EtUb;
    function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
        const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, (0, parcelRequire("f8qry")).default)(()=>{
            const now = new Date();
            const thisDay = now.getDate();
            const thisMonth = now.getMonth() + 1;
            const thisYear = now.getFullYear();
            return {
                thisDay: thisDay,
                thisMonth: thisMonth,
                thisYear: thisYear
            };
        });
        const [dayValue, setDayValue] = (0, (0, parcelRequire("33etG")).default)(day, ()=>defaultDay || thisDay);
        const [monthValue, setMonthValue] = (0, (0, parcelRequire("33etG")).default)(month, ()=>defaultMonth || thisMonth);
        const [yearValue, setYearValue] = (0, (0, parcelRequire("33etG")).default)(year, ()=>defaultYear || thisYear);
        const [todayValue] = (0, (0, parcelRequire("33etG")).default)(today, ()=>today || `${thisYear}-${(0, (0, parcelRequire("3EtUb")).default)(thisMonth)}-${(0, (0, parcelRequire("3EtUb")).default)(thisDay)}`);
        const [selectedValue, setSelectedValue] = (0, (0, parcelRequire("33etG")).default)(selected, ()=>defaultSelected);
        const [previouslySelectedValue, setPreviouslySelectedValue] = (0, (0, parcelRequire("33etG")).default)(previouslySelected, ()=>defaultPreviouslySelected);
        return {
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            today: [
                todayValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                previouslySelectedValue,
                setPreviouslySelectedValue
            ]
        };
    }
});
parcelRegister("3EtUb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd804e1790f6d755$export$2e2bcd8739ae039);
    function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
        return num < 10 ? `0${num}` : `${num}`;
    }
});
parcelRegister("bbnGB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ccb38b64bb63461$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
        const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur(event);
        }, [
            onBlur
        ]);
        const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
            onFocus(event);
        }, [
            onFocus
        ]);
        return {
            handleContainerBlur: handleContainerBlur,
            handleContainerFocus: handleContainerFocus
        };
    }
});
parcelRegister("hbcve", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fe53b5f3382c02e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZDAP;
    var $iioJV;
    var $6ASl9;
    var $5wbTt;
    function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
        const shouldDisplaySixthWeek = calendar.length % 6;
        const calendarLastValue = calendar[calendar.length - 1];
        return (0, $5uXOq.useMemo)(()=>{
            if (shouldDisplaySixthWeek) {
                const lastDayIsSibling = calendarLastValue.siblingMonth;
                const sliceStart = lastDayIsSibling ? (0, (0, parcelRequire("iioJV")).daysPerWeek) : 0;
                return (0, (0, parcelRequire("5wbTt")).default)(year, month, {
                    weekStartDay: weekStartDay
                }).slice(sliceStart, sliceStart + (0, (0, parcelRequire("iioJV")).daysPerWeek)).map((date)=>({
                        ...date,
                        siblingMonth: true
                    }));
            }
        }, [
            calendarLastValue,
            month,
            shouldDisplaySixthWeek,
            weekStartDay,
            year
        ]);
    }
    function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
        const calendar = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("5wbTt")).default)(year, month - 1, {
                weekStartDay: weekStartDay
            }), [
            month,
            weekStartDay,
            year
        ]);
        const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
            month: month,
            year: year,
            weekStartDay: weekStartDay
        });
        if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
        const minDate = minDateString ? (0, (0, parcelRequire("eZDAP")).default)(minDateString) : undefined;
        const maxDate = maxDateString ? (0, (0, parcelRequire("eZDAP")).default)(maxDateString) : undefined;
        const needJsDate = minDateString || maxDateString;
        return (0, $5uXOq.useMemo)(()=>{
            const weeks = [];
            calendar.forEach((date)=>{
                const dateAsString = (0, (0, parcelRequire("6ASl9")).default)(date, {
                    fixMonth: true
                });
                const JSDate = needJsDate ? (0, (0, parcelRequire("eZDAP")).default)(dateAsString) : undefined;
                let week;
                if (date.weekDay === weekStartDay) {
                    week = {
                        id: dateAsString,
                        values: []
                    };
                    weeks.push(week);
                } else week = weeks[weeks.length - 1];
                const weekDayOffset = (date.weekDay - weekStartDay) % 7;
                const weekDayName = daysLong[weekDayOffset];
                const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
                const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
                const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
                const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
                const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
                const isFocused = day === date.day && !date.siblingMonth;
                const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
                const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
                const isSiblingMonth = !!date.siblingMonth;
                const isToday = today === dateAsString;
                week.values.push({
                    id: dateAsString,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isToday: isToday,
                    month: date.month + 1,
                    isPreviouslySelected: isPreviouslySelected,
                    isSelected: isSelected,
                    isSiblingMonth: isSiblingMonth,
                    year: date.year,
                    day: date.day,
                    weekDayName: weekDayName
                });
            });
            return weeks;
        }, [
            calendar,
            day,
            disabled,
            disabledDateFilter,
            minDate,
            maxDate,
            needJsDate,
            previouslySelected,
            selected,
            today,
            weekStartDay,
            daysLong
        ]);
    }
});
parcelRegister("6ASl9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6ae62fd51c4538f$export$2e2bcd8739ae039);
    var $3EtUb;
    function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
        return `${date.year}-${(0, (0, parcelRequire("3EtUb")).default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, (0, parcelRequire("3EtUb")).default)(date.day)}`;
    }
});
parcelRegister("5wbTt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3dff1ed1384abe91$export$2e2bcd8739ae039);
    var $iioJV;
    var $9Zmg7;
    function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
        weekStartDay: 0
    }) {
        const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        const utcYear = date.getUTCFullYear();
        const utcMonth = date.getUTCMonth();
        const calendar = [];
        const firstDay = date.getUTCDay();
        const firstDate = -(((0, (0, parcelRequire("iioJV")).daysPerWeek) - weekStartDay + firstDay) % (0, (0, parcelRequire("iioJV")).daysPerWeek));
        const lastDate = (0, (0, parcelRequire("9Zmg7")).default)(utcYear, utcMonth);
        const lastDay = (lastDate - firstDate) % (0, (0, parcelRequire("iioJV")).daysPerWeek);
        const lastDateOfPreviousMonth = (0, (0, parcelRequire("9Zmg7")).default)(utcYear, utcMonth - 1);
        let dateCounter = firstDate;
        let currentDay;
        let currentDate;
        let currentDateObject = null;
        let calculatedMonth;
        let calculatedYear;
        const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, (0, parcelRequire("iioJV")).daysPerWeek) - lastDay : 0) + firstDate;
        while(dateCounter < maxDateCount){
            currentDate = dateCounter + 1;
            currentDay = ((dateCounter < 1 ? (0, (0, parcelRequire("iioJV")).daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, (0, parcelRequire("iioJV")).daysPerWeek);
            if (currentDate < 1 || currentDate > lastDate) {
                if (currentDate < 1) {
                    calculatedMonth = utcMonth - 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth < 0) {
                        calculatedMonth = (0, (0, parcelRequire("iioJV")).monthsPerYear) - 1;
                        calculatedYear--;
                    }
                    currentDate = lastDateOfPreviousMonth + currentDate;
                } else if (currentDate > lastDate) {
                    calculatedMonth = utcMonth + 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth > (0, (0, parcelRequire("iioJV")).monthsPerYear) - 1) {
                        calculatedMonth = 0;
                        calculatedYear++;
                    }
                    currentDate = dateCounter - lastDate + 1;
                }
                if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                    day: currentDate,
                    weekDay: currentDay,
                    month: calculatedMonth,
                    year: calculatedYear,
                    siblingMonth: true
                };
            } else currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: utcMonth,
                year: utcYear
            };
            calendar.push(currentDateObject);
            dateCounter++;
        }
        return calendar;
    }
});
parcelRegister("9Zmg7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$878800070b837d93$export$2e2bcd8739ae039);
    function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
        return new Date(year, month + 1, 0).getDate();
    }
});
parcelRegister("2TGJ3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$caae4eff24f6e8d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iioJV;
    var $6ASl9;
    var $9Zmg7;
    const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === (0, (0, parcelRequire("iioJV")).monthsPerYear)) {
            month = 1;
            year += 1;
        } else month += 1;
        return {
            month: month,
            year: year
        };
    };
    const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === 1) {
            month = (0, (0, parcelRequire("iioJV")).monthsPerYear);
            year -= 1;
        } else month -= 1;
        return {
            month: month,
            year: year
        };
    };
    function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
            const iso = (0, (0, parcelRequire("6ASl9")).default)({
                year: year,
                month: month,
                day: day
            });
            const isFocusableType = [
                'up',
                'down',
                'left',
                'right'
            ].includes(type);
            onChange({
                day: day,
                month: month,
                year: year,
                iso: iso,
                type: type
            });
            setDayValue(day);
            setMonthValue(month);
            setYearValue(year);
            setShouldSetFocus(isFocusableType);
        }, [
            onChange,
            setDayValue,
            setMonthValue,
            setYearValue,
            setShouldSetFocus
        ]);
        const navigate = (0, $5uXOq.useCallback)((type)=>{
            const { day: day, month: month, year: year } = dateRef.current;
            if (type === 'down') {
                const next = day + (0, (0, parcelRequire("iioJV")).daysPerWeek);
                const daysInMonth = (0, (0, parcelRequire("9Zmg7")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: next - daysInMonth,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'left') {
                const prev = day - 1;
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("9Zmg7")).default)(prevYear, prevMonth - 1);
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            } else if (type === 'right') {
                const next = day + 1;
                const daysInMonth = (0, (0, parcelRequire("9Zmg7")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: 1,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'up') {
                const prev = day - (0, (0, parcelRequire("iioJV")).daysPerWeek);
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("9Zmg7")).default)(prevYear, prevMonth - 1) + prev;
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            }
        }, [
            triggerOnChange
        ]);
        const handleClickNext = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'next'
            });
        }, [
            triggerOnChange
        ]);
        const handleClickPrev = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'prev'
            });
        }, [
            triggerOnChange
        ]);
        return {
            navigate: navigate,
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev
        };
    }
});
parcelRegister("f9D1v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42ec54640e7b9de4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iioJV;
    var $6ASl9;
    function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            const iso = (0, (0, parcelRequire("6ASl9")).default)({
                year: year,
                month: month,
                day: day
            });
            onSelect({
                day: day,
                month: month,
                year: year,
                iso: iso
            });
            setPreviouslySelectedValue(selectedValue);
            setSelectedValue([
                iso
            ]);
        }, [
            onSelect,
            selectedValue,
            setPreviouslySelectedValue,
            setSelectedValue
        ]);
        const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            triggerOnSelect({
                year: year,
                month: month,
                day: day
            });
        }, [
            triggerOnSelect
        ]);
        const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
            const { key: key } = e;
            const arrowKey = (0, (0, parcelRequire("iioJV")).arrowKeys)[key];
            if (key === 'Enter' || key === ' ') {
                e.preventDefault();
                triggerOnSelect(dateRef.current);
            } else if (arrowKey) {
                e.preventDefault();
                navigate(arrowKey);
            }
        }, [
            triggerOnSelect,
            navigate
        ]);
        return {
            handleClickDay: handleClickDay,
            handleContainerKeyDown: handleContainerKeyDown
        };
    }
});
parcelRegister("9efze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbd6f430b06675a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7qZ1x;
    function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
        const l10n = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(locale), [
            locale
        ]);
        const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
            l10n
        ]);
        const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        return {
            monthsLong: monthsLong,
            daysShort: daysShort,
            daysLong: daysLong
        };
    }
});
parcelRegister("avHVh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac07968b7cb494a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $5owSH;
    var $gkD4s;
    var $4oNEb;
    var $1V7PR;
    var $k5uoT;
    class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            if (prevProps.inputValue !== this.props.inputValue) this.update();
        }
        render() {
            const { containerRef: containerRef, content: content, testId: testId } = this.props;
            if (!containerRef) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null);
            const divStyles = {
                background: 'transparent',
                position: 'absolute',
                top: 0,
                height: containerRef.getBoundingClientRect().height,
                width: containerRef.getBoundingClientRect().width - parseInt((0, (0, parcelRequire("5owSH")).sizes).small.slice(0, -2)) - (0, (0, parcelRequire("k5uoT")).gridSize)()
            };
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gkD4s")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1V7PR")).Reference), null, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    "data-layer-child": true,
                    style: divStyles
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), null, ({ ref: ref, style: style, update: update })=>{
                this.update = update;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    style: {
                        ...style,
                        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog()
                    },
                    "data-testid": testId && `${testId}--popper--container`
                }, content);
            })));
        }
        constructor(...args){
            super(...args), this.update = (0, (0, parcelRequire("eGmKJ")).default);
        }
    }
});
parcelRegister("6AqCE", function(module, exports) {
    $parcel$export(module.exports, "getShortISOString", ()=>$caee16c105163c22$export$77d5bc49fed7ef14);
    $parcel$export(module.exports, "getSafeCalendarValue", ()=>$caee16c105163c22$export$ff525416014fb67d);
    var $k7m40;
    var $2ucUe;
    function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
        return (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)('YYYY-MM-DD'));
    }
    function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
        const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
        if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
        return calendarValue;
    }
});
parcelRegister("dBs4v", function(module, exports) {
    $parcel$export(module.exports, "makeSingleValue", ()=>$9661917c82165ad2$export$6e30bf8cb1347b56);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).SingleValue, {
                ...rest,
                className: className,
                clearValue: clearValue,
                cx: cx,
                data: data,
                getStyles: getStyles,
                getValue: getValue,
                hasValue: hasValue,
                innerProps: {
                    lang: lang
                },
                isDisabled: isDisabled,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: selectProps,
                setValue: setValue,
                theme: theme
            }, children);
        };
});
parcelRegister("jcbUF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48f5b21daaca02ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $6QvkM;
    var $9KnKW;
    var $acknU;
    var $cTemL;
    var $7qZ1x;
    var $VSDnB;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $7K5PP;
    var $7VXAu;
    var $jldZL;
    var $jHBnA;
    var $5RLF6;
    var $iaQLg;
    var $gtijU;
    var $6AqCE;
    var $dBs4v;
    function $48f5b21daaca02ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48f5b21daaca02ab$var$packageName = "platform-pkg";
    const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
    const $48f5b21daaca02ab$var$analyticsAttributes = {
        componentName: 'datePicker',
        packageName: $48f5b21daaca02ab$var$packageName,
        packageVersion: $48f5b21daaca02ab$var$packageVersion
    };
    const $48f5b21daaca02ab$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $48f5b21daaca02ab$var$dropdownIndicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $48f5b21daaca02ab$var$CalendarIcon = (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("acknU"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cTemL")))));
    const $48f5b21daaca02ab$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: 'color.text.subtlest',
        insetBlockStart: 'space.0',
        insetInlineEnd: 'space.0',
        transition: `color 150ms`,
        ':hover': {
            color: 'color.text.subtle'
        }
    });
    const $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.400'
    });
    const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.050'
    });
    const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.025'
    });
    const $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $48f5b21daaca02ab$var$calendarButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $48f5b21daaca02ab$var$DatePicker = (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const calendarRef = (0, $5uXOq.useRef)(null);
        const calendarButtonRef = (0, $5uXOq.useRef)(null);
        const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = $48f5b21daaca02ab$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const [_, setIsFocused] = (0, $5uXOq.useState)(false);
        const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
        const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
        const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
        const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()));
        const [l10n, setL10n] = (0, $5uXOq.useState)((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(propLocale));
        const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
        const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
        const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
        const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
        const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
        const onChangePropWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChangeProp,
            action: 'selectedDate',
            actionSubject: 'datePicker',
            ...$48f5b21daaca02ab$var$analyticsAttributes
        });
        if (propLocale !== locale) {
            setL10n((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(propLocale));
            setLocale(propLocale);
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!isKeyDown) return;
            if (isOpen && wasOpenedFromCalendarButton) {
                setIsKeyDown(false);
                calendarRef?.current?.querySelector('button')?.focus();
            }
        }, [
            isKeyDown,
            calendarRef,
            isOpen,
            wasOpenedFromCalendarButton
        ]);
        const getValue = ()=>propValue ?? value;
        const getIsOpen = ()=>isOpenProp ?? isOpen;
        const onCalendarChange = ({ iso: iso })=>{
            setCalendarValue((0, (0, parcelRequire("5RLF6")).getParsedISO)({
                iso: iso
            }));
        };
        const onCalendarSelect = ({ iso: iso })=>{
            setSelectInputValue('');
            setIsOpen(false);
            setCalendarValue(iso);
            setValue(iso);
            setWasOpenedFromCalendarButton(false);
            onChangePropWithAnalytics(iso);
            if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
            else {
                const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            setIsOpen(false);
        };
        const onInputClick = ()=>{
            if (!isDisabled && !getIsOpen()) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                onBlur(event);
            }
        };
        const onContainerFocus = ()=>{
            setShouldSetFocusOnCurrentDay(false);
        };
        const onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (clearingFromIcon) setClearingFromIcon(false);
            else if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setIsFocused(false);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onSelectFocus = (event)=>{
            const value = getValue();
            if (clearingFromIcon) setClearingFromIcon(false);
            else {
                setIsOpen(!shouldShowCalendarButton);
                setCalendarValue(value);
                setIsFocused(true);
                setWasOpenedFromCalendarButton(false);
            }
            onFocus(event);
        };
        const onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, (0, parcelRequire("5RLF6")).parseDate)(inputValue, {
                    parseInputValue: rest?.parseInputValue,
                    dateFormat: rest?.dateFormat,
                    l10n: l10n
                });
                if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) setCalendarValue((0, (0, parcelRequire("6AqCE")).getShortISOString)(parsed));
            }
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        };
        const onInputKeyDown = (event)=>{
            const value = getValue();
            const keyPressed = event.key.toLowerCase();
            if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
            switch(keyPressed){
                case 'escape':
                    if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    setIsOpen(false);
                    setShouldSetFocusOnCurrentDay(false);
                    setWasOpenedFromCalendarButton(false);
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                            setClearingFromIcon(false);
                            setValue('');
                        }
                        break;
                    }
                case 'enter':
                    if (!isOpen) return;
                    event.preventDefault();
                    if (!(0, (0, parcelRequire("5RLF6")).isDateDisabled)(calendarValue, {
                        disabled: disabled
                    })) {
                        const safeCalendarValue = (0, (0, parcelRequire("6AqCE")).getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        setSelectInputValue('');
                        setIsOpen(false);
                        setValue(safeCalendarValue);
                        setCalendarValue(safeCalendarValue);
                        setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                        if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!shouldSetFocusOnCurrentDay) {
                        setIsOpen(true);
                        setShouldSetFocusOnCurrentDay(true);
                    }
                    break;
                default:
                    break;
            }
        };
        const onCalendarButtonKeyDown = (e)=>{
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                setIsKeyDown(true);
                setWasOpenedFromCalendarButton(true);
            }
        };
        const onCalendarButtonClick = (e)=>{
            setIsOpen(!isOpen);
            setWasOpenedFromCalendarButton(true);
            e.stopPropagation();
        };
        const onClear = ()=>{
            setValue('');
            setCalendarValue(defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()));
            if (!hideIcon) setClearingFromIcon(true);
            onChangePropWithAnalytics('');
        };
        const onSelectChange = (_value, action)=>{
            if (action.action === 'clear') onClear();
        };
        const handleSelectInputChange = (selectInputValue, actionMeta)=>{
            if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
            setSelectInputValue(selectInputValue);
        };
        const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
            const oldRef = containerRef.current;
            containerRef.current = ref;
            if (oldRef == null && ref != null) forceUpdate();
        }, [
            containerRef
        ]);
        const getterValue = getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $48f5b21daaca02ab$var$dropdownIndicatorStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
            lang: propLocale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("jHBnA")).EmptyComponent) : dropDownIcon,
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iaQLg")).IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: (0, parcelRequire("gtijU")).Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: containerRef.current,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: calendarRef,
            calendarValue: getterValue && (0, (0, parcelRequire("6AqCE")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(getterValue)),
            calendarView: calendarValue,
            onCalendarChange: onCalendarChange,
            onCalendarSelect: onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-075, 6px)"
                })
        });
        const initialValue = getterValue ? {
            label: (0, (0, parcelRequire("5RLF6")).formatDate)(getterValue, {
                formatDisplayLabel: formatDisplayLabel,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }),
            value: getterValue
        } : null;
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
        const openCalendarLabelId = `open-calendar-label--${(0, (0, parcelRequire("9KnKW")).useId)()}`;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...innerProps,
            css: $48f5b21daaca02ab$var$pickerContainerStyles,
            "data-testid": testId && `${testId}--container`,
            onBlur: onContainerBlur,
            onFocus: onContainerFocus,
            onClick: onInputClick,
            onInput: onTextInput,
            onKeyDown: onInputKeyDown,
            ref: getContainerRef,
            role: "presentation"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            name: name,
            type: "hidden",
            value: getterValue,
            "data-testid": testId && `${testId}--input`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7K5PP")).default), {
            appearance: appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: onSelectBlur,
            onChange: onSelectChange,
            onFocus: onSelectFocus,
            onInputChange: handleSelectInputChange,
            placeholder: (0, (0, parcelRequire("5RLF6")).getPlaceholder)({
                placeholder: placeholder,
                l10n: l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $48f5b21daaca02ab$var$iconContainerStyles,
                value && !hideIcon ? $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew : $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles
            ]
        }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            id: openCalendarLabelId
        }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            ...inputLabelId ? {
                'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
            } : {
                'aria-label': fullopenCalendarLabel
            },
            onClick: onCalendarButtonClick,
            onKeyDown: onCalendarButtonKeyDown,
            ref: calendarButtonRef,
            testId: testId && `${testId}--open-calendar-button`,
            type: "button",
            backgroundColor: "color.background.neutral.subtle",
            padding: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
            xcss: [
                $48f5b21daaca02ab$var$calendarButtonStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') && $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($48f5b21daaca02ab$var$CalendarIcon, {
            label: "",
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                color: "var(--ds-icon, #44546F)"
            } : {
                primaryColor: "var(--ds-icon, #44546F)"
            }
        }))) : null));
    });
    var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;
});
parcelRegister("8tAHc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ceca1d2f82d990c4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ceca1d2f82d990c4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholderDate: {
            "id": "common-date.utils.date-messages.placeholder-date",
            "defaultMessage": "e.g. 2018/12/31"
        }
    });
});
parcelRegister("3LzsZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2176f4fa091e9ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $d2176f4fa091e9ab$var$SuppressEscKey extends (0, $5uXOq.Component) {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                role: "presentation",
                onKeyDown: this.onKeyEvent,
                onKeyUp: this.onKeyEvent
            }, this.props.children);
        }
        constructor(...args){
            super(...args), this.onKeyEvent = (e)=>{
                const { key: key } = e;
                if (key === 'Escape') {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                }
            };
        }
    }
    var $d2176f4fa091e9ab$export$2e2bcd8739ae039 = $d2176f4fa091e9ab$var$SuppressEscKey;
});
parcelRegister("lhpg4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42dd5dd53080d3ce$export$2e2bcd8739ae039);
    var $7VHMR;
    var $42dd5dd53080d3ce$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releaseDate: {
            "id": "project-directories.versions.release-version-modal.content.release-date.release-date",
            "defaultMessage": "Release date"
        }
    });
});
parcelRegister("3nRuh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c42196f8d6f40709$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $bC2fB;
    var $7ZIA5;
    var $3yLu1;
    var $ai3Yq;
    var $kqZtV;
    const $c42196f8d6f40709$var$mapStateToProps = ()=>{
        const renderVersionPickerFactory = (0, (0, parcelRequire("8QpSo")).default)((shouldSwapIssues, isSaving, baseUrl, projectKey, versionId)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ZIA5")).default), {
                    isDisabled: !shouldSwapIssues || isSaving,
                    baseUrl: baseUrl,
                    projectKey: projectKey,
                    ignore: [
                        versionId
                    ],
                    versionStatuses: [
                        'UNRELEASED'
                    ],
                    ...props
                }));
        return (state)=>{
            const { baseUrl: baseUrl, projectKey: projectKey, shouldSwapIssues: shouldSwapIssues, isSaving: isSaving, versionId: versionId } = (0, (0, parcelRequire("ai3Yq")).getPropsForVersionPicker)(state);
            return {
                toDoInProgressIssuesCount: (0, (0, parcelRequire("ai3Yq")).getTodoInProgressIssuesCount)(state),
                isSaving: (0, (0, parcelRequire("ai3Yq")).isSaving)(state),
                shouldSwapIssues: (0, (0, parcelRequire("ai3Yq")).isSwapSelected)(state),
                errors: (0, (0, parcelRequire("ai3Yq")).getErrors)(state),
                renderVersionPicker: renderVersionPickerFactory(shouldSwapIssues, isSaving, baseUrl, projectKey, versionId)
            };
        };
    };
    const $c42196f8d6f40709$var$dispatcher = (dispatch)=>({
            onInputChange: (version)=>dispatch((0, (0, parcelRequire("3yLu1")).releaseVersionUpdate)(version)),
            onSwapIssuesSelected: (swap)=>dispatch((0, (0, parcelRequire("3yLu1")).swapIssues)(swap))
        });
    const $c42196f8d6f40709$var$mapDispatchToProps = (dispatch)=>$c42196f8d6f40709$var$dispatcher(dispatch);
    var $c42196f8d6f40709$export$2e2bcd8739ae039 = (0, (0, parcelRequire("bC2fB")).connect)($c42196f8d6f40709$var$mapStateToProps, $c42196f8d6f40709$var$mapDispatchToProps)((0, (0, parcelRequire("kqZtV")).default));
});
parcelRegister("kqZtV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4dbde7804cdf94bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7O4UO;
    var $jouoW;
    var $az4zD;
    var $rnB41;
    class $4dbde7804cdf94bb$var$SwapIssues extends (0, $5uXOq.Component) {
        inputChange(update) {
            const { onInputChange: onInputChange } = this.props;
            onInputChange({
                moveUnfixedIssuesTo: update.moveUnfixedIssuesTo
            });
        }
        render() {
            const { intl: { formatMessage: formatMessage }, toDoInProgressIssuesCount: toDoInProgressIssuesCount, shouldSwapIssues: shouldSwapIssues, errors: errors, isSaving: isSaving, renderVersionPicker: renderVersionPicker } = this.props;
            const { moveUnfixedIssuesTo: moveUnfixedIssuesToError } = errors;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                name: "UnresolvedIssue",
                isRequired: true,
                label: formatMessage((0, (0, parcelRequire("rnB41")).default).unresolvedIssuesHeader, {
                    issues: toDoInProgressIssuesCount
                })
            }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                    isDisabled: isSaving,
                    isChecked: shouldSwapIssues,
                    onChange: this.onMoveIssuesSelected,
                    label: formatMessage((0, (0, parcelRequire("rnB41")).default).unresolvedIssuesMove, {
                        issues: toDoInProgressIssuesCount
                    }),
                    testId: "version-modals.release-version-modal.content.swap-issues.move-radio"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement($4dbde7804cdf94bb$var$VersionPickerContainer, null, renderVersionPicker({
                    onSelected: this.onSwapIssues
                })), moveUnfixedIssuesToError && (0, ($parcel$interopDefault($5uXOq))).createElement($4dbde7804cdf94bb$var$ValidationError, null, formatMessage((0, (0, parcelRequire("rnB41")).default).invalidVersionChosen, {
                    issues: toDoInProgressIssuesCount
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                    isDisabled: isSaving,
                    isChecked: !shouldSwapIssues,
                    onChange: this.onRemoveVersionFromIssuesSelected,
                    label: formatMessage((0, (0, parcelRequire("rnB41")).default).unresolvedIssuesIgnore),
                    testId: "version-modals.release-version-modal.content.swap-issues.ignore-radio"
                })));
        }
        constructor(...args){
            super(...args), this.onSwapIssues = (version)=>{
                if (version) this.inputChange({
                    moveUnfixedIssuesTo: version.id
                });
                else this.inputChange({
                    moveUnfixedIssuesTo: ''
                });
            }, this.onMoveIssuesSelected = ()=>{
                const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
                onSwapIssuesSelected(true);
            }, this.onRemoveVersionFromIssuesSelected = ()=>{
                const { onSwapIssuesSelected: onSwapIssuesSelected } = this.props;
                onSwapIssuesSelected(false);
            };
        }
    }
    var $4dbde7804cdf94bb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($4dbde7804cdf94bb$var$SwapIssues);
    const $4dbde7804cdf94bb$var$VersionPickerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s88z4d",
                __cmplp.className
            ])
        });
    });
    const $4dbde7804cdf94bb$var$ValidationError = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pku2gc _syaz17af",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("rnB41", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a40bbc0e4b3cafaf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a40bbc0e4b3cafaf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unresolvedIssuesHeader: {
            "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-header",
            "defaultMessage": "Unresolved {issues, plural, one {issue} other {issues}}"
        },
        unresolvedIssuesMove: {
            "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-move",
            "defaultMessage": "Move unresolved {issues, plural, one {issue} other {issues}} to"
        },
        unresolvedIssuesIgnore: {
            "id": "project-directories.versions.release-version-modal.content.swap-issues.unresolved-issues-ignore",
            "defaultMessage": "Ignore unresolved issues"
        },
        invalidVersionChosen: {
            "id": "project-directories.versions.release-version-modal.content.swap-issues.invalid-version-chosen",
            "defaultMessage": "Can't use this version. Change this version to another in your project or remove it from {issues, plural, one {this issue} other {these issues}}."
        }
    });
});
parcelRegister("uKe1m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a77752f277ff7388$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $ousew;
    var $az4zD;
    var $gED7w;
    class $a77752f277ff7388$export$7c6e2c02157bb7d2 extends (0, $5uXOq.Component) {
        renderDescriptionWithIssues() {
            const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, unresolvedIssuesUrl: unresolvedIssuesUrl } = this.props;
            const unresolvedIssueJqlViewLink = (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: unresolvedIssuesUrl
            }, formatMessage((0, (0, parcelRequire("gED7w")).default).descriptionWithIssuesCount, {
                issues: unresolvedIssuesCount
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("gED7w")).default).descriptionWithIssues,
                values: {
                    issueCountLink: unresolvedIssueJqlViewLink
                }
            }));
        }
        renderDescriptionWithoutIssues() {
            const { intl: { formatMessage: formatMessage }, resolvedIssueUrl: resolvedIssueUrl, resolvedIssuesCount: resolvedIssuesCount } = this.props;
            const resolvedIssueJqlViewLink = (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: resolvedIssueUrl
            }, formatMessage((0, (0, parcelRequire("gED7w")).default).descriptionWithoutIssues, {
                doneIssues: resolvedIssuesCount
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("gED7w")).default).descriptionWithoutIssuesRestMessage,
                values: {
                    issueCountLink: resolvedIssueJqlViewLink
                }
            }));
        }
        render() {
            const { unresolvedIssuesCount: unresolvedIssuesCount, SwapIssues: SwapIssues, ReleaseDate: ReleaseDate, ReleaseAutomationBanner: ReleaseAutomationBanner } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, unresolvedIssuesCount > 0 ? this.renderDescriptionWithIssues() : this.renderDescriptionWithoutIssues(), unresolvedIssuesCount > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement(SwapIssues, null) : null, (0, ($parcel$interopDefault($5uXOq))).createElement(ReleaseDate, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                fallback: "unmount",
                packageName: "jiraSoftwareReleasesVersionDetail",
                teamName: "fusion-solaris",
                id: "releaseAutomationBanner"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ReleaseAutomationBanner, null)));
        }
    }
    var $a77752f277ff7388$export$2e2bcd8739ae039 = (0, (0, parcelRequire("az4zD")).injectIntlV2)($a77752f277ff7388$export$7c6e2c02157bb7d2);
});
parcelRegister("gED7w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e5a4514f0f67d4d6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e5a4514f0f67d4d6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        descriptionWithIssues: {
            "id": "project-directories.versions.release-version-modal.content.description-with-issues",
            "defaultMessage": "This release contains {issueCountLink}."
        },
        descriptionWithIssuesCount: {
            "id": "project-directories.versions.release-version-modal.content.description-with-issues-count",
            "defaultMessage": "{issues, plural, one {{issues} unresolved issue} other {{issues} unresolved issues}}"
        },
        descriptionWithoutIssues: {
            "id": "project-directories.versions.release-version-modal.content.description-without-issues",
            "defaultMessage": "{doneIssues} {doneIssues, plural, one {issue} other {issues}}"
        },
        descriptionWithoutIssuesRestMessage: {
            "id": "project-directories.versions.release-version-modal.content.description-without-issues-rest-message",
            "defaultMessage": "{issueCountLink} will be released."
        }
    });
});
parcelRegister("61jfR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91e0f4109e87b34b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    var $jzjy1;
    var $iQv12;
    var $9fuVs;
    var $az4zD;
    var $8xH1O;
    var $dq84i;
    class $91e0f4109e87b34b$export$b77f092f9cf63f1e extends (0, $5uXOq.Component) {
        render() {
            const { Content: Content, unresolvedIssuesCount: unresolvedIssuesCount, isInitiating: isInitiating, onCancel: onCancel, intl: { formatMessage: formatMessage }, name: name } = this.props;
            if (isInitiating) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                isOpen: true,
                width: "small",
                onClose: onCancel,
                testId: "version-modals.release-version-modal.release-version-modal"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, unresolvedIssuesCount ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
                appearance: "warning"
            }, formatMessage((0, (0, parcelRequire("dq84i")).default).header, {
                name: name
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, (0, parcelRequire("dq84i")).default).header, {
                name: name
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(Content, null)), this.renderFooter(this.props)));
        }
        constructor(...args){
            super(...args), this.onButtonMounted = (node)=>{
                this.button = node;
            }, this.onRelease = (...args)=>{
                if (this.button) this.button.focus();
                this.props.onRelease(this.props.shouldRedirectToCreateReleaseNotes, args[args.length - 1]);
            }, this.renderFooter = (props)=>{
                const { intl: { formatMessage: formatMessage }, unresolvedIssuesCount: unresolvedIssuesCount, isSaving: isSaving, onCancel: onCancel, isReleaseDisabled: isReleaseDisabled, shouldRedirectToCreateReleaseNotes: shouldRedirectToCreateReleaseNotes, setRedirectToCreateReleaseNotesStatus: setRedirectToCreateReleaseNotesStatus, shouldShowCreateReleaseNotesOption: shouldShowCreateReleaseNotesOption } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), props, (0, ($parcel$interopDefault($5uXOq))).createElement($91e0f4109e87b34b$var$FooterContainer, {
                    showReleaseNotesPrompt: shouldShowCreateReleaseNotesOption
                }, shouldShowCreateReleaseNotesOption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8xH1O")).CreateReleaseNotesPrompt), {
                    onChange: setRedirectToCreateReleaseNotesStatus,
                    value: shouldRedirectToCreateReleaseNotes
                }), (0, ($parcel$interopDefault($5uXOq))).createElement($91e0f4109e87b34b$var$ButtonsContainer, null, isSaving && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $91e0f4109e87b34b$var$spinnerContainerStyles
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                    size: "small"
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    onClick: this.onRelease,
                    appearance: unresolvedIssuesCount ? 'warning' : 'primary',
                    type: "submit",
                    isDisabled: isReleaseDisabled,
                    ref: this.onButtonMounted
                }, formatMessage((0, (0, parcelRequire("dq84i")).default).release)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "subtle-link",
                    isDisabled: false,
                    onClick: onCancel
                }, formatMessage((0, (0, parcelRequire("dq84i")).default).cancel)))));
            };
        }
    }
    var $91e0f4109e87b34b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jzjy1")).AnalyticsSource)('releaseVersions', (0, $4d5e0871c06cee03$export$1171103ea9083ffa))((0, (0, parcelRequire("iQv12")).default)({
        onRelease: (isCreateReleaseNotesOptedIn)=>({
                name: 'release',
                isCreateReleaseNotesOptedIn: isCreateReleaseNotesOptedIn
            }),
        onCancel: 'cancel'
    })((0, (0, parcelRequire("az4zD")).injectIntlV2)($91e0f4109e87b34b$export$b77f092f9cf63f1e)));
    const $91e0f4109e87b34b$var$spinnerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginRight: 'space.200'
    });
    const $91e0f4109e87b34b$var$ButtonsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $91e0f4109e87b34b$var$FooterContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { showReleaseNotesPrompt: showReleaseNotesPrompt, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq",
                __cmplp.showReleaseNotesPrompt ? "_1bah1yb4" : "_1bahesu3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8xH1O", function(module, exports) {
    $parcel$export(module.exports, "CreateReleaseNotesPrompt", ()=>$cfcc6773eafb9afa$export$d8a8f048cf64e9ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kkJfY;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $gjQ4F;
    const $cfcc6773eafb9afa$export$d8a8f048cf64e9ff = ({ onChange: onChange, value: value })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onValueChange = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'toggled',
                actionSubject: 'checkbox'
            }), 'releaseModalCreateReleaseNotesCheckbox');
            onChange(event.target.checked);
        }, [
            createAnalyticsEvent,
            onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($cfcc6773eafb9afa$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            name: "createReleaseNotes",
            label: formatMessage((0, (0, parcelRequire("gjQ4F")).default).createReleaseNotesTitle),
            isChecked: value,
            onChange: onValueChange
        }));
    };
    const $cfcc6773eafb9afa$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kkJfY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3106eb14f9b0a593$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $5JjdN;
    var $kag1C;
    var $7xteU;
    var $hsLv2;
    var $e62YQ;
    const $3106eb14f9b0a593$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $3106eb14f9b0a593$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("5JjdN")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7xteU")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $3106eb14f9b0a593$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kag1C")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hsLv2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e62YQ")).default), null)));
    }));
    $3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
    var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;
});
parcelRegister("kag1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0746a27410bc168$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dV6Te;
    var $VSDnB;
    function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration')) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
                fill: "inherit"
            });
            else return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
                fill: "inherit",
                x: "8",
                y: "11",
                width: "8",
                height: "2",
                rx: "1"
            });
        }
        if (isChecked) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration')) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                fill: "inherit"
            });
            else return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
                fill: "inherit"
            });
        }
        return null;
    }
    const $a0746a27410bc168$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5"
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;
});
parcelRegister("7xteU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b368d644c230660$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $7b368d644c230660$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $7b368d644c230660$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $7b368d644c230660$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $7b368d644c230660$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $7b368d644c230660$var$baseStyles,
                label && $7b368d644c230660$var$textLabelLayoutStyles,
                isDisabled && $7b368d644c230660$var$disabledStyles,
                $7b368d644c230660$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("hsLv2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce636d67b4ff1120$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ce636d67b4ff1120$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $ce636d67b4ff1120$var$labelTextStyles
        }, children);
    }
});
parcelRegister("e62YQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2156c28a3894cac$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d2156c28a3894cac$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d2156c28a3894cac$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d2156c28a3894cac$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("gjQ4F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82038eb6c516431a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $82038eb6c516431a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createReleaseNotesTitle: {
            "id": "project-directories.versions.release-version-modal.create-release-notes-prompt.create-release-notes-title",
            "defaultMessage": "Create release notes"
        }
    });
});
parcelRegister("dq84i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bbc5f7f1540b8320$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bbc5f7f1540b8320$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "project-directories.versions.release-version-modal.header",
            "defaultMessage": "Release {name}"
        },
        release: {
            "id": "project-directories.versions.release-version-modal.release",
            "defaultMessage": "Release"
        },
        cancel: {
            "id": "project-directories.versions.release-version-modal.cancel",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("camqO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1844322308ffacbc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1844322308ffacbc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        releaseAction: {
            "id": "project-versions.table.actions.release-action",
            "defaultMessage": "Release"
        },
        unreleaseAction: {
            "id": "project-versions.table.actions.unrelease-action",
            "defaultMessage": "Unrelease"
        },
        archiveAction: {
            "id": "project-versions.table.actions.archive-action",
            "defaultMessage": "Archive"
        },
        unarchiveAction: {
            "id": "project-versions.table.actions.unarchive-action",
            "defaultMessage": "Unarchive"
        },
        mergeAction: {
            "id": "project-versions.table.actions.merge-action",
            "defaultMessage": "Merge"
        },
        editAction: {
            "id": "project-versions.table.actions.edit-action",
            "defaultMessage": "Edit"
        },
        deleteAction: {
            "id": "project-versions.table.actions.delete-action",
            "defaultMessage": "Delete"
        },
        deleteActionDisabledTooltip: {
            "id": "project-versions.table.actions.delete-action-disabled-tooltip",
            "defaultMessage": "You don't have permission to delete a version."
        },
        genericUpdateFailedFlagTitle: {
            "id": "project-versions.table.actions.generic-update-failed-flag-title",
            "defaultMessage": "Something went wrong"
        },
        releaseFailedFlagDescription: {
            "id": "project-versions.table.actions.release-failed-flag-description",
            "defaultMessage": "We were not able to update the version released status. Please refresh the page and try again."
        },
        archiveFailedFlagDescription: {
            "id": "project-versions.table.actions.archive-failed-flag-description",
            "defaultMessage": "We were not able to update the version archived status. Please refresh the page and try again."
        },
        archiveTitle: {
            "id": "project-versions.table.actions.archive-title",
            "defaultMessage": "{name} archived"
        },
        unarchiveTitle: {
            "id": "project-versions.table.actions.unarchive-title",
            "defaultMessage": "{name} unarchived"
        },
        releaseTitle: {
            "id": "project-versions.table.actions.release-title",
            "defaultMessage": "{name} released"
        },
        unReleaseTitle: {
            "id": "project-versions.table.actions.un-release-title",
            "defaultMessage": "{name} unreleased"
        },
        deleteTitle: {
            "id": "project-versions.table.actions.delete-title",
            "defaultMessage": "{name} deleted"
        },
        deleteFailedTitle: {
            "id": "project-versions.table.actions.delete-failed-title",
            "defaultMessage": "We couldn't delete that version"
        },
        deleteFailedDescription: {
            "id": "project-versions.table.actions.delete-failed-description",
            "defaultMessage": "Something went wrong. Try again."
        }
    });
});
parcelRegister("ht8dz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97ac3ef4ec7703e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hTEpF;
    var $koVbs;
    var $kMc1l = parcelRequire("kMc1l");
    var $1lqbR;
    function $97ac3ef4ec7703e7$export$1f74963c34e8bfec(props) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { statusFilter: statusFilter, searchFilter: searchFilter } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            imageUrl: (0, ($parcel$interopDefault($kMc1l))),
            header: formatMessage((0, (0, parcelRequire("1lqbR")).default).header),
            description: formatMessage(!searchFilter && statusFilter.length > 0 ? (0, (0, parcelRequire("1lqbR")).default).noMatchingStatusDescription : (0, (0, parcelRequire("1lqbR")).default).defaultDescription)
        });
    }
    var $97ac3ef4ec7703e7$export$2e2bcd8739ae039 = $97ac3ef4ec7703e7$export$1f74963c34e8bfec;
});
parcelRegister("kMc1l", function(module, exports) {
    module.exports = new URL("release.e083327a.svg", import.meta.url).toString();
});
parcelRegister("1lqbR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f79d42a61b588b63$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f79d42a61b588b63$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "project-versions.table.empty.header",
            "defaultMessage": "No matching versions"
        },
        noMatchingStatusDescription: {
            "id": "project-versions.table.empty.no-matching-status-description",
            "defaultMessage": "There aren't any versions in this project with that status. Check your filters and try again."
        },
        defaultDescription: {
            "id": "project-versions.table.empty.default-description",
            "defaultMessage": "There aren't any versions in this project that match your search. Check your search terms and filters and try again."
        }
    });
});
parcelRegister("iJQI5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a353a3674f075d1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2a353a3674f075d1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        showMore: {
            "id": "project-versions.table.show-more",
            "defaultMessage": "Show {count} more"
        },
        done: {
            "id": "project-versions.table.done",
            "defaultMessage": "{done} done"
        },
        inProgress: {
            "id": "project-versions.table.in-progress",
            "defaultMessage": "{inProgress} in progress"
        },
        toDo: {
            "id": "project-versions.table.to-do",
            "defaultMessage": "{toDo} to do"
        },
        empty: {
            "id": "project-versions.table.empty",
            "defaultMessage": "No issues"
        }
    });
});
parcelRegister("4hdHc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f986fcb135747f06$export$2e2bcd8739ae039);
    var $l8S66;
    var $eyBPg;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $iQv12;
    var $8oe80;
    var $12flw;
    var $5KMRC;
    var $hDzhb;
    var $guJqH;
    const $f986fcb135747f06$var$NameCell = ({ jiraVersion: jiraVersion, jiraProject: jiraProject, onClick: onClick })=>{
        const version = (0, $8Uumt.useFragment)((0, (0, parcelRequire("eyBPg")).default), jiraVersion);
        const project = (0, $8Uumt.useFragment)((0, (0, parcelRequire("l8S66")).default), jiraProject);
        const href = (0, (0, parcelRequire("guJqH")).getVersionIssuesUrl)(project.key, project.projectType === 'SOFTWARE', version.versionId, version.name);
        const onLinkClick = (...args)=>{
            onClick(args[args.length - 1]);
        };
        return project.projectType === 'SOFTWARE' ? (0, ($parcel$interopDefault($5uXOq))).createElement($f986fcb135747f06$var$LinkWithAnalytics, {
            to: (0, (0, parcelRequire("12flw")).softwareVersionDetailRoute),
            params: {
                projectKey: project.key,
                versionId: version.versionId,
                tab: 'release-report-all-issues'
            },
            prefetch: "hover",
            "data-testid": "project-versions.ui.table.name.name",
            onClick: onLinkClick
        }, version.name) : (0, ($parcel$interopDefault($5uXOq))).createElement($f986fcb135747f06$var$LinkWithAnalytics, {
            href: href,
            "data-testid": "project-versions.ui.table.name.name",
            onClick: onClick
        }, version.name);
    };
    var $f986fcb135747f06$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iQv12")).default)({
        onClick: 'version'
    })($f986fcb135747f06$var$NameCell);
    const $f986fcb135747f06$var$StyledLink = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5KMRC")).Container), null, (0, ($parcel$interopDefault($5uXOq))).createElement($f986fcb135747f06$var$StyledLinkComponent, props));
    const $f986fcb135747f06$var$LinkWithAnalytics = (0, (0, parcelRequire("8oe80")).default)('link', {
        onClick: 'clicked'
    })($f986fcb135747f06$var$StyledLink);
    const $f986fcb135747f06$var$StyledLinkComponent = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("l8S66", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0480e3f92b6cfd0e$export$2e2bcd8739ae039);
    const $0480e3f92b6cfd0e$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "name_projectVersions_NameCell_jiraProject",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "projectType"
                },
                "action": "THROW",
                "path": "projectType"
            }
        ],
        "type": "JiraProject"
    };
    $0480e3f92b6cfd0e$var$node.hash = "a64f354b68d1237c5efb3aba5192d28c";
    var $0480e3f92b6cfd0e$export$2e2bcd8739ae039 = $0480e3f92b6cfd0e$var$node;
});
parcelRegister("eyBPg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fb4e108bed0aeb8$export$2e2bcd8739ae039);
    const $3fb4e108bed0aeb8$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "name_projectVersions_NameCell_jiraVersion",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "versionId"
                },
                "action": "THROW",
                "path": "versionId"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "name"
                },
                "action": "THROW",
                "path": "name"
            }
        ],
        "type": "JiraVersion"
    };
    $3fb4e108bed0aeb8$var$node.hash = "ff19770b46145efacc61452e92184dda";
    var $3fb4e108bed0aeb8$export$2e2bcd8739ae039 = $3fb4e108bed0aeb8$var$node;
});
parcelRegister("5KMRC", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$752b6f064665c57c$export$42a852a2b6b56249);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $752b6f064665c57c$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_slp31hna _ca0qu2gc _n3tdu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("guJqH", function(module, exports) {
    $parcel$export(module.exports, "getVersionIssuesUrl", ()=>$cb3235dabeb531b7$export$ddba25f62ccdd322);
    var $cIy4l;
    const $cb3235dabeb531b7$var$getVersionPageUrl = (projectKey, versionId)=>`/projects/${projectKey}/versions/${versionId}`;
    const $cb3235dabeb531b7$var$getVersionIssuesJql = (projectKey, versionName)=>{
        const jql = `project = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(projectKey)} AND fixVersion = ${(0, (0, parcelRequire("cIy4l")).toQuotedString)(versionName)}`;
        return (0, (0, parcelRequire("cIy4l")).createIssuesUrl)(jql);
    };
    const $cb3235dabeb531b7$export$ddba25f62ccdd322 = (projectKey, isSoftwareProject, versionId, versionName)=>{
        if (isSoftwareProject) return $cb3235dabeb531b7$var$getVersionPageUrl(projectKey, versionId);
        return $cb3235dabeb531b7$var$getVersionIssuesJql(projectKey, versionName);
    };
});
parcelRegister("MIIU8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a904d6bbb8b4826$export$2e2bcd8739ae039);
    var $2E3nt;
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Uumt = parcelRequire("8Uumt");
    var $6xUNT;
    var $7IWsp;
    var $koVbs;
    var $5KMRC;
    var $8v1e6;
    const $4a904d6bbb8b4826$var$VersionProgress = ({ query: query })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const progress = (0, $8Uumt.useFragment)((0, (0, parcelRequire("2E3nt")).default), query);
        const doneCount = progress.done.totalCount;
        const inProgressCount = progress.inProgress.totalCount;
        const toDoCount = progress.toDo.totalCount;
        return toDoCount || inProgressCount || doneCount ? (0, ($parcel$interopDefault($5uXOq))).createElement($4a904d6bbb8b4826$var$BarContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6xUNT")).default), {
            sum: doneCount + inProgressCount + toDoCount,
            remainingTooltipContent: formatMessage((0, (0, parcelRequire("8v1e6")).default).toDo, {
                toDo: toDoCount
            }),
            backgroundColor: `var(--ds-border, ${(0, $829f609a65d26a98$exports).N30})`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IWsp")).default), {
            value: doneCount,
            tooltipContent: formatMessage((0, (0, parcelRequire("8v1e6")).default).done, {
                done: doneCount
            }),
            color: `var(--ds-border-success, ${(0, $829f609a65d26a98$exports).G300})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IWsp")).default), {
            value: inProgressCount,
            tooltipContent: formatMessage((0, (0, parcelRequire("8v1e6")).default).inProgress, {
                inProgress: inProgressCount
            }),
            color: `var(--ds-border-information, ${(0, $829f609a65d26a98$exports).B200})`
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement($4a904d6bbb8b4826$var$TextContainer, null, formatMessage((0, (0, parcelRequire("8v1e6")).default).empty));
    };
    const $4a904d6bbb8b4826$var$TextContainer = (0, (0, parcelRequire("5KMRC")).Container);
    const $4a904d6bbb8b4826$var$BarContainer = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("5KMRC")).Container), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0q1wm8",
                __cmplp.className
            ])
        });
    });
    var $4a904d6bbb8b4826$export$2e2bcd8739ae039 = $4a904d6bbb8b4826$var$VersionProgress;
});
parcelRegister("2E3nt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d81acd65c337996$export$2e2bcd8739ae039);
    const $4d81acd65c337996$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "totalCount"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "progressBar_projectVersions_VersionProgress",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "done",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "DONE"
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "done.totalCount"
                            }
                        ],
                        "storageKey": "issues(filter:\"DONE\")"
                    },
                    "action": "THROW",
                    "path": "done"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "inProgress",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "IN_PROGRESS"
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "inProgress.totalCount"
                            }
                        ],
                        "storageKey": "issues(filter:\"IN_PROGRESS\")"
                    },
                    "action": "THROW",
                    "path": "inProgress"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "toDo",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "filter",
                                "value": "TODO"
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issues",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "toDo.totalCount"
                            }
                        ],
                        "storageKey": "issues(filter:\"TODO\")"
                    },
                    "action": "THROW",
                    "path": "toDo"
                }
            ],
            "type": "JiraVersion"
        };
    }();
    $4d81acd65c337996$var$node.hash = "728b280b2216bb0f2cdb74b3d92d96fb";
    var $4d81acd65c337996$export$2e2bcd8739ae039 = $4d81acd65c337996$var$node;
});
parcelRegister("6xUNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d12efc7cca969bbb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $7IWsp;
    class $d12efc7cca969bbb$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                children: null,
                sum: 0,
                remainingTooltipContent: '',
                backgroundColor: (0, $829f609a65d26a98$exports).N30,
                height: 10
            };
        }
        validateElementsAndCalculateElementsWidth() {
            const { children: children } = this.props;
            let sumOfElementsValues = 0;
            const validatedElements = [];
            (0, $5uXOq.Children).map(children, (child)=>{
                const childEl = child;
                if (childEl.props.value && childEl.props.value > 0) {
                    sumOfElementsValues += childEl.props.value;
                    validatedElements.push(childEl);
                }
            });
            return {
                validatedElements: validatedElements,
                elementsSum: sumOfElementsValues
            };
        }
        render() {
            const { children: children, remainingTooltipContent: remainingTooltipContent, sum: sum, backgroundColor: backgroundColor, height: height, borderRadius: borderRadius, tooltipHoverPadding: tooltipHoverPadding } = this.props;
            if (!children) return (0, ($parcel$interopDefault($5uXOq))).createElement($d12efc7cca969bbb$var$ProgressWrapper, {
                "data-testid": "common.components.progress-bar.progress-wrapper",
                backgroundColor: backgroundColor,
                elementsGrow: 0,
                elementsHeight: height,
                borderRadius: borderRadius
            });
            const { validatedElements: validatedElements, elementsSum: elementsSum } = this.validateElementsAndCalculateElementsWidth();
            const remaining = sum - elementsSum;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($d12efc7cca969bbb$var$ProgressWrapper, {
                ...this.props,
                "data-testid": "common.components.progress-bar.progress-wrapper",
                backgroundColor: remaining > 0 ? backgroundColor : 'transparent',
                elementsHeight: height,
                borderRadius: borderRadius,
                tooltipHoverPadding: tooltipHoverPadding,
                role: "status",
                ariaLive: "polite"
            }, validatedElements, remaining > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7IWsp")).default), {
                value: remaining,
                tooltipContent: remainingTooltipContent,
                color: backgroundColor,
                tooltipHoverPadding: tooltipHoverPadding
            }));
        }
    }
    const $d12efc7cca969bbb$var$ProgressWrapper = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1750df9-0"
    })`width:100%;height:${(props)=>props.elementsHeight}px;display:flex;${({ borderRadius: borderRadius, elementsHeight: elementsHeight, tooltipHoverPadding: tooltipHoverPadding })=>!tooltipHoverPadding && `border-radius: ${borderRadius || elementsHeight / 2}px;
        overflow: hidden;
    `} & > div{${({ borderRadius: borderRadius, elementsHeight: elementsHeight })=>{
        const radius = `${borderRadius || elementsHeight / 2}px`;
        return `
                &:first-child {
                    border-top-left-radius: ${radius};
                    border-bottom-left-radius: ${radius};
                }
                &:last-child {
                    border-top-right-radius: ${radius};
                    border-bottom-right-radius: ${radius};
                }
                &:not(:last-child) {
                    margin-right: 2px;
                }
                &:last-child {
                    margin-right: 0;
                }
            `;
    }}}`;
    $d12efc7cca969bbb$var$ProgressWrapper.displayName = 'ProgressWrapper';
});
parcelRegister("7IWsp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$719ee7d438676972$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $3bDjY;
    const $719ee7d438676972$var$SingleElementWithTooltip = (props)=>{
        const { value: value, tooltipContent: tooltipContent, color: color, position: position, tooltipHoverPadding: tooltipHoverPadding } = props;
        const TooltipTag = (0, $5uXOq.useMemo)(()=>(0, $5uXOq.forwardRef)((tagProps, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElement, {
                    elementGrow: value,
                    color: color,
                    innerRef: ref,
                    tooltipHoverPadding: tooltipHoverPadding,
                    ...tagProps,
                    ...typeof tooltipContent === 'string' ? {
                        role: 'button',
                        'aria-label': tooltipContent,
                        alt: tooltipContent,
                        tabIndex: 0
                    } : {}
                })), [
            color,
            value,
            tooltipContent,
            tooltipHoverPadding
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            position: position,
            tag: TooltipTag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null)));
    };
    class $719ee7d438676972$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                value: 0,
                tooltipContent: ''
            };
        }
        render() {
            const { value: value, tooltipContent: tooltipContent, color: color } = this.props;
            const hasTooltipContent = Boolean(tooltipContent);
            if (hasTooltipContent) return (0, ($parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElementWithTooltip, {
                ...this.props,
                tooltipContent: tooltipContent
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($719ee7d438676972$var$SingleElement, {
                elementGrow: value,
                color: color,
                alt: tooltipContent
            });
        }
    }
    const $719ee7d438676972$var$SingleElement = (0, $47bDC.default).div.withConfig({
        componentId: "sc-234u1k-0"
    })`flex-grow:${(props)=>props.elementGrow};height:100%;min-width:5px;background-color:${(props)=>props.color};div{height:100%;width:100%;${({ tooltipHoverPadding: tooltipHoverPadding })=>tooltipHoverPadding && `padding-block: ${tooltipHoverPadding}px;
            margin-top: -${tooltipHoverPadding}px;`}}`;
    $719ee7d438676972$var$SingleElement.displayName = 'SingleElement';
});
parcelRegister("8v1e6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b855ecf4b5a58b0f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b855ecf4b5a58b0f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        done: {
            "id": "project-versions.table.progress-bar.done",
            "defaultMessage": "{done} done"
        },
        inProgress: {
            "id": "project-versions.table.progress-bar.in-progress",
            "defaultMessage": "{inProgress} in progress"
        },
        toDo: {
            "id": "project-versions.table.progress-bar.to-do",
            "defaultMessage": "{toDo} to do"
        },
        empty: {
            "id": "project-versions.table.progress-bar.empty",
            "defaultMessage": "No issues"
        }
    });
});
parcelRegister("3uVZB", function(module, exports) {
    $parcel$export(module.exports, "ReleaseDateCell", ()=>$998263ea901a7d34$export$c0bb7e6ec18f1eec);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $e8T8A;
    const $998263ea901a7d34$export$c0bb7e6ec18f1eec = ({ releaseDate: releaseDate, overdue: overdue })=>{
        const { formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $998263ea901a7d34$var$releaseDateCellStyles,
                overdue && $998263ea901a7d34$var$overdueReleaseDateCellStyles
            ]
        }, (0, (0, parcelRequire("e8T8A")).getFormattedVersionDate)(releaseDate, formatDate));
    };
    const $998263ea901a7d34$var$releaseDateCellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordWrap: 'break-word',
        paddingTop: 'space.100',
        paddingBottom: 'space.100'
    });
    const $998263ea901a7d34$var$overdueReleaseDateCellStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.danger'
    });
});
parcelRegister("kKyOF", function(module, exports) {
    $parcel$export(module.exports, "updateStoreOnMove", ()=>$b322116306ce5e46$export$82bdc89cde99e0a0);
    var $eiowN = parcelRequire("eiowN");
    var $iJZ8l;
    const $b322116306ce5e46$export$82bdc89cde99e0a0 = ({ store: store, connectionId: connectionId, sourceVersionAri: sourceVersionAri, operationType: operationType, beforeVersionAri: beforeVersionAri })=>{
        const connectionRecord = store.get(connectionId);
        if (connectionRecord == null) return;
        const sourceVersionDataId = (0, (0, parcelRequire("iJZ8l")).default)({
            id: sourceVersionAri
        }, 'JiraVersion') ?? '';
        const sourceVersionRecord = store.get(sourceVersionDataId);
        if (sourceVersionRecord == null) return;
        const { EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
        const connectionEdges = connectionRecord.getLinkedRecords(EDGES) || [];
        let updatedEdges = [
            ...connectionEdges
        ];
        const indexOfEdgeToMove = updatedEdges.findIndex((edge)=>edge.getLinkedRecord('node')?.getValue('id') === sourceVersionAri);
        const edgeToMove = updatedEdges.splice(indexOfEdgeToMove, 1)[0];
        switch(operationType){
            case 'move-position':
                {
                    const indexOfEdgeAfter = connectionEdges.findIndex((edge)=>edge.getLinkedRecord('node')?.getValue('id') === beforeVersionAri);
                    if (indexOfEdgeAfter > indexOfEdgeToMove) updatedEdges.splice(indexOfEdgeAfter - 1, 0, edgeToMove);
                    else updatedEdges.splice(indexOfEdgeAfter, 0, edgeToMove);
                    break;
                }
            case 'move-to-start':
                updatedEdges = [
                    ...updatedEdges,
                    edgeToMove
                ];
                break;
            case 'move-to-end':
                updatedEdges = [
                    edgeToMove,
                    ...updatedEdges
                ];
                break;
            default:
                break;
        }
        connectionRecord.setLinkedRecords(updatedEdges, EDGES);
    };
});
parcelRegister("8T1hp", function(module, exports) {
    $parcel$export(module.exports, "isVersionAdminContext", ()=>$11623deaab2d15e8$export$1de6bf38ac6f624a);
    $parcel$export(module.exports, "getProjectType", ()=>$11623deaab2d15e8$export$3dd0da95519c1a33);
    var $2vSU6;
    var $j0xEB;
    var $dJl1T;
    const $11623deaab2d15e8$export$1de6bf38ac6f624a = ()=>{
        const pathname = (0, (0, parcelRequire("j0xEB")).default)() && (0, (0, parcelRequire("j0xEB")).default)().pathname || '';
        const isVersionAdminContextSatisfied = pathname.endsWith && pathname.endsWith('/administer-versions');
        if (isVersionAdminContextSatisfied) (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('@atlassian/jira-project-versions', 'isVersionAdminContext is true');
        return isVersionAdminContextSatisfied;
    };
    const $11623deaab2d15e8$export$3dd0da95519c1a33 = (projectType)=>{
        switch(projectType){
            case 'BUSINESS':
                return 0, (0, parcelRequire("2vSU6")).CORE_PROJECT;
            case 'SOFTWARE':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'SERVICE_DESK':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'PRODUCT_DISCOVERY':
                return 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT;
            default:
                return null;
        }
    };
});
parcelRegister("j0xEB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b1198aeec732ce1$export$2e2bcd8739ae039);
    var $9b1198aeec732ce1$export$2e2bcd8739ae039 = ()=>{
        if (typeof window !== 'undefined') return window.location;
        return undefined;
    };
});
parcelRegister("7DbgJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$709f870a3eb06979$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $1u3Jv;
    var $eusud;
    const $709f870a3eb06979$export$fa156a01818e3239 = (baseUrl, projectKey)=>(0, (0, parcelRequire("eusud")).performPostRequest)(`${baseUrl}/rest/internal/2/project/${projectKey}/recent`).catch((e)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.common.src.add-project-to-history', 'Cannot set recent project', e);
        });
    const $709f870a3eb06979$var$AddProjectToHistory = ({ baseUrl: baseUrl, projectKey: projectKey })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: ()=>$709f870a3eb06979$export$fa156a01818e3239(baseUrl, projectKey)
        });
    var $709f870a3eb06979$export$2e2bcd8739ae039 = $709f870a3eb06979$var$AddProjectToHistory;
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("fhVq7", function(module, exports) {
    $parcel$export(module.exports, "ScrollablePage", ()=>$501f0ba909d41168$export$8d7a30196b47fe34);
    $parcel$export(module.exports, "PageLayout", ()=>$501f0ba909d41168$export$6d1402fb58384e4f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $4R6GH;
    var $dCm1o;
    const $501f0ba909d41168$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
            xcss: $501f0ba909d41168$var$scrollablePageStyles,
            paddingBlock: "space.0",
            paddingInline: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? 'space.300' : 'space.500'
        }, children);
    const $501f0ba909d41168$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
        const isVisualRefresh = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
            xcss: hideMargin ? $501f0ba909d41168$var$pageLayoutWithoutMarginStyles : isVisualRefresh ? $501f0ba909d41168$var$pageLayoutWithMarginStyles : $501f0ba909d41168$var$pageLayoutWithMarginStylesOld
        }, children);
    };
    const $501f0ba909d41168$var$scrollablePageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '800px',
        margin: 'space.0'
    });
    const $501f0ba909d41168$var$pageLayoutWithoutMarginStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.0'
    });
    const $501f0ba909d41168$var$pageLayoutWithMarginStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlock: '0',
        marginInline: 'space.500'
    });
    const $501f0ba909d41168$var$pageLayoutWithMarginStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlock: '0',
        marginInline: 'space.300'
    });
});
